/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Admin API
 * To perform authenticated requests via Swagger UI, log in to the app via the same web browser
 * (http://localhost:3000/users/sign_in) before using 'Try it out' section.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { orvalFetch } from '../../orvalFetcher';
/**
 * Deposit status.
 */
export type DepositStatusEnum = typeof DepositStatusEnum[keyof typeof DepositStatusEnum];


export const DepositStatusEnum = {
  open: 'open',
  paid: 'paid',
  failed: 'failed',
  refunded: 'refunded',
  expired: 'expired',
  returned: 'returned',
  cancelled: 'cancelled',
} as const;

/**
 * Deposit approval-review status.
 */
export type DepositReviewStatusEnum = typeof DepositReviewStatusEnum[keyof typeof DepositReviewStatusEnum];


export const DepositReviewStatusEnum = {
  verification_pending: 'verification_pending',
  auto_approved: 'auto_approved',
  manually_approved: 'manually_approved',
  manually_rejected: 'manually_rejected',
} as const;

export interface Deposit {
  id?: number;
  uuid?: string;
  amount?: string;
  status?: DepositStatusEnum;
  review_status?: DepositReviewStatusEnum;
  user_id?: number;
  /** @nullable */
  user_name?: string | null;
  /** Whether the deposit was created manually */
  manually_created?: boolean;
  created_at?: string;
}

export interface PaginationMeta {
  /** Whether there is a previous page */
  has_previous: boolean;
  /** Whether there is a next page */
  has_next: boolean;
  /**
     * The cursor of the next page
     * @nullable
     */
  next_cursor: string | null;
  /**
     * The cursor of the previous page
     * @nullable
     */
  previous_cursor: string | null;
  /** The number of records in the current page */
  records_count: number;
  /** The total number of records in total */
  total_count: number;
  /** List of fields that can be used for ordering */
  orderable_fields: string[];
}

export interface DepositsListResponse {
  collection: Deposit[];
  meta: PaginationMeta;
}

export type ApiErrorErrorDetailsItemDataType = typeof ApiErrorErrorDetailsItemDataType[keyof typeof ApiErrorErrorDetailsItemDataType];


export const ApiErrorErrorDetailsItemDataType = {
  link: 'link',
} as const;

/**
 * Extra payload the frontend renders next to the message. A `link` turns the message into a button pointing at the record the error is about.
 */
export type ApiErrorErrorDetailsItemData = {
  type: ApiErrorErrorDetailsItemDataType;
  resource_type: string;
  resource_id?: string;
};

export type ApiErrorErrorDetailsItem = {
  field?: string;
  message?: string;
  /** @nullable */
  code?: string | null;
  /** Extra payload the frontend renders next to the message. A `link` turns the message into a button pointing at the record the error is about. */
  data?: ApiErrorErrorDetailsItemData;
};

export type ApiErrorError = {
  message?: string;
  request_id?: string;
  details?: ApiErrorErrorDetailsItem[];
};

export interface ApiError {
  error?: ApiErrorError;
}

export type ResourceNotFoundError = ApiError & unknown;

export type InternalServerError = ApiError & unknown;

export type DepositsFilterMetadataResponseFields = {
  statuses: DepositStatusEnum[];
  /** URL to search for users */
  user_search_path: string;
};

export interface DepositsFilterMetadataResponse {
  count: number;
  fields: DepositsFilterMetadataResponseFields;
}

export interface PaymentSession {
  id?: number;
  state?: string;
  charge_type?: string;
  provider?: string;
  amount_total?: string;
  generate_invoice_path?: string;
  /** @nullable */
  payment_identifier?: string | null;
  created_at?: string;
}

/**
 * Determines frontend response handling - either file download or JSON processing. Defaults to application/json
 */
export type ActionResponseContentType = typeof ActionResponseContentType[keyof typeof ActionResponseContentType];


export const ActionResponseContentType = {
  'application/json': 'application/json',
  'application/pdf': 'application/pdf',
  'text/csv': 'text/csv',
} as const;

export interface Action {
  action_name: string;
  name: string;
  method: string;
  path: string;
  /** This property indicates that parameters are required for the action and a GET request to /admin/api/users/{userId}/actions/new?action_name=high_risk needs to be sent beforehand */
  require_params: boolean;
  /** Indicates whether a confirmation dialog needs to be rendered */
  confirm: boolean;
  confirmation_message?: string;
  /** Determines frontend response handling - either file download or JSON processing. Defaults to application/json */
  response_content_type: ActionResponseContentType;
  /** If this value is set, the link is expected to be from an external subdomain */
  external?: boolean;
  /** If this value is set, the action will not be displayed in the dropdwon list of actions. */
  hidden: boolean;
  /** Determines whether the action is applicable for the current resource and user. If false, the action will not be available for execution. */
  applicability?: boolean;
}

export type ActionList = Action[];

export interface DepositDetailedResponse {
  id?: number;
  uuid?: string;
  amount?: string;
  status?: DepositStatusEnum;
  review_status?: DepositReviewStatusEnum;
  user_id?: number;
  /** @nullable */
  user_name?: string | null;
  /** Whether the deposit was created manually */
  manually_created?: boolean;
  created_at?: string;
  payment_sessions?: PaymentSession[];
  actions?: ActionList;
}

export type DepositActionResponseData = {
  actionable_object: DepositDetailedResponse;
};

export interface DepositActionResponse {
  message: string;
  data: DepositActionResponseData;
}

export type InvalidRecordError = ApiError & unknown;

export type PayoutStatus = typeof PayoutStatus[keyof typeof PayoutStatus];


export const PayoutStatus = {
  requested: 'requested',
  cancelled: 'cancelled',
  pending: 'pending',
  processed: 'processed',
  queued: 'queued',
  failed: 'failed',
  invitation_sent: 'invitation_sent',
  risk_assessment: 'risk_assessment',
  processing: 'processing',
  returned: 'returned',
  partially_processed: 'partially_processed',
  awaiting_approval: 'awaiting_approval',
  auto_approved: 'auto_approved',
} as const;

export type PayoutPayoutType = typeof PayoutPayoutType[keyof typeof PayoutPayoutType];


export const PayoutPayoutType = {
  affiliate: 'affiliate',
  trading_account: 'trading_account',
  bonus: 'bonus',
  prime_upgrade: 'prime_upgrade',
} as const;

export type PayoutPaymentMethod = typeof PayoutPaymentMethod[keyof typeof PayoutPaymentMethod];


export const PayoutPaymentMethod = {
  bank_transfer: 'bank_transfer',
  crypto: 'crypto',
  deel: 'deel',
  rise: 'rise',
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  no_payment_method: 'no_payment_method',
} as const;

/**
 * @nullable
 */
export type PayoutRiskStatus = typeof PayoutRiskStatus[keyof typeof PayoutRiskStatus] | null;


export const PayoutRiskStatus = {
  requested: 'requested',
  monitoring: 'monitoring',
  risk_assessment: 'risk_assessment',
  banned: 'banned',
  waiting_client_response: 'waiting_client_response',
  recheck: 'recheck',
  declined: 'declined',
  proof_pending: 'proof_pending',
  clean: 'clean',
  null: 'null',
} as const;

/**
 * Type of the account.
 */
export type AccountTypeEnum = typeof AccountTypeEnum[keyof typeof AccountTypeEnum];


export const AccountTypeEnum = {
  two_step: 'two_step',
  competition: 'competition',
  test: 'test',
  algo: 'algo',
  one_step: 'one_step',
  three_step: 'three_step',
  two_step_x: 'two_step_x',
  two_step_plus: 'two_step_plus',
  instant: 'instant',
  one_step_eod: 'one_step_eod',
  two_step_pro: 'two_step_pro',
  two_step_flex: 'two_step_flex',
  one_step_flex: 'one_step_flex',
  one_step_exp_001: 'one_step_exp_001',
  one_step_pro: 'one_step_pro',
  one_step_pro_plus: 'one_step_pro_plus',
  funded: 'funded',
  one_step_1: 'one_step_1',
  instant_v2: 'instant_v2',
  one_step_pro_plus_live: 'one_step_pro_plus_live',
  instant_live_trailing: 'instant_live_trailing',
  prime_account: 'prime_account',
  raw: 'raw',
  standard: 'standard',
  swap_free: 'swap_free',
} as const;

/**
 * Challenge payout cycle.
 */
export type ChallengePayoutCycleEnum = typeof ChallengePayoutCycleEnum[keyof typeof ChallengePayoutCycleEnum];


export const ChallengePayoutCycleEnum = {
  tuesday: 'tuesday',
  daily: 'daily',
  weekly: 'weekly',
  biweekly: 'biweekly',
  monthly: 'monthly',
  on_demand: 'on_demand',
  business_week: 'business_week',
} as const;

/**
 * ISO 4217 currency code.
 */
export type Currency = string;

export type CurrenciesFilter = Currency[];

export type Tags = string[];

export interface SearchUserSerializer {
  id: number;
  email: string;
  role: string;
  first_name: string;
  last_name: string;
  /** @nullable */
  full_kyc_name: string | null;
}

/**
 * @nullable
 */
export type PayoutTradingStateBefore = {
  balance?: number;
  profit?: number;
} | null;

export interface Payout {
  id?: number;
  reference?: string;
  user_id?: number;
  user_name?: string;
  trading_account_login?: string;
  trading_account_id?: number;
  trading_account_platform?: string;
  trading_account_phase?: string;
  trading_account_phase_display_name?: string;
  payment_method?: PayoutPaymentMethod;
  amount?: number;
  /** Total amount of challenges purchased */
  challenges_amount?: number;
  status?: PayoutStatus;
  updated_at?: string;
  created_at?: string;
  /** Total refunded amount */
  refunds_amount?: number;
  /** Number of payouts associated with the user */
  payout_count?: number;
  payout_type?: PayoutPayoutType;
  tag_list?: Tags;
  risk_status?: PayoutRiskStatus | null;
  assignee?: SearchUserSerializer;
  payout_cycle?: ChallengePayoutCycleEnum;
  account_type?: AccountTypeEnum;
  /** @nullable */
  country_code?: string | null;
  /** @nullable */
  trading_state_before?: PayoutTradingStateBefore;
  original_currency?: Currency;
}

export interface PayoutsListResponse {
  collection?: Payout[];
  meta?: PaginationMeta;
}

/**
 * Determine in which cases will the bulk action be applicable, for example, { status: [:requested, :risk_assessment] }  this means that the bulk action will only be applicable if all the selected  objects have status equal to requested or risk_assessment
 */
export type BulkActionApplicableIf = { [key: string]: unknown };

export interface BulkAction {
  action_name: string;
  name: string;
  method: string;
  path: string;
  /** Determine in which cases will the bulk action be applicable, for example, { status: [:requested, :risk_assessment] }  this means that the bulk action will only be applicable if all the selected  objects have status equal to requested or risk_assessment */
  applicable_if?: BulkActionApplicableIf;
}

export type PayoutsFilterMetadataResponseFieldsTemplatesItem = {
  /** Template name */
  name: string;
  /** Template id */
  value: number;
};

export type PayoutsFilterMetadataResponseFields = {
  /** Url to be used to search for the users based on search_field parameter to be added */
  user_search_path: string;
  tags: Tags;
  payout_types: PayoutPayoutType[];
  statuses: PayoutStatus[];
  payment_methods: PayoutPaymentMethod[];
  payout_cycles: ChallengePayoutCycleEnum[];
  account_types: AccountTypeEnum[];
  currencies: CurrenciesFilter;
  risk_statuses: (PayoutRiskStatus | null)[];
  templates: PayoutsFilterMetadataResponseFieldsTemplatesItem[];
  /** Url to be used to search for the risk members based on search_field parameter */
  assignee_search_path: string;
};

export interface PayoutsFilterMetadataResponse {
  count: number;
  fields: PayoutsFilterMetadataResponseFields;
  bulk_actions: BulkAction[];
}

/**
 * The type of the value, can be integer-float-string-currency-numeric-list
 */
export type WidgetValueType = typeof WidgetValueType[keyof typeof WidgetValueType];


export const WidgetValueType = {
  integer: 'integer',
  float: 'float',
  string: 'string',
  currency: 'currency',
  numeric: 'numeric',
  list: 'list',
} as const;

/**
 * @nullable
 */
export type WidgetAdditionalData = {
  type?: string;
  title?: string;
  value?: number;
} | null;

export interface Widget {
  title: string;
  /** The value of the widget; can be a number, null, or a list of objects */
  value: WidgetValue;
  /**
     * Contains the currency of the value in case the value_type is a currency
     * @nullable
     */
  currency?: string | null;
  /** The type of the value, can be integer-float-string-currency-numeric-list */
  value_type: WidgetValueType;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  additional_data?: WidgetAdditionalData;
}

/**
 * The value of the widget; can be a number, null, or a list of objects
 */
export type WidgetValue = number | null | string | Widget[];

export interface PayoutWidgetsResponse {
  collection?: Widget[];
  meta?: PaginationMeta;
}

export type PayoutUpdateRequestBodyPayout = {
  payment_method?: PayoutPaymentMethod;
  status?: PayoutStatus;
  amount?: number;
  enable_trading?: boolean;
  assignee_id?: number;
  risk_status?: PayoutRiskStatus | null;
};

export interface PayoutUpdateRequestBody {
  payout: PayoutUpdateRequestBodyPayout;
}

export type PayoutsUpdateResponseData = {
  payout: Payout;
};

export interface PayoutsUpdateResponse {
  message: string;
  data: PayoutsUpdateResponseData;
}

export type UserStatisticsResponsePurchasedChallenges = {
  count?: number;
  total_value?: number;
};

export type UserStatisticsResponseTotalPayouts = {
  count?: number;
  total_value?: number;
};

export interface UserStatisticsResponse {
  id?: number;
  purchased_challenges?: UserStatisticsResponsePurchasedChallenges;
  total_master_accounts?: number;
  total_payouts?: UserStatisticsResponseTotalPayouts;
  net_sales?: number;
}

export type PayoutTransactionStatus = typeof PayoutTransactionStatus[keyof typeof PayoutTransactionStatus];


export const PayoutTransactionStatus = {
  requested: 'requested',
  cancelled: 'cancelled',
  pending: 'pending',
  processed: 'processed',
  queued: 'queued',
  failed: 'failed',
  processing: 'processing',
} as const;

export type CryptoWalletProtocol = typeof CryptoWalletProtocol[keyof typeof CryptoWalletProtocol];


export const CryptoWalletProtocol = {
  trc20: 'trc20',
  erc20: 'erc20',
} as const;

export type CryptoWalletCurrency = typeof CryptoWalletCurrency[keyof typeof CryptoWalletCurrency];


export const CryptoWalletCurrency = {
  usdt: 'usdt',
  usdc: 'usdc',
} as const;

/**
 * @nullable
 */
export type CryptoWallet = {
  address: string;
  protocol: CryptoWalletProtocol;
  currency: CryptoWalletCurrency;
} | null;

/**
 * Enriched payout details for presentation. Based on `PayoutTransaction.payment_details` JSONB accessors but may include additional provider-specific data (e.g. bank account info, balances) depending on payment method.
 */
export type PayoutTransactionPayoutDetails = {
  bank_account_uuid?: string;
  crypto_wallet_id?: number;
  card_token?: string;
  state?: string;
  [key: string]: unknown;
 };

/**
 * Provider-specific payout details. Known keys are defined by `PayoutTransaction.external_payment_details` JSONB accessors.
 */
export type PayoutTransactionExternalPaymentDetails = {
  instrument_id?: string;
  scheme?: string;
  issuer_country?: string;
  transaction_id?: string;
  status?: string;
};

export interface PayoutTransaction {
  id: number;
  /** Unique payout transaction identifier. */
  uuid: string;
  percentage: number;
  payment_method: PayoutPaymentMethod;
  status: PayoutTransactionStatus;
  amount: number;
  /** Transaction amount in the original account currency. */
  original_currency_amount: number;
  /** Exchange rate from original currency to USD. */
  exchange_rate: number;
  /**
     * Bonus amount for `tradin_transfer` payouts.
     * @nullable
     */
  bonus: number | null;
  /**
     * Bonus percentage applied to `tradin_transfer` payouts.
     * @nullable
     */
  tradin_transfer_bonus_percentage: number | null;
  /** Enriched payout details for presentation. Based on `PayoutTransaction.payment_details` JSONB accessors but may include additional provider-specific data (e.g. bank account info, balances) depending on payment method. */
  payout_details: PayoutTransactionPayoutDetails;
  /**
     * URL to the blockchain or payment explorer for this transaction.
     * @nullable
     */
  transaction_url: string | null;
  /**
     * Error message returned by the payment provider, if any.
     * @nullable
     */
  provider_error: string | null;
  /** Provider-specific payout details. Known keys are defined by `PayoutTransaction.external_payment_details` JSONB accessors. */
  external_payment_details: PayoutTransactionExternalPaymentDetails;
  crypto_wallet: CryptoWallet | null;
  /**
     * External identifier assigned by the payout provider.
     * @nullable
     */
  external_identifier: string | null;
  /** Time when the payout transaction was created. */
  created_at: string;
  /** Admin actions available for this payout transaction. */
  actions: Action[];
}

/**
 * Account size.
 */
export type AccountSizeEnum = typeof AccountSizeEnum[keyof typeof AccountSizeEnum];


export const AccountSizeEnum = {
  NUMBER_1000: 1000,
  NUMBER_5000: 5000,
  NUMBER_10000: 10000,
  NUMBER_25000: 25000,
  NUMBER_50000: 50000,
  NUMBER_100000: 100000,
  NUMBER_200000: 200000,
} as const;

export interface AccountDetails {
  account_type: AccountTypeEnum;
  /** @nullable */
  balance: number | null;
  /** @nullable */
  eligible_amount: number | null;
  /** @nullable */
  profit_split_percentage: string | null;
  /** @nullable */
  profit?: number | null;
  /** @nullable */
  accumulated_profit?: number | null;
  /** @nullable */
  phase_display_name?: string | null;
  account_size: AccountSizeEnum;
  /** The account size in USD. */
  account_size_usd: number;
}

export interface RewardSummary {
  /** @nullable */
  total_account_profit: number | null;
  /** @nullable */
  reward_percentage: string | null;
  /** @nullable */
  requested_reward: number | null;
  /** @nullable */
  requested_reward_usd: number | null;
  /** @nullable */
  remaining_balance: number | null;
  /** @nullable */
  user_share: number | null;
  /** @nullable */
  our_share: number | null;
  /** @nullable */
  user_share_usd: number | null;
  /** @nullable */
  our_share_usd: number | null;
  service_fee: number;
}

/**
 * Platform name.
 */
export type PlatformEnum = typeof PlatformEnum[keyof typeof PlatformEnum];


export const PlatformEnum = {
  mt5: 'mt5',
  matchtrader: 'matchtrader',
  ctrader: 'ctrader',
  tradelocker: 'tradelocker',
  tradinx: 'tradinx',
} as const;

export type ChallengeSummaryAccountSize = AccountSizeEnum | null;

export interface ChallengeSummary {
  /** The ID of the challenge. */
  id: number;
  account_size: ChallengeSummaryAccountSize;
  account_type: AccountTypeEnum;
  platform: PlatformEnum;
  price: number;
  not_discounted_price: number;
  /** The ID of the template associated with the challenge. */
  template_id: number;
  /** The name of the template associated with the challenge. */
  template_name: string;
}

export type PayoutEditResponseAccountDetailsOneOf = { [key: string]: unknown };

export type PayoutEditResponseAccountDetails = PayoutEditResponseAccountDetailsOneOf | AccountDetails;

/**
 * @nullable
 */
export type PayoutEditResponseTradingStateBefore = {
  balance?: number;
  profit?: number;
} | null;

export type PayoutEditResponseRewardSummaryOneOf = { [key: string]: unknown };

export type PayoutEditResponseRewardSummary = PayoutEditResponseRewardSummaryOneOf | RewardSummary;

export interface PayoutEditResponse {
  id: number;
  reference: string;
  payout_type: PayoutPayoutType;
  commission_type: string;
  /** @nullable */
  kyc_full_name: string | null;
  /** The ID of the user */
  user_id: number;
  user_name: string;
  email: string;
  amount: number;
  amount_aed: number;
  refunds_amount: number;
  challenges_amount: number;
  trading_account_login: string;
  trading_account_id: number;
  payment_method: PayoutPaymentMethod;
  /** @nullable */
  kyc_address: string | null;
  payment_details_summary: string;
  status: PayoutStatus;
  /** @nullable */
  payout_txid: string | null;
  /** @nullable */
  foreign_payout_status: string | null;
  editable_fields: string[];
  actions: ActionList;
  /** @nullable */
  invoice_link: string | null;
  /** @nullable */
  certificate_link: string | null;
  important_statistics: UserStatisticsResponse;
  risk_status: PayoutRiskStatus | null;
  tag_list: Tags;
  /** Payout transactions sorted by `created_at` descending (newest first). */
  transactions: PayoutTransaction[];
  account_details: PayoutEditResponseAccountDetails;
  /** @nullable */
  trading_state_before: PayoutEditResponseTradingStateBefore;
  reward_summary: PayoutEditResponseRewardSummary;
  new_challenges?: ChallengeSummary[];
  currency: Currency;
}

export interface EmailTemplate {
  id?: number;
  title?: string;
  subject?: string;
  body?: string;
  created_at?: string;
  updated_at?: string;
}

export interface EmailTemplatesListResponse {
  collection?: EmailTemplate[];
  meta?: PaginationMeta;
}

export type EmailTemplateCreateUpdateRequestBodyEmailTemplate = {
  /** Title of the email template */
  title?: string;
  /** Subject of the email template */
  subject?: string;
  /** Body content of the email template */
  body?: string;
};

export interface EmailTemplateCreateUpdateRequestBody {
  email_template: EmailTemplateCreateUpdateRequestBodyEmailTemplate;
}

export type EmailTemplateResponseBodyData = {
  email_template: EmailTemplate;
};

export interface EmailTemplateResponseBody {
  message: string;
  data: EmailTemplateResponseBodyData;
}

export interface EmailTemplateErrorResponse {[key: string]: string[]}

export type EmailTemplateResponseBodyErrorData = {
  errors: EmailTemplateErrorResponse;
};

export interface EmailTemplateResponseBodyError {
  message: string;
  data: EmailTemplateResponseBodyErrorData;
}

export type BulkActionFormFieldType = typeof BulkActionFormFieldType[keyof typeof BulkActionFormFieldType];


export const BulkActionFormFieldType = {
  search_path: 'search_path',
  selector: 'selector',
  checkbox: 'checkbox',
  text: 'text',
  date: 'date',
  number: 'number',
  file: 'file',
  markdown: 'markdown',
} as const;

export type BulkActionFormFieldOptionsItem = {
  label?: string;
  value?: string;
};

export interface BulkActionFormField {
  name?: string;
  param_key?: string;
  type: BulkActionFormFieldType;
  /** Used with field type = divider and markdown to set the text content */
  value?: string;
  required?: boolean;
  default?: string;
  /** A path to search users for a field type = search_path */
  search_path?: string;
  /** Options for select for a field type = selector */
  options?: BulkActionFormFieldOptionsItem[];
  placeholder?: string;
  /** Whether the field is disabled */
  disabled?: boolean;
}

export type BulkActionFormButtonType = typeof BulkActionFormButtonType[keyof typeof BulkActionFormButtonType];


export const BulkActionFormButtonType = {
  submit: 'submit',
} as const;

export interface BulkActionFormButton {
  name: string;
  type: BulkActionFormButtonType;
}

export interface BulkFormParamsSchema {
  modal_title: string;
  modal_description: string;
  submit_btn_txt?: string;
  action: BulkAction;
  fields: BulkActionFormField[];
  buttons: BulkActionFormButton[];
}

export type Psp = typeof Psp[keyof typeof Psp];


export const Psp = {
  checkout: 'checkout',
  crypto: 'crypto',
  deel: 'deel',
  forumpay: 'forumpay',
  myfatoorah: 'myfatoorah',
  nowpayments: 'nowpayments',
  pay_to_card: 'pay_to_card',
  paymaxis: 'paymaxis',
  payout: 'payout',
  rise: 'rise',
  stripe: 'stripe',
  wire_transfer: 'wire_transfer',
  bank_transfer: 'bank_transfer',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  free_account: 'free_account',
  no_payment_method: 'no_payment_method',
} as const;

export interface PayoutsFilter {
  /** Filter by payout ids */
  ids?: number[];
  /** Search by user id linked to payout */
  filter_user_id?: number;
  /** Search for payouts by user name or email */
  search_field?: string;
  /** Filter payouts updated after this date */
  last_update_from?: string;
  /** Filter payouts updated before this date */
  last_update_to?: string;
  /** Filter for payouts by amount lower end */
  amount_from?: number;
  /** Filter for payouts by amount higher end */
  amount_to?: number;
  /** Filter payouts by payment methods */
  payment_methods?: Psp[];
  /** Filter payouts by status */
  statuses?: PayoutStatus[];
  /** Filter payouts by payout types */
  payout_types?: PayoutPayoutType[];
  /** Filter payouts by tags */
  tag_list?: string[];
  /** Filter payouts created after this date */
  created_at_from?: string;
  /** Filter payouts created before this date */
  created_at_to?: string;
  /** Filter payouts by payout cycles */
  payout_cycles?: ChallengePayoutCycleEnum[];
  /** Filter payouts by account types */
  account_types?: AccountTypeEnum[];
  /** Filter payouts by risk statuses */
  risk_statuses?: (PayoutRiskStatus | null)[];
  /** Filter payouts by trading account template ids */
  template_ids?: number[];
  /** Filter payouts by assignee id */
  assignee_id?: number;
}

/**
 * Sorting direction
 */
export type BulkActionsPayoutFiltersAllOfDirection = typeof BulkActionsPayoutFiltersAllOfDirection[keyof typeof BulkActionsPayoutFiltersAllOfDirection];


export const BulkActionsPayoutFiltersAllOfDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type BulkActionsPayoutFiltersAllOf = {
  /** Order by field name */
  field?: string;
  /** Sorting direction */
  direction?: BulkActionsPayoutFiltersAllOfDirection;
  /** Maximum number of results to return */
  limit?: number;
};

export type BulkActionsPayoutFilters = PayoutsFilter & BulkActionsPayoutFiltersAllOf;

export interface Assign {
  assignee_id: number;
  filters?: BulkActionsPayoutFilters;
}

export interface CommonPayoutBulkActionResponse {
  message: string;
}

export interface CreateBulkProcessingTask {
  filters: BulkActionsPayoutFilters;
}

export interface AccountManager {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  /** @nullable */
  full_kyc_name: string | null;
}

export type UsersListItemAccountManager = AccountManager | null;

export interface UsersListItem {
  id: number;
  /** @nullable */
  brand_id: number | null;
  /** @nullable */
  brand_name: string | null;
  created_at: string;
  name: string;
  email: string;
  country: string;
  country_code: string;
  phone_number_verification_status: string;
  kycaid_verification_status: string;
  rise_onboarding_status: string;
  trading_accounts_count: number;
  payouts_count: number;
  blocked: boolean;
  high_risk_profile: boolean;
  can_be_account_manager: boolean;
  account_manager: UsersListItemAccountManager;
  tag_list: Tags;
  /** @nullable */
  trust_profile_score?: number | null;
}

export interface UsersListResponse {
  collection?: UsersListItem[];
  meta?: PaginationMeta;
}

/**
 * Expected value type used for validation, or null for a stale setting
 * @nullable
 */
export type AppSettingDefinitionType = typeof AppSettingDefinitionType[keyof typeof AppSettingDefinitionType] | null;


export const AppSettingDefinitionType = {
  boolean: 'boolean',
  integer: 'integer',
  string: 'string',
  decimal: 'decimal',
  array: 'array',
  object: 'object',
} as const;

export type AppSettingDefinitionDefaultValueAnyOf = { [key: string]: unknown };

/**
 * Default value used when the setting is not persisted, or null for a stale setting
 */
export type AppSettingDefinitionDefaultValue = boolean | number | string | unknown[] | AppSettingDefinitionDefaultValueAnyOf | null;

export type AppSettingDefinitionValueAnyOf = { [key: string]: unknown };

/**
 * Persisted setting value, or null when not configured
 */
export type AppSettingDefinitionValue = boolean | number | string | unknown[] | AppSettingDefinitionValueAnyOf | null;

export interface AppSettingDefinition {
  /** Setting namespace */
  namespace: string;
  /** Unique key within a namespace */
  key: string;
  /**
     * Human-readable setting label, or null for a stale setting
     * @nullable
     */
  label: string | null;
  /**
     * Expected value type used for validation, or null for a stale setting
     * @nullable
     */
  type: AppSettingDefinitionType;
  /** Default value used when the setting is not persisted, or null for a stale setting */
  default_value: AppSettingDefinitionDefaultValue;
  /** Persisted setting value, or null when not configured */
  value: AppSettingDefinitionValue;
  /** Whether the setting value can be edited; false for stale settings not present in the definitions */
  editable: boolean;
}

export type AppSettingUpdateRequestBodyValueAnyOf = { [key: string]: unknown };

/**
 * New value for the setting. Must match the definition `type`.
 */
export type AppSettingUpdateRequestBodyValue = boolean | number | string | unknown[] | AppSettingUpdateRequestBodyValueAnyOf;

export interface AppSettingUpdateRequestBody {
  /** New value for the setting. Must match the definition `type`. */
  value: AppSettingUpdateRequestBodyValue;
}

export type AppSettingUpdateResponseBodyData = {
  app_setting: AppSettingDefinition;
};

export interface AppSettingUpdateResponseBody {
  message: string;
  data: AppSettingUpdateResponseBodyData;
}

export interface UserSearchFilter {
  /** Search for users by first_name, last_name, email, or notes body */
  search_field?: string;
  /** Search for users by email */
  email?: string;
  /** Search for users by KYC first_name or last_name */
  kyc_name?: string;
  /** Search for users by country code */
  country?: string;
  /** Search for users created after this date */
  created_at_from?: string;
  /** Search for users created before this date */
  created_at_to?: string;
  /** Search for users by status */
  status?: string;
}

export interface ExternalIdentifiers {
  /** @nullable */
  kycaid_applicant_identifier: string | null;
  /** @nullable */
  rise_identifier: string | null;
}

export interface AffiliateInfo {
  /** @nullable */
  next_affiliate_payout_at: string | null;
}

/**
 * KYCAID verification status
 */
export type KycProfileKycaidVerificationStatus = typeof KycProfileKycaidVerificationStatus[keyof typeof KycProfileKycaidVerificationStatus];


export const KycProfileKycaidVerificationStatus = {
  unverified: 'unverified',
  verified: 'verified',
  pending: 'pending',
} as const;

/**
 * @nullable
 */
export type KycProfileGender = typeof KycProfileGender[keyof typeof KycProfileGender] | null;


export const KycProfileGender = {
  male: 'male',
  female: 'female',
} as const;

export interface KycProfile {
  id: number;
  /**
     * User's city of residence
     * @nullable
     */
  city: string | null;
  /**
     * User's country code (ISO)
     * @nullable
     */
  country: string | null;
  /**
     * Date of birth
     * @nullable
     */
  dob: string | null;
  /**
     * User's first name
     * @nullable
     */
  first_name: string | null;
  /**
     * House or building number
     * @nullable
     */
  house_number: string | null;
  /**
     * IP address used during verification
     * @nullable
     */
  ip_address: string | null;
  /** @nullable */
  kycaid_applicant_identifier: string | null;
  /** @nullable */
  kycaid_form_url: string | null;
  /** @nullable */
  kycaid_verification_identifier: string | null;
  /** KYCAID verification status */
  kycaid_verification_status: KycProfileKycaidVerificationStatus;
  /** @nullable */
  last_name: string | null;
  /** @nullable */
  middle_name: string | null;
  /** @nullable */
  postal_code: string | null;
  /** @nullable */
  region: string | null;
  /** @nullable */
  street_name: string | null;
  /**
     * SSN number for US citizens
     * @nullable
     */
  tax_identifier: string | null;
  user_id: number;
  /** @nullable */
  full_name: string | null;
  /** @nullable */
  kycaid_url: string | null;
  /** @nullable */
  full_address: string | null;
  /** Indicates if the user is a US citizen */
  us_citizen: boolean;
  /** @nullable */
  gender?: KycProfileGender;
}

export type UserDetailedBlockedPayoutMethodsItem = typeof UserDetailedBlockedPayoutMethodsItem[keyof typeof UserDetailedBlockedPayoutMethodsItem];


export const UserDetailedBlockedPayoutMethodsItem = {
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  rise: 'rise',
  crypto: 'crypto',
} as const;

export type UserDetailedAccountManager = AccountManager | null;

export type UserDetailedKycProfile = KycProfile | null;

export interface UserDetailed {
  id: number;
  /** @nullable */
  brand_id: number | null;
  /** @nullable */
  brand_name: string | null;
  created_at: string;
  name: string;
  email: string;
  /** @nullable */
  country_code: string | null;
  /** @nullable */
  address: string | null;
  /** @nullable */
  full_kyc_name: string | null;
  kycaid_verification_status: string;
  phone_number_verification_status: string;
  /** @nullable */
  phone_number: string | null;
  /** @nullable */
  whatsapp_phone_number: string | null;
  rise_onboarding_status: string;
  /** @nullable */
  rise_identifier: string | null;
  /** @nullable */
  kyc_country: string | null;
  /** @nullable */
  full_kyc_address: string | null;
  external_identifiers: ExternalIdentifiers;
  affiliate: AffiliateInfo;
  status: string;
  blocked: boolean;
  high_risk_profile: boolean;
  /** Whether Prime transition mode is enabled for all eligible master accounts of this user. */
  prime_transition: boolean;
  blocked_payout_methods: UserDetailedBlockedPayoutMethodsItem[];
  can_be_account_manager: boolean;
  account_manager: UserDetailedAccountManager;
  actions: ActionList;
  kyc_profile?: UserDetailedKycProfile;
  tag_list: Tags;
  max_active_allocation: number;
  max_active_accounts: number;
  /** @nullable */
  trust_profile_score?: number | null;
  roles: string[];
  keys: string[];
}

export type UserEditResponseAccountManager = AccountManager | null;

export type UserEditResponseBlockedPayoutMethodsItem = typeof UserEditResponseBlockedPayoutMethodsItem[keyof typeof UserEditResponseBlockedPayoutMethodsItem];


export const UserEditResponseBlockedPayoutMethodsItem = {
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  rise: 'rise',
  crypto: 'crypto',
} as const;

export type UserEditResponseBlockedPayoutMethodOptionsItemValue = typeof UserEditResponseBlockedPayoutMethodOptionsItemValue[keyof typeof UserEditResponseBlockedPayoutMethodOptionsItemValue];


export const UserEditResponseBlockedPayoutMethodOptionsItemValue = {
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  rise: 'rise',
  crypto: 'crypto',
} as const;

export type UserEditResponseBlockedPayoutMethodOptionsItem = {
  label: string;
  value: UserEditResponseBlockedPayoutMethodOptionsItemValue;
};

export type UserEditResponseEditableFieldsItemAnyOf = { [key: string]: unknown };

export type UserEditResponseEditableFieldsItem = string | UserEditResponseEditableFieldsItemAnyOf;

export type UserEditResponseRoleOptionsItem = {
  label?: string;
  value?: string;
};

export type UserEditResponsePhoneNumberVerificationStatusOptionsItem = {
  label?: string;
  value?: string;
};

export type UserEditResponseReferralTierOptionsItem = {
  label?: string;
  value?: number;
};

export type UserEditResponsePermissionGroupOptionsItem = {
  label?: string;
  value?: number;
};

export interface UserEditResponse {
  id: number;
  first_name: string;
  last_name: string;
  paid_customer: boolean;
  affiliate_payouts_on_demand_enabled: boolean;
  competition_manager: boolean;
  can_be_account_manager: boolean;
  account_manager: UserEditResponseAccountManager;
  referral_code: string;
  /** Only present on funding_pips. */
  referral_tier_id?: number;
  /** Only present on funding_pips. */
  discount_tier_id?: number;
  role: string;
  phone_number_verification_status: string;
  blocked_payout_methods: UserEditResponseBlockedPayoutMethodsItem[];
  blocked_payout_method_options: UserEditResponseBlockedPayoutMethodOptionsItem[];
  /** @nullable */
  kycaid_applicant_identifier: string | null;
  editable_fields: UserEditResponseEditableFieldsItem[];
  role_options: UserEditResponseRoleOptionsItem[];
  phone_number_verification_status_options: UserEditResponsePhoneNumberVerificationStatusOptionsItem[];
  /** Only present on funding_pips. */
  referral_tier_options?: UserEditResponseReferralTierOptionsItem[];
  max_active_allocation: number;
  max_active_accounts: number;
  permission_group_ids: number[];
  permission_group_options: UserEditResponsePermissionGroupOptionsItem[];
  actions: ActionList;
}

export type UserUpdateResponseData = {
  user: UserEditResponse;
};

export interface UserUpdateResponse {
  message: string;
  data: UserUpdateResponseData;
}

export type UserUpdateRequestBodyUserBlockedPayoutMethodsItem = typeof UserUpdateRequestBodyUserBlockedPayoutMethodsItem[keyof typeof UserUpdateRequestBodyUserBlockedPayoutMethodsItem];


export const UserUpdateRequestBodyUserBlockedPayoutMethodsItem = {
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  rise: 'rise',
  crypto: 'crypto',
} as const;

export type UserUpdateRequestBodyUser = {
  first_name: string;
  last_name: string;
  paid_customer: boolean;
  affiliate_payouts_on_demand_enabled: boolean;
  competition_manager: boolean;
  /** Only allowed if the current user is an admin or super_admin (Will be editable if present in the editable_fields). */
  can_be_account_manager?: boolean;
  /**
     * Only allowed if the current user is an admin or super_admin. The assigned user must have can_be_account_manager set to true (Will be editable if present in the editable_fields).
     * @nullable
     */
  account_manager_id?: number | null;
  referral_code: string;
  /** Only allowed on funding_pips (Will be editable if present in the editable_fields). */
  referral_tier_id?: number;
  /** Only allowed on funding_pips (Will be editable if present in the editable_fields). */
  discount_tier_id?: number;
  phone_number_verification_status: string;
  blocked_payout_methods?: UserUpdateRequestBodyUserBlockedPayoutMethodsItem[];
  /** Only allowed if the current user is a super_user or super_admin (Will be editable if present in the editable_fields). */
  role?: string;
  /**
     * Only allowed if the current user is a super_user, super_admin, or admin, and the user has kycaid_verification_status as pending (Will be editable if present in the editable_fields).
     * @nullable
     */
  kycaid_applicant_identifier?: string | null;
  /** @nullable */
  max_active_allocation?: number | null;
  /** @nullable */
  max_active_accounts?: number | null;
  /** Only allowed if the current user is a super_user or super_admin (Will be editable if present in the editable_fields). */
  permission_group_ids?: number[];
};

export interface UserUpdateRequestBody {
  user: UserUpdateRequestBodyUser;
}

export type UserTradingRiskStatisticsResponseFailedChallenges = {
  evaluation?: number;
};

export type UserTradingRiskStatisticsResponseLostMasterAccounts = {
  total_value?: number;
  count?: number;
};

export interface UserTradingRiskStatisticsResponse {
  id?: number;
  failed_challenges?: UserTradingRiskStatisticsResponseFailedChallenges;
  max_traded_lots?: number;
  /** @nullable */
  most_traded_asset?: string | null;
  biggest_winning_day?: number;
  /** Returns the smallest daily profit. The value can be negative (indicating a loss). */
  biggest_losing_day?: number;
  lost_master_accounts?: UserTradingRiskStatisticsResponseLostMasterAccounts;
  /** Returns the biggest losing trade (the smallest profit). The value can be negative (indicating a loss). */
  biggest_losing_trade?: number;
}

export type UserPrimeStatisticsResponseState = typeof UserPrimeStatisticsResponseState[keyof typeof UserPrimeStatisticsResponseState];


export const UserPrimeStatisticsResponseState = {
  below: 'below',
  reached: 'reached',
  cap: 'cap',
} as const;

/**
 * The trader's current-month Prime Monthly Reward tracker: eligible volume and the reward milestone it maps to. Milestone amounts are display-only; ops set the actual reward. `next_*` fields are null once the trader is at the cap milestone. Returns 0 for the whole month unless the trader still holds at least one live (ongoing) Prime account at month end.
 */
export interface UserPrimeStatisticsResponse {
  eligible_volume: number;
  current_milestone_volume: number;
  projected_amount: number;
  /** @nullable */
  next_milestone_volume: number | null;
  /** @nullable */
  next_milestone_amount: number | null;
  state: UserPrimeStatisticsResponseState;
}

export type ActionFormFieldType = typeof ActionFormFieldType[keyof typeof ActionFormFieldType];


export const ActionFormFieldType = {
  selector: 'selector',
  checkbox: 'checkbox',
  text: 'text',
  date: 'date',
  number: 'number',
  file: 'file',
  markdown: 'markdown',
  string: 'string',
} as const;

/**
 * In case of other field with param_key `method` equal `confirmo`, this field must be required
 */
export type ActionFormFieldRequiredOneOf = {[key: string]: string};

export type ActionFormFieldRequired = boolean | ActionFormFieldRequiredOneOf;

export type ActionFormFieldOptionsItem = {
  label?: string;
  value?: string;
};

/**
 * In case of other field with param_key `method` equal `confirmo`, this field must be visible, otherwise hidden
 */
export type ActionFormFieldVisibleIf = {[key: string]: string};

export interface ActionFormField {
  name?: string;
  param_key?: string;
  type: ActionFormFieldType;
  /** Used with field type = divider and markdown to set the text content */
  value?: string;
  required?: ActionFormFieldRequired;
  searchable?: boolean;
  default?: string;
  /** Options for select */
  options?: ActionFormFieldOptionsItem[];
  placeholder?: string;
  /** In case of other field with param_key `method` equal `confirmo`, this field must be visible, otherwise hidden */
  visible_if?: ActionFormFieldVisibleIf;
  /** Whether the field is disabled */
  disabled?: boolean;
}

/**
 * Prefilled value — a hidden identifier (string) or an editable amount (number).
 */
export type EditableChecklistItemFieldValue = string | number;

/**
 * A single input within an `editable_checklist` row.
 */
export interface EditableChecklistItemField {
  name?: string;
  type?: string;
  param_key: string;
  /** Prefilled value — a hidden identifier (string) or an editable amount (number). */
  value?: EditableChecklistItemFieldValue;
  /** Submitted but not shown/edited (e.g. the session UUID). */
  hidden?: boolean;
  /** The operator can edit this value (e.g. the refund amount). */
  editable?: boolean;
}

export type EditableChecklistFieldOptionsItem = {
  /** Row label. */
  name?: string;
  /** Stable details identifying the row's source, shown under the label. Distinguishes rows whose label is identical because they share a provider and amount. */
  description?: string;
  /** Inputs that make up the submitted object for this row. */
  fields: EditableChecklistItemField[];
};

/**
 * A checklist field with one predefined row per `options` entry. Each row carries its own editable `fields`; the client submits the checked rows as an array of objects (keyed by each sub-field's `param_key`) under this field's `param_key`.
 */
export interface EditableChecklistField {
  name?: string;
  type: 'editable_checklist';
  param_key: string;
  required?: boolean;
  /** One predefined row per option. */
  options: EditableChecklistFieldOptionsItem[];
}

export type ActionFormButtonType = typeof ActionFormButtonType[keyof typeof ActionFormButtonType];


export const ActionFormButtonType = {
  submit: 'submit',
  button: 'button',
} as const;

export interface ActionFormButton {
  name: string;
  type: ActionFormButtonType;
  /** Returned only when the button is intended to execute an action. If the action has require_params set to true, a parameter request must be sent first to obtain new action parameters */
  action?: Action;
}

export type FormParamsSchemaFieldsItem = ActionFormField | EditableChecklistField;

export interface FormParamsSchema {
  modal_title: string;
  modal_description: string;
  submit_btn_txt?: string;
  action: Action;
  fields?: FormParamsSchemaFieldsItem[];
  buttons: ActionFormButton[];
}

export interface ConvertToCrypto {
  crypto_wallet_id: number;
  ban_user?: boolean;
}

export type CommonPayoutActionResponseData = {
  actionable_object: PayoutEditResponse;
};

export interface CommonPayoutActionResponse {
  message: string;
  data: CommonPayoutActionResponseData;
}

export interface PayoutEnableTradingRequestBody {
  enable_trading?: boolean;
}

export interface PayoutSendEmailRequest {
  email_template_id: number;
}

export type ReplacePaymentMethod = typeof ReplacePaymentMethod[keyof typeof ReplacePaymentMethod];


export const ReplacePaymentMethod = {
  crypto: 'crypto',
  rise: 'rise',
  tradin_transfer: 'tradin_transfer',
} as const;

export interface Replace {
  payment_method: ReplacePaymentMethod;
  /**
     * Required when `payment_method` is `crypto`.
     * @nullable
     */
  crypto_wallet_id?: number | null;
  /** Applies only when `payment_method` is `crypto`. */
  ban_user?: boolean;
}

export type CommonPayoutTransactionActionResponseData = {
  actionable_object: PayoutTransaction;
};

export interface CommonPayoutTransactionActionResponse {
  message: string;
  data: CommonPayoutTransactionActionResponseData;
}

export type UserBlockResponseData = {
  actionable_object: UserDetailed;
};

export interface UserBlockResponse {
  message: string;
  data: UserBlockResponseData;
}

export type UserUnblockResponseData = {
  actionable_object: UserDetailed;
};

export interface UserUnblockResponse {
  message: string;
  data: UserUnblockResponseData;
}

export type UserResetPasswordResponseData = {
  actionable_object: UserDetailed;
};

export interface UserResetPasswordResponse {
  message: string;
  data: UserResetPasswordResponseData;
}

export type UserReset2faResponseData = {
  actionable_object: UserDetailed;
};

export interface UserReset2faResponse {
  message: string;
  data: UserReset2faResponseData;
}

export type UserStartVerificationResponseData = {
  actionable_object: UserDetailed;
};

export interface UserStartVerificationResponse {
  message: string;
  data: UserStartVerificationResponseData;
}

export type DisableVerificationResponseData = {
  actionable_object: UserDetailed;
};

export interface DisableVerificationResponse {
  message: string;
  data: DisableVerificationResponseData;
}

export type RefreshKycDocumentsResponseData = {
  actionable_object: UserDetailed;
};

export interface RefreshKycDocumentsResponse {
  message: string;
  data: RefreshKycDocumentsResponseData;
}

export type UserDownloadAsZipResponseData = {
  actionable_object: UserDetailed;
};

export interface UserDownloadAsZipResponse {
  message: string;
  data: UserDownloadAsZipResponseData;
}

export type ToggleHighRiskResponseData = {
  actionable_object: UserDetailed;
};

export interface ToggleHighRiskResponse {
  message: string;
  data: ToggleHighRiskResponseData;
}

export type UserChangeBrandResponseData = {
  actionable_object: UserDetailed;
};

export interface UserChangeBrandResponse {
  message: string;
  data: UserChangeBrandResponseData;
}

export type UserCreateWithdrawalResponseData = {
  actionable_object: UserDetailed;
};

export interface UserCreateWithdrawalResponse {
  message: string;
  data: UserCreateWithdrawalResponseData;
}

export type UserCreateDepositResponseData = {
  actionable_object: UserDetailed;
};

export interface UserCreateDepositResponse {
  message: string;
  data: UserCreateDepositResponseData;
}

/**
 * Account phase.
 */
export type PhaseEnum = typeof PhaseEnum[keyof typeof PhaseEnum];


export const PhaseEnum = {
  student: 'student',
  practitioner: 'practitioner',
  senior: 'senior',
  master: 'master',
  prime: 'prime',
} as const;

export type IpActivityTypeEnum = typeof IpActivityTypeEnum[keyof typeof IpActivityTypeEnum];


export const IpActivityTypeEnum = {
  trade: 'trade',
  kyc: 'kyc',
  login: 'login',
} as const;

export type ConfidenceLevelEnum = typeof ConfidenceLevelEnum[keyof typeof ConfidenceLevelEnum];


export const ConfidenceLevelEnum = {
  unresolved: 'unresolved',
  single_source: 'single_source',
  agreed: 'agreed',
  disputed: 'disputed',
} as const;

export type UserIpActivityCoordinates = {
  lat?: number;
  lon?: number;
};

export interface UserIpActivity {
  id: number;
  ip_address: string;
  region: string;
  country: string;
  /**
     * Majority-vote country across providers (alpha-2); null when unresolved.
     * @nullable
     */
  effective_country: string | null;
  /** Agreement between Abstract (country) and the geo_sources providers. */
  confidence_level: ConfidenceLevelEnum;
  city: string;
  coordinates: UserIpActivityCoordinates;
  /** @nullable */
  trading_account_login: string | null;
  /** @nullable */
  trading_account_phase: string | null;
  /** @nullable */
  trading_account_phase_display_name: string | null;
  /** @nullable */
  user_id: number | null;
  type: string;
  /**
     * VPN/proxy flag from Abstract; null when the country was resolved by a fallback provider.
     * @nullable
     */
  is_vpn: boolean | null;
  allowlisted: boolean;
  activity_type: IpActivityTypeEnum;
  created_at: string;
}

export interface UserIpActivitiesResponse {
  collection?: UserIpActivity[];
}

export interface Platforms {[key: string]: string}

export type UserIpActivitiesFilterMetadataResponseFields = {
  activity_types: string[];
  platforms: Platforms;
  phases: string[];
  trading_account_logins: (string | null)[];
};

export interface UserIpActivitiesFilterMetadataResponse {
  count: number;
  fields: UserIpActivitiesFilterMetadataResponseFields;
}

export type EmailLogsListResponseCollectionItemUser = {
  id?: number;
  name?: string;
};

export type EmailLogsListResponseCollectionItem = {
  id: number;
  subject: string;
  created_at: string;
  user: EmailLogsListResponseCollectionItemUser;
};

export interface EmailLogsListResponse {
  collection?: EmailLogsListResponseCollectionItem[];
  meta?: PaginationMeta;
}

export interface EmailLogResponse {
  meta: string;
  document: string;
}

/**
 * Account status.
 */
export type TradingAccountStatusEnum = typeof TradingAccountStatusEnum[keyof typeof TradingAccountStatusEnum];


export const TradingAccountStatusEnum = {
  new: 'new',
  ongoing: 'ongoing',
  not_passed: 'not_passed',
  passed: 'passed',
  in_review: 'in_review',
  pending_verification: 'pending_verification',
  rejected: 'rejected',
  prime_onboarding: 'prime_onboarding',
  prime_merged: 'prime_merged',
  onboarding: 'onboarding',
  refunded: 'refunded',
  expired: 'expired',
  closed: 'closed',
} as const;

export type ChallengesFilterMetadataResponseFields = {
  statuses: TradingAccountStatusEnum[];
  account_types: AccountTypeEnum[];
  phases: PhaseEnum[];
  platforms: Platforms;
  account_sizes: AccountSizeEnum[];
};

export interface ChallengesFilterMetadataResponse {
  count: number;
  fields: ChallengesFilterMetadataResponseFields;
}

export interface ChallengeTradingAccount {
  /** The ID of the trading account. */
  id: number;
  /** Login for the trading account. */
  login: string;
  /**
     * The ID of the user associated with the trading account.
     * @nullable
     */
  user_id?: number | null;
  account_size: AccountSizeEnum;
  /** The account size in USD. */
  account_size_usd: number;
  account_type: AccountTypeEnum;
  /** The timestamp when the challenge was created, in ISO 8601 format. */
  started_at: string;
  /**
     * The timestamp when the challenge was ended, in ISO 8601 format.
     * @nullable
     */
  ended_at: string | null;
  platform: PlatformEnum;
  phase: PhaseEnum;
  phase_display_name: string;
  status: TradingAccountStatusEnum;
  /** Trading enabled flag. */
  trading_enabled: boolean;
  actions: ActionList;
  currency: Currency;
}

/**
 * Details of the payment, including identifiers.
 */
export type ChallengePaymentSessionPaymentDetails = {
  /**
     * Identifier for the payment.
     * @nullable
     */
  payment_identifier?: string | null;
  /**
     * Identifier for the invoice.
     * @nullable
     */
  invoice_identifier?: string | null;
  /**
     * Identifier for the Stripe event.
     * @nullable
     */
  stripe_event_identifier?: string | null;
  /**
     * Identifier for the Stripe checkout session.
     * @nullable
     */
  stripe_checkout_session_identifier?: string | null;
  /**
     * Identifier for the Stripe payment intent.
     * @nullable
     */
  stripe_payment_intent_identifier?: string | null;
};

export interface ChallengePaymentSession {
  /** The ID of the payment session. */
  id?: number;
  /** Type of the charge, capitalized. */
  charge_type?: string;
  /** Payment provider used for the session, capitalized. */
  provider?: string;
  /** Details of the payment, including identifiers. */
  payment_details?: ChallengePaymentSessionPaymentDetails;
  /**
     * IP address from which the transaction was made, including region and country.
     * @nullable
     */
  transaction_ip_address?: string | null;
  /** Path to generate the invoice for this payment session, use as GET request. */
  generate_invoice_path?: string;
}

export interface ChallengeAddon {
  /** The ID of the template addon. */
  id: number;
  /** Trading/payout rule the addon applies to. */
  rule_name: string;
  /** Raw addon value. */
  value: string;
  /**
     * Group the addon belongs to.
     * @nullable
     */
  group_name: string | null;
  /**
     * Optional addon note.
     * @nullable
     */
  description: string | null;
  /** Price impact of the addon, from a fixed amount or a percentage of the template purchase price. */
  price_delta: number;
  /** Platforms the addon is available for; empty means all. */
  platforms: string[];
  /**
     * Unit of the addon rule value (e.g. "%", "$", "day").
     * @nullable
     */
  units: string | null;
}

/**
 * Status.
 */
export type ChallengeStatus = typeof ChallengeStatus[keyof typeof ChallengeStatus];


export const ChallengeStatus = {
  ongoing: 'ongoing',
  ended: 'ended',
} as const;

export interface Challenge {
  /** The ID of the challenge. */
  id: number;
  /** Status. */
  status: ChallengeStatus;
  /**
     * Size of the account.
     * @nullable
     */
  account_size: number | null;
  account_type: AccountTypeEnum;
  platform: PlatformEnum;
  /** The timestamp when the challenge was created, in ISO 8601 format. */
  created_at: string;
  trading_accounts: ChallengeTradingAccount[];
  payment_sessions?: ChallengePaymentSession[];
  addons?: ChallengeAddon[];
}

export interface ChallengesListResponse {
  collection?: Challenge[];
}

export type ChallengeCreated = Challenge;

export type BankAccountMethodBankDetailsAnyOf = { [key: string]: unknown };

/**
 * @nullable
 */
export type BankAccountMethodBankDetails = BankAccountMethodBankDetailsAnyOf | null;

export type BankAccountMethodStatus = typeof BankAccountMethodStatus[keyof typeof BankAccountMethodStatus];


export const BankAccountMethodStatus = {
  unverified: 'unverified',
  in_progress: 'in_progress',
  verified: 'verified',
  unsupported: 'unsupported',
} as const;

export interface BankAccountMethod {
  id: number;
  /** @nullable */
  bank_details?: BankAccountMethodBankDetails;
  /** @nullable */
  payment_type: string | null;
  sepa: boolean;
  /** @nullable */
  kyc_form_url?: string | null;
  /** @nullable */
  kyc_verification_identifier?: string | null;
  status: BankAccountMethodStatus;
  uuid: string;
  created_at: string;
  updated_at: string;
  user_id: number;
}

export interface BankAccountsResponse {
  collection?: BankAccountMethod[];
}

export type CryptoWalletMethodConfirmationStatus = typeof CryptoWalletMethodConfirmationStatus[keyof typeof CryptoWalletMethodConfirmationStatus];


export const CryptoWalletMethodConfirmationStatus = {
  pending: 'pending',
  active: 'active',
} as const;

export type CryptoWalletMethodCurrency = typeof CryptoWalletMethodCurrency[keyof typeof CryptoWalletMethodCurrency];


export const CryptoWalletMethodCurrency = {
  usdt: 'usdt',
  usdc: 'usdc',
} as const;

export type CryptoWalletMethodProtocol = typeof CryptoWalletMethodProtocol[keyof typeof CryptoWalletMethodProtocol];


export const CryptoWalletMethodProtocol = {
  trc20: 'trc20',
  erc20: 'erc20',
} as const;

export interface CryptoWalletMethod {
  id: number;
  address: string;
  confirmation_status: CryptoWalletMethodConfirmationStatus;
  /** @nullable */
  confirmed_at?: string | null;
  currency: CryptoWalletMethodCurrency;
  /** @nullable */
  discarded_at?: string | null;
  name: string;
  protocol: CryptoWalletMethodProtocol;
  user_id: number;
  created_at: string;
  updated_at: string;
}

export interface CryptoWalletsResponse {
  collection?: CryptoWalletMethod[];
}

export interface PaymentCardMethod {
  id: number;
  user_id: number;
  /** @nullable */
  brand: string | null;
  first4: string;
  last4: string;
  /** @nullable */
  holder_name?: string | null;
  exp_month: number;
  exp_year: number;
  /** @nullable */
  verification_status?: string | null;
  created_at: string;
  updated_at: string;
}

export interface PaymentCardsResponse {
  collection?: PaymentCardMethod[];
}

/**
 * Acceptance source of the policy.
 */
export type PolicyAcceptanceSourceEnum = typeof PolicyAcceptanceSourceEnum[keyof typeof PolicyAcceptanceSourceEnum];


export const PolicyAcceptanceSourceEnum = {
  registration: 'registration',
  purchase_gate: 'purchase_gate',
  preference_center: 'preference_center',
  withdrawal_gate: 'withdrawal_gate',
  legacy_unknown: 'legacy_unknown',
  ib_onboarding_gate: 'ib_onboarding_gate',
} as const;

/**
 * Scope of the policy.
 */
export type PolicyScopeEnum = typeof PolicyScopeEnum[keyof typeof PolicyScopeEnum];


export const PolicyScopeEnum = {
  registration: 'registration',
  purchase: 'purchase',
  withdrawal: 'withdrawal',
  ib_onboarding: 'ib_onboarding',
  other: 'other',
} as const;

export interface PolicyAcceptance {
  /** Policy acceptance record ID */
  id: number;
  /** ID of the accepted policy */
  policy_id: number;
  /** Title of the accepted policy */
  policy_title: string;
  /** Slug of the accepted policy */
  policy_slug: string;
  /** Scope of the accepted policy */
  policy_scope: PolicyScopeEnum;
  /** Policy version the user accepted */
  policy_version: string;
  /** Timestamp when the policy was accepted */
  accepted_at: string;
  /** Surface where the acceptance was captured */
  source: PolicyAcceptanceSourceEnum;
  /**
     * IP address recorded at acceptance time, null if redacted
     * @nullable
     */
  recorded_ip?: string | null;
  /**
     * User-agent string recorded at acceptance time, null if redacted
     * @nullable
     */
  user_agent?: string | null;
  /**
     * Timestamp when provenance data (IP, user-agent) was redacted
     * @nullable
     */
  provenance_redacted_at: string | null;
  /**
     * Public URL of the accepted policy, null when the linked policy has no URL
     * @nullable
     */
  download_url: string | null;
}

export interface PolicyAcceptancesResponse {
  collection: PolicyAcceptance[];
  meta: PaginationMeta;
}

export type PolicyAcceptancesFilterMetadataResponseFields = {
  /** All possible acceptance source values */
  sources: PolicyAcceptanceSourceEnum[];
  /** All possible policy scope values */
  policy_scopes: PolicyScopeEnum[];
};

export interface PolicyAcceptancesFilterMetadataResponse {
  /** Total number of policy acceptances matching the current filter */
  count: number;
  fields: PolicyAcceptancesFilterMetadataResponseFields;
}

/**
 * Origin of the document
 */
export type KycDocumentSource = typeof KycDocumentSource[keyof typeof KycDocumentSource];


export const KycDocumentSource = {
  kycaid: 'kycaid',
} as const;

/**
 * KYCAID document type stored in blob metadata
 * @nullable
 */
export type KycDocumentKycaidDocumentType = typeof KycDocumentKycaidDocumentType[keyof typeof KycDocumentKycaidDocumentType] | null;


export const KycDocumentKycaidDocumentType = {
  GOVERNMENT_ID: 'GOVERNMENT_ID',
  PASSPORT: 'PASSPORT',
  DOMESTIC_PASSPORT: 'DOMESTIC_PASSPORT',
  PERMANENT_RESIDENCE_PERMIT: 'PERMANENT_RESIDENCE_PERMIT',
  DRIVERS_LICENSE: 'DRIVERS_LICENSE',
  FOREIGN_CITIZEN_PASSPORT: 'FOREIGN_CITIZEN_PASSPORT',
  ADDRESS_DOCUMENT: 'ADDRESS_DOCUMENT',
  CREDIT_CARD: 'CREDIT_CARD',
} as const;

/**
 * Side of the KYCAID document (front or back) stored in blob metadata
 * @nullable
 */
export type KycDocumentKycaidDocumentSide = typeof KycDocumentKycaidDocumentSide[keyof typeof KycDocumentKycaidDocumentSide] | null;


export const KycDocumentKycaidDocumentSide = {
  front: 'front',
  back: 'back',
} as const;

export interface KycDocument {
  /** Active Storage attachment ID */
  id: number;
  /** Active Storage blob ID */
  blob_id: number;
  /** Stored filename */
  filename: string;
  /**
     * MIME type of the file
     * @nullable
     */
  content_type: string | null;
  /** File size in bytes */
  byte_size: number;
  /** Timestamp when the file was attached */
  attached_at: string;
  /** Origin of the document */
  source: KycDocumentSource;
  /**
     * Pre-signed download URL, valid for 10 minutes
     * @nullable
     */
  download_url?: string | null;
  /**
     * KYCAID document identifier stored in blob metadata
     * @nullable
     */
  kycaid_document_id?: string | null;
  /**
     * KYCAID document type stored in blob metadata
     * @nullable
     */
  kycaid_document_type?: KycDocumentKycaidDocumentType;
  /**
     * KYCAID document status stored in blob metadata
     * @nullable
     */
  kycaid_document_status?: string | null;
  /**
     * Side of the KYCAID document (front or back) stored in blob metadata
     * @nullable
     */
  kycaid_document_side?: KycDocumentKycaidDocumentSide;
}

export interface KycDocumentsResponse {
  collection?: KycDocument[];
}

/**
 * Questionnaire type identifier.
 */
export type QuestionnaireType = typeof QuestionnaireType[keyof typeof QuestionnaireType];


export const QuestionnaireType = {
  onboarding: 'onboarding',
  ib_onboarding: 'ib_onboarding',
} as const;

/**
 * Overall completion state across the questionnaire's steps for the "onboarding" type; for "ib_onboarding" this is the user's IbProfile application status instead.
 */
export type QuestionnaireStatus = typeof QuestionnaireStatus[keyof typeof QuestionnaireStatus];


export const QuestionnaireStatus = {
  not_started: 'not_started',
  in_progress: 'in_progress',
  completed: 'completed',
  questionnaire_pending: 'questionnaire_pending',
  approval_pending: 'approval_pending',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export interface Questionnaire {
  /** Questionnaire type identifier. */
  type: QuestionnaireType;
  title: string;
  /** Overall completion state across the questionnaire's steps for the "onboarding" type; for "ib_onboarding" this is the user's IbProfile application status instead. */
  status: QuestionnaireStatus;
  /**
     * Path to the questionnaire's detail endpoint, or null if that questionnaire type doesn't have one yet.
     * @nullable
     */
  url: string | null;
}

export interface QuestionnairesResponse {
  collection?: Questionnaire[];
}

/**
 * Input kind.
 */
export type QuestionnaireStepSectionInputsItemType = typeof QuestionnaireStepSectionInputsItemType[keyof typeof QuestionnaireStepSectionInputsItemType];


export const QuestionnaireStepSectionInputsItemType = {
  text: 'text',
  selector: 'selector',
  phone: 'phone',
} as const;

/**
 * Country-shaped option (nationality, country of residence, ...).
 */
export type QuestionnaireStepSectionInputsItemOptionsItemOneOf = {
  /** Country ISO code. */
  id: string;
  /** Country name. */
  value: string;
};

export type QuestionnaireStepSectionInputsItemOptionsItem = string | QuestionnaireStepSectionInputsItemOptionsItemOneOf;

/**
 * Present on conditional inputs. This input is required (and shown) only when the named parent input's answer equals — or, for a multi-select parent, includes — the given value.
 */
export type QuestionnaireStepSectionInputsItemRequiredIf = {[key: string]: string};

/**
 * Phone number (phone inputs only).
 */
export type QuestionnaireStepSectionInputsItemValueOneOf = {
  dial_code?: string;
  number?: string;
};

/**
 * The user's saved value for this input, or null if not yet filled. Selector values are the option's "id" (for id/value-shaped options like countries) or the option string itself.
 */
export type QuestionnaireStepSectionInputsItemValue = string | string[] | QuestionnaireStepSectionInputsItemValueOneOf | null;

export type QuestionnaireStepSectionInputsItem = {
  id: string;
  label: string;
  /** Input kind. */
  type: QuestionnaireStepSectionInputsItemType;
  /** Whether this input is currently required, resolved against the user's other saved answers (accounts for "required_if" conditions — e.g. a "specify other" input is only required once its parent selector's answer triggers it). */
  required: boolean;
  /** Allowed values for selector inputs. */
  options?: QuestionnaireStepSectionInputsItemOptionsItem[];
  /** Whether a selector accepts multiple values. */
  multiple?: boolean;
  /** Present on conditional inputs. This input is required (and shown) only when the named parent input's answer equals — or, for a multi-select parent, includes — the given value. */
  required_if?: QuestionnaireStepSectionInputsItemRequiredIf;
  /** @nullable */
  placeholder?: string | null;
  /** The user's saved value for this input, or null if not yet filled. Selector values are the option's "id" (for id/value-shaped options like countries) or the option string itself. */
  value?: QuestionnaireStepSectionInputsItemValue;
};

export interface QuestionnaireStepSection {
  title: string;
  inputs: QuestionnaireStepSectionInputsItem[];
}

/**
 * "kyc" for the final verification step, "default" for regular form steps.
 */
export type QuestionnaireStepType = typeof QuestionnaireStepType[keyof typeof QuestionnaireStepType];


export const QuestionnaireStepType = {
  default: 'default',
  kyc: 'kyc',
} as const;

/**
 * KYC verification status (KYC step only).
 * @nullable
 */
export type QuestionnaireStepKycStatus = typeof QuestionnaireStepKycStatus[keyof typeof QuestionnaireStepKycStatus] | null;


export const QuestionnaireStepKycStatus = {
  unverified: 'unverified',
  verified: 'verified',
  pending: 'pending',
  identity_verified: 'identity_verified',
} as const;

export interface QuestionnaireStep {
  /** Step identifier (slug). */
  id: string;
  title: string;
  /** "kyc" for the final verification step, "default" for regular form steps. */
  type: QuestionnaireStepType;
  completed: boolean;
  sections: QuestionnaireStepSection[];
  /**
     * KYC verification status (KYC step only).
     * @nullable
     */
  kyc_status?: QuestionnaireStepKycStatus;
  /**
     * kycaid form URL to complete verification (KYC step only).
     * @nullable
     */
  kyc_form_url?: string | null;
}

/**
 * Questionnaire type identifier.
 */
export type QuestionnaireDetailType = typeof QuestionnaireDetailType[keyof typeof QuestionnaireDetailType];


export const QuestionnaireDetailType = {
  onboarding: 'onboarding',
  ib_onboarding: 'ib_onboarding',
} as const;

export type QuestionnaireDetailCapabilities = {
  /** Whether the current admin can create this questionnaire. */
  create: boolean;
  /** Whether the current admin can update this questionnaire. */
  update: boolean;
};

export interface QuestionnaireDetail {
  /** Questionnaire type identifier. */
  type: QuestionnaireDetailType;
  title: string;
  /** Overall questionnaire state. For "onboarding", the completion state across the questionnaire's steps (not_started/in_progress/completed). For "ib_onboarding", the IB application's review status (not_started if the user has no IB profile yet, otherwise the profile's own status: questionnaire_pending/approval_pending/approved/rejected). */
  status: string;
  steps: QuestionnaireStep[];
  actions: ActionList;
  capabilities?: QuestionnaireDetailCapabilities;
}

export interface OnboardingQuestionnaireResponse {
  /**
     * @minItems 1
     * @maxItems 1
     */
  collection?: QuestionnaireDetail[];
}

export interface IbOnboardingQuestionnaireResponse {
  /**
     * @minItems 1
     * @maxItems 1
     */
  collection?: QuestionnaireDetail[];
}

/**
 * The IB onboarding step to save.
 */
export type SaveIbOnboardingStepRequestBodyStepId = typeof SaveIbOnboardingStepRequestBodyStepId[keyof typeof SaveIbOnboardingStepRequestBodyStepId];


export const SaveIbOnboardingStepRequestBodyStepId = {
  business_information: 'business_information',
  client_base_information: 'client_base_information',
  marketing_acquisition: 'marketing_acquisition',
  compliance_verification: 'compliance_verification',
} as const;

/**
 * The submitted inputs for the step, keyed by input id. Submitted blank values overwrite previously-saved values so optional or conditional answers can be cleared.
 */
export type SaveIbOnboardingStepRequestBodyData = { [key: string]: unknown };

export interface SaveIbOnboardingStepRequestBody {
  /** The IB onboarding step to save. */
  step_id: SaveIbOnboardingStepRequestBodyStepId;
  /** The submitted inputs for the step, keyed by input id. Submitted blank values overwrite previously-saved values so optional or conditional answers can be cleared. */
  data?: SaveIbOnboardingStepRequestBodyData;
}

/**
 * Always "default" for IB onboarding steps.
 */
export type IbOnboardingDetailsSerializerStepsItemType = typeof IbOnboardingDetailsSerializerStepsItemType[keyof typeof IbOnboardingDetailsSerializerStepsItemType];


export const IbOnboardingDetailsSerializerStepsItemType = {
  default: 'default',
} as const;

/**
 * Input kind.
 */
export type IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItemType = typeof IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItemType[keyof typeof IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItemType];


export const IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItemType = {
  text: 'text',
  selector: 'selector',
} as const;

/**
 * Present on conditional inputs. This input is required (and shown) only when the named parent input's answer equals — or, for a multi-select parent, includes — the given value.
 */
export type IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItemRequiredIf = {[key: string]: string};

export type IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItem = {
  id: string;
  label: string;
  /** Input kind. */
  type: IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItemType;
  required?: boolean;
  /** Allowed values for selector inputs. */
  options?: string[];
  /** Whether a selector accepts multiple values. */
  multiple?: boolean;
  /** Present on conditional inputs. This input is required (and shown) only when the named parent input's answer equals — or, for a multi-select parent, includes — the given value. */
  required_if?: IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItemRequiredIf;
  /** @nullable */
  placeholder?: string | null;
  /** The user's saved value for this input, or null if not yet filled. Shape depends on the input type (string, or array for multi-selectors). */
  value?: unknown;
};

export type IbOnboardingDetailsSerializerStepsItemSectionsItem = {
  title: string;
  inputs: IbOnboardingDetailsSerializerStepsItemSectionsItemInputsItem[];
};

export type IbOnboardingDetailsSerializerStepsItem = {
  /** Step identifier (slug). */
  id: string;
  title: string;
  /** Always "default" for IB onboarding steps. */
  type: IbOnboardingDetailsSerializerStepsItemType;
  completed: boolean;
  sections: IbOnboardingDetailsSerializerStepsItemSectionsItem[];
};

export interface IbOnboardingDetailsSerializer {
  /** True when every step is complete. */
  completed: boolean;
  steps: IbOnboardingDetailsSerializerStepsItem[];
}

export type ChallengesNewResponseTemplates = {[key: string]: string};

export interface ChallengesNewResponse {
  platforms: Platforms;
  templates: ChallengesNewResponseTemplates;
}

export interface TradingAccount {
  /** Number of payouts made from the trading account. */
  payout_count: number;
  /** Current equity of the trading account. */
  equity: number;
  /**
     * Current profit of the trading account.
     * @nullable
     */
  profit: number | null;
  /** Current balance of the trading account. */
  balance: number;
  /** Name for the trading account. */
  name: string;
  /** The ID of the trading account. */
  id: number;
  /** Login for the trading account. */
  login: string;
  /**
     * The ID of the user associated with the trading account.
     * @nullable
     */
  user_id: number | null;
  account_size: AccountSizeEnum;
  /** The account size in USD. */
  account_size_usd: number;
  account_type: AccountTypeEnum;
  /** The timestamp when the challenge was created, in ISO 8601 format. */
  started_at: string;
  /**
     * The timestamp when the challenge was ended, in ISO 8601 format.
     * @nullable
     */
  ended_at: string | null;
  platform: PlatformEnum;
  phase: string;
  phase_display_name: string;
  status: TradingAccountStatusEnum;
  tag_list: Tags;
  created_at?: string;
  currency: Currency;
  /** Whether Prime transition mode is active for this account directly or through the user. */
  prime_transition_active: boolean;
}

export interface TradingAccountsListResponse {
  collection?: TradingAccount[];
  meta?: PaginationMeta;
}

export type TradingAccountsFilterMetadataResponseFields = {
  /** Url to be used to search for the users based on search_field parameter to be added */
  user_search_path: string;
  tags: Tags;
  statuses: string[];
  account_types: AccountTypeEnum[];
  phases: PhaseEnum[];
  platforms: Platforms;
  account_sizes: AccountSizeEnum[];
  currencies: CurrenciesFilter;
};

export interface TradingAccountsFilterMetadataResponse {
  count: number;
  fields: TradingAccountsFilterMetadataResponseFields;
  bulk_actions: BulkAction[];
}

/**
 * Trading server.
 */
export type TradingServerEnum = typeof TradingServerEnum[keyof typeof TradingServerEnum];


export const TradingServerEnum = {
  FundingPips: 'FundingPips',
  FundingTicks: 'FundingTicks',
  FPIPS: 'FPIPS',
} as const;

export type AgreementType = typeof AgreementType[keyof typeof AgreementType];


export const AgreementType = {
  onboarding: 'onboarding',
  change: 'change',
  prime_onboarding: 'prime_onboarding',
} as const;

export type AgreementStatus = typeof AgreementStatus[keyof typeof AgreementStatus];


export const AgreementStatus = {
  sent: 'sent',
  signed: 'signed',
  withdrawn: 'withdrawn',
  declined: 'declined',
} as const;

export interface Agreement {
  id: number;
  contract_url: string;
  contract_identifier: string;
  agreement_type: AgreementType;
  status: AgreementStatus;
  actions: ActionList;
}

export interface TradingAccountStatisticsResponse {
  created_at: string;
  /** @nullable */
  started_at: string | null;
  /** @nullable */
  ended_at: string | null;
  trading_server: TradingServerEnum;
  group: string;
  platform: PlatformEnum;
  payout_count: number;
  /** @nullable */
  profit_split_percentage: number | null;
  payout_cycle: ChallengePayoutCycleEnum;
  /** @nullable */
  next_payout_at: string | null;
  account_size: number;
  consistency_factor: number;
  consistency_score: number;
  challenge_risk_score: number;
  risk_score: number;
  ip_address_score: number;
  similar_trade_score: number;
  similar_trade_with_ip_score: number;
  quick_profit_score: number;
  stripe_fingerprint_score: number;
  agreements: Agreement[];
}

export interface TradingAccountWidgetsResponse {
  collection?: Widget[];
}

/**
 * Details about the trading account's balance reconciliation.
 */
export interface ReconcileDetails {
  /** Total profit/loss from all closed positions. */
  closed_positions_profit?: string;
  /** Sum of all balance adjustment actions (deposits, withdrawals, adjustments). */
  balance_actions?: string;
  /** Total commissions charged on the account. Retained for backward compatibility; always "0.0". */
  commissions?: string;
  /** Calculated expected balance (closed_positions_profit + balance_actions - commissions). */
  expected_balance?: string;
  /** The current actual balance of the trading account. */
  current_balance?: string;
  /** Indicates if the current balance matches the expected balance within 1% tolerance of account size. */
  does_balance_match?: boolean;
}

/**
 * Details about the refund. Only present when status is refunded.
 */
export type DetailedTradingAccountRefundDetails = {
  /** Status of the refund. */
  refund_status?: string;
  /** Address where the refund was sent. */
  refund_address?: string;
  /** Confirmo ID for the refund. */
  confirmo_id?: string;
  /** Amount that was paid and refunded. */
  amount_paid?: number;
  /** User id who initiated a refund. */
  refunded_by_id?: number;
  /** User name who initiated a refund. */
  refunded_by_name?: string;
};

export interface DetailedTradingAccount {
  /** The ID of the trading account. */
  id: number;
  /** Login for the trading account. */
  login: string;
  /** Password for the trading account. */
  password: string;
  /** Investor password for the trading account. */
  investor_password: string;
  /**
     * The ID of the user associated with the trading account.
     * @nullable
     */
  user_id: number | null;
  account_size: AccountSizeEnum;
  /** The account size in USD. */
  account_size_usd: number;
  account_type: AccountTypeEnum;
  /** The timestamp when the challenge was created, in ISO 8601 format. */
  started_at: string;
  /**
     * The timestamp when the challenge was ended, in ISO 8601 format.
     * @nullable
     */
  ended_at: string | null;
  platform: PlatformEnum;
  phase: string;
  phase_display_name: string;
  status: TradingAccountStatusEnum;
  /** Trading enabled flag. */
  trading_enabled: boolean;
  /** Whether Prime transition mode is active for this account directly or through the user. */
  prime_transition_active: boolean;
  /** Whether rewards/payouts can be requested for this account. */
  payouts_allowed: boolean;
  tag_list: Tags;
  /**
     * External identifier.
     * @nullable
     */
  external_identifier: string | null;
  /** Leverage of the trading account. */
  leverage?: number;
  actions: ActionList;
  /** Details about the refund. Only present when status is refunded. */
  refund_details?: DetailedTradingAccountRefundDetails;
  reconcile_details: ReconcileDetails;
  currency: Currency;
}

export type TradingAccountUpdateRequestTradingAccount = {
  min_trading_days?: number;
  max_loss_percentage?: number;
  profit_target_percentage?: number;
  max_daily_loss_percentage?: number;
  profit_split_percentage?: number;
  daily_lotsize_limit?: number;
  upgrade_template_id?: number;
};

export interface TradingAccountUpdateRequest {
  trading_account?: TradingAccountUpdateRequestTradingAccount;
}

export type TradingAccountUpdateResponseData = {
  trading_account: DetailedTradingAccount;
};

export interface TradingAccountUpdateResponse {
  message: string;
  data: TradingAccountUpdateResponseData;
}

export interface TradingAccountEditResponse {
  /**
     * Minimum number of trading days required.
     * @nullable
     */
  min_trading_days: number | null;
  /**
     * Maximum loss percentage allowed.
     * @nullable
     */
  max_loss_percentage: number | null;
  /**
     * Profit target percentage to achieve.
     * @nullable
     */
  profit_target_percentage: number | null;
  /**
     * Maximum daily loss percentage allowed.
     * @nullable
     */
  max_daily_loss_percentage: number | null;
  /**
     * Profit split percentage for the trader.
     * @nullable
     */
  profit_split_percentage: number | null;
  /**
     * Daily lot size limit for trading.
     * @nullable
     */
  daily_lotsize_limit: number | null;
  actions: ActionList;
}

export type CommonTradingAccountActionResponseData = {
  actionable_object: DetailedTradingAccount;
};

export interface CommonTradingAccountActionResponse {
  message: string;
  data: CommonTradingAccountActionResponseData;
}

/**
 * The payment method to use for the refund
 */
export type TradingAccountRefundRequestPaymentMethod = typeof TradingAccountRefundRequestPaymentMethod[keyof typeof TradingAccountRefundRequestPaymentMethod];


export const TradingAccountRefundRequestPaymentMethod = {
  paymaxis: 'paymaxis',
  confirmo: 'confirmo',
} as const;

export interface TradingAccountRefundRequest {
  /** The payment method to use for the refund */
  payment_method: TradingAccountRefundRequestPaymentMethod;
  /** The crypto wallet id for the refund (if applicable) */
  crypto_wallet_id?: number;
}

export interface TradingAccountSendEmailRequest {
  email_template_id: number;
}

export interface TradingAccountViolateRequest {
  email_template_id: number;
}

export interface TradingAccountReactivateRequest {
  email_template_id?: number;
}

export interface TradingAccountChangeLeverageRequest {
  leverage?: number;
}

export interface TradingAccountChangeGroupRequest {
  group_id: number;
}

export interface TradingAccountEnableTradingRequest {
  skip_activation_condition?: boolean;
}

/**
 * Rule name.
 */
export type TradingRulesEnum = typeof TradingRulesEnum[keyof typeof TradingRulesEnum];


export const TradingRulesEnum = {
  eod_trailing_loss: 'eod_trailing_loss',
  min_active_trading_days: 'min_active_trading_days',
  min_active_trading_days_for_period: 'min_active_trading_days_for_period',
  max_inactive_trading_days: 'max_inactive_trading_days',
  max_lots_exposure: 'max_lots_exposure',
  max_loss: 'max_loss',
  max_risk: 'max_risk',
  consistency_score: 'consistency_score',
  payout_target: 'payout_target',
  min_trading_days: 'min_trading_days',
  profit_target: 'profit_target',
  max_daily_loss: 'max_daily_loss',
  high_frequency_trading: 'high_frequency_trading',
  max_single_position_loss: 'max_single_position_loss',
} as const;

export interface TradingAccountAddNewRuleRequest {
  rule_name: TradingRulesEnum;
  /** The value for the selected rule */
  threshold: string;
}

export interface TradingAccountPerformMigrationRequest {
  new_platform?: PlatformEnum;
}

/**
 * The payout cycle
 */
export type TradingAccountSetPayoutCycleRequestPayoutCycle = typeof TradingAccountSetPayoutCycleRequestPayoutCycle[keyof typeof TradingAccountSetPayoutCycleRequestPayoutCycle];


export const TradingAccountSetPayoutCycleRequestPayoutCycle = {
  tuesday: 'tuesday',
  biweekly: 'biweekly',
  monthly: 'monthly',
  on_demand: 'on_demand',
  business_week: 'business_week',
} as const;

export interface TradingAccountSetPayoutCycleRequest {
  /** The payout cycle */
  payout_cycle: TradingAccountSetPayoutCycleRequestPayoutCycle;
}

export interface TradingAccountScaleUpRequest {
  /** The scale up percentage */
  percentage: number;
  /** The max daily loss percentage */
  max_daily_loss_percentage: number;
  /** The max loss percentage */
  max_loss_percentage: number;
}

export interface GenerateEvidenceReportRequest {
  /** The login of the child account to generate the evidence report for */
  child_login: string;
  /** The detection window in minutes for the evidence report */
  window_size: number;
  /** Whether to include trades from the same IP address in the evidence report */
  same_ip: boolean;
  /** Whether to include trades from the same client ID in the evidence report */
  same_cid: boolean;
  /** Whether to include trades from the same country in the evidence report */
  same_country: boolean;
  /** The start time for the evidence report (optional) */
  start_time?: string;
  /** The end time for the evidence report (optional) */
  end_time?: string;
  /** Whether to show volume or not in the report */
  show_volume: boolean;
}

export interface TradingAccountFilter {
  /** Search for trading accounts by trading account login */
  search_field?: string;
  /** Search by trading account ids */
  ids?: number[];
  /** Search by trading account login */
  login?: string;
  /** Search by user id linked to trading account */
  filter_user_id?: number;
  /** Search for trading accounts by account size from */
  account_size_from?: number;
  /** Search for trading accounts by account size to */
  account_size_to?: number;
  /** Search for trading accounts by account size in USD from */
  account_size_usd_from?: number;
  /** Search for trading accounts by account size in USD to */
  account_size_usd_to?: number;
  /** Search for trading accounts by started at from */
  started_at_from?: string;
  /** Search for trading accounts by started at to */
  started_at_to?: string;
  /** Search for trading accounts by ended at from */
  ended_at_from?: string;
  /** Search for trading accounts by ended at to */
  ended_at_to?: string;
  /** Search for trading accounts by balance from */
  balance_from?: number;
  /** Search for trading accounts by balance to */
  balance_to?: number;
  /** Search for trading accounts by account type */
  account_type?: string[];
  /** Filter trading accounts by platform. */
  platform?: PlatformEnum[];
  /** Search for trading accounts by trading account phase */
  phase?: string[];
  /** Search for trading accounts by status */
  status?: string[];
  /** Search for trading accounts by tag list */
  tag_list?: string[];
}

/**
 * Sorting direction
 */
export type BulkActionsTradingAccountFiltersAllOfDirection = typeof BulkActionsTradingAccountFiltersAllOfDirection[keyof typeof BulkActionsTradingAccountFiltersAllOfDirection];


export const BulkActionsTradingAccountFiltersAllOfDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type BulkActionsTradingAccountFiltersAllOf = {
  /** Order by field name */
  field?: string;
  /** Sorting direction */
  direction?: BulkActionsTradingAccountFiltersAllOfDirection;
  /** Maximum number of results to return */
  limit?: number;
};

export type BulkActionsTradingAccountFilters = TradingAccountFilter & BulkActionsTradingAccountFiltersAllOf;

export interface CreateBulkReactivateTask {
  filters: BulkActionsTradingAccountFilters;
  note: string;
  email_template_id?: number;
}

export interface CommonTradingAccountBulkActionResponse {
  message: string;
}

export interface CreateBulkViolateTask {
  filters: BulkActionsTradingAccountFilters;
  note?: string;
  email_template_id: number;
}

export interface CreateBulkApproveTask {
  filters: BulkActionsTradingAccountFilters;
  note?: string;
}

export interface CreateBulkDisableTradingTask {
  filters: BulkActionsTradingAccountFilters;
}

export interface CreateBulkOnboardingTask {
  filters: BulkActionsTradingAccountFilters;
}

export interface CreateBulkSendEmailByLoginTask {
  filters: BulkActionsTradingAccountFilters;
  email_template_id: number;
}

export type TradingAccountIpActivityCoordinates = {
  lat?: number;
  lon?: number;
};

export interface TradingAccountIpActivity {
  id: number;
  ip_address: string;
  user_id: number;
  region: string;
  country: string;
  /**
     * Majority-vote country across providers (alpha-2); null when unresolved.
     * @nullable
     */
  effective_country: string | null;
  /** Agreement between Abstract (country) and the geo_sources providers. */
  confidence_level: ConfidenceLevelEnum;
  city: string;
  coordinates: TradingAccountIpActivityCoordinates;
  /**
     * VPN/proxy flag from Abstract; null when the country was resolved by a fallback provider.
     * @nullable
     */
  is_vpn: boolean | null;
  allowlisted: boolean;
  activity_type: IpActivityTypeEnum;
  created_at: string;
}

export interface TradingAccountIpActivitiesResponse {
  collection?: TradingAccountIpActivity[];
}

export interface TradingAccountIpActivitiesFilterMetadataResponse {
  count: number;
}

export type PositionAction = typeof PositionAction[keyof typeof PositionAction];


export const PositionAction = {
  long: 'long',
  short: 'short',
} as const;

export interface Position {
  trading_account_id: number;
  login: string;
  /** Unique position identifier from the trading platform */
  identifier: string;
  instrument: string;
  action: PositionAction;
  lot_size: number;
  open_price: number;
  close_price: number;
  opened_at: string;
  closed_at: string;
}

/**
 * Type of trading pattern detected
 */
export type TradeFlag = typeof TradeFlag[keyof typeof TradeFlag];


export const TradeFlag = {
  copy: 'copy',
  reverse: 'reverse',
} as const;

export interface Trade {
  /** A unique identifier for the matching trade */
  id: string;
  /** Time lag in seconds between mother and child positions */
  lag: number;
  /** Type of trading pattern detected */
  flag: TradeFlag;
  /** Trading instrument symbol */
  instrument: string;
  mother_position: Position;
  child_position: Position;
}

export interface NewTradingEvidenceReportResponse {
  trades: Trade[];
}

export interface GenerateSelectedTradesEvidenceReportRequest {
  /** The login of the child account to generate the evidence report for */
  child_login: string;
  /** The detection window in minutes for the evidence report */
  window_size: number;
  /** Whether to include trades from the same IP address in the evidence report */
  same_ip: boolean;
  /** Whether to include trades from the same client ID in the evidence report */
  same_cid: boolean;
  /** Whether to include trades from the same country in the evidence report */
  same_country: boolean;
  /** The start time for the evidence report (optional) */
  start_time?: string;
  /** The end time for the evidence report (optional) */
  end_time?: string;
  trade_ids: string[];
  /** Whether to show vol or not in the report */
  show_volume: boolean;
}

export interface NewRiskParameterResponse {
  fields?: ActionFormField[];
}

export interface EditRiskParameterResponse {
  fields?: ActionFormField[];
}

export interface ConsistencyScoreOptions {
  calculate_from?: string;
  threshold_buffer?: number;
  max_daily_profit?: number;
}

export interface EodTrailingLossOptions {
  max_loss_amount?: number;
  trailing_limit?: number;
}

export interface MinActiveTradingDaysOptions {
  daily_profit_percentage?: number;
  start_date?: string;
}

export interface MinActiveTradingDaysForPeriodOptions {
  daily_profit_percentage?: number;
  start_date?: string;
  end_date?: string;
}

export interface MaxChallengeDurationOptions {
  starts_at?: string;
}

export interface MaxLossOptions {
  max_loss_percentage?: number;
  max_value?: number;
}

export interface MaxRiskOptions {
  max_risk_percentage?: number;
  max_value?: number;
}

export type PayoutTargetOptionsTiersItem = { [key: string]: unknown };

export interface PayoutTargetOptions {
  tier_index?: number;
  starting_balance?: number;
  tiers?: PayoutTargetOptionsTiersItem[];
}

export interface MinTradingDaysOptions {
  calculate_from?: string;
}

export interface ProfitTargetOptions {
  profit_target_percentage?: number;
  max_value?: number;
}

export interface MaxDailyLossOptions {
  max_daily_loss_percentage?: number;
  max_value?: number;
}

export interface HighFrequencyTradingOptions {
  calculate_from?: string;
  rule_type?: string;
}

export interface MaxSinglePositionLossOptions {
  max_single_position_loss_percentage?: number;
  calculate_from?: string;
}

export type NewsTradingOptionsViolatedPositionsItem = { [key: string]: unknown };

export interface NewsTradingOptions {
  violation_type?: string;
  max_hours_before_news_to_open_position?: number;
  violated_positions?: NewsTradingOptionsViolatedPositionsItem[];
  hold_during_news_restricted?: boolean;
}

export interface TrailingLossOptions {
  max_trailing_loss_percentage?: number;
  max_trailing_loss_amount?: number;
  max_threshold?: number;
}

export type RiskParameterAllOf = {
  id: number;
  trading_account_id: number;
  type: string;
  value: number;
  threshold: number;
  risk_level: string;
  status: string;
};

export type RiskParameterAllOfTwo = ConsistencyScoreOptions | EodTrailingLossOptions | MinActiveTradingDaysOptions | MinActiveTradingDaysForPeriodOptions | MaxChallengeDurationOptions | MaxLossOptions | MaxRiskOptions | PayoutTargetOptions | MinTradingDaysOptions | ProfitTargetOptions | MaxDailyLossOptions | HighFrequencyTradingOptions | MaxSinglePositionLossOptions | NewsTradingOptions | TrailingLossOptions;

export type RiskParameter = RiskParameterAllOf & RiskParameterAllOfTwo;

export interface RiskParametersListResponse {
  collection?: RiskParameter[];
}

export type CreateRiskParameterRequestAllOfRiskLevel = typeof CreateRiskParameterRequestAllOfRiskLevel[keyof typeof CreateRiskParameterRequestAllOfRiskLevel];


export const CreateRiskParameterRequestAllOfRiskLevel = {
  violation: 'violation',
  objective: 'objective',
} as const;

export type CreateRiskParameterRequestAllOf = {
  type: string;
  risk_level: CreateRiskParameterRequestAllOfRiskLevel;
  threshold: number;
  value?: number;
};

export type CreateRiskParameterRequestAllOfThree = ConsistencyScoreOptions | EodTrailingLossOptions | MinActiveTradingDaysOptions | MinActiveTradingDaysForPeriodOptions | MaxChallengeDurationOptions | MaxLossOptions | MaxRiskOptions | PayoutTargetOptions | MinTradingDaysOptions | ProfitTargetOptions | MaxDailyLossOptions | HighFrequencyTradingOptions | MaxSinglePositionLossOptions | NewsTradingOptions | TrailingLossOptions;

export type CreateRiskParameterRequest = CreateRiskParameterRequestAllOf & CreateRiskParameterRequestAllOfThree;

export type RiskParameterActionResponseData = {
  risk_parameter: RiskParameter;
};

export interface RiskParameterActionResponse {
  message: string;
  data: RiskParameterActionResponseData;
}

export type UpdateRiskParameterRequestAllOfRiskLevel = typeof UpdateRiskParameterRequestAllOfRiskLevel[keyof typeof UpdateRiskParameterRequestAllOfRiskLevel];


export const UpdateRiskParameterRequestAllOfRiskLevel = {
  violation: 'violation',
  objective: 'objective',
} as const;

export type UpdateRiskParameterRequestAllOf = {
  risk_level?: UpdateRiskParameterRequestAllOfRiskLevel;
  threshold: number;
  value?: number;
};

export type UpdateRiskParameterRequestAllOfThree = ConsistencyScoreOptions | EodTrailingLossOptions | MinActiveTradingDaysOptions | MinActiveTradingDaysForPeriodOptions | MaxChallengeDurationOptions | MaxLossOptions | MaxRiskOptions | PayoutTargetOptions | MinTradingDaysOptions | ProfitTargetOptions | MaxDailyLossOptions | HighFrequencyTradingOptions | MaxSinglePositionLossOptions | NewsTradingOptions | TrailingLossOptions;

export type UpdateRiskParameterRequest = UpdateRiskParameterRequestAllOf & UpdateRiskParameterRequestAllOfThree;

export type NewTemplateResponsePhaseOptionsItem = {
  label: string;
  value: string;
};

export type NewTemplateResponseAccountTypeOptionsItem = {
  label: string;
  value: string;
};

export type NewTemplateResponseAccountSizeOptionsItem = {
  label: string;
  value: number;
};

export type NewTemplateResponseTrailingLossMethodOptionsItem = {
  label: string;
  value: string;
};

export type NewTemplateResponseNewsTradingRuleOptionsItem = {
  label: string;
  value: string;
};

export type NewTemplateResponseActivationConditionOptionsItem = {
  label: string;
  value: string;
};

export type NewTemplateResponsePayoutCycleOptionsItem = {
  label: string;
  value: string;
};

export type NewTemplateResponseLeverageOptionsItem = {
  label: string;
  value: number;
};

export type NewTemplateResponseUpgradeTemplateOptionsItem = {
  label: string;
  value: number;
};

export interface NewTemplateResponse {
  phase_options: NewTemplateResponsePhaseOptionsItem[];
  account_type_options: NewTemplateResponseAccountTypeOptionsItem[];
  account_size_options: NewTemplateResponseAccountSizeOptionsItem[];
  trailing_loss_method_options: NewTemplateResponseTrailingLossMethodOptionsItem[];
  news_trading_rule_options: NewTemplateResponseNewsTradingRuleOptionsItem[];
  activation_condition_options: NewTemplateResponseActivationConditionOptionsItem[];
  payout_cycle_options: NewTemplateResponsePayoutCycleOptionsItem[];
  leverage_options: NewTemplateResponseLeverageOptionsItem[];
  upgrade_template_options: NewTemplateResponseUpgradeTemplateOptionsItem[];
}

export interface ListItemTemplate {
  id?: number;
  brand_id: number;
  brand_name: string;
  name: string;
  phase: string;
  phase_display_name: string;
  account_type: AccountTypeEnum;
  account_size: AccountSizeEnum;
  currency: string;
  /** @nullable */
  purchase_price?: number | null;
}

export interface ListTemplateResponse {
  collection?: ListItemTemplate[];
  meta?: PaginationMeta;
}

/**
 * Trailing Loss Method
 */
export type TrailingLossMethodsEnum = typeof TrailingLossMethodsEnum[keyof typeof TrailingLossMethodsEnum];


export const TrailingLossMethodsEnum = {
  equity: 'equity',
  balance: 'balance',
} as const;

/**
 * News Trading Rule
 */
export type NewsTradingRuleEnum = typeof NewsTradingRuleEnum[keyof typeof NewsTradingRuleEnum];


export const NewsTradingRuleEnum = {
  disabled: 'disabled',
  violate_account: 'violate_account',
  violate_position: 'violate_position',
} as const;

/**
 * Activation Condition
 * @nullable
 */
export type ActivationConditionEnum = typeof ActivationConditionEnum[keyof typeof ActivationConditionEnum] | null;


export const ActivationConditionEnum = {
  payout_cycle: 'payout_cycle',
  activation_fee: 'activation_fee',
  instant_verification: 'instant_verification',
  subscription_required: 'subscription_required',
} as const;

export interface CreateUpdateTemplateRequestBody {
  name: string;
  phase: PhaseEnum;
  account_type: AccountTypeEnum;
  account_size: AccountSizeEnum;
  /** @nullable */
  contract_identifier?: string | null;
  /** @nullable */
  min_trading_days?: number | null;
  /** @nullable */
  max_loss_percentage?: number | null;
  /** @nullable */
  max_eod_trailing_loss_percentage?: number | null;
  /** @nullable */
  min_eod_trailing_loss_percentage?: number | null;
  /** @nullable */
  max_trailing_loss_percentage?: number | null;
  /** @nullable */
  trailing_loss_lock_percentage?: number | null;
  trailing_loss_method?: TrailingLossMethodsEnum;
  /** @nullable */
  max_trades_without_sl?: number | null;
  /** @nullable */
  daily_lotsize_limit?: number | null;
  /** @nullable */
  max_single_position_loss_limit?: number | null;
  /** @nullable */
  max_single_price_movement_percentage?: number | null;
  /** @nullable */
  profit_target_percentage?: number | null;
  /** @nullable */
  max_daily_loss_percentage?: number | null;
  /** @nullable */
  max_challenge_duration_days?: number | null;
  /** @nullable */
  max_trading_inactivity_days?: number | null;
  /** @nullable */
  max_risk_percentage?: number | null;
  /** @nullable */
  upgrade_delay?: number | null;
  /** @nullable */
  news_trading_allowed?: boolean | null;
  news_trading_rule?: NewsTradingRuleEnum;
  /** @nullable */
  free_retry_enabled?: boolean | null;
  /** @nullable */
  extension_enabled?: boolean | null;
  /** @nullable */
  consistent_trading_percentage?: number | null;
  activation_condition?: ActivationConditionEnum | null;
  payout_cycle?: ChallengePayoutCycleEnum;
  /** @nullable */
  leverage?: number | null;
  kyc_onboarding_enabled: boolean;
  /** @nullable */
  upgrade_template_id?: number | null;
  /** @nullable */
  purchase_price?: number | null;
  default_template: boolean;
}

export interface DetailedTemplate {
  id: number;
  brand_id: number;
  brand_name: string;
  name: string;
  phase: string;
  phase_display_name: string;
  account_type: AccountTypeEnum;
  account_size: AccountSizeEnum;
  currency: string;
  /** @nullable */
  contract_identifier?: string | null;
  /** @nullable */
  min_trading_days?: number | null;
  /** @nullable */
  max_loss_percentage?: number | null;
  /** @nullable */
  max_eod_trailing_loss_percentage?: number | null;
  /** @nullable */
  min_eod_trailing_loss_percentage?: number | null;
  /** @nullable */
  max_trailing_loss_percentage?: number | null;
  /** @nullable */
  trailing_loss_lock_percentage?: number | null;
  /** @nullable */
  trailing_loss_method?: string | null;
  /** @nullable */
  max_trades_without_sl?: number | null;
  /** @nullable */
  daily_lotsize_limit?: number | null;
  /** @nullable */
  max_single_position_loss_limit?: number | null;
  /** @nullable */
  max_single_price_movement_percentage?: number | null;
  /** @nullable */
  profit_target_percentage?: number | null;
  /** @nullable */
  max_daily_loss_percentage?: number | null;
  /** @nullable */
  max_challenge_duration_days?: number | null;
  /** @nullable */
  max_trading_inactivity_days?: number | null;
  /** @nullable */
  max_risk_percentage?: number | null;
  /** @nullable */
  upgrade_delay?: number | null;
  /** @nullable */
  news_trading_allowed?: boolean | null;
  /** @nullable */
  news_trading_rule?: string | null;
  /** @nullable */
  free_retry_enabled?: boolean | null;
  /** @nullable */
  extension_enabled?: boolean | null;
  /** @nullable */
  consistent_trading_percentage?: number | null;
  /** @nullable */
  activation_condition?: string | null;
  /** @nullable */
  payout_cycle?: string | null;
  /** @nullable */
  leverage?: number | null;
  kyc_onboarding_enabled: boolean;
  /** @nullable */
  upgrade_template_id?: number | null;
  /** @nullable */
  purchase_price?: number | null;
  default_template: boolean;
}

export type TemplateCommonResponseData = {
  template: DetailedTemplate;
};

export interface TemplateCommonResponse {
  message: string;
  data: TemplateCommonResponseData;
}

export type EditTemplateResponseBrandOptionsItem = {
  label: string;
  value: number;
};

export type EditTemplateResponsePhaseOptionsItem = {
  label: string;
  value: string;
};

export type EditTemplateResponseAccountTypeOptionsItem = {
  label: string;
  value: string;
};

export type EditTemplateResponseAccountSizeOptionsItem = {
  label: string;
  value: number;
};

export type EditTemplateResponseTrailingLossMethod = TrailingLossMethodsEnum | null;

export type EditTemplateResponseTrailingLossMethodOptionsItem = {
  label: string;
  value: string;
};

export type EditTemplateResponseNewsTradingRule = NewsTradingRuleEnum | null;

export type EditTemplateResponseNewsTradingRuleOptionsItem = {
  label: string;
  value: string;
};

export type EditTemplateResponseActivationCondition = ActivationConditionEnum | null;

export type EditTemplateResponseActivationConditionOptionsItem = {
  label: string;
  value: string;
};

export type EditTemplateResponsePayoutCycle = ChallengePayoutCycleEnum | null;

export type EditTemplateResponsePayoutCycleOptionsItem = {
  label: string;
  value: string;
};

export type EditTemplateResponseLeverageOptionsItem = {
  label: string;
  value: number;
};

export type EditTemplateResponseUpgradeTemplateOptionsItem = {
  label: string;
  value: number;
};

export interface EditTemplateResponse {
  id: number;
  brand_id: number;
  brand_options: EditTemplateResponseBrandOptionsItem[];
  name: string;
  phase: PhaseEnum;
  phase_options: EditTemplateResponsePhaseOptionsItem[];
  account_type: AccountTypeEnum;
  account_type_options: EditTemplateResponseAccountTypeOptionsItem[];
  account_size: AccountSizeEnum;
  account_size_options: EditTemplateResponseAccountSizeOptionsItem[];
  /** @nullable */
  contract_identifier?: string | null;
  /** @nullable */
  min_trading_days?: number | null;
  /** @nullable */
  max_loss_percentage?: number | null;
  /** @nullable */
  max_eod_trailing_loss_percentage?: number | null;
  /** @nullable */
  min_eod_trailing_loss_percentage?: number | null;
  /** @nullable */
  max_trailing_loss_percentage?: number | null;
  /** @nullable */
  trailing_loss_lock_percentage?: number | null;
  trailing_loss_method?: EditTemplateResponseTrailingLossMethod;
  trailing_loss_method_options: EditTemplateResponseTrailingLossMethodOptionsItem[];
  /** @nullable */
  max_trades_without_sl?: number | null;
  /** @nullable */
  daily_lotsize_limit?: number | null;
  /** @nullable */
  max_single_position_loss_limit?: number | null;
  /** @nullable */
  max_single_price_movement_percentage?: number | null;
  /** @nullable */
  profit_target_percentage?: number | null;
  /** @nullable */
  max_daily_loss_percentage?: number | null;
  /** @nullable */
  max_challenge_duration_days?: number | null;
  /** @nullable */
  max_trading_inactivity_days?: number | null;
  /** @nullable */
  max_risk_percentage?: number | null;
  /** @nullable */
  upgrade_delay?: number | null;
  /** @nullable */
  news_trading_allowed?: boolean | null;
  news_trading_rule?: EditTemplateResponseNewsTradingRule;
  news_trading_rule_options: EditTemplateResponseNewsTradingRuleOptionsItem[];
  /** @nullable */
  free_retry_enabled?: boolean | null;
  /** @nullable */
  extension_enabled?: boolean | null;
  /** @nullable */
  consistent_trading_percentage?: number | null;
  activation_condition?: EditTemplateResponseActivationCondition;
  activation_condition_options: EditTemplateResponseActivationConditionOptionsItem[];
  payout_cycle?: EditTemplateResponsePayoutCycle;
  payout_cycle_options: EditTemplateResponsePayoutCycleOptionsItem[];
  /** @nullable */
  leverage?: number | null;
  leverage_options: EditTemplateResponseLeverageOptionsItem[];
  kyc_onboarding_enabled: boolean;
  /** @nullable */
  upgrade_template_id?: number | null;
  upgrade_template_options: EditTemplateResponseUpgradeTemplateOptionsItem[];
  /** @nullable */
  purchase_price?: number | null;
  /**
     * Display-only "was" price rendered as a strikethrough next to the purchase price; never charged.
     * @nullable
     */
  compare_at_price?: number | null;
  default_template: boolean;
}

export type TemplatesFilterMetadataResponseFieldsBrandsItem = {
  name: string;
  value: number;
};

export type TemplatesFilterMetadataResponseFields = {
  account_types: AccountTypeEnum[];
  account_sizes: AccountSizeEnum[];
  brands: TemplatesFilterMetadataResponseFieldsBrandsItem[];
  phases: PhaseEnum[];
  currencies: string[];
};

export interface TemplatesFilterMetadataResponse {
  count: number;
  fields: TemplatesFilterMetadataResponseFields;
}

export type PolicyScopeOptionsItem = {
  label: string;
  value: string;
};

export type PolicyScopeOptions = PolicyScopeOptionsItem[];

export type PolicyBrandOptionsItem = {
  label: string;
  value: number;
};

export type PolicyBrandOptions = PolicyBrandOptionsItem[];

export interface NewPolicyResponse {
  scope_options: PolicyScopeOptions;
  brand_options: PolicyBrandOptions;
}

export interface Policy {
  id: number;
  title: string;
  slug: string;
  scope: PolicyScopeEnum;
  version: string;
  effective_from: string;
  mandatory: boolean;
  /** @nullable */
  download_url?: string | null;
  brand_id: number;
  brand_name: string;
  created_at: string;
}

export interface ListPolicyResponse {
  collection: Policy[];
  meta: PaginationMeta;
}

export type CreatePolicyRequestBodyPolicy = {
  title: string;
  scope: PolicyScopeEnum;
  version: string;
  effective_from: string;
  mandatory?: boolean;
  /** @nullable */
  url?: string | null;
  brand_id: number;
};

export interface CreatePolicyRequestBody {
  policy: CreatePolicyRequestBodyPolicy;
}

export type PolicyCommonResponseData = {
  policy: Policy;
};

export interface PolicyCommonResponse {
  message: string;
  data: PolicyCommonResponseData;
}

export interface EditPolicyResponse {
  id: number;
  title: string;
  slug: string;
  scope: PolicyScopeEnum;
  /** @nullable */
  url: string | null;
  mandatory: boolean;
  brand_id: number;
  /** Fields the current user is permitted to update. Other fields remain visible but disabled. */
  editable_fields: string[];
  scope_options: PolicyScopeOptions;
  brand_options: PolicyBrandOptions;
}

export type UpdatePolicyRequestBodyPolicy = {
  mandatory?: boolean;
};

export interface UpdatePolicyRequestBody {
  policy: UpdatePolicyRequestBodyPolicy;
}

export type PoliciesFilterMetadataResponseFieldsBrandsItem = {
  name: string;
  value: number;
};

export type PoliciesFilterMetadataResponseFields = {
  scopes: PolicyScopeEnum[];
  brands: PoliciesFilterMetadataResponseFieldsBrandsItem[];
};

export interface PoliciesFilterMetadataResponse {
  count: number;
  fields: PoliciesFilterMetadataResponseFields;
}

export type PlatformOptionsItem = {
  label: string;
  value: string;
};

export type PlatformOptions = PlatformOptionsItem[];

export type AccountTypeOptionsItem = {
  label: string;
  value: string;
};

export type AccountTypeOptions = AccountTypeOptionsItem[];

export type PhaseOptionsItem = {
  label: string;
  value: string;
};

export type PhaseOptions = PhaseOptionsItem[];

export type CurrencyOptionsItem = {
  label: string;
  value: Currency;
};

export type CurrencyOptions = CurrencyOptionsItem[];

export type LeverageOptionsItem = {
  label: string;
  value: number;
};

export type LeverageOptions = LeverageOptionsItem[];

export type AccountSizeOptionsItem = {
  label: string;
  value: number;
};

export type AccountSizeOptions = AccountSizeOptionsItem[];

export interface NewGroupResponse {
  platform_options: PlatformOptions;
  account_type_options: AccountTypeOptions;
  phase_options: PhaseOptions;
  currency_options: CurrencyOptions;
  leverage_options: LeverageOptions;
  account_size_options: AccountSizeOptions;
}

/**
 * Leverage value.
 */
export type LeverageEnum = typeof LeverageEnum[keyof typeof LeverageEnum];


export const LeverageEnum = {
  NUMBER_2: 2,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_12: 12,
  NUMBER_30: 30,
  NUMBER_50: 50,
  NUMBER_100: 100,
} as const;

export interface Group {
  id: number;
  name: string;
  external_identifier: string;
  platform: PlatformEnum;
  account_type: AccountTypeEnum;
  phase: PhaseEnum;
  currency: Currency;
  leverage: LeverageEnum;
  swap_free: boolean;
  /** @nullable */
  account_size?: number | null;
  close_only: boolean;
  created_at: string;
}

export interface ListGroupResponse {
  collection: Group[];
  meta: PaginationMeta;
}

export type GroupRequestParametersAccountSize = AccountSizeEnum | null;

export interface GroupRequestParameters {
  name?: string;
  external_identifier?: string;
  platform?: PlatformEnum;
  account_type?: AccountTypeEnum;
  phase?: PhaseEnum;
  account_size?: GroupRequestParametersAccountSize;
  currency?: Currency;
  leverage?: LeverageEnum;
  swap_free?: boolean;
  close_only?: boolean;
}

export type CreateGroupRequestBodyGroup = GroupRequestParameters & unknown & Required<Pick<GroupRequestParameters & unknown, 'name' | 'external_identifier' | 'platform' | 'account_type' | 'phase' | 'swap_free' | 'leverage' | 'currency' | 'close_only'>>;

export interface CreateGroupRequestBody {
  group: CreateGroupRequestBodyGroup;
}

export type GroupCommonResponseData = {
  group: Group;
};

export interface GroupCommonResponse {
  message: string;
  data: GroupCommonResponseData;
}

export interface EditGroupResponse {
  id: number;
  name: string;
  external_identifier: string;
  platform: PlatformEnum;
  account_type: AccountTypeEnum;
  phase: PhaseEnum;
  currency: Currency;
  leverage: number;
  swap_free: boolean;
  /** @nullable */
  account_size?: number | null;
  close_only: boolean;
  platform_options: PlatformOptions;
  account_type_options: AccountTypeOptions;
  phase_options: PhaseOptions;
  currency_options: CurrencyOptions;
  leverage_options: LeverageOptions;
  account_size_options: AccountSizeOptions;
}

export interface UpdateGroupRequestBody {
  group: GroupRequestParameters;
}

export type GroupsFilterMetadataResponseFields = {
  account_types: AccountTypeEnum[];
  platforms: Platforms;
  phases: PhaseEnum[];
  currencies: Currency[];
  leverages: LeverageEnum[];
  account_sizes: AccountSizeEnum[];
};

export interface GroupsFilterMetadataResponse {
  count: number;
  fields: GroupsFilterMetadataResponseFields;
}

export interface RiskScoreFinancial {
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  overall_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  maximum_drawdown_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  winning_rate_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  risk_reward_ratio_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  sharpe_ratio_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  sortino_ratio_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  calmar_ratio_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  consistency_score: number | null;
}

export interface RiskScoreToxicity {
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  overall_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  matching_toxicity_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  ip_analysis_score: number | null;
}

export interface RiskScoreAbuse {
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  overall_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  profit_ratio_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  elr_score: number | null;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  inefficiency_ratio_score: number | null;
}

export interface TradingAccountRiskScore {
  /**
     * @minimum 1
     * @maximum 999999999
     */
  trading_account_id: number;
  login: string;
  /**
     * @minLength 2
     * @maxLength 32
     * @pattern ^[a-z0-9_-]+$
     */
  platform: string;
  /**
     * @minimum 0
     * @maximum 100
     * @nullable
     */
  score: number | null;
  financial: RiskScoreFinancial;
  toxicity: RiskScoreToxicity;
  abuse: RiskScoreAbuse;
}

export interface TradingAccountRiskScoresResponse {
  collection?: TradingAccountRiskScore[];
}

export interface SessionGetCreateResponse {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  timezone: string;
  role: string;
  super_user: boolean;
  keys: string[];
}

export type CreateTradingAccountResponseData = {
  trading_account: DetailedTradingAccount;
};

export interface CreateTradingAccountResponse {
  message: string;
  data: CreateTradingAccountResponseData;
}

export type TemplatePhase = typeof TemplatePhase[keyof typeof TemplatePhase];


export const TemplatePhase = {
  student: 'student',
  practitioner: 'practitioner',
  senior: 'senior',
  master: 'master',
} as const;

export interface Template {
  id: number;
  name: string;
  phase: TemplatePhase;
  phase_display_name: string;
  account_size: number;
  account_type: AccountTypeEnum;
  currency: string;
}

export interface NewTradingAccountResponse {
  templates: Template[];
  platforms: Platforms;
}

/**
 * Type of the flag
 */
export type TradingAccountFlagType = typeof TradingAccountFlagType[keyof typeof TradingAccountFlagType];


export const TradingAccountFlagType = {
  profit_1min_trades: 'profit_1min_trades',
  profit_5second_trades: 'profit_5second_trades',
  maximum_open_trades_at_once: 'maximum_open_trades_at_once',
  maximum_open_trades_at_once_per_symbol: 'maximum_open_trades_at_once_per_symbol',
  max_buy_sell_open_at_once_any: 'max_buy_sell_open_at_once_any',
  max_buy_sell_open_at_once_same_symbol: 'max_buy_sell_open_at_once_same_symbol',
  most_used_ip_matches_kyc_ip: 'most_used_ip_matches_kyc_ip',
  hft: 'hft',
} as const;

/**
 * Value of metric
 */
export type TradingAccountFlagDetailsItemValue = string | number;

export type TradingAccountFlagDetailsItem = {
  /** A metric of strategy */
  metric: string;
  /** Value of metric */
  value: TradingAccountFlagDetailsItemValue;
  /** Unit of the metric value */
  unit: string;
};

export interface TradingAccountFlag {
  /** Type of the flag */
  type: TradingAccountFlagType;
  /** Description of the flag */
  description: string;
  flagged: boolean;
  /** ID of the trading account */
  trading_account_id: number;
  details: TradingAccountFlagDetailsItem[];
}

export interface TradingAccountFlagsResponse {
  collection: TradingAccountFlag[];
}

/**
 * Severity of the violation
 */
export type TradingAccountViolationType = typeof TradingAccountViolationType[keyof typeof TradingAccountViolationType];


export const TradingAccountViolationType = {
  soft_breach: 'soft_breach',
  hard_breach: 'hard_breach',
} as const;

export interface TradingAccountViolation {
  /** Unique identifier of the violation */
  id: number;
  /** Name of the violation */
  name: string;
  /** Recorded value that triggered the violation (format depends on the violation type) */
  value: string;
  /** Severity of the violation */
  type: TradingAccountViolationType;
  /** Human-readable title of the violation */
  title: string;
  /** Detailed, human-readable description of the violation */
  description: string;
  /** When the violation was recorded */
  created_at: string;
}

export interface TradingAccountViolationsResponse {
  collection: TradingAccountViolation[];
}

/**
 * @nullable
 */
export type IpAddress = {
  address: string;
  region: string;
  country: string;
  city: string;
  lat: number;
  lon: number;
  created_at: string;
  updated_at: string;
  is_vpn: boolean;
  allowlisted: boolean;
} | null;

export type ClosedPositionAction = typeof ClosedPositionAction[keyof typeof ClosedPositionAction];


export const ClosedPositionAction = {
  buy: 'buy',
  sell: 'sell',
} as const;

export interface ClosedPosition {
  identifier: string;
  opened_at: string;
  closed_at: string;
  symbol: string;
  action: ClosedPositionAction;
  entry_price: number;
  close_price: number;
  /** @nullable */
  pips: number | null;
  lot_size: number;
  /** @nullable */
  take_profit_price: number | null;
  /** @nullable */
  stop_loss_price: number | null;
  swap: number;
  commission: number;
  /** @nullable */
  profit: number | null;
  ip_address: IpAddress | null;
}

export interface GetTradingAccountClosedPositionsResponse {
  collection: ClosedPosition[];
  meta?: PaginationMeta;
}

export type ClosedPositionsFilterMetadataResponseFields = {
  actions: string[];
  trade_symbols: string[];
  violation_reasons: string[];
};

export interface ClosedPositionsFilterMetadataResponse {
  count: number;
  fields: ClosedPositionsFilterMetadataResponseFields;
}

export type OpenPositionAction = typeof OpenPositionAction[keyof typeof OpenPositionAction];


export const OpenPositionAction = {
  buy: 'buy',
  sell: 'sell',
} as const;

export interface OpenPosition {
  identifier: string;
  action: OpenPositionAction;
  entry_price: number;
  lot_size: number;
  opened_at: string;
  /** @nullable */
  profit: number | null;
  /** @nullable */
  stop_loss_price: number | null;
  symbol: string;
  /** @nullable */
  take_profit_price: number | null;
  swap: number;
}

export interface GetTradingAccountOpenPositionsResponse {
  collection: OpenPosition[];
  meta?: PaginationMeta;
}

export type OpenPositionsFilterMetadataResponseFields = {
  actions: string[];
  trade_symbols: string[];
  violation_statuses: string[];
};

export interface OpenPositionsFilterMetadataResponse {
  count: number;
  fields: OpenPositionsFilterMetadataResponseFields;
}

export type BalanceActionAction = typeof BalanceActionAction[keyof typeof BalanceActionAction];


export const BalanceActionAction = {
  in: 'in',
  out: 'out',
} as const;

export interface BalanceAction {
  amount: number;
  action: BalanceActionAction;
  comment: string;
  created_at: string;
}

export interface GetTradingAccountBalanceActionsResponse {
  collection: BalanceAction[];
  meta?: PaginationMeta;
}

export interface TradesPerIp {
  ip_address: string;
  region: string;
  trades_count: number;
  last_trade_at: unknown;
}

export interface GetTradesPerIpResponse {
  collection: TradesPerIp[];
}

export interface TradingAccountsMergeNewResponse {
  collection?: DetailedTradingAccount[];
}

export type TradingAccountsMergeResponseData = {
  trading_account: DetailedTradingAccount;
};

export interface TradingAccountsMergeResponse {
  message: string;
  data: TradingAccountsMergeResponseData;
}

export type DiscountTierInputType = typeof DiscountTierInputType[keyof typeof DiscountTierInputType];


export const DiscountTierInputType = {
  affiliate: 'affiliate',
  campaign: 'campaign',
} as const;

export interface DiscountTierInput {
  name: string;
  type: DiscountTierInputType;
  /**
     * Completed-referral threshold for affiliate tiers.
     * @minimum 0
     */
  apply_from: number;
  is_custom: boolean;
}

export type DiscountTierRuleInputInitialDiscountType = typeof DiscountTierRuleInputInitialDiscountType[keyof typeof DiscountTierRuleInputInitialDiscountType];


export const DiscountTierRuleInputInitialDiscountType = {
  amount: 'amount',
  percentage: 'percentage',
} as const;

export type DiscountTierRuleInputRecurringDiscountType = typeof DiscountTierRuleInputRecurringDiscountType[keyof typeof DiscountTierRuleInputRecurringDiscountType];


export const DiscountTierRuleInputRecurringDiscountType = {
  amount: 'amount',
  percentage: 'percentage',
} as const;

/**
 * Empty eligibility means the rule has no product or country restriction.
 */
export type DiscountTierRuleInputEligibility = {
  countries?: string[];
  account_sizes?: number[];
  account_types?: string[];
};

export interface DiscountTierRuleInput {
  /** Include for an existing rule; omit to create a rule. */
  id?: number;
  /** @minimum 0 */
  initial_discount_value: number;
  initial_discount_type: DiscountTierRuleInputInitialDiscountType;
  /** @minimum 0 */
  recurring_discount_value: number;
  recurring_discount_type: DiscountTierRuleInputRecurringDiscountType;
  /**
     * @minimum 0
     * @maximum 100
     */
  initial_commission_percentage: number;
  /**
     * @minimum 0
     * @maximum 100
     */
  recurring_commission_percentage: number;
  /** @minimum 0 */
  nth_purchase_commission?: number;
  /**
     * @minimum 0
     * @maximum 100
     */
  payout_commission_percentage?: number;
  payout_commission_cap?: string;
  /** Empty eligibility means the rule has no product or country restriction. */
  eligibility?: DiscountTierRuleInputEligibility;
}

export type DiscountTierRuleAllOf = {
  id: number;
  /**
     * Tie-break order for equally specific matching rules.
     * @minimum 0
     */
  position: number;
};

export type DiscountTierRule = DiscountTierRuleInput & DiscountTierRuleAllOf;

export type DiscountTierAllOf = {
  id: number;
  /** Ordered override rules. Tier-level fields are the fallback/default values. */
  rules: DiscountTierRule[];
  /** Number of scheduled or processing updates for the tier. */
  active_schedules_count: number;
};

export type DiscountTier = DiscountTierInput & DiscountTierAllOf;

export interface Coupon {
  id?: number;
  name?: string;
  code?: string;
  redemption_limit?: number;
  per_user_redemption_limit?: number;
  private?: boolean;
  redemptions_count?: number;
  valid_from?: string;
  valid_till?: string;
  created_at?: string;
  /** @nullable */
  user_id?: number | null;
  /** @nullable */
  user_name?: string | null;
  active_schedules_count?: number;
}

export interface AffiliateProfile {
  id: number;
  affiliate_payouts_on_demand_enabled: boolean;
  /** @nullable */
  next_affiliate_payout_at: string | null;
  user: SearchUserSerializer;
  discount_tier: DiscountTier;
  coupon: Coupon;
}

export interface AffiliateProfileUpdateRequestBody {
  /** ID of an existing affiliate discount tier to assign to the profile. */
  discount_tier_id?: number;
  /** Toggles on-demand affiliate payouts for the profile. */
  affiliate_payouts_on_demand_enabled?: boolean;
}

/**
 * Type of the referral.
 */
export type ReferralTypeEnum = typeof ReferralTypeEnum[keyof typeof ReferralTypeEnum];


export const ReferralTypeEnum = {
  trading_account: 'trading_account',
  bonus: 'bonus',
  payout: 'payout',
  recurrent_purchase: 'recurrent_purchase',
  deducted_commission: 'deducted_commission',
} as const;

export interface UserTotalReferrals {
  total_fee: number;
  referral_type: ReferralTypeEnum;
  email: string;
  new_fee: number;
  pending_fee: number;
  processed_fee: number;
  refunded_fee: number;
  latest_update: string;
  /** @nullable */
  referred_user_id: number | null;
}

export interface TotalReferralsResponse {
  collection?: UserTotalReferrals[];
}

export interface UserReferralsWidgetsResponse {
  collection?: Widget[];
}

export interface TotalReferrals {
  total_fee: number;
  referral_type: ReferralTypeEnum;
  email: string;
  new_fee: number;
  pending_fee: number;
  processed_fee: number;
  refunded_fee: number;
  latest_update: string;
  user_id: number;
}

export interface ReferralsWidgetsResponse {
  collection?: Widget[];
}

/**
 * The type of note.
 */
export type NoteTypeEnum = typeof NoteTypeEnum[keyof typeof NoteTypeEnum];


export const NoteTypeEnum = {
  user: 'user',
  risk: 'risk',
  system: 'system',
} as const;

/**
 * Resource type.
 */
export type NoteResourceTypeEnum = typeof NoteResourceTypeEnum[keyof typeof NoteResourceTypeEnum];


export const NoteResourceTypeEnum = {
  user: 'user',
  trading_account: 'trading_account',
} as const;

export interface Note {
  /** The ID of the created note. */
  id: number;
  /** The content of the note. */
  body: string;
  type: NoteTypeEnum;
  /** The ID of the user who created the note. */
  added_by_user_id: number;
  /** The name of the user who created the note. */
  added_by_user_name: string;
  /** The ID of the user to which the note belongs. */
  user_id: number;
  /**
     * The ID of the trading account to which the note belongs.
     * @nullable
     */
  trading_account_id: number | null;
  /** The label of the resource to which the note belongs. */
  resource_label: string;
  /** The type of the resource to which the note belongs. */
  resource_type: NoteResourceTypeEnum;
  /** The timestamp when the note was created, in ISO 8601 format. */
  created_at: string;
  /** The timestamp when the note was updated, in ISO 8601 format. */
  updated_at: string;
  /** Whether or not the note should be visible on the frontend. */
  visible_on_frontend: boolean;
  /** Whether or not the note should be editable on the frontend. */
  editing_allowed: boolean;
}

export interface NotesListResponse {
  collection: Note[];
  meta: PaginationMeta;
}

/**
 * The type of note allowed for Admin API creation. System notes are created internally only. Defaults to `user` when omitted.
 */
export type NoteRequestBodyNoteType = typeof NoteRequestBodyNoteType[keyof typeof NoteRequestBodyNoteType];


export const NoteRequestBodyNoteType = {
  user: 'user',
  risk: 'risk',
} as const;

export type NoteRequestBodyNote = {
  /** The content of the note. */
  body: string;
  /** The type of note allowed for Admin API creation. System notes are created internally only. Defaults to `user` when omitted. */
  type?: NoteRequestBodyNoteType;
  /** Whether or not the note should be visible on the frontend. Defaults to `false`. Risk notes are always hidden from frontend visibility. */
  visible_on_frontend?: boolean;
};

export interface NoteRequestBody {
  note: NoteRequestBodyNote;
}

export type NoteApiResponseData = {
  note: Note;
};

export interface NoteApiResponse {
  message: string;
  data: NoteApiResponseData;
}

export type NoteUpdateRequestBodyNote = {
  /** The content of the note. */
  body: string;
  /** Whether or not the note should be visible on the frontend. If omitted, the current value is preserved. Risk notes are always hidden from frontend visibility. */
  visible_on_frontend?: boolean;
};

export interface NoteUpdateRequestBody {
  note: NoteUpdateRequestBodyNote;
}

export interface UserIpActivityFilter {
  /** Search for ip activity by trading account phase */
  phase?: string[];
  /** Search for ip activity by trading account platform */
  platform?: string[];
  /** Search for ip activity by trading account login */
  trading_account_login?: string[];
  /** Search for users created after this date */
  created_at_from?: string;
  /** Date to get referrals upto */
  created_at_to?: string;
  /** Filter by VPN usage */
  is_vpn?: boolean;
}

export interface ReferralsFilter {
  /** Search for referrals by email */
  search?: string;
  /** Search for referrals by referral type */
  referral_type?: string[];
  /** Date to get referrals upto */
  created_at_from?: string;
  /** Filter by created_at ending to */
  created_at_to?: string;
}

export interface EmailTemplateFilter {
  /** Search for EmailTemplates by title, subject or rich-text body */
  search_field?: string;
}

export type BalanceTransactionEntryTypes = typeof BalanceTransactionEntryTypes[keyof typeof BalanceTransactionEntryTypes];


export const BalanceTransactionEntryTypes = {
  deposit: 'deposit',
  purchase: 'purchase',
  payout: 'payout',
  refund: 'refund',
  adjustment: 'adjustment',
  internal_transfer: 'internal_transfer',
  company_share: 'company_share',
  service_fee: 'service_fee',
  payout_refund: 'payout_refund',
} as const;

export type BalanceTransactionStatuses = typeof BalanceTransactionStatuses[keyof typeof BalanceTransactionStatuses];


export const BalanceTransactionStatuses = {
  hold: 'hold',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

export type BalanceTransactionSourceTypes = typeof BalanceTransactionSourceTypes[keyof typeof BalanceTransactionSourceTypes];


export const BalanceTransactionSourceTypes = {
  PayoutTransaction: 'PayoutTransaction',
  PaymentSession: 'PaymentSession',
  InternalTransfer: 'InternalTransfer',
  Payout: 'Payout',
} as const;

export interface BalanceTransactionFilter {
  /** Filter by user id linked to the balance transaction */
  filter_user_id?: number;
  /** Filter by amount lower end */
  amount_from?: number;
  /** Filter by amount higher end */
  amount_to?: number;
  /** Filter by created_at starting from */
  created_at_from?: string;
  /** Filter by created_at ending to */
  created_at_to?: string;
  /** Filter by exact balance transaction reference */
  search_field?: string;
  /** Filter by source id, requires source_type to be present, otherwise no records are returned */
  source_id?: number;
  /** Filter by entry type */
  entry_type?: BalanceTransactionEntryTypes[];
  /** Filter by status */
  status?: BalanceTransactionStatuses[];
  /** Filter by source type */
  source_type?: BalanceTransactionSourceTypes[];
}

/**
 * Filter by action (e.g., buy or sell)
 */
export type ClosedPositionsFilterAction = typeof ClosedPositionsFilterAction[keyof typeof ClosedPositionsFilterAction];


export const ClosedPositionsFilterAction = {
  buy: 'buy',
  sell: 'sell',
} as const;

/**
 * Filter by violation reason
 */
export type ClosedPositionsFilterViolationReason = typeof ClosedPositionsFilterViolationReason[keyof typeof ClosedPositionsFilterViolationReason];


export const ClosedPositionsFilterViolationReason = {
  profit_threshold: 'profit_threshold',
  news_trading: 'news_trading',
  manual_review: 'manual_review',
  single_price_movement: 'single_price_movement',
  hft_trade_style: 'hft_trade_style',
  lots_exposure_limit: 'lots_exposure_limit',
} as const;

export interface ClosedPositionsFilter {
  /** Filter by action (e.g., buy or sell) */
  action?: ClosedPositionsFilterAction;
  /** Filter by trade symbol */
  symbol?: string;
  /** Filter by positions opened after this date */
  opened_at_from?: string;
  /** Filter by positions opened before this date */
  opened_at_to?: string;
  /** Filter by positions closed after this date */
  closed_at_from?: string;
  /** Filter by positions closed before this date */
  closed_at_to?: string;
  /** Filter by lot size greater than or equal to this value */
  lot_size_from?: number;
  /** Filter by lot size less than or equal to this value */
  lot_size_to?: number;
  /** Filter by violation reason */
  violation_reason?: ClosedPositionsFilterViolationReason;
  /** Filter by profit greater than or equal to this value */
  profit_from?: number;
  /** Filter by profit less than or equal to this value */
  profit_to?: number;
}

/**
 * Filter by action (e.g., buy or sell)
 */
export type OpenPositionsFilterAction = typeof OpenPositionsFilterAction[keyof typeof OpenPositionsFilterAction];


export const OpenPositionsFilterAction = {
  buy: 'buy',
  sell: 'sell',
} as const;

export interface OpenPositionsFilter {
  /** Filter by action (e.g., buy or sell) */
  action?: OpenPositionsFilterAction;
  /** Filter by trade symbol */
  trade_symbol?: string;
  /** Filter by positions opened after this date */
  opened_at_from?: string;
  /** Filter by positions opened before this date */
  opened_at_to?: string;
  /** Filter by lot size greater than or equal to this value */
  lot_size_from?: number;
  /** Filter by lot size less than or equal to this value */
  lot_size_to?: number;
  /** Filter by violation status */
  violation_status?: string;
  /** Filter by profit greater than or equal to this value */
  profit_from?: number;
  /** Filter by profit less than or equal to this value */
  profit_to?: number;
}

export interface ChallengeFilter {
  /** Filter challenges by account type. */
  account_type?: AccountTypeEnum[];
  /** Filter challenges by platform. */
  platform?: PlatformEnum[];
  /** Filter challenges by phase. */
  phase?: PhaseEnum[];
  /** Filter challenges with account size greater than or equal to this value. */
  account_size_from?: AccountSizeEnum;
  /** Filter challenges with account size less than or equal to this value. */
  account_size_to?: AccountSizeEnum;
  /** Filter challenges by status. */
  status?: TradingAccountStatusEnum[];
  /** Filter challenges started after this date. */
  started_at_from?: string;
  /** Filter challenges started before this date. */
  started_at_to?: string;
  /** Filter challenges ended after this date. */
  ended_at_from?: string;
  /** Filter challenges ended before this date. */
  ended_at_to?: string;
}

export interface TradingAccountIpActivityFilter {
  /** Filter by VPN usage */
  is_vpn?: boolean;
  /** Search for users created after this date */
  created_at_from?: string;
  /** Date to get referrals upto */
  created_at_to?: string;
}

export interface CouponsFilter {
  /** Search coupons by name, code, or user exceptions inside the coupon */
  search_field?: string;
  /** Search by user id of referred user */
  filter_user_id?: number;
  /** Filter coupons with valid_from after this date */
  valid_from_from?: string;
  /** Filter coupons with valid_from before this date */
  valid_from_to?: string;
  /** Filter coupons with valid_till after this date */
  valid_till_from?: string;
  /** Filter coupons with valid_till before this date */
  valid_till_to?: string;
  /** Filter coupons created after this date */
  created_at_from?: string;
  /** Filter coupons created before this date */
  created_at_to?: string;
  /** Filter coupons with redemption limit greater than or equal to this value */
  redemption_limit_from?: number;
  /** Filter coupons with redemption limit less than or equal to this value */
  redemption_limit_to?: number;
  /** Filter coupons with redemptions count greater than or equal to this value */
  redemptions_count_from?: number;
  /** Filter coupons with redemptions count less than or equal to this value */
  redemptions_count_to?: number;
}

export type CouponRedemptionsFilterStatusItem = typeof CouponRedemptionsFilterStatusItem[keyof typeof CouponRedemptionsFilterStatusItem];


export const CouponRedemptionsFilterStatusItem = {
  applied: 'applied',
  success: 'success',
  failed: 'failed',
} as const;

export interface CouponRedemptionsFilter {
  /** Search by user email, name */
  search_field?: string;
  /** Filter redemption status */
  status?: CouponRedemptionsFilterStatusItem[];
  /** Filter redmeptions created after this date */
  created_at_from?: string;
  /** Filter redmeptions created before this date */
  created_at_to?: string;
  /** Filter by user ID */
  user_id?: number;
}

export interface NotesFilter {
  /** Search notes by body. */
  search_field?: string;
  /** Filter notes by note type. */
  type?: NoteTypeEnum;
  /** Filter by polymorphic target type. Must be passed together with `target_id`. Accepts class names like `Payout` or route-style values like `payouts`. */
  target_type?: string;
  /** Filter by polymorphic target id. Must be passed together with `target_type`. */
  target_id?: number;
  /** Filter notes by the user who added the note. */
  added_by_user_id?: number;
  /** Filter notes created after this date. */
  created_at_from?: string;
  /** Filter notes created before this date. */
  created_at_to?: string;
}

/**
 * Risk engine matching flag. Values below are known examples; Risk Engine may add more flags.
 * @minLength 2
 * @maxLength 64
 * @pattern ^[A-Z0-9_]+$
 */
export type MatchingFlagEnum = string;

export interface RiskEngineFlaggedAccountsFilter {
  /** Filter by matching flags */
  flags?: MatchingFlagEnum[];
  /**
     * Number of days to look back
     * @minimum 1
     * @maximum 60
     */
  days?: number;
  /**
     * Minimum matching score
     * @minimum 0
     * @maximum 100
     */
  score_min?: number;
  /**
     * Maximum matching score
     * @minimum 0
     * @maximum 100
     */
  score_max?: number;
}

export interface RiskEngineSimilarTradingAccountsFilter {
  /** Filter by matching flags */
  flags?: MatchingFlagEnum[];
  /**
     * Minimum matching score
     * @minimum 0
     * @maximum 100
     */
  score_min?: number;
  /**
     * Maximum matching score
     * @minimum 0
     * @maximum 100
     */
  score_max?: number;
}

export interface RiskEngineSimilarUserAccountsFilter {
  /** Filter by matching flags */
  flags?: MatchingFlagEnum[];
  /**
     * Minimum matching score
     * @minimum 0
     * @maximum 100
     */
  score_min?: number;
  /**
     * Maximum matching score
     * @minimum 0
     * @maximum 100
     */
  score_max?: number;
}

export interface RiskEngineTradingAccountIncidentsFilter {
  /** Filter incidents starting from this time (ISO8601) */
  start_time?: string;
  /** Filter incidents ending at this time (ISO8601) */
  end_time?: string;
  /** Time window size in minutes for grouping incidents */
  window_size?: number;
}

export interface RiskEngineUserIncidentsFilter {
  /** Filter incidents starting from this time (ISO8601) */
  start_time?: string;
  /** Filter incidents ending at this time (ISO8601) */
  end_time?: string;
  /** Time window size in minutes for grouping incidents */
  window_size?: number;
}

export type SearchFilterFilters = UserSearchFilter | UserIpActivityFilter | ReferralsFilter | TradingAccountFilter | EmailTemplateFilter | BalanceTransactionFilter | ClosedPositionsFilter | OpenPositionsFilter | PayoutsFilter | ChallengeFilter | TradingAccountIpActivityFilter | CouponsFilter | CouponRedemptionsFilter | NotesFilter | RiskEngineFlaggedAccountsFilter | RiskEngineSimilarTradingAccountsFilter | RiskEngineSimilarUserAccountsFilter | RiskEngineTradingAccountIncidentsFilter | RiskEngineUserIncidentsFilter;

export interface SearchFilter {
  id: number;
  name: string;
  filters: SearchFilterFilters;
}

export interface SearchFiltersListResponse {
  collection: SearchFilter[];
}

export type ResourceTypeNotSupportedError = ApiError & unknown;

export interface UserPolicyAcceptancesFilter {
  /** Filter by acceptance source. */
  source?: PolicyAcceptanceSourceEnum[];
  /** Filter by policy scope. */
  policy_scope?: PolicyScopeEnum[];
}

/**
 * Withdrawal status.
 */
export type WithdrawalStatusEnum = typeof WithdrawalStatusEnum[keyof typeof WithdrawalStatusEnum];


export const WithdrawalStatusEnum = {
  requested: 'requested',
  processing: 'processing',
  processed: 'processed',
  partially_processed: 'partially_processed',
  failed: 'failed',
} as const;

export interface WithdrawalsFilter {
  /** Filter by user id linked to the withdrawal */
  filter_user_id?: number;
  /** Filter withdrawals by status */
  statuses?: WithdrawalStatusEnum[];
  /** Filter withdrawals by amount lower end */
  amount_from?: number;
  /** Filter withdrawals by amount higher end */
  amount_to?: number;
  /** Filter withdrawals created after this date */
  created_at_from?: string;
  /** Filter withdrawals created before this date */
  created_at_to?: string;
}

export interface GroupsFilter {
  /** Filter groups by account type. */
  account_type?: AccountTypeEnum[];
  /** Filter groups by platform. */
  platform?: PlatformEnum[];
  /** Filter groups by phase. */
  phase?: PhaseEnum[];
  /** Filter groups by currencies. */
  currencies?: CurrenciesFilter;
  /** Filter groups by leverage. */
  leverage?: LeverageEnum[];
  /** Filter groups with account size greater than or equal to this value. */
  account_size_from?: AccountSizeEnum;
  /** Filter groups with account size less than or equal to this value. */
  account_size_to?: AccountSizeEnum;
  /** Filter groups by swap free. */
  swap_free?: boolean;
  /** Filter groups by close only. */
  close_only?: boolean;
  /** Search for groups by name or external_identifier. */
  search_field?: string;
}

export interface DepositsFilter {
  /** Filter by user id linked to deposit */
  filter_user_id?: number;
  /** Filter deposits by status */
  statuses?: DepositStatusEnum[];
  /** Filter deposits by minimum amount */
  amount_from?: number;
  /** Filter deposits by maximum amount */
  amount_to?: number;
  /** Filter deposits created after this date */
  created_at_from?: string;
  /** Filter deposits created before this date */
  created_at_to?: string;
}

/**
 * Competition status
 */
export type CompetitionStatusEnum = typeof CompetitionStatusEnum[keyof typeof CompetitionStatusEnum];


export const CompetitionStatusEnum = {
  upcoming: 'upcoming',
  ongoing: 'ongoing',
  ended: 'ended',
} as const;

/**
 * Competition type
 */
export type CompetitionTypeEnum = typeof CompetitionTypeEnum[keyof typeof CompetitionTypeEnum];


export const CompetitionTypeEnum = {
  monthly: 'monthly',
  community: 'community',
  event: 'event',
} as const;

export interface CompetitionsFilter {
  /** Filter competitions by status */
  statuses?: CompetitionStatusEnum[];
  /** Filter competitions by type */
  competition_types?: CompetitionTypeEnum[];
  /** Filter competitions by published state */
  published?: boolean;
  /** Filter competitions starting after this date */
  starts_at_from?: string;
  /** Filter competitions starting before this date */
  starts_at_to?: string;
  /** Filter competitions ending after this date */
  ends_at_from?: string;
  /** Filter competitions ending before this date */
  ends_at_to?: string;
  /** Filter competitions by template */
  template_ids?: number[];
}

export interface PoliciesFilter {
  /** Filter by scope. */
  scopes?: PolicyScopeEnum[];
  /** Filter by mandatory flag. */
  mandatory?: boolean;
  /** Filter by brand. */
  brand_id?: number;
  /** Filter policies with effective_from on or after this date. */
  effective_from_from?: string;
  /** Filter policies with effective_from on or before this date. */
  effective_from_to?: string;
}

/**
 * IB profile application status.
 */
export type IbProfileStatusEnum = typeof IbProfileStatusEnum[keyof typeof IbProfileStatusEnum];


export const IbProfileStatusEnum = {
  questionnaire_pending: 'questionnaire_pending',
  approval_pending: 'approval_pending',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export interface IbProfilesFilter {
  /** Filter by user id linked to the IB profile */
  filter_user_id?: number;
  /** Filter IB profiles by status */
  statuses?: IbProfileStatusEnum[];
}

export type CreateSearchFilterResponseData = {
  filter: SearchFilter;
};

export interface CreateSearchFilterResponse {
  message: string;
  data: CreateSearchFilterResponseData;
}

export type CardMethodDetailsType = typeof CardMethodDetailsType[keyof typeof CardMethodDetailsType];


export const CardMethodDetailsType = {
  card: 'card',
} as const;

/**
 * A card payment
 */
export interface CardMethodDetails {
  type: CardMethodDetailsType;
  /** @nullable */
  last4?: string | null;
  /** @nullable */
  card_brand?: string | null;
}

export type CryptoMethodDetailsType = typeof CryptoMethodDetailsType[keyof typeof CryptoMethodDetailsType];


export const CryptoMethodDetailsType = {
  crypto: 'crypto',
} as const;

/**
 * A crypto payment.
 */
export interface CryptoMethodDetails {
  type: CryptoMethodDetailsType;
  /** @nullable */
  address_first6?: string | null;
  /** @nullable */
  address_last4?: string | null;
  /** @nullable */
  crypto_currency?: string | null;
}

export type WireTransferMethodDetailsType = typeof WireTransferMethodDetailsType[keyof typeof WireTransferMethodDetailsType];


export const WireTransferMethodDetailsType = {
  wire_transfer: 'wire_transfer',
} as const;

/**
 * A wire transfer payout backed by a bank account.
 */
export interface WireTransferMethodDetails {
  type: WireTransferMethodDetailsType;
  /** @nullable */
  friendly_name?: string | null;
  /** @nullable */
  iban_last4?: string | null;
}

export type OtherMethodDetailsType = typeof OtherMethodDetailsType[keyof typeof OtherMethodDetailsType];


export const OtherMethodDetailsType = {
  other: 'other',
} as const;

/**
 * A Paymaxis payment session whose method is neither card nor crypto.
 */
export interface OtherMethodDetails {
  type: OtherMethodDetailsType;
  /** @nullable */
  provider?: string | null;
}

/**
 * Masked payment-method details for a PayoutTransaction
 */
export type PayoutMethodDetails = CardMethodDetails | CryptoMethodDetails | WireTransferMethodDetails | OtherMethodDetails | null;

/**
 * Masked payment-method details for a PaymentSession.
 */
export type PaymentSessionMethodDetails = CardMethodDetails | CryptoMethodDetails | OtherMethodDetails | null;

export type DetailsOneOfPaymentMethod = typeof DetailsOneOfPaymentMethod[keyof typeof DetailsOneOfPaymentMethod];


export const DetailsOneOfPaymentMethod = {
  bank_transfer: 'bank_transfer',
  crypto: 'crypto',
  deposit_refund: 'deposit_refund',
  deel: 'deel',
  rise: 'rise',
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  no_payment_method: 'no_payment_method',
} as const;

export type DetailsOneOfPaymentAccount = typeof DetailsOneOfPaymentAccount[keyof typeof DetailsOneOfPaymentAccount];


export const DetailsOneOfPaymentAccount = {
  standard: 'standard',
  prime: 'prime',
} as const;

/**
 * Present when source_type is PayoutTransaction.
 */
export type DetailsOneOf = {
  payment_method: DetailsOneOfPaymentMethod;
  payment_account: DetailsOneOfPaymentAccount;
  method_details: PayoutMethodDetails;
};

/**
 * @nullable
 */
export type DetailsOneOfFourProvider = typeof DetailsOneOfFourProvider[keyof typeof DetailsOneOfFourProvider] | null;


export const DetailsOneOfFourProvider = {
  stripe: 'stripe',
  nowpayments: 'nowpayments',
  checkout: 'checkout',
  myfatoorah: 'myfatoorah',
  forumpay: 'forumpay',
  paymaxis: 'paymaxis',
  payout: 'payout',
  free_account: 'free_account',
} as const;

/**
 * Present when source_type is PaymentSession.
 */
export type DetailsOneOfFour = {
  /** @nullable */
  provider: DetailsOneOfFourProvider;
  /**
     * Gateway payment method taken from the session metadata (e.g. BASIC_CARD, CRYPTO). Null when unknown.
     * @nullable
     */
  payment_method: string | null;
  method_details: PaymentSessionMethodDetails;
};

/**
 * Direction relative to the trading account leg of the transfer.
 */
export type DetailsOneOfSixDirection = typeof DetailsOneOfSixDirection[keyof typeof DetailsOneOfSixDirection];


export const DetailsOneOfSixDirection = {
  to_trading_account: 'to_trading_account',
  from_trading_account: 'from_trading_account',
} as const;

/**
 * Present when source_type is InternalTransfer.
 */
export type DetailsOneOfSix = {
  /** Direction relative to the trading account leg of the transfer. */
  direction: DetailsOneOfSixDirection;
};

/**
 * Compact, source-specific supplementary information for the transaction row.
 */
export type Details = DetailsOneOf | DetailsOneOfFour | DetailsOneOfSix | null;

export interface BalanceTransaction {
  /** The ID of the balance transaction. */
  id: number;
  /** The amount of the balance transaction (may be negative). */
  amount: string;
  /** The entry type of the balance transaction. */
  entry_type: BalanceTransactionEntryTypes;
  /** The unique reference of the balance transaction. */
  reference: string;
  /** The polymorphic type of the source object. */
  source_type: BalanceTransactionSourceTypes;
  /** The ID of the source object. */
  source_id: number;
  /** The status of the balance transaction. */
  status: BalanceTransactionStatuses;
  /** The timestamp when the balance transaction was created, in ISO 8601 format. */
  created_at: string;
  /** The ID of the user. */
  user_id: number;
  /** The email of the user. */
  user_email: string;
  /** Source-specific supplementary information, resolved by source_type. */
  details: Details;
}

export interface BalanceTransactionsListResponse {
  collection?: BalanceTransaction[];
  meta?: PaginationMeta;
}

export type BalanceTransactionsFilterMetadataResponseFieldsBrandsItem = {
  name: string;
  value: number;
};

export type BalanceTransactionsFilterMetadataResponseFields = {
  brands: BalanceTransactionsFilterMetadataResponseFieldsBrandsItem[];
  /** Url to be used to search for the users based on search_field parameter to be added */
  user_search_path: string;
  entry_types: BalanceTransactionEntryTypes[];
  statuses: BalanceTransactionStatuses[];
  source_types: BalanceTransactionSourceTypes[];
};

export interface BalanceTransactionsFilterMetadataResponse {
  count: number;
  fields: BalanceTransactionsFilterMetadataResponseFields;
}

export type BalanceTransactionPayoutStatus = typeof BalanceTransactionPayoutStatus[keyof typeof BalanceTransactionPayoutStatus];


export const BalanceTransactionPayoutStatus = {
  requested: 'requested',
  cancelled: 'cancelled',
  pending: 'pending',
  processed: 'processed',
  queued: 'queued',
  failed: 'failed',
  invitation_sent: 'invitation_sent',
  risk_assessment: 'risk_assessment',
  processing: 'processing',
  returned: 'returned',
  partially_processed: 'partially_processed',
  awaiting_approval: 'awaiting_approval',
  auto_approved: 'auto_approved',
} as const;

export type BalanceTransactionPayoutPayoutType = typeof BalanceTransactionPayoutPayoutType[keyof typeof BalanceTransactionPayoutPayoutType];


export const BalanceTransactionPayoutPayoutType = {
  trading_account: 'trading_account',
  affiliate: 'affiliate',
  bonus: 'bonus',
} as const;

export type BalanceTransactionPayoutPaymentMethod = typeof BalanceTransactionPayoutPaymentMethod[keyof typeof BalanceTransactionPayoutPaymentMethod];


export const BalanceTransactionPayoutPaymentMethod = {
  bank_transfer: 'bank_transfer',
  crypto: 'crypto',
  deel: 'deel',
  rise: 'rise',
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  no_payment_method: 'no_payment_method',
} as const;

export interface BalanceTransactionPayout {
  id: number;
  /** Human-readable identifier of the payout. */
  reference: string;
  amount: string;
  requested_amount_usd: string;
  status: BalanceTransactionPayoutStatus;
  payout_type: BalanceTransactionPayoutPayoutType;
  payment_method: BalanceTransactionPayoutPaymentMethod;
  created_at: string;
}

/**
 * Withdrawal approval-review status.
 */
export type WithdrawalReviewStatusEnum = typeof WithdrawalReviewStatusEnum[keyof typeof WithdrawalReviewStatusEnum];


export const WithdrawalReviewStatusEnum = {
  verification_pending: 'verification_pending',
  auto_approved: 'auto_approved',
  manually_approved: 'manually_approved',
  manually_rejected: 'manually_rejected',
} as const;

export interface Withdrawal {
  id?: number;
  reference?: string;
  amount?: string;
  status?: WithdrawalStatusEnum;
  review_status?: WithdrawalReviewStatusEnum;
  user_id?: number;
  /** @nullable */
  user_name?: string | null;
  /** Whether the withdrawal was created manually */
  manually_created?: boolean;
  created_at?: string;
}

export type PayoutTransactionSourceStatus = typeof PayoutTransactionSourceStatus[keyof typeof PayoutTransactionSourceStatus];


export const PayoutTransactionSourceStatus = {
  requested: 'requested',
  cancelled: 'cancelled',
  processed: 'processed',
  failed: 'failed',
  processing: 'processing',
  invitation_sent: 'invitation_sent',
  replaced: 'replaced',
} as const;

export type PayoutTransactionSourcePaymentMethod = typeof PayoutTransactionSourcePaymentMethod[keyof typeof PayoutTransactionSourcePaymentMethod];


export const PayoutTransactionSourcePaymentMethod = {
  bank_transfer: 'bank_transfer',
  crypto: 'crypto',
  deposit_refund: 'deposit_refund',
  deel: 'deel',
  rise: 'rise',
  wire_transfer: 'wire_transfer',
  pay_to_card: 'pay_to_card',
  tradin_transfer: 'tradin_transfer',
  prime_transfer: 'prime_transfer',
  no_payment_method: 'no_payment_method',
} as const;

export type PayoutTransactionSourcePaymentAccount = typeof PayoutTransactionSourcePaymentAccount[keyof typeof PayoutTransactionSourcePaymentAccount];


export const PayoutTransactionSourcePaymentAccount = {
  standard: 'standard',
  prime: 'prime',
} as const;

/**
 * The polymorphic type of the origin object.
 */
export type PayoutTransactionSourceOriginType = typeof PayoutTransactionSourceOriginType[keyof typeof PayoutTransactionSourceOriginType];


export const PayoutTransactionSourceOriginType = {
  Payout: 'Payout',
  Withdrawal: 'Withdrawal',
} as const;

/**
 * The third-level object the payout transaction originates from.
 */
export type PayoutTransactionSourceOrigin = BalanceTransactionPayout | Withdrawal;

export interface PayoutTransactionSource {
  id: number;
  uuid: string;
  amount: string;
  status: PayoutTransactionSourceStatus;
  payment_method: PayoutTransactionSourcePaymentMethod;
  payment_account: PayoutTransactionSourcePaymentAccount;
  method_details: PayoutMethodDetails;
  /** @nullable */
  external_identifier?: string | null;
  /** @nullable */
  provider_error?: string | null;
  created_at: string;
  /** The polymorphic type of the origin object. */
  origin_type: PayoutTransactionSourceOriginType;
  /** The third-level object the payout transaction originates from. */
  origin: PayoutTransactionSourceOrigin;
}

/**
 * Provider-side identifiers. Contents vary by payment method.
 */
export type PaymentSessionProviderMetadataExternalRefs = { [key: string]: unknown };

/**
 * Instrument details as delivered by the provider, masked on their side.
 */
export type PaymentSessionProviderMetadataPaymentMethodDetails = { [key: string]: unknown };

/**
 * What the payment provider's webhook delivered for this session, narrowed to the keys the webhook writes. A missing key means the provider did not send it: `payment_method_details` and `recurring_token` only arrive with a completed payment, `error_code` only with a failed one. Empty for providers that store nothing on the session.
 */
export interface PaymentSessionProviderMetadata {
  payment_method?: string;
  terminal_name?: string;
  /** Provider-side identifiers. Contents vary by payment method. */
  external_refs?: PaymentSessionProviderMetadataExternalRefs;
  /** Instrument details as delivered by the provider, masked on their side. */
  payment_method_details?: PaymentSessionProviderMetadataPaymentMethodDetails;
  /** Present when this payment started a subscription. */
  recurring_token?: string;
  error_code?: string;
}

export type BalanceTransactionChallengeStatus = typeof BalanceTransactionChallengeStatus[keyof typeof BalanceTransactionChallengeStatus];


export const BalanceTransactionChallengeStatus = {
  ongoing: 'ongoing',
  ended: 'ended',
} as const;

/**
 * @nullable
 */
export type BalanceTransactionChallengePayoutCycle = typeof BalanceTransactionChallengePayoutCycle[keyof typeof BalanceTransactionChallengePayoutCycle] | null;


export const BalanceTransactionChallengePayoutCycle = {
  tuesday: 'tuesday',
  daily: 'daily',
  weekly: 'weekly',
  biweekly: 'biweekly',
  monthly: 'monthly',
  on_demand: 'on_demand',
  business_week: 'business_week',
} as const;

export interface BalanceTransactionChallenge {
  id: number;
  uuid: string;
  status: BalanceTransactionChallengeStatus;
  /** @nullable */
  account_size?: number | null;
  /**
     * Trading account type (see AccountTypes).
     * @nullable
     */
  account_type?: string | null;
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  leverage?: number | null;
  /** @nullable */
  payout_cycle?: BalanceTransactionChallengePayoutCycle;
  created_at: string;
  paid_amount: string;
}

export interface BalanceTransactionOrder {
  id: number;
  uuid: string;
  created_at: string;
  /** Every account the order paid for. The payment session amounts cover the whole order, not any single account listed here. */
  challenges: BalanceTransactionChallenge[];
}

/**
 * @nullable
 */
export type PaymentSessionSourceProvider = typeof PaymentSessionSourceProvider[keyof typeof PaymentSessionSourceProvider] | null;


export const PaymentSessionSourceProvider = {
  stripe: 'stripe',
  nowpayments: 'nowpayments',
  checkout: 'checkout',
  myfatoorah: 'myfatoorah',
  forumpay: 'forumpay',
  paymaxis: 'paymaxis',
  payout: 'payout',
  free_account: 'free_account',
} as const;

export type PaymentSessionSourceState = typeof PaymentSessionSourceState[keyof typeof PaymentSessionSourceState];


export const PaymentSessionSourceState = {
  open: 'open',
  paid: 'paid',
  failed: 'failed',
  refunded: 'refunded',
  expired: 'expired',
  returned: 'returned',
  cancelled: 'cancelled',
  refund_declined: 'refund_declined',
  partially_refunded: 'partially_refunded',
} as const;

export type PaymentSessionSourceChargeType = typeof PaymentSessionSourceChargeType[keyof typeof PaymentSessionSourceChargeType];


export const PaymentSessionSourceChargeType = {
  purchase: 'purchase',
  activation: 'activation',
  reset: 'reset',
  recurring: 'recurring',
  deposit: 'deposit',
} as const;

/**
 * The polymorphic type of the origin object.
 */
export type PaymentSessionSourceOriginType = typeof PaymentSessionSourceOriginType[keyof typeof PaymentSessionSourceOriginType];


export const PaymentSessionSourceOriginType = {
  Challenge: 'Challenge',
  Deposit: 'Deposit',
  Order: 'Order',
} as const;

/**
 * The third-level object the payment session originates from. An Order covers several accounts bought together in one charge and lists them under `challenges` instead of carrying the account fields itself.
 */
export type PaymentSessionSourceOrigin = BalanceTransactionChallenge | Deposit | BalanceTransactionOrder;

export interface PaymentSessionSource {
  id: number;
  uuid: string;
  /** @nullable */
  provider?: PaymentSessionSourceProvider;
  method_details: PaymentSessionMethodDetails;
  state: PaymentSessionSourceState;
  charge_type: PaymentSessionSourceChargeType;
  /**
     * Undiscounted charge total. For an Order this covers every account on it.
     * @nullable
     */
  amount_total?: string | null;
  /**
     * What the customer was actually charged. For an Order this covers every account on it.
     * @nullable
     */
  amount_paid?: string | null;
  /** @nullable */
  amount_to_pay?: string | null;
  /** @nullable */
  payment_identifier?: string | null;
  created_at: string;
  /** The polymorphic type of the origin object. */
  origin_type: PaymentSessionSourceOriginType;
  provider_metadata?: PaymentSessionProviderMetadata;
  /** The third-level object the payment session originates from. An Order covers several accounts bought together in one charge and lists them under `challenges` instead of carrying the account fields itself. */
  origin: PaymentSessionSourceOrigin;
}

export interface BalanceTransactionUser {
  id: number;
  uuid: string;
  email: string;
  /** First name plus the initial of the last name. */
  full_name: string;
  created_at: string;
}

export type BalanceTransactionTradingAccountPhase = typeof BalanceTransactionTradingAccountPhase[keyof typeof BalanceTransactionTradingAccountPhase];


export const BalanceTransactionTradingAccountPhase = {
  student: 'student',
  practitioner: 'practitioner',
  senior: 'senior',
  master: 'master',
  prime: 'prime',
} as const;

export interface BalanceTransactionTradingAccount {
  id: number;
  /** Unique human-readable identifier of the trading account. */
  login: string;
  name: string;
  /**
     * External identifier of the trading account.
     * @nullable
     */
  external_identifier?: string | null;
  /** Trading account type (see AccountTypes). */
  account_type: string;
  phase: BalanceTransactionTradingAccountPhase;
  /** Trading account status (see TradingAccounts::Statuses). */
  status: string;
  platform: string;
  currency: string;
  account_size: number;
  created_at: string;
}

export type InternalTransferSourceStatus = typeof InternalTransferSourceStatus[keyof typeof InternalTransferSourceStatus];


export const InternalTransferSourceStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

/**
 * The polymorphic type of the source object.
 */
export type InternalTransferSourceSourceType = typeof InternalTransferSourceSourceType[keyof typeof InternalTransferSourceSourceType];


export const InternalTransferSourceSourceType = {
  User: 'User',
  TradingAccount: 'TradingAccount',
  Challenge: 'Challenge',
} as const;

/**
 * The third-level object the internal transfer moves funds from.
 */
export type InternalTransferSourceSource = BalanceTransactionUser | BalanceTransactionTradingAccount | BalanceTransactionChallenge;

/**
 * The polymorphic type of the target object.
 */
export type InternalTransferSourceTargetType = typeof InternalTransferSourceTargetType[keyof typeof InternalTransferSourceTargetType];


export const InternalTransferSourceTargetType = {
  User: 'User',
  TradingAccount: 'TradingAccount',
  Challenge: 'Challenge',
} as const;

/**
 * The third-level object the internal transfer moves funds to.
 */
export type InternalTransferSourceTarget = BalanceTransactionUser | BalanceTransactionTradingAccount | BalanceTransactionChallenge;

export interface InternalTransferSource {
  id: number;
  uuid: string;
  amount: string;
  status: InternalTransferSourceStatus;
  created_at: string;
  /** The polymorphic type of the source object. */
  source_type: InternalTransferSourceSourceType;
  /** The third-level object the internal transfer moves funds from. */
  source: InternalTransferSourceSource;
  /** The polymorphic type of the target object. */
  target_type: InternalTransferSourceTargetType;
  /** The third-level object the internal transfer moves funds to. */
  target: InternalTransferSourceTarget;
}

/**
 * The second-level source object, resolved by source_type. Includes its own nested third-level object(s).
 */
export type BalanceTransactionDetailsSource = PayoutTransactionSource | PaymentSessionSource | InternalTransferSource | BalanceTransactionPayout;

export interface BalanceTransactionDetails {
  /** The ID of the balance transaction. */
  id: number;
  /** The amount of the balance transaction (may be negative). */
  amount: string;
  /** The entry type of the balance transaction. */
  entry_type: BalanceTransactionEntryTypes;
  /** The unique reference of the balance transaction. */
  reference: string;
  /** The polymorphic type of the source object. */
  source_type: BalanceTransactionSourceTypes;
  /** The ID of the source object. */
  source_id: number;
  /** The status of the balance transaction. */
  status: BalanceTransactionStatuses;
  /** The timestamp when the balance transaction was created, in ISO 8601 format. */
  created_at: string;
  /** The ID of the user. */
  user_id: number;
  /** The email of the user. */
  user_email: string;
  /** The second-level source object, resolved by source_type. Includes its own nested third-level object(s). */
  source: BalanceTransactionDetailsSource;
}

export interface PermissionGroup {
  id: number;
  name: string;
  /** @nullable */
  description?: string | null;
  keys: string[];
  created_at: string;
  updated_at: string;
}

export interface PermissionGroupsListResponse {
  collection: PermissionGroup[];
  meta: PaginationMeta;
}

export interface PermissionGroupDetailed {
  id: number;
  name: string;
  /** @nullable */
  description?: string | null;
  keys: string[];
  created_at: string;
  updated_at: string;
  users: SearchUserSerializer[];
}

export type PermissionGroupResponseBodyData = {
  permission_group: PermissionGroupDetailed;
};

export interface PermissionGroupResponseBody {
  message: string;
  data: PermissionGroupResponseBodyData;
}

export interface PermissionGroupKey {
  key: string;
  label: string;
}

export interface PermissionGroupCategory {
  category: string;
  label: string;
  keys: PermissionGroupKey[];
}

export interface PermissionGroupResource {
  resource: string;
  label: string;
  categories: PermissionGroupCategory[];
}

export interface PermissionGroupNewResponse {
  available_keys: PermissionGroupResource[];
}

export interface PermissionGroupEditResponse {
  id: number;
  name: string;
  /** @nullable */
  description?: string | null;
  keys: string[];
  created_at: string;
  updated_at: string;
  available_keys: PermissionGroupResource[];
}

export interface CouponsListResponse {
  collection?: Coupon[];
  meta?: PaginationMeta;
}

export interface CouponParameters {
  /** Name of the coupon */
  name?: string;
  /** Coupon code. If omitted on create, a unique code is generated automatically */
  code?: string;
  /** Platforms where the coupon is valid, if empty applies to all platforms */
  supported_platforms?: string[];
  /** Maximum number of times the coupon can be redeemed, 0 means unlimited */
  redemption_limit?: number;
  /** Maximum number of times a single user can redeem the coupon, 0 means unlimited */
  per_user_redemption_limit?: number;
  /** When true, the coupon is hidden from public listing and can only be applied via an associated coupon code */
  private?: boolean;
  /**
     * Start date and time when the coupon becomes valid (ISO 8601 format)
     * @nullable
     */
  valid_from?: string | null;
  /**
     * End date and time when the coupon expires (ISO 8601 format)
     * @nullable
     */
  valid_till?: string | null;
  /** ID of the Discount Tier assigned to the coupon */
  discount_tier_id?: number;
  /** List of selected whitelisted countries, can be multiple or none */
  whitelisted_countries?: string[];
  /** List of selected blacklisted countries, can be multiple or none */
  blacklisted_countries?: string[];
  /**
     * Only allowed if the current user is a super_user, super_admin (Will be editable if present in the editable_fields)
     * @nullable
     */
  scheduled_at?: string | null;
}

export type CreateCouponRequestBodyCoupon = CouponParameters & Required<Pick<CouponParameters, 'name' | 'redemption_limit' | 'discount_tier_id'>>;

export interface CreateCouponRequestBody {
  coupon: CreateCouponRequestBodyCoupon;
}

/**
 * The status of a scheduled action
 */
export type ScheduleStatus = typeof ScheduleStatus[keyof typeof ScheduleStatus];


export const ScheduleStatus = {
  processing: 'processing',
  scheduled: 'scheduled',
  processed: 'processed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

/**
 * The type of the object associated with the scheduled action
 */
export type SchedulableType = typeof SchedulableType[keyof typeof SchedulableType];


export const SchedulableType = {
  Task: 'Task',
  Coupon: 'Coupon',
  DiscountTier: 'DiscountTier',
} as const;

/**
 * Dynamic object with arbitrary key-value pairs or empty object
 */
export type ScheduledActionPayload = { [key: string]: unknown };

export interface ScheduledAction {
  /** The scheduled action id */
  id: number;
  /** Dynamic object with arbitrary key-value pairs or empty object */
  payload: ScheduledActionPayload;
  /**
     * The scheduled execution time in ISO 8601 format
     * @nullable
     */
  scheduled_at: string | null;
  status: ScheduleStatus;
  actions: ActionList;
  /** The ID of the object associated with the scheduled action */
  schedulable_id: number;
  schedulable_type: SchedulableType;
  /** The ID of the user who created the scheduled action */
  created_by_id: number;
  /** The full name of the user who created the scheduled action */
  created_by_name: string;
  /**
     * The reason for failure if the scheduled action failed
     * @nullable
     */
  failure_reason: string | null;
}

export interface DetailedCoupon {
  id?: number;
  name?: string;
  code?: string;
  redemption_limit?: number;
  per_user_redemption_limit?: number;
  private?: boolean;
  redemptions_count?: number;
  valid_from?: string;
  /** @nullable */
  valid_till?: string | null;
  created_at?: string;
  updated_at?: string;
  /** @nullable */
  user_id?: number | null;
  /** @nullable */
  user_name?: string | null;
  platforms?: string;
  /** List of selected whitelisted countries, can be multiple or none */
  whitelisted_countries?: string[];
  /** List of selected blacklisted countries, can be multiple or none */
  blacklisted_countries?: string[];
  /** The list of scheduled actions for the coupon */
  scheduled_actions?: ScheduledAction[];
  discount_tier?: DiscountTier;
}

export type CommonResponseBodyData = {
  coupon: DetailedCoupon;
};

export interface CommonResponseBody {
  message: string;
  data: CommonResponseBodyData;
}

export type CouponsFilterMetadataResponseFields = {
  /** Url to be used to search for the users based on search_field parameter to be added */
  user_search_path: string;
};

export interface CouponsFilterMetadataResponse {
  count: number;
  fields: CouponsFilterMetadataResponseFields;
}

export interface AuditLog {
  action: string;
  user_id: number;
  user_email: string;
  user_role: string;
  user_full_name: string;
  request_id: string;
  /** @nullable */
  target_type: string | null;
  /** @nullable */
  target_id: number | null;
  call_trace: string;
  /** JSON-encoded request payload */
  payload: string;
  created_at: string;
}

export interface AuditLogsListResponse {
  collection?: AuditLog[];
  meta?: PaginationMeta;
}

export type AuditLogsFilterMetadataResponseFields = {
  /** URL to search for users by name/nickname; the frontend resolves a user_id and sends it as filter_user_id. */
  user_search_path: string;
  target_types: string[];
};

export interface AuditLogsFilterMetadataResponse {
  count: number;
  fields: AuditLogsFilterMetadataResponseFields;
}

export interface WithdrawalsListResponse {
  collection: Withdrawal[];
  meta: PaginationMeta;
}

export type WithdrawalsFilterMetadataResponseFields = {
  statuses: WithdrawalStatusEnum[];
  /** URL to search for users */
  user_search_path: string;
};

export interface WithdrawalsFilterMetadataResponse {
  count: number;
  fields: WithdrawalsFilterMetadataResponseFields;
}

export interface WithdrawalDetailedResponse {
  id?: number;
  reference?: string;
  amount?: string;
  status?: WithdrawalStatusEnum;
  review_status?: WithdrawalReviewStatusEnum;
  user_id?: number;
  /** @nullable */
  user_name?: string | null;
  /** Whether the withdrawal was created manually */
  manually_created?: boolean;
  created_at?: string;
  /** Payout transactions sorted by `created_at` descending (newest first). */
  transactions?: PayoutTransaction[];
  actions?: ActionList;
}

export type WithdrawalActionResponseData = {
  actionable_object: WithdrawalDetailedResponse;
};

export interface WithdrawalActionResponse {
  message: string;
  data: WithdrawalActionResponseData;
}

export interface IbProfile {
  id: number;
  status: IbProfileStatusEnum;
  user_id: number;
  user_name: string;
  created_at: string;
}

export interface IbProfilesListResponse {
  collection: IbProfile[];
  meta: PaginationMeta;
}

export type IbProfilesFilterMetadataResponseFields = {
  statuses: IbProfileStatusEnum[];
  /** URL to search for users */
  user_search_path: string;
};

export interface IbProfilesFilterMetadataResponse {
  count: number;
  fields: IbProfilesFilterMetadataResponseFields;
}

export interface IbProfileDetail {
  id: number;
  user_id: number;
  user_name: string;
  created_at: string;
  questionnaire: QuestionnaireDetail;
}

export interface UpdateCouponRequestBody {
  coupon: CouponParameters;
}

export type CouponsNewResponsePlatformsOptionsItem = {
  label: string;
  value: string;
};

export type CouponsNewResponseCountriesOptionsItem = {
  label: string;
  value: string;
};

export type CouponsNewResponseDiscountTierOptionsItem = {
  label: string;
  value: number;
};

export interface CouponsNewResponse {
  /** List of supported platforms, can be multiple or none */
  platforms_options: CouponsNewResponsePlatformsOptionsItem[];
  /** List of available countries */
  countries_options: CouponsNewResponseCountriesOptionsItem[];
  /** List of available Discount Tiers */
  discount_tier_options: CouponsNewResponseDiscountTierOptionsItem[];
}

/**
 * The scheduled execution time of the change to be applied (ISO 8601 format and it can only be set by super user and super admin)
 * @nullable
 */
export type ScheduledAt = string | null;

export type CouponEditResponsePlatformsOptionsItem = {
  label: string;
  value: string;
};

export type CouponEditResponseCountriesOptionsItem = {
  label: string;
  value: string;
};

export type CouponEditResponseDiscountTierOptionsItem = {
  label: string;
  value: number;
};

export type CouponEditResponseEditableFieldsItemAnyOf = { [key: string]: unknown };

export type CouponEditResponseEditableFieldsItem = string | CouponEditResponseEditableFieldsItemAnyOf;

export interface CouponEditResponse {
  id: number;
  name: string;
  code: string;
  redemption_limit: number;
  per_user_redemption_limit: number;
  private: boolean;
  redemptions_count: number;
  valid_from: string;
  /** @nullable */
  valid_till: string | null;
  /** @nullable */
  user_id: number | null;
  /** @nullable */
  discount_tier_id: number | null;
  /** List of supported platforms */
  platforms_options: CouponEditResponsePlatformsOptionsItem[];
  /** List of selected platforms, can be multiple or none */
  selected_platforms: string[];
  /** List of selected whitelisted countries, can be multiple or none */
  selected_whitelisted_countries: string[];
  /** List of selected blacklisted countries, can be multiple or none */
  selected_blacklisted_countries: string[];
  /** List of available countries */
  countries_options: CouponEditResponseCountriesOptionsItem[];
  /** List of available Discount Tiers */
  discount_tier_options: CouponEditResponseDiscountTierOptionsItem[];
  hidden_fields: string[];
  editable_fields: CouponEditResponseEditableFieldsItem[];
  scheduled_at: ScheduledAt | null;
  /** The list of active scheduled actions for the coupon */
  active_scheduled_actions: ScheduledAction[];
}

export type CouponRedemptionStatus = typeof CouponRedemptionStatus[keyof typeof CouponRedemptionStatus];


export const CouponRedemptionStatus = {
  applied: 'applied',
  success: 'success',
  failed: 'failed',
} as const;

export interface CouponRedemption {
  id?: number;
  status?: CouponRedemptionStatus;
  user_id?: number;
  user_name?: string;
  user_email?: string;
  challenge_id?: number;
  created_at?: string;
  updated_at?: string;
}

export type RedemptionsFilterMetadataResponseFieldsAvailableStatusesItem = typeof RedemptionsFilterMetadataResponseFieldsAvailableStatusesItem[keyof typeof RedemptionsFilterMetadataResponseFieldsAvailableStatusesItem];


export const RedemptionsFilterMetadataResponseFieldsAvailableStatusesItem = {
  applied: 'applied',
  success: 'success',
  failed: 'failed',
} as const;

export type RedemptionsFilterMetadataResponseFields = {
  /** Url to be used to search for the users based on search_field parameter to be added */
  user_search_path: string;
  available_statuses: RedemptionsFilterMetadataResponseFieldsAvailableStatusesItem[];
};

export interface RedemptionsFilterMetadataResponse {
  count: number;
  fields: RedemptionsFilterMetadataResponseFields;
}

export interface UserException {
  id?: number;
  /** @nullable */
  user_email?: string | null;
  redemption_limit?: number;
  redemptions_count?: number;
  /** @nullable */
  valid_from?: string | null;
  /** @nullable */
  valid_till?: string | null;
  created_at?: string;
  updated_at?: string;
  coupon_id?: number;
}

export interface UserExceptionsListResponseBody {
  collection?: UserException[];
  meta?: PaginationMeta;
}

export type UserExceptionRequestBodyUserException = {
  /**
     * Email of the user the exception is assigned to.
     * Required when the coupon code value is blank (user exceptions rely on
     * email instead of a promo code); optional when a code is present.
     * Must be unique per coupon (case-insensitive); the value is normalized
     * by stripping whitespace and lowercasing before save.
     * Creating or updating an exception with an email that already exists
     * for the same coupon returns a validation error.
     */
  user_email: string;
  /** Maximum number of times the exception can be redeemed, 0 means unlimited */
  redemption_limit?: number;
  /**
     * Start date and time when the exception becomes valid (ISO 8601 format)
     * @nullable
     */
  valid_from?: string | null;
  /**
     * End date and time when the exception expires (ISO 8601 format)
     * @nullable
     */
  valid_till?: string | null;
};

export interface UserExceptionRequestBody {
  user_exception: UserExceptionRequestBodyUserException;
}

export type UserExceptionCommonResponseBodyData = {
  user_exception: UserException;
};

export interface UserExceptionCommonResponseBody {
  message: string;
  data: UserExceptionCommonResponseBodyData;
}

export interface UserExceptionEditResponse {
  id: number;
  /** @nullable */
  user_email: string | null;
  redemption_limit: number;
  redemptions_count: number;
  /** @nullable */
  valid_from: string | null;
  /** @nullable */
  valid_till: string | null;
  coupon_id: number;
  editable_fields: string[];
}

/**
 * The status of a task
 */
export type Statuses = typeof Statuses[keyof typeof Statuses];


export const Statuses = {
  created: 'created',
  processing: 'processing',
  failed: 'failed',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export interface Task {
  /** The ID of the task. */
  id: number;
  /** Amount of attempts to process a task */
  attempts: number;
  /** Rows from an uploaded CSV file were processed with errors */
  failed_rows_count: number;
  /** The timestamp when the task was created, in ISO 8601 format. */
  created_at: string;
  /**
     * The latest timestamp when the task was run, in ISO 8601 format.
     * @nullable
     */
  last_run_at?: string | null;
  /** The command of a task */
  command: string;
  /** Total rows from an uploaded CSV file were processed */
  total: number;
  status: Statuses;
  /** The ID of an admin user who added a task */
  added_by_user_id: number;
  /** The name of an admin user who added a task */
  added_by_user_name: string;
  /**
     * The ID of an admin user who processed a task
     * @nullable
     */
  processed_by_user_id?: number | null;
  /**
     * The name of an admin user who processed a task
     * @nullable
     */
  processed_by_user_name?: string | null;
  scheduled_at: ScheduledAt | null;
  actions: ActionList;
}

export interface TasksListResponse {
  collection?: Task[];
  meta?: PaginationMeta;
}

/**
 * The type of the task
 */
export type CreateTaskRequestBodyTaskType = typeof CreateTaskRequestBodyTaskType[keyof typeof CreateTaskRequestBodyTaskType];


export const CreateTaskRequestBodyTaskType = {
  'Tasks::AffiliatesFromCsv': 'Tasks::AffiliatesFromCsv',
  'Tasks::ProcessRiseOrCrypto': 'Tasks::ProcessRiseOrCrypto',
  'Tasks::BalanceOperation': 'Tasks::BalanceOperation',
  'Tasks::SendEmailByLogin': 'Tasks::SendEmailByLogin',
  'Tasks::SendEmailByUser': 'Tasks::SendEmailByUser',
  'Tasks::BlockUsers': 'Tasks::BlockUsers',
  'Tasks::BulkOnboard': 'Tasks::BulkOnboard',
  'Tasks::BulkApprove': 'Tasks::BulkApprove',
  'Tasks::BulkViolate': 'Tasks::BulkViolate',
  'Tasks::BulkCreateAccounts': 'Tasks::BulkCreateAccounts',
} as const;

export interface CreateTaskRequestBody {
  /** The type of the task */
  'task[type]': CreateTaskRequestBodyTaskType;
  'task[csv]': Blob;
}

export type TaskResponseBodyData = {
  task: Task;
};

export interface TaskResponseBody {
  message: string;
  data: TaskResponseBodyData;
}

export type TasksFilterMetadataResponseFields = {
  statuses: Statuses[];
  /** Url to be used to search for the users based on search_field parameter to be added */
  added_by_users_path: string;
  /** Url to be used to search for the users based on search_field parameter to be added */
  processed_by_users_path: string;
};

export interface TasksFilterMetadataResponse {
  count: number;
  fields: TasksFilterMetadataResponseFields;
}

export type TasksNewResponseSampleFiles = {[key: string]: {
  name: string;
  file_url: string;
}};

export interface TasksNewResponse {
  sample_files: TasksNewResponseSampleFiles;
}

/**
 * The details of the task
 * @nullable
 */
export type TaskDetailedDetails = {
  payouts_amount?: number;
  payouts_count?: number;
} | null;

export type TaskDetailedLinksItem = {
  action_name: string;
  name: string;
  path: string;
  method: string;
  require_params: boolean;
  confirm: boolean;
  hidden: boolean;
  response_content_type: string;
};

export interface TaskDetailed {
  /** The ID of the task. */
  id: number;
  /** Amount of attempts to process a task */
  attempts: number;
  /** Rows from an uploaded CSV file were processed with errors */
  failed_rows_count: number;
  /** The timestamp when the task was created, in ISO 8601 format. */
  created_at: string;
  /**
     * The latest timestamp when the task was run, in ISO 8601 format.
     * @nullable
     */
  last_run_at?: string | null;
  /** The command of a task */
  command: string;
  /** Total rows from an uploaded CSV file were processed */
  total: number;
  status: Statuses;
  /** The ID of an admin user who added a task */
  added_by_user_id: number;
  /** The name of an admin user who added a task */
  added_by_user_name: string;
  /**
     * The ID of an admin user who processed a task
     * @nullable
     */
  processed_by_user_id?: number | null;
  /**
     * The name of an admin user who processed a task
     * @nullable
     */
  processed_by_user_name?: string | null;
  /**
     * The details of the task
     * @nullable
     */
  details?: TaskDetailedDetails;
  /** Action links for the task */
  links: TaskDetailedLinksItem[];
  /** The list of scheduled actions for the task */
  scheduled_actions: ScheduledAction[];
  scheduled_at: ScheduledAt | null;
  actions: ActionList;
}

export type DeleteTaskResponseData = {
  task: Task;
};

export interface DeleteTaskResponse {
  message: string;
  data: DeleteTaskResponseData;
}

export type UpdateTaskResponseData = {
  task: Task;
};

export interface UpdateTaskResponse {
  message: string;
  data: UpdateTaskResponseData;
}

export type TaskFailedRowsResponseHeadersItem = {
  /** Display name of the column */
  name: string;
  /** Internal key for the column */
  key: string;
  /** Indicates whether the column is sortable */
  sortable: boolean;
};

export type TaskFailedRowsResponseCollectionItem = { [key: string]: unknown };

export interface TaskFailedRowsResponse {
  /** List of headers */
  headers: TaskFailedRowsResponseHeadersItem[];
  /** List of rows */
  collection: TaskFailedRowsResponseCollectionItem[];
  meta: PaginationMeta;
}

export interface ScheduledActionRequestBody {
  scheduled_at: ScheduledAt | null;
}

export type CommonTaskActionResponseData = {
  actionable_object: TaskDetailed;
};

export interface CommonTaskActionResponse {
  message: string;
  data: CommonTaskActionResponseData;
}

export interface NewReferralTierResponse {
  /**
     * The name of the referral tier
     * @nullable
     */
  name: string | null;
  /** The flag indicating the referral tier is a custom */
  is_custom: boolean;
  /** Only first purchase (related coupons will inherit this property) */
  only_first_purchase: boolean;
  /** The apply from */
  apply_from: number;
  /** The commission percentage */
  commission_percentage: number;
  /** The commission percentage for the first purchase */
  first_purchase_commission_percentage: number;
  /** The discount percentage */
  discount_percentage: number;
  /** The Nth purchase commission */
  nth_purchase_commission: number;
  /** The payout commission percentage */
  payout_commission_percentage: number;
  /**
     * The payout commission cap
     * @nullable
     */
  payout_commission_cap: number | null;
  /** The first purchase discount percentage, value starting from 0 to 100 */
  first_purchase_discount_percentage: number;
}

export interface ReferralTier {
  /** The referral tier id */
  id: number;
  /** The name of the referral tier */
  name: string;
  /** The flag indicating the referral tier is a custom */
  is_custom: boolean;
  /** Only first purchase (related coupons will inherit this property) */
  only_first_purchase: boolean;
  /** The apply from */
  apply_from: number;
  /** The commission percentage */
  commission_percentage: number;
  /** The commission percentage for the first purchase */
  first_purchase_commission_percentage: number;
  /** The discount percentage */
  discount_percentage: number;
  /** The Nth purchase commission */
  nth_purchase_commission: number;
  /** The payout commission percentage */
  payout_commission_percentage: number;
  /** The payout commission cap */
  payout_commission_cap: string;
  /** The first purchase discount percentage, value starting from 0 to 100 */
  first_purchase_discount_percentage: number;
  /** The list of scheduled actions for the referral tier */
  scheduled_actions?: ScheduledAction[];
  /** The number of active schedules for the referral tier */
  active_schedules_count: number;
}

export interface ReferralTiersResponse {
  collection?: ReferralTier[];
}

export type ReferralTierRequestBodyReferralTier = {
  /** The name of the referral tier */
  name?: string;
  /** The flag indicating the referral tier is a custom */
  is_custom?: boolean;
  /** Only first purchase (related coupons will inherit this property) */
  only_first_purchase?: boolean;
  /** The apply from */
  apply_from?: number;
  /** The commission percentage */
  commission_percentage?: number;
  /** The commission percentage for the first purchase */
  first_purchase_commission_percentage?: number;
  /** The discount percentage */
  discount_percentage?: number;
  /** The Nth purchase commission */
  nth_purchase_commission?: number;
  /** The payout commission percentage */
  payout_commission_percentage?: number;
  /** The payout commission cap */
  payout_commission_cap?: number;
  /** The first purchase discount percentage, value starting from 0 to 100 */
  first_purchase_discount_percentage?: number;
  scheduled_at?: ScheduledAt | null;
};

export interface ReferralTierRequestBody {
  referral_tier: ReferralTierRequestBodyReferralTier;
}

export type CreateReferralTierResponseData = {
  referral_tier: ReferralTier;
};

export interface CreateReferralTierResponse {
  message: string;
  data: CreateReferralTierResponseData;
}

export type DeleteReferralTierResponseData = {
  referral_tier: ReferralTier;
};

export interface DeleteReferralTierResponse {
  message: string;
  data: DeleteReferralTierResponseData;
}

export type UpdateReferralTierResponseData = {
  referral_tier: ReferralTier;
};

export interface UpdateReferralTierResponse {
  message: string;
  data: UpdateReferralTierResponseData;
}

export interface ReferralTierEditResponse {
  /** The referral tier id */
  id: number;
  /**
     * The name of the referral tier
     * @nullable
     */
  name: string | null;
  /** The flag indicating the referral tier is a custom */
  is_custom: boolean;
  /** Only first purchase (related coupons will inherit this property) */
  only_first_purchase: boolean;
  /** The apply from */
  apply_from: number;
  /** The commission percentage */
  commission_percentage: number;
  /** The commission percentage for the first purchase */
  first_purchase_commission_percentage: number;
  /** The discount percentage */
  discount_percentage: number;
  /** The Nth purchase commission */
  nth_purchase_commission: number;
  /** The payout commission percentage */
  payout_commission_percentage: number;
  /** The payout commission cap */
  payout_commission_cap: string;
  /** The first purchase discount percentage, value starting from 0 to 100 */
  first_purchase_discount_percentage: number;
  hidden_fields: string[];
  editable_fields: string[];
  scheduled_at: ScheduledAt | null;
  /** The list of all scheduled actions for the referral tier */
  scheduled_actions: ScheduledAction[];
}

export type DiscountTierFormOptionsCountriesOptionsItem = {
  label: string;
  value: string;
};

export type DiscountTierFormOptionsAccountSizesOptionsItem = {
  label: string;
  value: number;
};

export type DiscountTierFormOptionsAccountTypesOptionsItem = {
  label: string;
  value: string;
};

export interface DiscountTierFormOptions {
  /** Countries available for rule eligibility. */
  countries_options: DiscountTierFormOptionsCountriesOptionsItem[];
  /** Account sizes available for rule eligibility. */
  account_sizes_options: DiscountTierFormOptionsAccountSizesOptionsItem[];
  /** Account types available for rule eligibility. */
  account_types_options: DiscountTierFormOptionsAccountTypesOptionsItem[];
}

export type NewDiscountTierAllOf = {
  /** @maxItems 0 */
  rules: unknown[];
};

export type NewDiscountTier = DiscountTierInput & DiscountTierFormOptions & NewDiscountTierAllOf;

export type DiscountTierRequestBodyDiscountTierAllOf = {
  scheduled_at?: ScheduledAt | null;
  /** Complete ordered override matrix. Send an empty array when the tier has no overrides. */
  rules: DiscountTierRuleInput[];
};

export type DiscountTierRequestBodyDiscountTier = DiscountTierInput & DiscountTierRequestBodyDiscountTierAllOf;

export interface DiscountTierRequestBody {
  discount_tier: DiscountTierRequestBodyDiscountTier;
}

export type DetailedDiscountTierAllOf = {
  /** Fields the current admin may update. */
  editable_fields: string[];
  /** Form fields hidden from the current admin. */
  hidden_fields: string[];
  scheduled_at: ScheduledAt | null;
  /** All scheduled updates for the tier. */
  scheduled_actions: ScheduledAction[];
};

export type DetailedDiscountTier = DiscountTier & DiscountTierFormOptions & DetailedDiscountTierAllOf;

export interface Competition {
  id: number;
  title: string;
  status: CompetitionStatusEnum;
  competition_type: CompetitionTypeEnum;
  starts_at: string;
  ends_at: string;
  /** @nullable */
  max_participants: number | null;
  platform: PlatformEnum;
  published: boolean;
  rewards_allowed: boolean;
  template_id: number;
  /**
     * Rich text description of the competition
     * @nullable
     */
  description: string | null;
  /**
     * Rich text description of prizes
     * @nullable
     */
  prizes: string | null;
  created_at?: string;
}

export interface CompetitionsListResponse {
  collection: Competition[];
  meta: PaginationMeta;
}

export interface CompetitionParameters {
  /** Title of the competition */
  title?: string;
  status?: CompetitionStatusEnum;
  competition_type?: CompetitionTypeEnum;
  /** ID of the associated template */
  template_id?: number;
  /** Competition start date and time */
  starts_at?: string;
  /** Competition end date and time */
  ends_at?: string;
  /**
     * Maximum number of participants (null for unlimited)
     * @nullable
     */
  max_participants?: number | null;
  platform?: PlatformEnum;
  /** Whether the competition is publicly visible */
  published?: boolean;
  /** Whether rewards are allowed for the competition */
  rewards_allowed?: boolean;
  /**
     * Rich text description of the competition
     * @nullable
     */
  description?: string | null;
  /**
     * Rich text description of prizes
     * @nullable
     */
  prizes?: string | null;
}

export type CreateCompetitionRequestBodyCompetition = CompetitionParameters & Required<Pick<CompetitionParameters, 'title' | 'competition_type' | 'template_id' | 'starts_at' | 'ends_at' | 'platform' | 'published'>>;

export interface CreateCompetitionRequestBody {
  competition: CreateCompetitionRequestBodyCompetition;
}

export type CompetitionResponseData = {
  competition: Competition;
};

export interface CompetitionResponse {
  message: string;
  data: CompetitionResponseData;
}

export type CompetitionsFilterMetadataResponseFieldsTemplatesItem = {
  /** Template name */
  name: string;
  /** Template id */
  value: number;
};

export type CompetitionsFilterMetadataResponseFields = {
  statuses: CompetitionStatusEnum[];
  competition_types: CompetitionTypeEnum[];
  platforms: PlatformEnum[];
  templates: CompetitionsFilterMetadataResponseFieldsTemplatesItem[];
};

export interface CompetitionsFilterMetadataResponse {
  count: number;
  fields: CompetitionsFilterMetadataResponseFields;
}

export interface OptionItemString {
  label: string;
  value: string;
}

export interface OptionItemInteger {
  label: string;
  value: number;
}

export interface CompetitionFormOptions {
  status_options: OptionItemString[];
  competition_type_options: OptionItemString[];
  templates_options: OptionItemInteger[];
  platforms_options: OptionItemString[];
}

export interface UpdateCompetitionRequestBody {
  competition: CompetitionParameters;
}

export type CompetitionEditResponseAllOf = {
  id: number;
  title: string;
  status: CompetitionStatusEnum;
  competition_type: CompetitionTypeEnum;
  starts_at: string;
  ends_at: string;
  /** @nullable */
  max_participants: number | null;
  platform: PlatformEnum;
  published: boolean;
  rewards_allowed: boolean;
  template_id: number;
  /**
     * Rich text description of the competition
     * @nullable
     */
  description: string | null;
  /**
     * Rich text description of prizes
     * @nullable
     */
  prizes: string | null;
};

export type CompetitionEditResponse = CompetitionEditResponseAllOf & CompetitionFormOptions;

/**
 * Brand controls — a set of configurable values keyed by control name. Boolean and list controls carry a value; numeric limits are `null` until set. The set of controls evolves over time, so additional keys may be present. Only the values are editable — the set of keys is fixed by the backend.
 */
export interface BrandControls {
  allow_user_creation?: boolean;
  restricted_email_domains?: string[];
  onboarding_additional_questions?: boolean;
  allow_trading_account_creation?: boolean;
  /** @nullable */
  demo_account_limit?: number | null;
  allow_deposit?: boolean;
  /** @nullable */
  min_deposit?: string | null;
  /** @nullable */
  max_deposit?: string | null;
  /** @nullable */
  daily_deposit_limit?: string | null;
  restricted_deposit_methods?: string[];
  allow_withdrawal?: boolean;
  /** @nullable */
  min_withdrawal_amount?: string | null;
  /** @nullable */
  max_withdrawal_amount?: string | null;
  /** @nullable */
  daily_withdrawal_limit?: string | null;
  /** @nullable */
  withdrawal_cooldown_period_minutes?: number | null;
  restricted_withdrawal_methods?: string[];
  /** @nullable */
  min_internal_transfer_amount?: string | null;
  /** @nullable */
  max_internal_transfer_amount?: string | null;
  /** @nullable */
  internal_transfer_cooldown_period_seconds?: number | null;
  account_inwards_transfer_allowed?: boolean;
  account_outwards_transfer_allowed?: boolean;
  [key: string]: unknown;
 }

export interface Brand {
  /** The brand id */
  id: number;
  /** The brand name */
  name: string;
  /** Whether this is the default brand */
  is_default: boolean;
  controls: BrandControls;
  /** When the brand was created */
  created_at: string;
  /** When the brand was last updated */
  updated_at: string;
}

export interface BrandsListResponse {
  collection: Brand[];
}

/**
 * Brand controls
 */
export type BrandRequestBodyBrandControls = { [key: string]: unknown };

export type BrandRequestBodyBrand = {
  /** The brand name */
  name?: string;
  /** Whether this is the default brand */
  is_default?: boolean;
  /** Brand controls */
  controls?: BrandRequestBodyBrandControls;
};

export interface BrandRequestBody {
  brand: BrandRequestBodyBrand;
}

export type CreateBrandResponseData = {
  brand: Brand;
};

export interface CreateBrandResponse {
  message: string;
  data: CreateBrandResponseData;
}

export interface NewBrandResponse {
  /**
     * The brand name
     * @nullable
     */
  name: string | null;
  is_default: boolean;
  controls: BrandControls;
}

export type DeleteBrandResponseData = {
  brand: Brand;
};

export interface DeleteBrandResponse {
  message: string;
  data: DeleteBrandResponseData;
}

/**
 * Brand controls
 */
export type BrandUpdateRequestBodyBrandControls = { [key: string]: unknown };

export type BrandUpdateRequestBodyBrand = {
  /** Whether this is the default brand */
  is_default?: boolean;
  /** Brand controls */
  controls?: BrandUpdateRequestBodyBrandControls;
};

export interface BrandUpdateRequestBody {
  brand: BrandUpdateRequestBodyBrand;
}

export type UpdateBrandResponseData = {
  brand: Brand;
};

export interface UpdateBrandResponse {
  message: string;
  data: UpdateBrandResponseData;
}

export interface BrandEditResponse {
  id: number;
  is_default: boolean;
  controls: BrandControls;
}

/**
 * Authentication credentials. The `strategy` field determines the type; secret values are masked in responses. Remaining fields depend on the strategy.
 * @nullable
 */
export type AuthCredentials = {
  /** The credential strategy */
  strategy: string;
} | null;

/**
 * Queryable gateway metadata
 */
export type PaymentProviderGatewayMetadata = { [key: string]: unknown };

export interface PaymentProviderGateway {
  id: number;
  brand_id: number;
  brand_name: string;
  name: string;
  slug: string;
  base_url: string;
  active: boolean;
  /** Queryable gateway metadata */
  metadata: PaymentProviderGatewayMetadata;
  auth: AuthCredentials | null;
  webhook_auth: AuthCredentials | null;
}

export interface PaymentProviderGatewaysListResponse {
  collection: PaymentProviderGateway[];
  meta: PaginationMeta;
}

export type PaymentProviderGatewayRequestBodyPaymentProviderGatewayMetadata = { [key: string]: unknown };

/**
 * Credentials; `strategy` selects the type, remaining fields depend on it
 */
export type PaymentProviderGatewayRequestBodyPaymentProviderGatewayAuth = { [key: string]: unknown };

/**
 * Optional webhook verification credentials
 */
export type PaymentProviderGatewayRequestBodyPaymentProviderGatewayWebhookAuthAnyOf = { [key: string]: unknown };

/**
 * Optional webhook verification credentials
 * @nullable
 */
export type PaymentProviderGatewayRequestBodyPaymentProviderGatewayWebhookAuth = PaymentProviderGatewayRequestBodyPaymentProviderGatewayWebhookAuthAnyOf | null;

export type PaymentProviderGatewayRequestBodyPaymentProviderGateway = {
  name?: string;
  slug?: string;
  base_url?: string;
  active?: boolean;
  metadata?: PaymentProviderGatewayRequestBodyPaymentProviderGatewayMetadata;
  /** Credentials; `strategy` selects the type, remaining fields depend on it */
  auth?: PaymentProviderGatewayRequestBodyPaymentProviderGatewayAuth;
  /**
     * Optional webhook verification credentials
     * @nullable
     */
  webhook_auth?: PaymentProviderGatewayRequestBodyPaymentProviderGatewayWebhookAuth;
};

export interface PaymentProviderGatewayRequestBody {
  payment_provider_gateway: PaymentProviderGatewayRequestBodyPaymentProviderGateway;
}

export type CreatePaymentProviderGatewayResponseData = {
  payment_provider_gateway: PaymentProviderGateway;
};

export interface CreatePaymentProviderGatewayResponse {
  message: string;
  data: CreatePaymentProviderGatewayResponseData;
}

export type PaymentProviderGatewaysFilterMetadataResponseFieldsBrandsItem = {
  name: string;
  value: number;
};

export type PaymentProviderGatewaysFilterMetadataResponseFields = {
  brands: PaymentProviderGatewaysFilterMetadataResponseFieldsBrandsItem[];
};

export interface PaymentProviderGatewaysFilterMetadataResponse {
  count: number;
  fields: PaymentProviderGatewaysFilterMetadataResponseFields;
}

export type StrategyOptionFieldsItemOptionsItem = {
  label: string;
  value: string;
};

export type StrategyOptionFieldsItem = {
  /** The field name */
  name: string;
  /** Allowed values for the field; present only when the field is restricted to a fixed set */
  options?: StrategyOptionFieldsItemOptionsItem[];
};

export interface StrategyOption {
  /** The strategy identifier */
  type: string;
  /** The fields required by this strategy */
  fields: StrategyOptionFieldsItem[];
}

export type NewPaymentProviderGatewayResponseMetadata = { [key: string]: unknown };

export interface NewPaymentProviderGatewayResponse {
  /** @nullable */
  name: string | null;
  slug: string;
  /** @nullable */
  base_url: string | null;
  active: boolean;
  metadata: NewPaymentProviderGatewayResponseMetadata;
  auth: AuthCredentials | null;
  webhook_auth: AuthCredentials | null;
  auth_strategies: StrategyOption[];
  webhook_strategies: StrategyOption[];
}

export type DeletePaymentProviderGatewayResponseData = {
  payment_provider_gateway: PaymentProviderGateway;
};

export interface DeletePaymentProviderGatewayResponse {
  message: string;
  data: DeletePaymentProviderGatewayResponseData;
}

export type UpdatePaymentProviderGatewayResponseData = {
  payment_provider_gateway: PaymentProviderGateway;
};

export interface UpdatePaymentProviderGatewayResponse {
  message: string;
  data: UpdatePaymentProviderGatewayResponseData;
}

export type PaymentProviderGatewayEditResponseBrandOptionsItem = {
  label: string;
  value: number;
};

export type PaymentProviderGatewayEditResponseMetadata = { [key: string]: unknown };

export interface PaymentProviderGatewayEditResponse {
  id: number;
  brand_id: number;
  brand_options: PaymentProviderGatewayEditResponseBrandOptionsItem[];
  name: string;
  slug: string;
  base_url: string;
  active: boolean;
  metadata: PaymentProviderGatewayEditResponseMetadata;
  auth: AuthCredentials | null;
  webhook_auth: AuthCredentials | null;
  auth_strategies: StrategyOption[];
  webhook_strategies: StrategyOption[];
}

export interface TagRequestBody {
  tag_list: Tags;
}

export interface TagUpdateResponseBody {
  message: string;
  data: Tags;
}

/**
 * User who made the change, or a non-user source identifier.
 */
export type VersionWhodunnit = string | SearchUserSerializer | null;

/**
 * Serialized attribute changes for this version. Only fields configured in the resource allowlist are included. If no changes are visible after filtering, the changeset will be empty.
 */
export type VersionChangeset = { [key: string]: unknown };

export interface Version {
  /** The timestamp when the version entry was created. */
  created_at: string;
  /** Type of the version event. */
  event: string;
  /** User who made the change, or a non-user source identifier. */
  whodunnit: VersionWhodunnit;
  /** Serialized attribute changes for this version. Only fields configured in the resource allowlist are included. If no changes are visible after filtering, the changeset will be empty. */
  changeset: VersionChangeset;
}

export interface VersionsListResponse {
  collection?: Version[];
  meta?: PaginationMeta;
}

export interface ScheduledActionsResponse {
  collection?: ScheduledAction[];
  meta?: PaginationMeta;
}

export type ScheduledActionsFilterMetadataResponseFields = {
  /** Url to be used to search for the users based on search_field parameter to be added */
  user_search_path: string;
  statuses: ScheduleStatus[];
  schedulable_types: SchedulableType[];
};

export interface ScheduledActionsFilterMetadataResponse {
  count: number;
  fields: ScheduledActionsFilterMetadataResponseFields;
}

export type CommonScheduledActionResponseData = {
  actionable_object: ScheduledAction;
};

export interface CommonScheduledActionResponse {
  message: string;
  data: CommonScheduledActionResponseData;
}

export type MatchingFilterMetadataResponseFields = {
  /**
     * @minItems 3
     * @maxItems 6
     */
  flags: MatchingFlagEnum[];
};

export interface MatchingFilterMetadataResponse {
  fields: MatchingFilterMetadataResponseFields;
}

export type RiskEngineClosedPositionAccountType = typeof RiskEngineClosedPositionAccountType[keyof typeof RiskEngineClosedPositionAccountType];


export const RiskEngineClosedPositionAccountType = {
  M: 'M',
  C: 'C',
  UNKNOWN: 'UNKNOWN',
} as const;

export type RiskEngineClosedPositionSide = typeof RiskEngineClosedPositionSide[keyof typeof RiskEngineClosedPositionSide];


export const RiskEngineClosedPositionSide = {
  long: 'long',
  short: 'short',
  unknown: 'unknown',
} as const;

export interface RiskEngineClosedPosition {
  account_type?: RiskEngineClosedPositionAccountType;
  /**
     * @minimum 1
     * @maximum 999999999
     */
  trading_account_id?: number;
  /**
     * @minLength 8
     * @maxLength 8
     * @pattern ^[0-9]{8}$
     */
  login?: string;
  /**
     * @minLength 3
     * @maxLength 24
     * @pattern ^[A-Za-z0-9_:-]+$
     */
  position?: string;
  /**
     * @minLength 3
     * @maxLength 24
     * @pattern ^[A-Z0-9._/-]+$
     */
  instrument?: string;
  side?: RiskEngineClosedPositionSide;
  open_time?: string;
  /**
     * @minimum 0
     * @maximum 1000
     */
  opened_lot?: number;
  /**
     * @minimum 0
     * @maximum 1000000
     */
  entry_price?: number;
  close_time?: string;
  /**
     * @minimum 0
     * @maximum 1000
     */
  closed_lot?: number;
  /**
     * @minimum 0
     * @maximum 1000000
     */
  close_price?: number;
  /**
     * @minimum 0
     * @maximum 1000000
     */
  contract_size?: number;
  /**
     * @minimum -1000000
     * @maximum 1000000
     */
  net_profit?: number;
}

export type IncidentFlag = typeof IncidentFlag[keyof typeof IncidentFlag];


export const IncidentFlag = {
  copy: 'copy',
  reverse: 'reverse',
} as const;

export interface Incident {
  /**
     * @minLength 3
     * @maxLength 24
     * @pattern ^[A-Z0-9._/-]+$
     */
  instrument?: string;
  /**
     * Time lag in seconds between mother and child positions
     * @minimum 0
     * @maximum 86400
     */
  lag?: number;
  flag?: IncidentFlag;
  mother_position?: RiskEngineClosedPosition;
  child_position?: RiskEngineClosedPosition;
}

export interface IncidentsResponse {
  collection?: Incident[];
}

export interface SimilarAccount {
  /**
     * @minimum 1
     * @maximum 999999999
     */
  mother_trading_account_id?: number;
  /**
     * @minLength 8
     * @maxLength 8
     * @pattern ^[0-9]{8}$
     */
  mother_trading_account_login?: string;
  /**
     * @minLength 2
     * @maxLength 32
     * @pattern ^[a-z0-9_-]+$
     */
  mother_platform?: string;
  /**
     * @minimum 1
     * @maximum 999999999
     */
  child_trading_account_id?: number;
  /**
     * @minLength 8
     * @maxLength 8
     * @pattern ^[0-9]{8}$
     */
  child_trading_account_login?: string;
  /**
     * @minLength 2
     * @maxLength 32
     * @pattern ^[a-z0-9_-]+$
     */
  child_platform?: string;
  same_country?: boolean;
  matching_cid?: boolean;
  matching_ip?: boolean;
  /**
     * @minimum 0
     * @maximum 100
     */
  score?: number;
  updated_at?: string;
  flags?: MatchingFlagEnum[];
}

export interface SimilarAccountsResponse {
  collection?: SimilarAccount[];
}

export interface RiskEnginePageMeta {
  /** Whether the risk engine has a next page */
  has_next: boolean;
  /**
     * Current risk engine page number
     * @minimum 1
     * @maximum 10000
     */
  page: number;
  /**
     * Number of records returned by the risk engine for the current page
     * @minimum 0
     * @maximum 10000
     */
  count: number;
}

export interface FlaggedAccountsResponse {
  collection?: SimilarAccount[];
  meta?: RiskEnginePageMeta;
}

/**
 * IP anomaly prediction code. Values below are known examples; Risk Engine may add more prediction codes.
 * @minLength 2
 * @maxLength 64
 * @pattern ^[A-Z0-9_]+$
 */
export type PredictionCodeEnum = string;

export interface IpAnomaly {
  /**
     * @minimum 1
     * @maximum 999999999
     */
  user_id?: number;
  prediction_code?: PredictionCodeEnum;
  /**
     * @minLength 12
     * @maxLength 160
     */
  comment?: string;
  event_time?: string;
}

export interface IpAnomaliesResponse {
  collection?: IpAnomaly[];
}

export interface CountryControls {
  allow_user_creation?: boolean;
  restricted_email_domains?: string[];
  onboarding_additional_questions?: boolean;
  allow_trading_account_creation?: boolean;
  /** @nullable */
  demo_account_limit?: number | null;
  /** @nullable */
  live_account_limit?: number | null;
  allow_deposit?: boolean;
  /** @nullable */
  min_deposit?: number | null;
  /** @nullable */
  max_deposit?: number | null;
  /** @nullable */
  daily_deposit_limit?: number | null;
  restricted_deposit_methods?: string[];
  allow_withdrawal?: boolean;
  /** @nullable */
  min_withdrawal_amount?: number | null;
  /** @nullable */
  max_withdrawal_amount?: number | null;
  /** @nullable */
  daily_withdrawal_limit?: number | null;
  /** @nullable */
  withdrawal_cooldown_period_minutes?: number | null;
  restricted_withdrawal_methods?: string[];
  /** @nullable */
  min_internal_transfer_amount?: number | null;
  /** @nullable */
  max_internal_transfer_amount?: number | null;
  /** @nullable */
  internal_transfer_cooldown_period_seconds?: number | null;
  account_inwards_transfer_allowed?: boolean;
  account_outwards_transfer_allowed?: boolean;
}

export interface Country {
  id: number;
  name: string;
  iso_code: string;
  brand_id: number;
  brand_name: string;
  controls: CountryControls;
  created_at?: string;
  updated_at?: string;
}

export interface CountriesListResponse {
  collection: Country[];
  meta: PaginationMeta;
}

export type CountriesFilterMetadataResponseFieldsBrandsItem = {
  name: string;
  value: number;
};

export type CountriesFilterMetadataResponseFields = {
  brands: CountriesFilterMetadataResponseFieldsBrandsItem[];
};

export interface CountriesFilterMetadataResponse {
  count: number;
  fields: CountriesFilterMetadataResponseFields;
}

export type UpdateCountryRequestBodyCountry = {
  brand_id?: number;
  controls?: CountryControls;
};

export interface UpdateCountryRequestBody {
  country: UpdateCountryRequestBodyCountry;
}

export type CountryResponseData = {
  country: Country;
};

export interface CountryResponse {
  message: string;
  data: CountryResponseData;
}

export interface BrandOption {
  label: string;
  value: number;
}

export interface CountryEditResponse {
  brand_id: number;
  brands: BrandOption[];
  brand_options: BrandOption[];
  controls: CountryControls;
}

export type AdminIpWhitelistRequestSerializerStatus = typeof AdminIpWhitelistRequestSerializerStatus[keyof typeof AdminIpWhitelistRequestSerializerStatus];


export const AdminIpWhitelistRequestSerializerStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
} as const;

export interface AdminIpWhitelistRequestSerializer {
  id: number;
  ip_address: string;
  status: AdminIpWhitelistRequestSerializerStatus;
  /** @nullable */
  rejection_reason?: string | null;
  /** @nullable */
  reviewed_at?: string | null;
  created_at: string;
  updated_at: string;
  user_id: number;
  /** @nullable */
  user_email?: string | null;
  /** @nullable */
  user_name?: string | null;
  /** @nullable */
  reviewed_by_name?: string | null;
  /**
     * Relative path to the attached proof document.
     * @nullable
     */
  proof_document_url?: string | null;
}

export interface UserRiskScore {
  /**
     * @minimum 1
     * @maximum 999999999
     */
  user_id: number;
  /**
     * @minimum 0
     * @maximum 100
     */
  score: number;
  financial: RiskScoreFinancial;
  toxicity: RiskScoreToxicity;
  abuse: RiskScoreAbuse;
}

/**
 * Not Found
 */
export type N404Response = ResourceNotFoundError;

/**
 * Invalid Record Error
 */
export type N422Response = InvalidRecordError;

/**
 * Internal Server Error
 */
export type N500Response = InternalServerError;

export type DiscountTierMutationResponseResponseData = {
  discount_tier: DiscountTier;
};

export type DiscountTierMutationResponseResponse = {
  message: string;
  data: DiscountTierMutationResponseResponseData;
};

/**
 * Filter by user id
 */
export type UserIdSearchParamParameter = number;

/**
 * Filter by deposit statuses
 */
export type DepositStatusesParamParameter = DepositStatusEnum[];

/**
 * Filter by amount lower end
 */
export type AmountFromParameter = number;

/**
 * Filter by amount higher end
 */
export type AmountToParameter = number;

/**
 * Filter by created_at_from
 */
export type CreatedAtFromParamParameter = string;

/**
 * Filter by created_at_to
 */
export type CreatedAtToParamParameter = string;

/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
export type ExcludeTestDataParameter = boolean;

/**
 * Cursor pagination - after
 */
export type PaginationAfterParamParameter = string;

/**
 * Cursor pagination - before
 */
export type PaginationBeforeParamParameter = string;

export type OrderDirectionParamParameter = typeof OrderDirectionParamParameter[keyof typeof OrderDirectionParamParameter];


export const OrderDirectionParamParameter = {
  asc: 'asc',
  desc: 'desc',
} as const;

/**
 * Limit for returning records (default is 50)
 */
export type LimitParamParameter = number;

/**
 * Filter by updated_at_from
 */
export type PayoutLastUpdateFromParamParameter = string;

/**
 * Filter by updated_at to
 */
export type PayoutLastUpdateToParamParameter = string;

/**
 * Filter by payout statuses
 */
export type PayoutStatusesParamParameter = PayoutStatus[];

/**
 * Filter by tags
 */
export type TagListParameter = string[];

/**
 * Filter by payout types
 */
export type PayoutTypesParamParameter = PayoutPayoutType[];

/**
 * Filter by payment methods
 */
export type PayoutPaymentMethodsParamParameter = PayoutPaymentMethod[];

/**
 * Filter by risk statuses
 */
export type PayoutRiskStatusesParamParameter = (PayoutRiskStatus | null)[];

/**
 * Filter by assignee id
 */
export type PayoutAssigneeIdParamParameter = number;

/**
 * Filter by account type
 */
export type PayoutAccountTypesParamParameter = AccountTypeEnum[];

/**
 * Filter by payout cycle
 */
export type PayoutPayoutCyclesParamParameter = ChallengePayoutCycleEnum[];

/**
 * Filter by trading account template ids
 */
export type PayoutTemplateIdsParamParameter = number[];

export type CurrenciesParameter = CurrenciesFilter;

/**
 * Filter by email/name/last name
 */
export type SearchFieldParamParameter = string;

/**
 * Filter by title/subject/body
 */
export type EmailTemplateSearchParamParameter = string;

/**
 * Filter by payout ids
 */
export type FiltersIdsParameter = number[];

/**
 * Filter by user id
 */
export type FiltersFilterUserIdParameter = number;

/**
 * Filter by assignee id
 */
export type FiltersAssigneeIdParameter = number;

/**
 * Filter payouts updated after this date
 */
export type FiltersLastUpdateFromParameter = string;

/**
 * Filter payouts updated before this date
 */
export type FiltersLastUpdateToParameter = string;

/**
 * Filter by payout statuses
 */
export type FiltersStatusesParameter = PayoutStatus[];

/**
 * Filter by payout types
 */
export type FiltersPayoutTypesParameter = PayoutPayoutType[];

/**
 * Filter by payment methods
 */
export type FiltersPaymentMethodsParameter = PayoutPaymentMethod[];

/**
 * Filter by risk statuses
 */
export type FiltersRiskStatusesParameter = (PayoutRiskStatus | null)[];

/**
 * Filter by account types
 */
export type FiltersAccountTypesParameter = AccountTypeEnum[];

/**
 * Filter by payout cycles
 */
export type FiltersPayoutCyclesParameter = ChallengePayoutCycleEnum[];

/**
 * Filter by trading account template ids
 */
export type FiltersTemplateIdsParameter = number[];

/**
 * Filter by minimal payout amount
 */
export type FiltersAmountFromParameter = number;

/**
 * Filter by maximal payout amount
 */
export type FiltersAmountToParameter = number;

/**
 * Search by email/name/last name
 */
export type FiltersSearchFieldParameter = string;

/**
 * Order by field name
 */
export type FiltersFieldParameter = string;

export type FiltersDirectionParameter = typeof FiltersDirectionParameter[keyof typeof FiltersDirectionParameter];


export const FiltersDirectionParameter = {
  asc: 'asc',
  desc: 'desc',
} as const;

/**
 * Maximum number of results
 */
export type FiltersLimitParameter = number;

/**
 * Exclude records tagged with any of the given tags
 */
export type ExcludedTagListParameter = string[];

/**
 * Filter by email
 */
export type UserEmailParamParameter = string;

/**
 * Filter by KYC first_name or last_name
 */
export type UserKycNameParamParameter = string;

/**
 * Filter by country code
 */
export type UserCountryParamParameter = string[];

/**
 * Filter by phone number verification status
 */
export type PhoneNumberVerificationStatusParamParameter = string[];

/**
 * Filter by rise onboard status
 */
export type RiseOnboardingStatusParamParameter = string[];

/**
 * Filter by kycaid verification status
 */
export type KycaidVerificationStatusParamParameter = string[];

/**
 * Filter users with trust profile score greater than or equal to this value
 */
export type TrustProfileScoreFromParameter = number;

/**
 * Filter users with trust profile score less than or equal to this value
 */
export type TrustProfileScoreToParameter = number;

/**
 * Filter by start date starting from
 */
export type CreatedAtFromParameter = string;

/**
 * Filter by created_at ending to
 */
export type CreatedAtToParameter = string;

/**
 * Filter by platform
 */
export type PlatformParameter = PlatformEnum[];

/**
 * Filter by phase
 */
export type PhaseParameter = PhaseEnum[];

/**
 * Filter by whether the IP address is a VPN
 */
export type IsVpnParameter = boolean;

/**
 * Filter by activity_type
 */
export type ActivityTypeParameter = IpActivityTypeEnum[];

/**
 * Filter by account type
 */
export type AccountTypeParameter = AccountTypeEnum[];

export type AccountSizeFromParameter = AccountSizeEnum;

export type AccountSizeToParameter = AccountSizeEnum;

/**
 * Filter by status
 */
export type TradingAccountStatusParameter = TradingAccountStatusEnum[];

/**
 * Filter by date started
 */
export type StartedAtFromParameter = string;

/**
 * Filter by date started
 */
export type StartedAtToParameter = string;

/**
 * Filter by date ended
 */
export type EndedAtFromParameter = string;

/**
 * Filter by date ended
 */
export type EndedAtToParameter = string;

/**
 * Filter by acceptance source
 */
export type PolicyAcceptanceSourceParamParameter = PolicyAcceptanceSourceEnum[];

/**
 * Filter by policy scope
 */
export type PolicyScopeParamParameter = PolicyScopeEnum[];

/**
 * Filter by login
 */
export type TradingAccountSearchFieldParameter = string;

/**
 * Filter by trading account login
 */
export type TradingAccountLoginParameter = string;

export type AccountSizeUsdFromParameter = AccountSizeEnum;

export type AccountSizeUsdToParameter = AccountSizeEnum;

/**
 * Filter from balance
 */
export type BalanceFromParameter = number;

/**
 * Filter to balance
 */
export type BalanceToParameter = number;

/**
 * Filter by scope
 */
export type ScopesParameter = PolicyScopeEnum[];

export type MandatoryParameter = boolean;

export type BrandIdParameter = number;

export type EffectiveFromFromParameter = string;

export type EffectiveFromToParameter = string;

/**
 * Filter by leverage
 */
export type LeverageParametersParameter = LeverageEnum[];

/**
 * Filter by swap_free
 */
export type SwapFreeParametersParameter = boolean;

/**
 * Filter by close_only
 */
export type CloseOnlyParametersParameter = boolean;

/**
 * Trading account IDs to get the data for
 */
export type TradingAccountsIdsParameter = number[];

export type TradingAccountActionTypeParamParameterItem = typeof TradingAccountActionTypeParamParameterItem[keyof typeof TradingAccountActionTypeParamParameterItem];


export const TradingAccountActionTypeParamParameterItem = {
  buy: 'buy',
  sell: 'sell',
} as const;

/**
 * Filter by action type
 */
export type TradingAccountActionTypeParamParameter = TradingAccountActionTypeParamParameterItem[];

/**
 * Filter by trade symbol
 */
export type TradingAccountSymbolParamParameter = string;

/**
 * Filter by opened_at starting from
 */
export type TradingAccountOpenedAtFromParamParameter = string;

/**
 * Filter by opened_at ending to
 */
export type TradingAccountOpenedAtToParamParameter = string;

/**
 * Filter by closed_at starting from
 */
export type TradingAccountClosedAtFromParamParameter = string;

/**
 * Filter by closed_at ending to
 */
export type TradingAccountClosedAtToParamParameter = string;

/**
 * Filter by lot_size starting from
 */
export type TradingAccountLotSizeFromParamParameter = number;

/**
 * Filter by lot_size starting to
 */
export type TradingAccountLotSizeToParamParameter = number;

export type TradingAccountViolationReasonParamParameter = typeof TradingAccountViolationReasonParamParameter[keyof typeof TradingAccountViolationReasonParamParameter];


export const TradingAccountViolationReasonParamParameter = {
  profit_threshold: 'profit_threshold',
  news_trading: 'news_trading',
  manual_review: 'manual_review',
  single_price_movement: 'single_price_movement',
  hft_trade_style: 'hft_trade_style',
  lots_exposure_limit: 'lots_exposure_limit',
} as const;

/**
 * Profit starting from
 */
export type TradingAccountProfitFromParamParameter = number;

/**
 * Profit starting to
 */
export type TradingAccountProfitToParamParameter = number;

/**
 * Filter by trade symbol
 */
export type TradingAccountTradeSymbolParamParameter = string;

export type TradingAccountViolationStatusParamParameter = typeof TradingAccountViolationStatusParamParameter[keyof typeof TradingAccountViolationStatusParamParameter];


export const TradingAccountViolationStatusParamParameter = {
  no_violation: 'no_violation',
  violation_pending: 'violation_pending',
  violation_completed: 'violation_completed',
} as const;

export type SearchFilterResourceTypeParamParameter = typeof SearchFilterResourceTypeParamParameter[keyof typeof SearchFilterResourceTypeParamParameter];


export const SearchFilterResourceTypeParamParameter = {
  users: 'users',
  trading_accounts: 'trading_accounts',
  user_ip_activities: 'user_ip_activities',
  transactions: 'transactions',
  referrals: 'referrals',
  email_templates: 'email_templates',
  open_positions: 'open_positions',
  closed_positions: 'closed_positions',
  payouts: 'payouts',
  challenges: 'challenges',
  trading_account_ip_activities: 'trading_account_ip_activities',
  notes: 'notes',
  risk_engine_flagged_accounts: 'risk_engine_flagged_accounts',
  risk_engine_similar_trading_accounts: 'risk_engine_similar_trading_accounts',
  risk_engine_similar_user_accounts: 'risk_engine_similar_user_accounts',
  risk_engine_trading_account_incidents: 'risk_engine_trading_account_incidents',
  risk_engine_user_incidents: 'risk_engine_user_incidents',
  withdrawals: 'withdrawals',
  groups: 'groups',
  deposits: 'deposits',
  competitions: 'competitions',
  policies: 'policies',
  user_policy_acceptances: 'user_policy_acceptances',
  ib_profiles: 'ib_profiles',
} as const;

/**
 * Filter by coupon name or code
 */
export type CouponsSearchFieldParamParameter = string;

/**
 * Filter by valid from starting from
 */
export type ValidFromFromParameter = string;

/**
 * Filter by valid from ending
 */
export type ValidFromToParameter = string;

/**
 * Filter by valid till starting from
 */
export type ValidTillFromParameter = string;

/**
 * Filter by valid till end
 */
export type ValidTillToParameter = string;

/**
 * Filter by coupon redemption limit lower end
 */
export type RedemptionLimitFromParameter = number;

/**
 * Filter by coupon redemption limit higher end
 */
export type RedemptionLimitToParameter = number;

/**
 * Filter by coupon redemption count lower end
 */
export type RedemptionsCountFromParameter = number;

/**
 * Filter by coupon redemption count higher end
 */
export type RedemptionsCountToParameter = number;

/**
 * Filter by target type. Must be combined with target_id; otherwise ignored.
 */
export type AuditLogTargetTypeParamParameter = string;

/**
 * Filter by target id. Must be combined with target_type; otherwise ignored.
 */
export type AuditLogTargetIdParamParameter = number;

/**
 * Filter by withdrawal statuses
 */
export type WithdrawalStatusesParamParameter = WithdrawalStatusEnum[];

/**
 * Filter by IB profile statuses
 */
export type IbProfileStatusesParamParameter = IbProfileStatusEnum[];

/**
 * Filter by user email
 */
export type UserExceptionsSearchFieldParamParameter = string;

/**
 * Filter by competition status
 */
export type CompetitionStatusesParamParameter = CompetitionStatusEnum[];

/**
 * Filter by competition type
 */
export type CompetitionTypesParamParameter = CompetitionTypeEnum[];

/**
 * Filter competitions starting at or after this date
 */
export type StartsAtFromParamParameter = string;

/**
 * Filter competitions starting at or before this date
 */
export type StartsAtToParamParameter = string;

/**
 * Filter competitions ending at or after this date
 */
export type EndsAtFromParamParameter = string;

/**
 * Filter competitions ending at or before this date
 */
export type EndsAtToParamParameter = string;

/**
 * Filter by status
 */
export type StatusesParamParameter = ScheduleStatus[];

/**
 * Filter by scheduled_at_from
 */
export type ScheduledAtFromParamParameter = string;

/**
 * Filter by scheduled_at_to
 */
export type ScheduledAtToParamParameter = string;

/**
 * Filter by the type of the object associated with the scheduled action.
 */
export type SchedulableTypeParamParameter = SchedulableType[];

export type RiskEngineStartTimeParamParameter = string;

export type RiskEngineEndTimeParamParameter = string;

export type RiskEngineWindowSizeParamParameter = number;

/**
 * Filter by matching flags
 */
export type RiskEngineFlagsParamParameter = MatchingFlagEnum[];

/**
 * Filter by minimum score
 */
export type RiskEngineScoreMinParamParameter = number;

/**
 * Filter by maximum score
 */
export type RiskEngineScoreMaxParamParameter = number;

export type RiskEnginePageParamParameter = number;

export type RiskEngineSizeParamParameter = number;

/**
 * Number of days to look back
 */
export type RiskEngineDaysParamParameter = number;

export type ListDepositsParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by deposit statuses
 */
'statuses[]'?: DepositStatusesParamParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: ListDepositsField;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type ListDepositsField = typeof ListDepositsField[keyof typeof ListDepositsField];


export const ListDepositsField = {
  amount: 'amount',
  created_at: 'created_at',
} as const;

export type GetDepositsFilterMetadataParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by deposit statuses
 */
'statuses[]'?: DepositStatusesParamParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
};

export type ListPayoutsParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Filter by updated_at_from
 */
last_update_from?: PayoutLastUpdateFromParamParameter;
/**
 * Filter by updated_at to
 */
last_update_to?: PayoutLastUpdateToParamParameter;
/**
 * Filter by payout statuses
 */
'statuses[]'?: PayoutStatusesParamParameter;
/**
 * Filter by tags
 */
'tag_list[]'?: TagListParameter;
/**
 * Filter by payout types
 */
'payout_types[]'?: PayoutTypesParamParameter;
/**
 * Filter by payment methods
 */
'payment_methods[]'?: PayoutPaymentMethodsParamParameter;
/**
 * Filter by risk statuses
 */
'risk_statuses[]'?: PayoutRiskStatusesParamParameter;
/**
 * Filter by assignee id
 */
assignee_id?: PayoutAssigneeIdParamParameter;
/**
 * Filter by account type
 */
'account_types[]'?: PayoutAccountTypesParamParameter;
/**
 * Filter by payout cycle
 */
'payout_cycles[]'?: PayoutPayoutCyclesParamParameter;
/**
 * Filter by trading account template ids
 */
'template_ids[]'?: PayoutTemplateIdsParamParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by currency
 */
'currencies[]'?: CurrenciesParameter;
/**
 * Filter by email/name/last name
 */
search_field?: SearchFieldParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type GetPayoutsFilterMetadataParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by email/name/last name
 */
search_field?: SearchFieldParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Filter by updated_at_from
 */
last_update_from?: PayoutLastUpdateFromParamParameter;
/**
 * Filter by tags
 */
'tag_list[]'?: TagListParameter;
/**
 * Filter by updated_at to
 */
last_update_to?: PayoutLastUpdateToParamParameter;
/**
 * Filter by payout statuses
 */
'statuses[]'?: PayoutStatusesParamParameter;
/**
 * Filter by payout types
 */
'payout_types[]'?: PayoutTypesParamParameter;
/**
 * Filter by payment methods
 */
'payment_methods[]'?: PayoutPaymentMethodsParamParameter;
/**
 * Filter by risk statuses
 */
'risk_statuses[]'?: PayoutRiskStatusesParamParameter;
/**
 * Filter by assignee id
 */
assignee_id?: PayoutAssigneeIdParamParameter;
/**
 * Filter by account type
 */
'account_types[]'?: PayoutAccountTypesParamParameter;
/**
 * Filter by payout cycle
 */
'payout_cycles[]'?: PayoutPayoutCyclesParamParameter;
/**
 * Filter by trading account template ids
 */
'template_ids[]'?: PayoutTemplateIdsParamParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by currency
 */
'currencies[]'?: CurrenciesParameter;
};

export type GetPayoutsWidgetsParams = {
/**
 * Filter by email/name/last name
 */
search_field?: SearchFieldParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Filter by updated_at_from
 */
last_update_from?: PayoutLastUpdateFromParamParameter;
/**
 * Filter by updated_at to
 */
last_update_to?: PayoutLastUpdateToParamParameter;
/**
 * Filter by payout statuses
 */
'statuses[]'?: PayoutStatusesParamParameter;
/**
 * Filter by payout types
 */
'payout_types[]'?: PayoutTypesParamParameter;
/**
 * Filter by payment methods
 */
'payment_methods[]'?: PayoutPaymentMethodsParamParameter;
/**
 * Filter by risk statuses
 */
'risk_statuses[]'?: PayoutRiskStatusesParamParameter;
/**
 * Filter by assignee id
 */
assignee_id?: PayoutAssigneeIdParamParameter;
/**
 * Filter by account type
 */
'account_types[]'?: PayoutAccountTypesParamParameter;
/**
 * Filter by payout cycle
 */
'payout_cycles[]'?: PayoutPayoutCyclesParamParameter;
/**
 * Filter by trading account template ids
 */
'template_ids[]'?: PayoutTemplateIdsParamParameter;
};

export type EmailTemplatesIndexParams = {
/**
 * Filter by title/subject/body
 */
search_field?: EmailTemplateSearchParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type GetEmailTemplateFilterMetadataParams = {
/**
 * Filter by title/subject/body
 */
search_field?: EmailTemplateSearchParamParameter;
};

export type GetEmailTemplateFilterMetadata200 = {
  count: number;
};

export type ListPayoutBulkActionParamsParams = {
/**
 * Bulk action name
 */
action_name: string;
/**
 * Filter by payout ids
 */
'filters[ids][]'?: FiltersIdsParameter;
/**
 * Filter by user id
 */
'filters[filter_user_id]'?: FiltersFilterUserIdParameter;
/**
 * Filter by assignee id
 */
'filters[assignee_id]'?: FiltersAssigneeIdParameter;
/**
 * Filter payouts updated after this date
 */
'filters[last_update_from]'?: FiltersLastUpdateFromParameter;
/**
 * Filter payouts updated before this date
 */
'filters[last_update_to]'?: FiltersLastUpdateToParameter;
/**
 * Filter by payout statuses
 */
'filters[statuses][]'?: FiltersStatusesParameter;
/**
 * Filter by payout types
 */
'filters[payout_types][]'?: FiltersPayoutTypesParameter;
/**
 * Filter by payment methods
 */
'filters[payment_methods][]'?: FiltersPaymentMethodsParameter;
/**
 * Filter by risk statuses
 */
'filters[risk_statuses][]'?: FiltersRiskStatusesParameter;
/**
 * Filter by account types
 */
'filters[account_types][]'?: FiltersAccountTypesParameter;
/**
 * Filter by payout cycles
 */
'filters[payout_cycles][]'?: FiltersPayoutCyclesParameter;
/**
 * Filter by trading account template ids
 */
'filters[template_ids][]'?: FiltersTemplateIdsParameter;
/**
 * Filter by minimal payout amount
 */
'filters[amount_from]'?: FiltersAmountFromParameter;
/**
 * Filter by maximal payout amount
 */
'filters[amount_to]'?: FiltersAmountToParameter;
/**
 * Search by email/name/last name
 */
'filters[search_field]'?: FiltersSearchFieldParameter;
/**
 * Order by field name
 */
'filters[field]'?: FiltersFieldParameter;
/**
 * Sorting direction
 */
'filters[direction]'?: FiltersDirectionParameter;
/**
 * Maximum number of results
 */
'filters[limit]'?: FiltersLimitParameter;
};

export type ListUsersParams = {
/**
 * Filter by email/name/last name
 */
search_field?: SearchFieldParamParameter;
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by tags
 */
'tag_list[]'?: TagListParameter;
/**
 * Exclude records tagged with any of the given tags
 */
'excluded_tag_list[]'?: ExcludedTagListParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
/**
 * Filter by email
 */
email?: UserEmailParamParameter;
/**
 * Filter by KYC first_name or last_name
 */
kyc_name?: UserKycNameParamParameter;
/**
 * Filter by country code
 */
'country[]'?: UserCountryParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Filter by phone number verification status
 */
'phone_number_verification_status[]'?: PhoneNumberVerificationStatusParamParameter;
/**
 * Filter by rise onboard status
 */
'rise_onboarding_status[]'?: RiseOnboardingStatusParamParameter;
/**
 * Filter by kycaid verification status
 */
'kycaid_verification_status[]'?: KycaidVerificationStatusParamParameter;
/**
 * Filter users with trust profile score greater than or equal to this value
 */
trust_profile_score_from?: TrustProfileScoreFromParameter;
/**
 * Filter users with trust profile score less than or equal to this value
 */
trust_profile_score_to?: TrustProfileScoreToParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Order by field
 */
field?: string;
};

export type ListAccountManagersParams = {
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field, supported fields email, id
 */
field?: string;
};

export type ListAccountManagers200 = {
  collection?: AccountManager[];
};

export type ListAppSettings200 = {
  collection?: AppSettingDefinition[];
};

export type GetUserFilterMetadataParams = {
/**
 * Filter by tags
 */
'tag_list[]'?: TagListParameter;
/**
 * Exclude records tagged with any of the given tags
 */
'excluded_tag_list[]'?: ExcludedTagListParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
/**
 * Filter by email/name/last name
 */
search_field?: SearchFieldParamParameter;
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by email
 */
email?: UserEmailParamParameter;
/**
 * Filter by KYC first_name or last_name
 */
kyc_name?: UserKycNameParamParameter;
/**
 * Filter by country code
 */
'country[]'?: UserCountryParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Filter by phone number verification status
 */
'phone_number_verification_status[]'?: PhoneNumberVerificationStatusParamParameter;
/**
 * Filter by rise onboard status
 */
'rise_onboarding_status[]'?: RiseOnboardingStatusParamParameter;
/**
 * Filter by kycaid verification status
 */
'kycaid_verification_status[]'?: KycaidVerificationStatusParamParameter;
};

export type GetUserFilterMetadata200FieldsBrandsItem = {
  name: string;
  value: number;
};

/**
 * Mapping of country names to their ISO codes
 */
export type GetUserFilterMetadata200FieldsCountries = {[key: string]: string};

export type GetUserFilterMetadata200Fields = {
  brands: GetUserFilterMetadata200FieldsBrandsItem[];
  tags: Tags;
  kycaid_verification_statuses: string[];
  rise_onboarding_statuses: string[];
  phone_number_verification_statuses: string[];
  /** Mapping of country names to their ISO codes */
  countries: GetUserFilterMetadata200FieldsCountries;
};

export type GetUserFilterMetadata200 = {
  count: number;
  fields: GetUserFilterMetadata200Fields;
};

export type ExportDataParams = {
/**
 * Model name for export (e.g., user, trading_account, payout, balance_transaction)
 */
model: string;
/**
 * The type of export, e.g. all_data, balance_sheet_data (default is all_data)
 */
exporter?: string;
/**
 * The number of items to export
 */
items?: number;
/**
 * The string indicating sorting order
 */
order?: string;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * The id of trading account (required for balance_sheet_data exporter)
 */
trading_account_id?: number;
/**
 * A set of fields for data filtering, depending on the selected model
 * Example properties for a "user" model; may vary for other models:
 */
search_filter?: UserSearchFilter;
};

export type ListPayoutActionParamsParams = {
/**
 * Action name
 */
action_name: string;
};

export type CancelPayoutBody = {
  /** Reason for declining */
  reason?: string;
};

export type ListPayoutTransactionActionParamsParams = {
/**
 * Action name
 */
action_name: ListPayoutTransactionActionParamsActionName;
};

export type ListPayoutTransactionActionParamsActionName = typeof ListPayoutTransactionActionParamsActionName[keyof typeof ListPayoutTransactionActionParamsActionName];


export const ListPayoutTransactionActionParamsActionName = {
  replace: 'replace',
} as const;

export type ListUserActionParamsParams = {
/**
 * Action name
 */
action_name: string;
};

export type GenerateDisputeBody = {
  account_type: string;
};

export type ChangeUserBrandBody = {
  /** The ID of the target brand. */
  brand_id: number;
};

export type CreateUserWithdrawalBodyDepositRefundTransactionsItem = {
  /** UUID of the refundable deposit payment session. */
  payment_session_uuid: string;
  /** Amount to refund from this session (up to its refundable amount). */
  amount: number;
};

/**
 * External method used for the part paid outside deposit refunds.
 */
export type CreateUserWithdrawalBodyPaymentMethod = typeof CreateUserWithdrawalBodyPaymentMethod[keyof typeof CreateUserWithdrawalBodyPaymentMethod];


export const CreateUserWithdrawalBodyPaymentMethod = {
  manual: 'manual',
} as const;

export type CreateUserWithdrawalBody = {
  /** Deposit payment sessions to refund, each for the given amount. */
  deposit_refund_transactions?: CreateUserWithdrawalBodyDepositRefundTransactionsItem[];
  /** External method used for the part paid outside deposit refunds. */
  payment_method?: CreateUserWithdrawalBodyPaymentMethod;
  /** Amount sent via the external payment method. */
  amount?: number;
  /** External transaction id (the id as it appears in the PSP), when known. */
  external_identifier?: string;
  /** Mandatory operator reason, recorded as a note on the withdrawal. */
  reason: string;
};

/**
 * Payment rail the deposit is recorded against.
 */
export type CreateUserDepositBodyProvider = typeof CreateUserDepositBodyProvider[keyof typeof CreateUserDepositBodyProvider];


export const CreateUserDepositBodyProvider = {
  manual: 'manual',
} as const;

/**
 * Payment method the original payment was made with, when known.
 */
export type CreateUserDepositBodyPaymentMethod = typeof CreateUserDepositBodyPaymentMethod[keyof typeof CreateUserDepositBodyPaymentMethod];


export const CreateUserDepositBodyPaymentMethod = {
  BASIC_CARD: 'BASIC_CARD',
  CRYPTO: 'CRYPTO',
  OTHER: 'OTHER',
} as const;

export type CreateUserDepositBody = {
  /** Payment rail the deposit is recorded against. */
  provider: CreateUserDepositBodyProvider;
  /** External transaction ID from the provider (the real Paymaxis payment id), when known. Optional, but when supplied it must not be known to the system on any payment rail: if a payment session already carries this identifier the request fails with 422 and `already_exists`, and that error's `data` names the record the identifier is already attached to. */
  payment_identifier?: string;
  /** Payment method the original payment was made with, when known. */
  payment_method?: CreateUserDepositBodyPaymentMethod;
  /** Deposit amount in the system currency (USD). */
  amount: number;
  /** Mandatory operator reason, recorded as a note on the deposit. */
  reason: string;
};

export type GetIpActivitiesParams = {
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Filter by whether the IP address is a VPN
 */
is_vpn?: IsVpnParameter;
/**
 * Filter by activity_type
 */
'activity_type[]'?: ActivityTypeParameter;
/**
 * Filter by trading account login
 */
'trading_account_login[]'?: string[];
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: string;
};

export type GetFilterMetadataIpActivitiesParams = {
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Filter by whether the IP address is a VPN
 */
is_vpn?: IsVpnParameter;
/**
 * Filter by activity_type
 */
'activity_type[]'?: ActivityTypeParameter;
/**
 * Filter by trading account login
 */
'trading_account_login[]'?: string[];
};

export type GetSimilarUsers200 = {
  collection: SearchUserSerializer[];
};

export type GetEmailLogsParams = {
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type FilterMetadataChallengesForUserParams = {
/**
 * Filter by account type
 */
'account_type[]'?: AccountTypeParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Account size.
 */
account_size_from?: AccountSizeFromParameter;
/**
 * Account size.
 */
account_size_to?: AccountSizeToParameter;
/**
 * Filter by status
 */
'status[]'?: TradingAccountStatusParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by date started
 */
started_at_from?: StartedAtFromParameter;
/**
 * Filter by date started
 */
started_at_to?: StartedAtToParameter;
/**
 * Filter by date ended
 */
ended_at_from?: EndedAtFromParameter;
/**
 * Filter by date ended
 */
ended_at_to?: EndedAtToParameter;
};

export type ListChallengesForUserParams = {
/**
 * Filter by account type
 */
'account_type[]'?: AccountTypeParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Account size.
 */
account_size_from?: AccountSizeFromParameter;
/**
 * Account size.
 */
account_size_to?: AccountSizeToParameter;
/**
 * Filter by status
 */
'status[]'?: TradingAccountStatusParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by date started
 */
started_at_from?: StartedAtFromParameter;
/**
 * Filter by date started
 */
started_at_to?: StartedAtToParameter;
/**
 * Filter by date ended
 */
ended_at_from?: EndedAtFromParameter;
/**
 * Filter by date ended
 */
ended_at_to?: EndedAtToParameter;
/**
 * Order by field, e.g., "trading_accounts.created_at"
 */
field?: string;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
};

export type CreateChallengeForUserBodyChallenge = {
  template_id: number;
  platform: PlatformEnum;
};

export type CreateChallengeForUserBody = {
  challenge: CreateChallengeForUserBodyChallenge;
};

export type GetUserPolicyAcceptancesParams = {
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Filter by acceptance source
 */
source?: PolicyAcceptanceSourceParamParameter;
/**
 * Filter by policy scope
 */
policy_scope?: PolicyScopeParamParameter;
/**
 * Order by field
 */
field?: string;
};

export type GetUserPolicyAcceptancesFilterMetadataParams = {
/**
 * Filter by acceptance source
 */
source?: PolicyAcceptanceSourceParamParameter;
/**
 * Filter by policy scope
 */
policy_scope?: PolicyScopeParamParameter;
};

export type ListTradingAccountsParams = {
/**
 * Filter by tags
 */
'tag_list[]'?: TagListParameter;
/**
 * Exclude records tagged with any of the given tags
 */
'excluded_tag_list[]'?: ExcludedTagListParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
/**
 * Filter by login
 */
search_field?: TradingAccountSearchFieldParameter;
/**
 * Filter by trading account login
 */
login?: TradingAccountLoginParameter;
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by account type
 */
'account_type[]'?: AccountTypeParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by currency
 */
'currencies[]'?: CurrenciesParameter;
/**
 * Account size.
 */
account_size_from?: AccountSizeFromParameter;
/**
 * Account size.
 */
account_size_to?: AccountSizeToParameter;
/**
 * Account size.
 */
account_size_usd_from?: AccountSizeUsdFromParameter;
/**
 * Account size.
 */
account_size_usd_to?: AccountSizeUsdToParameter;
/**
 * Filter by status
 */
'status[]'?: TradingAccountStatusParameter;
/**
 * Filter by date started
 */
started_at_from?: StartedAtFromParameter;
/**
 * Filter by date started
 */
started_at_to?: StartedAtToParameter;
/**
 * Filter by date ended
 */
ended_at_from?: EndedAtFromParameter;
/**
 * Filter by date ended
 */
ended_at_to?: EndedAtToParameter;
/**
 * Filter from balance
 */
balance_from?: BalanceFromParameter;
/**
 * Filter to balance
 */
balance_to?: BalanceToParameter;
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Order by field, supported fields id, account_size_usd, started_at, ended_at, payout_count, created_at
 */
field?: string;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
};

export type GetTradingAccountFilterMetadataParams = {
/**
 * Filter by tags
 */
'tag_list[]'?: TagListParameter;
/**
 * Exclude records tagged with any of the given tags
 */
'excluded_tag_list[]'?: ExcludedTagListParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
/**
 * Filter by login
 */
search_field?: TradingAccountSearchFieldParameter;
/**
 * Filter by trading account login
 */
login?: TradingAccountLoginParameter;
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by account type
 */
'account_type[]'?: AccountTypeParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by currency
 */
'currencies[]'?: CurrenciesParameter;
/**
 * Account size.
 */
account_size_from?: AccountSizeFromParameter;
/**
 * Account size.
 */
account_size_to?: AccountSizeToParameter;
/**
 * Account size.
 */
account_size_usd_from?: AccountSizeUsdFromParameter;
/**
 * Account size.
 */
account_size_usd_to?: AccountSizeUsdToParameter;
/**
 * Filter by status
 */
'status[]'?: TradingAccountStatusParameter;
/**
 * Filter by date started
 */
started_at_from?: StartedAtFromParameter;
/**
 * Filter by date started
 */
started_at_to?: StartedAtToParameter;
/**
 * Filter by date ended
 */
ended_at_from?: EndedAtFromParameter;
/**
 * Filter by date ended
 */
ended_at_to?: EndedAtToParameter;
/**
 * Filter from balance
 */
balance_from?: BalanceFromParameter;
/**
 * Filter to balance
 */
balance_to?: BalanceToParameter;
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
};

export type GetRelatedTradingAccounts200 = {
  collection: DetailedTradingAccount[];
};

export type ListTradingAccountActionParamsParams = {
/**
 * Action name
 */
action_name: string;
};

export type ListTradingAccountBulkActionParamsParams = {
/**
 * Bulk action name
 */
action_name: string;
};

export type GetTradingAccountIpActivitiesParams = {
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by whether the IP address is a VPN
 */
is_vpn?: IsVpnParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: string;
};

export type GetTradingAccountFilterMetadataIpActivitiesParams = {
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by whether the IP address is a VPN
 */
is_vpn?: IsVpnParameter;
};

export type RequestTradesFromRiskEngineParams = {
/**
 * Login of trading account to check trades against
 */
child_login: string;
/**
 * The detection window in minutes for the evidence report (must be between 1 and 20)
 */
window_size: number;
/**
 * The start time for the evidence report
 */
start_time?: string;
/**
 * The end time for the evidence report
 */
end_time?: string;
};

export type ListTemplatesParams = {
/**
 * Filter by name
 */
search_field?: string;
account_size?: number;
account_type?: string;
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by phase
 */
'phases[]'?: PhaseEnum[];
/**
 * Filter by currency
 */
'currencies[]'?: string[];
/**
 * Filter by default template status
 */
default_template?: boolean;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type GetTemplateFilterMetadataParams = {
/**
 * Field to search by
 */
search_field?: string;
/**
 * Filter by account_type
 */
'account_type[]'?: AccountTypeEnum[];
/**
 * Filter by account_size
 */
'account_size[]'?: AccountSizeEnum[];
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by phase
 */
'phases[]'?: PhaseEnum[];
/**
 * Filter by currency
 */
'currencies[]'?: string[];
/**
 * Filter by default template status
 */
default_template?: boolean;
};

export type ListPoliciesParams = {
/**
 * Filter by title, slug, or version
 */
search_field?: string;
/**
 * Filter by scope
 */
'scopes[]'?: ScopesParameter;
mandatory?: MandatoryParameter;
brand_id?: BrandIdParameter;
effective_from_from?: EffectiveFromFromParameter;
effective_from_to?: EffectiveFromToParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field, supported fields: id, created_at, effective_from
 */
field?: ListPoliciesField;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type ListPoliciesField = typeof ListPoliciesField[keyof typeof ListPoliciesField];


export const ListPoliciesField = {
  id: 'id',
  created_at: 'created_at',
  effective_from: 'effective_from',
} as const;

export type GetPolicyFilterMetadataParams = {
/**
 * Filter by title, slug, or version
 */
search_field?: string;
/**
 * Filter by scope
 */
'scopes[]'?: ScopesParameter;
mandatory?: MandatoryParameter;
brand_id?: BrandIdParameter;
effective_from_from?: EffectiveFromFromParameter;
effective_from_to?: EffectiveFromToParameter;
/**
 * Order by field, supported fields: id, created_at, effective_from
 */
field?: GetPolicyFilterMetadataField;
};

export type GetPolicyFilterMetadataField = typeof GetPolicyFilterMetadataField[keyof typeof GetPolicyFilterMetadataField];


export const GetPolicyFilterMetadataField = {
  id: 'id',
  created_at: 'created_at',
  effective_from: 'effective_from',
} as const;

export type ListGroupsParams = {
/**
 * Filter by email/name/last name
 */
search_field?: SearchFieldParamParameter;
/**
 * Filter by account type
 */
'account_type[]'?: AccountTypeParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Filter by currency
 */
'currencies[]'?: CurrenciesParameter;
/**
 * Filter by leverage
 */
'leverage[]'?: LeverageParametersParameter;
/**
 * Account size.
 */
account_size_from?: AccountSizeFromParameter;
/**
 * Account size.
 */
account_size_to?: AccountSizeToParameter;
/**
 * Filter by swap_free
 */
swap_free?: SwapFreeParametersParameter;
/**
 * Filter by close_only
 */
close_only?: CloseOnlyParametersParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type GetGroupFilterMetadataParams = {
/**
 * Filter by email/name/last name
 */
search_field?: SearchFieldParamParameter;
/**
 * Filter by account type
 */
'account_type[]'?: AccountTypeParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by phase
 */
'phase[]'?: PhaseParameter;
/**
 * Filter by currency
 */
'currencies[]'?: CurrenciesParameter;
/**
 * Filter by leverage
 */
'leverage[]'?: LeverageParametersParameter;
/**
 * Account size.
 */
account_size_from?: AccountSizeFromParameter;
/**
 * Account size.
 */
account_size_to?: AccountSizeToParameter;
/**
 * Filter by swap_free
 */
swap_free?: SwapFreeParametersParameter;
/**
 * Filter by close_only
 */
close_only?: CloseOnlyParametersParameter;
};

export type GetTradingAccountsRiskScoresParams = {
/**
 * Trading account IDs to get the data for
 */
'trading_accounts_ids[]'?: TradingAccountsIdsParameter;
};

export type CreateSessionBodyUser = {
  /** The email of the user */
  email: string;
  /** The password of the user */
  password: string;
  /** Whether to remember the session */
  remember_me?: boolean;
};

export type CreateSessionBody = {
  user: CreateSessionBodyUser;
};

export type CreateSession401ErrorsEmail = {
  error?: string;
};

export type CreateSession401Errors = {
  email?: CreateSession401ErrorsEmail;
};

export type CreateSession401 = {
  errors?: CreateSession401Errors;
};

export type OtpAttemptBodyUser = {
  otp_attempt?: string;
};

export type OtpAttemptBody = {
  user?: OtpAttemptBodyUser;
};

export type OtpAttempt422ErrorDetailsItem = {
  field?: string;
  message?: string;
  code?: string;
};

export type OtpAttempt422Error = {
  message?: string;
  details?: OtpAttempt422ErrorDetailsItem[];
};

export type OtpAttempt422 = {
  error?: OtpAttempt422Error;
};

export type CreateTradingAccountBodyTradingAccount = {
  /** Template id */
  template_id: number;
};

export type CreateTradingAccountBody = {
  trading_account: CreateTradingAccountBodyTradingAccount;
};

export type CreateTradingAccount422ErrorDetailsItem = {
  code?: string;
  message?: string;
  field?: string;
};

export type CreateTradingAccount422Error = {
  message?: string;
  request_id?: string;
  details?: CreateTradingAccount422ErrorDetailsItem[];
};

export type CreateTradingAccount422 = {
  error?: CreateTradingAccount422Error;
};

export type GetTradingAccountClosedPositionsParams = {
/**
 * Filter by action type
 */
'action_type[]'?: TradingAccountActionTypeParamParameter;
/**
 * Filter by trade symbol
 */
symbol?: TradingAccountSymbolParamParameter;
/**
 * Filter by opened_at starting from
 */
opened_at_from?: TradingAccountOpenedAtFromParamParameter;
/**
 * Filter by opened_at ending to
 */
opened_at_to?: TradingAccountOpenedAtToParamParameter;
/**
 * Filter by closed_at starting from
 */
closed_at_from?: TradingAccountClosedAtFromParamParameter;
/**
 * Filter by closed_at ending to
 */
closed_at_to?: TradingAccountClosedAtToParamParameter;
/**
 * Filter by lot_size starting from
 */
lot_size_from?: TradingAccountLotSizeFromParamParameter;
/**
 * Filter by lot_size starting to
 */
lot_size_to?: TradingAccountLotSizeToParamParameter;
/**
 * Filter by violation reason
 */
violation_reason?: TradingAccountViolationReasonParamParameter;
/**
 * Profit starting from
 */
profit_from?: TradingAccountProfitFromParamParameter;
/**
 * Profit starting to
 */
profit_to?: TradingAccountProfitToParamParameter;
};

export type GetFilterMetadataTradingAccountClosedPositionsParams = {
/**
 * Filter by action type
 */
'action_type[]'?: TradingAccountActionTypeParamParameter;
/**
 * Filter by trade symbol
 */
symbol?: TradingAccountSymbolParamParameter;
/**
 * Filter by opened_at starting from
 */
opened_at_from?: TradingAccountOpenedAtFromParamParameter;
/**
 * Filter by opened_at ending to
 */
opened_at_to?: TradingAccountOpenedAtToParamParameter;
/**
 * Filter by closed_at starting from
 */
closed_at_from?: TradingAccountClosedAtFromParamParameter;
/**
 * Filter by closed_at ending to
 */
closed_at_to?: TradingAccountClosedAtToParamParameter;
/**
 * Filter by lot_size starting from
 */
lot_size_from?: TradingAccountLotSizeFromParamParameter;
/**
 * Filter by lot_size starting to
 */
lot_size_to?: TradingAccountLotSizeToParamParameter;
/**
 * Filter by violation reason
 */
violation_reason?: TradingAccountViolationReasonParamParameter;
/**
 * Profit starting from
 */
profit_from?: TradingAccountProfitFromParamParameter;
/**
 * Profit starting to
 */
profit_to?: TradingAccountProfitToParamParameter;
};

export type GetTradingAccountOpenPositionsParams = {
/**
 * Filter by action type
 */
'action_type[]'?: TradingAccountActionTypeParamParameter;
/**
 * Filter by trade symbol
 */
trade_symbol?: TradingAccountTradeSymbolParamParameter;
/**
 * Filter by opened_at starting from
 */
opened_at_from?: TradingAccountOpenedAtFromParamParameter;
/**
 * Filter by opened_at ending to
 */
opened_at_to?: TradingAccountOpenedAtToParamParameter;
/**
 * Filter by lot_size starting from
 */
lot_size_from?: TradingAccountLotSizeFromParamParameter;
/**
 * Filter by lot_size starting to
 */
lot_size_to?: TradingAccountLotSizeToParamParameter;
/**
 * Filter by violation status
 */
violation_status?: TradingAccountViolationStatusParamParameter;
/**
 * Profit starting from
 */
profit_from?: TradingAccountProfitFromParamParameter;
/**
 * Profit starting to
 */
profit_to?: TradingAccountProfitToParamParameter;
};

export type GetFilterMetadataTradingAccountOpenPositionsParams = {
/**
 * Filter by action type
 */
'action_type[]'?: TradingAccountActionTypeParamParameter;
/**
 * Filter by trade symbol
 */
trade_symbol?: TradingAccountTradeSymbolParamParameter;
/**
 * Filter by opened_at starting from
 */
opened_at_from?: TradingAccountOpenedAtFromParamParameter;
/**
 * Filter by opened_at ending to
 */
opened_at_to?: TradingAccountOpenedAtToParamParameter;
/**
 * Filter by lot_size starting from
 */
lot_size_from?: TradingAccountLotSizeFromParamParameter;
/**
 * Filter by lot_size starting to
 */
lot_size_to?: TradingAccountLotSizeToParamParameter;
/**
 * Filter by violation status
 */
violation_status?: TradingAccountViolationStatusParamParameter;
/**
 * Profit starting from
 */
profit_from?: TradingAccountProfitFromParamParameter;
/**
 * Profit starting to
 */
profit_to?: TradingAccountProfitToParamParameter;
};

export type GetTradingAccountBalanceActionsParams = {
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: string;
};

export type GetTradesPerIpParams = {
/**
 * Order by field
 */
field?: string;
/**
 * Order direction
 */
direction?: GetTradesPerIpDirection;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type GetTradesPerIpDirection = typeof GetTradesPerIpDirection[keyof typeof GetTradesPerIpDirection];


export const GetTradesPerIpDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type MergeTradingAccountsPostBody = {
  target_trading_account_id?: number;
  source_trading_account_id?: number;
};

export type MergeTradingAccountsPost422ErrorDetailsItem = {
  field?: string;
  message?: string;
  code?: string;
};

export type MergeTradingAccountsPost422Error = {
  message?: string;
  request_id?: string;
  details?: MergeTradingAccountsPost422ErrorDetailsItem[];
};

export type MergeTradingAccountsPost422 = {
  error?: MergeTradingAccountsPost422Error;
};

export type GetTotalReferralsParams = {
/**
 * Type of referrals to get widgets for
 */
referral_type?: string;
/**
 * Field to search by
 */
search_field?: string;
/**
 * Date to get referrals upto
 */
created_at_from?: string;
/**
 * Filter by created_at ending to
 */
created_at_to?: string;
/**
 * Order by field, supported fields latest_update, refunded_fee, processed_fee, pending_fee, new_fee, total_fee, referral_type, referred_user_email
 */
field?: string;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type GetTotalReferrals200 = {
  collection?: TotalReferrals[];
  meta?: PaginationMeta;
};

export type GetReferralsWidgetsParams = {
/**
 * Type of referrals to get widgets for
 */
referral_type?: string;
/**
 * Field to search by
 */
search?: string;
/**
 * Date to get referrals upto
 */
created_at_from?: string;
/**
 * Filter by created_at ending to
 */
created_at_to?: string;
};

export type ListNotesForResourceParams = {
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Filter notes by note type.
 */
type?: NoteTypeEnum;
/**
 * Search notes by body.
 */
search_field?: string;
/**
 * Filter by polymorphic target type. Must be passed together with `target_id`. Accepts class names like `Payout` or route-style values like `payouts`.
 */
target_type?: string;
/**
 * Filter by polymorphic target id. Must be passed together with `target_type`.
 */
target_id?: number;
/**
 * Filter notes by the user who added the note.
 */
added_by_user_id?: number;
/**
 * Filter notes created after this date.
 */
created_at_from?: string;
/**
 * Filter notes created before this date.
 */
created_at_to?: string;
};

export type DeleteAResourceNote200 = {
  message?: string;
};

export type ListSearchFiltersParams = {
/**
 * Resource type to create search filter.
 */
resource_type: SearchFilterResourceTypeParamParameter;
};

export type CreateSearchFilterForUserParams = {
/**
 * Resource type to create search filter.
 */
resource_type: SearchFilterResourceTypeParamParameter;
};

export type CreateSearchFilterForUserBodyFilterFilters = UserSearchFilter | UserIpActivityFilter | TradingAccountIpActivityFilter | ReferralsFilter | TradingAccountFilter | EmailTemplateFilter | BalanceTransactionFilter | UserPolicyAcceptancesFilter | ClosedPositionsFilter | OpenPositionsFilter | PayoutsFilter | ChallengeFilter | NotesFilter | RiskEngineFlaggedAccountsFilter | RiskEngineSimilarTradingAccountsFilter | RiskEngineSimilarUserAccountsFilter | RiskEngineTradingAccountIncidentsFilter | RiskEngineUserIncidentsFilter | WithdrawalsFilter | GroupsFilter | DepositsFilter | CompetitionsFilter | PoliciesFilter | IbProfilesFilter;

export type CreateSearchFilterForUserBodyFilter = {
  /** Uniq name of the search filter */
  name: string;
  filters: CreateSearchFilterForUserBodyFilterFilters;
};

export type CreateSearchFilterForUserBody = {
  filter: CreateSearchFilterForUserBodyFilter;
};

export type DeleteSearchFilterForUser200 = {
  message?: string;
};

export type ListBalanceTransactionsForUserParams = {
/**
 * Order by field - created_at (default), amount.
 */
field?: string;
/**
 * Order direction - asc, desc (default)
 */
direction?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by entry_type
 */
'entry_type[]'?: BalanceTransactionEntryTypes[];
/**
 * Filter by status
 */
'status[]'?: BalanceTransactionStatuses[];
/**
 * Filter by source_type
 */
'source_type[]'?: BalanceTransactionSourceTypes[];
};

export type GetBalanceTransactionFilterMetadataParams = {
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by entry_type
 */
'entry_type[]'?: BalanceTransactionEntryTypes[];
/**
 * Filter by status
 */
'status[]'?: BalanceTransactionStatuses[];
/**
 * Filter by source_type
 */
'source_type[]'?: BalanceTransactionSourceTypes[];
};

export type ListBalanceTransactionsParams = {
/**
 * Order by field - created_at (default), amount.
 */
field?: string;
/**
 * Order direction - asc, desc (default)
 */
direction?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by entry_type
 */
'entry_type[]'?: BalanceTransactionEntryTypes[];
/**
 * Filter by status
 */
'status[]'?: BalanceTransactionStatuses[];
/**
 * Filter by source_type
 */
'source_type[]'?: BalanceTransactionSourceTypes[];
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
};

export type GetBalanceTransactionIndexFilterMetadataParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by entry_type
 */
'entry_type[]'?: BalanceTransactionEntryTypes[];
/**
 * Filter by status
 */
'status[]'?: BalanceTransactionStatuses[];
/**
 * Filter by source_type
 */
'source_type[]'?: BalanceTransactionSourceTypes[];
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
};

export type ListPermissionGroupsParams = {
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type CreatePermissionGroupBodyPermissionGroup = {
  name: string;
  /** @nullable */
  description?: string | null;
  keys: string[];
};

export type CreatePermissionGroupBody = {
  permission_group: CreatePermissionGroupBodyPermissionGroup;
};

export type UpdatePermissionGroupBodyPermissionGroup = {
  name?: string;
  /** @nullable */
  description?: string | null;
  keys?: string[];
};

export type UpdatePermissionGroupBody = {
  permission_group: UpdatePermissionGroupBodyPermissionGroup;
};

export type ListCouponsParams = {
/**
 * Filter by coupon name or code
 */
search_field?: CouponsSearchFieldParamParameter;
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by valid from starting from
 */
valid_from_from?: ValidFromFromParameter;
/**
 * Filter by valid from ending
 */
valid_from_to?: ValidFromToParameter;
/**
 * Filter by valid till starting from
 */
valid_till_from?: ValidTillFromParameter;
/**
 * Filter by valid till end
 */
valid_till_to?: ValidTillToParameter;
/**
 * Filter by coupon redemption limit lower end
 */
redemption_limit_from?: RedemptionLimitFromParameter;
/**
 * Filter by coupon redemption limit higher end
 */
redemption_limit_to?: RedemptionLimitToParameter;
/**
 * Filter by coupon redemption count lower end
 */
redemptions_count_from?: RedemptionsCountFromParameter;
/**
 * Filter by coupon redemption count higher end
 */
redemptions_count_to?: RedemptionsCountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Order by field
 */
field?: string;
};

export type GetCouponsFilterMetadataParams = {
/**
 * Filter by coupon name or code
 */
search_field?: CouponsSearchFieldParamParameter;
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by valid from starting from
 */
valid_from_from?: ValidFromFromParameter;
/**
 * Filter by valid from ending
 */
valid_from_to?: ValidFromToParameter;
/**
 * Filter by valid till starting from
 */
valid_till_from?: ValidTillFromParameter;
/**
 * Filter by valid till end
 */
valid_till_to?: ValidTillToParameter;
/**
 * Filter by coupon redemption limit lower end
 */
redemption_limit_from?: RedemptionLimitFromParameter;
/**
 * Filter by coupon redemption limit higher end
 */
redemption_limit_to?: RedemptionLimitToParameter;
/**
 * Filter by coupon redemption count lower end
 */
redemptions_count_from?: RedemptionsCountFromParameter;
/**
 * Filter by coupon redemption count higher end
 */
redemptions_count_to?: RedemptionsCountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
};

export type ListAuditLogsParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by target type. Must be combined with target_id; otherwise ignored.
 */
target_type?: AuditLogTargetTypeParamParameter;
/**
 * Filter by target id. Must be combined with target_type; otherwise ignored.
 */
target_id?: AuditLogTargetIdParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type GetAuditLogsFilterMetadataParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by target type. Must be combined with target_id; otherwise ignored.
 */
target_type?: AuditLogTargetTypeParamParameter;
/**
 * Filter by target id. Must be combined with target_type; otherwise ignored.
 */
target_id?: AuditLogTargetIdParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
};

export type ListWithdrawalsParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by withdrawal statuses
 */
'statuses[]'?: WithdrawalStatusesParamParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: ListWithdrawalsField;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type ListWithdrawalsField = typeof ListWithdrawalsField[keyof typeof ListWithdrawalsField];


export const ListWithdrawalsField = {
  amount: 'amount',
  created_at: 'created_at',
} as const;

export type GetWithdrawalsFilterMetadataParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by withdrawal statuses
 */
'statuses[]'?: WithdrawalStatusesParamParameter;
/**
 * Filter by amount lower end
 */
amount_from?: AmountFromParameter;
/**
 * Filter by amount higher end
 */
amount_to?: AmountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Whether to exclude records belonging to test data (tagged internally as test data). Defaults to false, which includes them
 */
exclude_test_data?: ExcludeTestDataParameter;
};

export type ListIbProfilesParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by IB profile statuses
 */
'statuses[]'?: IbProfileStatusesParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: ListIbProfilesField;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
};

export type ListIbProfilesField = typeof ListIbProfilesField[keyof typeof ListIbProfilesField];


export const ListIbProfilesField = {
  created_at: 'created_at',
} as const;

export type GetIbProfilesFilterMetadataParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by IB profile statuses
 */
'statuses[]'?: IbProfileStatusesParamParameter;
};

export type GetCouponRedemptionsParams = {
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Search by user email, name, or numeric user_id
 */
search_field?: string;
/**
 * Filter by user ID
 */
user_id?: number;
/**
 * Filter by redemption status
 */
status?: GetCouponRedemptionsStatusItem[];
};

export type GetCouponRedemptionsStatusItem = typeof GetCouponRedemptionsStatusItem[keyof typeof GetCouponRedemptionsStatusItem];


export const GetCouponRedemptionsStatusItem = {
  applied: 'applied',
  success: 'success',
  failed: 'failed',
} as const;

export type GetCouponRedemptions200 = {
  collection: CouponRedemption[];
  meta: PaginationMeta;
};

export type GetUserExceptionsParams = {
/**
 * Filter by user email
 */
search_field?: UserExceptionsSearchFieldParamParameter;
/**
 * Filter by valid from starting from
 */
valid_from_from?: ValidFromFromParameter;
/**
 * Filter by valid from ending
 */
valid_from_to?: ValidFromToParameter;
/**
 * Filter by valid till starting from
 */
valid_till_from?: ValidTillFromParameter;
/**
 * Filter by valid till end
 */
valid_till_to?: ValidTillToParameter;
/**
 * Filter by coupon redemption limit lower end
 */
redemption_limit_from?: RedemptionLimitFromParameter;
/**
 * Filter by coupon redemption limit higher end
 */
redemption_limit_to?: RedemptionLimitToParameter;
/**
 * Filter by coupon redemption count lower end
 */
redemptions_count_from?: RedemptionsCountFromParameter;
/**
 * Filter by coupon redemption count higher end
 */
redemptions_count_to?: RedemptionsCountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Order by field
 */
field?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: number;
};

export type GetUserExceptionsFilterMetadataParams = {
/**
 * Filter by user email
 */
search_field?: UserExceptionsSearchFieldParamParameter;
/**
 * Filter by valid from starting from
 */
valid_from_from?: ValidFromFromParameter;
/**
 * Filter by valid from ending
 */
valid_from_to?: ValidFromToParameter;
/**
 * Filter by valid till starting from
 */
valid_till_from?: ValidTillFromParameter;
/**
 * Filter by valid till end
 */
valid_till_to?: ValidTillToParameter;
/**
 * Filter by coupon redemption limit lower end
 */
redemption_limit_from?: RedemptionLimitFromParameter;
/**
 * Filter by coupon redemption limit higher end
 */
redemption_limit_to?: RedemptionLimitToParameter;
/**
 * Filter by coupon redemption count lower end
 */
redemptions_count_from?: RedemptionsCountFromParameter;
/**
 * Filter by coupon redemption count higher end
 */
redemptions_count_to?: RedemptionsCountToParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Order by field
 */
field?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: number;
};

export type GetUserExceptionsFilterMetadata200 = {
  count: number;
};

export type ListTasksParams = {
/**
 * Order by field (default is created_at).
 */
field?: ListTasksField;
/**
 * Order direction - asc, desc (default)
 */
direction?: ListTasksDirection;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by last_run_at from
 */
last_run_at_from?: string;
/**
 * Filter by last_run_at to
 */
last_run_at_to?: string;
/**
 * Filter by status
 */
'status[]'?: Statuses[];
/**
 * Filter by an admin user who processed a task
 */
processed_by_user_id?: number;
/**
 * Filter by an admin user who added a task
 */
added_by_user_id?: number;
};

export type ListTasksField = typeof ListTasksField[keyof typeof ListTasksField];


export const ListTasksField = {
  created_at: 'created_at',
  last_run_at: 'last_run_at',
  total: 'total',
} as const;

export type ListTasksDirection = typeof ListTasksDirection[keyof typeof ListTasksDirection];


export const ListTasksDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetTaskIndexFilterMetadataParams = {
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
/**
 * Filter by last_run_at from
 */
last_run_at_from?: string;
/**
 * Filter by last_run_at to
 */
last_run_at_to?: string;
/**
 * Filter by status
 */
'status[]'?: Statuses[];
/**
 * Filter by an admin user who processed a task
 */
processed_by_user_id?: number;
/**
 * Filter by an admin user who added a task
 */
added_by_user_id?: number;
};

export type DownloadTasksSampleFileParams = {
/**
 * Task type to download sample file for
 */
task_type: string;
};

export type ListTaskActionParamsParams = {
/**
 * Action name
 */
action_name: string;
};

export type GetReferralTiersParams = {
/**
 * Order by field (default is created_at).
 */
field?: string;
/**
 * Order direction - asc, desc (default)
 */
direction?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type GetDiscountTiersParams = {
/**
 * Filter by tier type.
 */
type?: GetDiscountTiersType;
/**
 * Order by `created_at`, `name`, `type`, or `apply_from`.
 */
field?: string;
direction?: GetDiscountTiersDirection;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type GetDiscountTiersType = typeof GetDiscountTiersType[keyof typeof GetDiscountTiersType];


export const GetDiscountTiersType = {
  affiliate: 'affiliate',
  campaign: 'campaign',
} as const;

export type GetDiscountTiersDirection = typeof GetDiscountTiersDirection[keyof typeof GetDiscountTiersDirection];


export const GetDiscountTiersDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetDiscountTiers200Meta = { [key: string]: unknown };

export type GetDiscountTiers200 = {
  collection: DiscountTier[];
  meta: GetDiscountTiers200Meta;
};

export type ListCompetitionsParams = {
/**
 * Filter by competition status
 */
'statuses[]'?: CompetitionStatusesParamParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by competition type
 */
'competition_types[]'?: CompetitionTypesParamParameter;
/**
 * Filter competitions starting at or after this date
 */
starts_at_from?: StartsAtFromParamParameter;
/**
 * Filter competitions starting at or before this date
 */
starts_at_to?: StartsAtToParamParameter;
/**
 * Filter competitions ending at or after this date
 */
ends_at_from?: EndsAtFromParamParameter;
/**
 * Filter competitions ending at or before this date
 */
ends_at_to?: EndsAtToParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order by field
 */
field?: ListCompetitionsField;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
};

export type ListCompetitionsField = typeof ListCompetitionsField[keyof typeof ListCompetitionsField];


export const ListCompetitionsField = {
  created_at: 'created_at',
  starts_at: 'starts_at',
  ends_at: 'ends_at',
} as const;

export type GetCompetitionsFilterMetadataParams = {
/**
 * Filter by competition status
 */
'statuses[]'?: CompetitionStatusesParamParameter;
/**
 * Filter by platform
 */
'platform[]'?: PlatformParameter;
/**
 * Filter by competition type
 */
'competition_types[]'?: CompetitionTypesParamParameter;
/**
 * Filter competitions starting at or after this date
 */
starts_at_from?: StartsAtFromParamParameter;
/**
 * Filter competitions starting at or before this date
 */
starts_at_to?: StartsAtToParamParameter;
/**
 * Filter competitions ending at or after this date
 */
ends_at_from?: EndsAtFromParamParameter;
/**
 * Filter competitions ending at or before this date
 */
ends_at_to?: EndsAtToParamParameter;
/**
 * Filter by created_at_from
 */
created_at_from?: CreatedAtFromParamParameter;
/**
 * Filter by created_at_to
 */
created_at_to?: CreatedAtToParamParameter;
};

export type GetPaymentProviderGatewaysParams = {
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by name, slug, or base URL
 */
search_field?: string;
/**
 * Filter by active status
 */
active?: boolean;
/**
 * Order by field.
 */
field?: string;
/**
 * Order direction - asc, desc
 */
direction?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type GetPaymentProviderGatewayFilterMetadataParams = {
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by name, slug, or base URL
 */
search_field?: string;
/**
 * Filter by active status
 */
active?: boolean;
};

export type SearchUsersParams = {
/**
 * Filter by id/email
 */
search_field?: string;
/**
 * Filter user by type
 */
search_type?: SearchUsersSearchType;
/**
 * Filter by role
 */
'role[]'?: string[];
/**
 * Filter by kycaid verification status
 */
'kycaid_verification_status[]'?: KycaidVerificationStatusParamParameter;
/**
 * Filter by phone number verification status
 */
'phone_number_verification_status[]'?: PhoneNumberVerificationStatusParamParameter;
/**
 * Filter by start date starting from
 */
created_at_from?: CreatedAtFromParameter;
/**
 * Filter by created_at ending to
 */
created_at_to?: CreatedAtToParameter;
};

export type SearchUsersSearchType = typeof SearchUsersSearchType[keyof typeof SearchUsersSearchType];


export const SearchUsersSearchType = {
  tasks_processed_by: 'tasks_processed_by',
  tasks_added_by: 'tasks_added_by',
  risk_members: 'risk_members',
  payouts_assignee: 'payouts_assignee',
} as const;

export type SearchUsers200 = {
  collection?: SearchUserSerializer[];
};

export type ListVersionsParams = {
/**
 * Object type to load versions for
 */
object_name: ListVersionsObjectName;
/**
 * Numeric ID of the object to get versions for
 */
id: number;
/**
 * Order by field (default is created_at).
 */
field?: ListVersionsField;
/**
 * Order direction - asc, desc (default)
 */
direction?: ListVersionsDirection;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type ListVersionsObjectName = typeof ListVersionsObjectName[keyof typeof ListVersionsObjectName];


export const ListVersionsObjectName = {
  Payout: 'Payout',
  PayoutTransaction: 'PayoutTransaction',
} as const;

export type ListVersionsField = typeof ListVersionsField[keyof typeof ListVersionsField];


export const ListVersionsField = {
  created_at: 'created_at',
  event: 'event',
} as const;

export type ListVersionsDirection = typeof ListVersionsDirection[keyof typeof ListVersionsDirection];


export const ListVersionsDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetScheduledActionsParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by status
 */
'statuses[]'?: StatusesParamParameter;
/**
 * Filter by scheduled_at_from
 */
scheduled_at_from?: ScheduledAtFromParamParameter;
/**
 * Filter by scheduled_at_to
 */
scheduled_at_to?: ScheduledAtToParamParameter;
/**
 * Filter by the type of the object associated with the scheduled action.
 */
'schedulable_types[]'?: SchedulableTypeParamParameter;
/**
 * Order by field (default is id).
 */
field?: string;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
};

export type GetScheduledActionsFilterMetadataParams = {
/**
 * Filter by user id
 */
filter_user_id?: UserIdSearchParamParameter;
/**
 * Filter by status
 */
'statuses[]'?: StatusesParamParameter;
/**
 * Filter by scheduled_at_from
 */
scheduled_at_from?: ScheduledAtFromParamParameter;
/**
 * Filter by scheduled_at_to
 */
scheduled_at_to?: ScheduledAtToParamParameter;
/**
 * Filter by the type of the object associated with the scheduled action.
 */
'schedulable_types[]'?: SchedulableTypeParamParameter;
};

export type ListScheduledActionParamsParams = {
/**
 * Action name
 */
action_name: string;
};

export type GetTradingAccountIncidentsParams = {
mother_trading_account_id: number;
child_trading_account_id: number;
start_time?: RiskEngineStartTimeParamParameter;
end_time?: RiskEngineEndTimeParamParameter;
/**
 * @minimum 1
 * @maximum 20
 */
window_size?: RiskEngineWindowSizeParamParameter;
};

export type GetSimilarTradingAccountsParams = {
/**
 * Filter by matching flags
 */
'flags[]'?: RiskEngineFlagsParamParameter;
/**
 * Filter by minimum score
 * @minimum 0
 */
score_min?: RiskEngineScoreMinParamParameter;
/**
 * Filter by maximum score
 * @minimum 0
 */
score_max?: RiskEngineScoreMaxParamParameter;
};

export type GetUserIncidentsParams = {
mother_user_id: number;
child_user_id: number;
start_time?: RiskEngineStartTimeParamParameter;
end_time?: RiskEngineEndTimeParamParameter;
/**
 * @minimum 1
 * @maximum 20
 */
window_size?: RiskEngineWindowSizeParamParameter;
};

export type GetSimilarUserAccountsParams = {
/**
 * Filter by matching flags
 */
'flags[]'?: RiskEngineFlagsParamParameter;
/**
 * Filter by minimum score
 * @minimum 0
 */
score_min?: RiskEngineScoreMinParamParameter;
/**
 * Filter by maximum score
 * @minimum 0
 */
score_max?: RiskEngineScoreMaxParamParameter;
};

export type GetFlaggedAccountsParams = {
/**
 * @minimum 1
 */
page?: RiskEnginePageParamParameter;
/**
 * @minimum 20
 * @maximum 200
 */
size?: RiskEngineSizeParamParameter;
/**
 * Number of days to look back
 * @minimum 1
 * @maximum 60
 */
days?: RiskEngineDaysParamParameter;
/**
 * Filter by matching flags
 */
'flags[]'?: RiskEngineFlagsParamParameter;
/**
 * Filter by minimum score
 * @minimum 0
 */
score_min?: RiskEngineScoreMinParamParameter;
/**
 * Filter by maximum score
 * @minimum 0
 */
score_max?: RiskEngineScoreMaxParamParameter;
};

export type MarkUserChecked200 = {
  message?: string;
};

export type GetUsersIpAnomaliesParams = {
'user_ids[]': number[];
};

export type MarkUsersCheckedBody = {
  user_ids: number[];
};

export type MarkUsersChecked200 = {
  message?: string;
};

export type ListCountriesParams = {
/**
 * Filter by name or ISO code
 */
search_field?: string;
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by exact ISO code
 */
iso_code?: string;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
/**
 * Order by field
 */
field?: ListCountriesField;
};

export type ListCountriesField = typeof ListCountriesField[keyof typeof ListCountriesField];


export const ListCountriesField = {
  id: 'id',
  name: 'name',
  iso_code: 'iso_code',
  created_at: 'created_at',
} as const;

export type GetCountryFilterMetadataParams = {
/**
 * Filter by name or ISO code
 */
search_field?: string;
/**
 * Filter by brand ID
 */
brand_id?: number;
/**
 * Filter by exact ISO code
 */
iso_code?: string;
};

export type AdminListIpWhitelistRequestsParams = {
/**
 * Cursor pagination - after
 */
after?: PaginationAfterParamParameter;
/**
 * Cursor pagination - before
 */
before?: PaginationBeforeParamParameter;
/**
 * Limit for returning records (default is 50)
 */
limit?: LimitParamParameter;
/**
 * Order direction
 */
direction?: OrderDirectionParamParameter;
};

export type AdminListIpWhitelistRequests200 = {
  collection?: AdminIpWhitelistRequestSerializer[];
  meta?: PaginationMeta;
};

export type AdminRejectIpWhitelistRequestBody = {
  rejection_reason?: string;
};

export type GetTradingAccountsScoresParams = {
/**
 * Trading account IDs to get the data for
 */
'trading_accounts_ids[]'?: TradingAccountsIdsParameter;
};

export type ResendAgreementContract200 = {
  message: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List deposits
 */
export const listDeposits = (
    params?: ListDepositsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DepositsListResponse>(
      {url: `/admin/api/deposits`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListDepositsQueryKey = (params?: ListDepositsParams,) => {
    return [
    'admin','api','deposits', ...(params ? [params] : [])
    ] as const;
    }


export const getListDepositsQueryOptions = <TData = Awaited<ReturnType<typeof listDeposits>>, TError = N404Response | N500Response>(params?: ListDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeposits>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDepositsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeposits>>> = ({ signal }) => listDeposits(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDeposits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDepositsQueryResult = NonNullable<Awaited<ReturnType<typeof listDeposits>>>
export type ListDepositsQueryError = N404Response | N500Response


export function useListDeposits<TData = Awaited<ReturnType<typeof listDeposits>>, TError = N404Response | N500Response>(
 params: undefined |  ListDepositsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeposits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDeposits>>,
          TError,
          Awaited<ReturnType<typeof listDeposits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDeposits<TData = Awaited<ReturnType<typeof listDeposits>>, TError = N404Response | N500Response>(
 params?: ListDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeposits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDeposits>>,
          TError,
          Awaited<ReturnType<typeof listDeposits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDeposits<TData = Awaited<ReturnType<typeof listDeposits>>, TError = N404Response | N500Response>(
 params?: ListDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeposits>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List deposits
 */

export function useListDeposits<TData = Awaited<ReturnType<typeof listDeposits>>, TError = N404Response | N500Response>(
 params?: ListDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeposits>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDepositsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List deposits
 */
export const prefetchListDepositsQuery = async <TData = Awaited<ReturnType<typeof listDeposits>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeposits>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListDepositsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get deposit count for search filter and data for dropdowns
 */
export const getDepositsFilterMetadata = (
    params?: GetDepositsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DepositsFilterMetadataResponse>(
      {url: `/admin/api/deposits/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDepositsFilterMetadataQueryKey = (params?: GetDepositsFilterMetadataParams,) => {
    return [
    'admin','api','deposits','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetDepositsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError = N404Response | N500Response>(params?: GetDepositsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepositsFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepositsFilterMetadata>>> = ({ signal }) => getDepositsFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepositsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getDepositsFilterMetadata>>>
export type GetDepositsFilterMetadataQueryError = N404Response | N500Response


export function useGetDepositsFilterMetadata<TData = Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetDepositsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepositsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getDepositsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepositsFilterMetadata<TData = Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetDepositsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepositsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getDepositsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepositsFilterMetadata<TData = Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetDepositsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get deposit count for search filter and data for dropdowns
 */

export function useGetDepositsFilterMetadata<TData = Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetDepositsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepositsFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get deposit count for search filter and data for dropdowns
 */
export const prefetchGetDepositsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetDepositsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepositsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetDepositsFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get deposit details
 */
export const getDeposit = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DepositDetailedResponse>(
      {url: `/admin/api/deposits/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetDepositQueryKey = (id: number,) => {
    return [
    'admin','api','deposits',id
    ] as const;
    }


export const getGetDepositQueryOptions = <TData = Awaited<ReturnType<typeof getDeposit>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeposit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepositQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeposit>>> = ({ signal }) => getDeposit(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeposit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepositQueryResult = NonNullable<Awaited<ReturnType<typeof getDeposit>>>
export type GetDepositQueryError = N404Response | N500Response


export function useGetDeposit<TData = Awaited<ReturnType<typeof getDeposit>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeposit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeposit>>,
          TError,
          Awaited<ReturnType<typeof getDeposit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeposit<TData = Awaited<ReturnType<typeof getDeposit>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeposit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeposit>>,
          TError,
          Awaited<ReturnType<typeof getDeposit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeposit<TData = Awaited<ReturnType<typeof getDeposit>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeposit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get deposit details
 */

export function useGetDeposit<TData = Awaited<ReturnType<typeof getDeposit>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeposit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepositQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get deposit details
 */
export const prefetchGetDepositQuery = async <TData = Awaited<ReturnType<typeof getDeposit>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeposit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetDepositQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Approve a deposit
 */
export const approveDeposit = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DepositActionResponse>(
      {url: `/admin/api/deposits/${id}/approve`, method: 'PATCH', signal
    },
      options);
    }




export const getApproveDepositMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeposit>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveDeposit>>, TError,{id: number}, TContext> => {

const mutationKey = ['approveDeposit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveDeposit>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approveDeposit(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveDepositMutationResult = NonNullable<Awaited<ReturnType<typeof approveDeposit>>>

    export type ApproveDepositMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Approve a deposit
 */
export const useApproveDeposit = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeposit>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveDeposit>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApproveDepositMutationOptions(options), queryClient);
    }

/**
 * @summary Reject a deposit
 */
export const rejectDeposit = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DepositActionResponse>(
      {url: `/admin/api/deposits/${id}/reject`, method: 'PATCH', signal
    },
      options);
    }




export const getRejectDepositMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectDeposit>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectDeposit>>, TError,{id: number}, TContext> => {

const mutationKey = ['rejectDeposit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectDeposit>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  rejectDeposit(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectDepositMutationResult = NonNullable<Awaited<ReturnType<typeof rejectDeposit>>>

    export type RejectDepositMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Reject a deposit
 */
export const useRejectDeposit = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectDeposit>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectDeposit>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRejectDepositMutationOptions(options), queryClient);
    }

/**
 * @summary List payouts
 */
export const listPayouts = (
    params?: ListPayoutsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PayoutsListResponse>(
      {url: `/admin/api/payouts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPayoutsQueryKey = (params?: ListPayoutsParams,) => {
    return [
    'admin','api','payouts', ...(params ? [params] : [])
    ] as const;
    }


export const getListPayoutsQueryOptions = <TData = Awaited<ReturnType<typeof listPayouts>>, TError = N404Response | N500Response>(params?: ListPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayoutsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayouts>>> = ({ signal }) => listPayouts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayouts>>>
export type ListPayoutsQueryError = N404Response | N500Response


export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = N404Response | N500Response>(
 params: undefined |  ListPayoutsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayouts>>,
          TError,
          Awaited<ReturnType<typeof listPayouts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = N404Response | N500Response>(
 params?: ListPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayouts>>,
          TError,
          Awaited<ReturnType<typeof listPayouts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = N404Response | N500Response>(
 params?: ListPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List payouts
 */

export function useListPayouts<TData = Awaited<ReturnType<typeof listPayouts>>, TError = N404Response | N500Response>(
 params?: ListPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPayoutsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List payouts
 */
export const prefetchListPayoutsQuery = async <TData = Awaited<ReturnType<typeof listPayouts>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayouts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListPayoutsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get payouts count for search filter and data for dropdowns
 */
export const getPayoutsFilterMetadata = (
    params?: GetPayoutsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PayoutsFilterMetadataResponse>(
      {url: `/admin/api/payouts/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPayoutsFilterMetadataQueryKey = (params?: GetPayoutsFilterMetadataParams,) => {
    return [
    'admin','api','payouts','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetPayoutsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError = N404Response | N500Response>(params?: GetPayoutsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutsFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>> = ({ signal }) => getPayoutsFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>>
export type GetPayoutsFilterMetadataQueryError = N404Response | N500Response


export function useGetPayoutsFilterMetadata<TData = Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetPayoutsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPayoutsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutsFilterMetadata<TData = Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetPayoutsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPayoutsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutsFilterMetadata<TData = Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetPayoutsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payouts count for search filter and data for dropdowns
 */

export function useGetPayoutsFilterMetadata<TData = Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetPayoutsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutsFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get payouts count for search filter and data for dropdowns
 */
export const prefetchGetPayoutsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetPayoutsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPayoutsFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get payouts widgets
 */
export const getPayoutsWidgets = (
    params?: GetPayoutsWidgetsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PayoutWidgetsResponse>(
      {url: `/admin/api/payouts/widgets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPayoutsWidgetsQueryKey = (params?: GetPayoutsWidgetsParams,) => {
    return [
    'admin','api','payouts','widgets', ...(params ? [params] : [])
    ] as const;
    }


export const getGetPayoutsWidgetsQueryOptions = <TData = Awaited<ReturnType<typeof getPayoutsWidgets>>, TError = N404Response | N500Response>(params?: GetPayoutsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutsWidgetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutsWidgets>>> = ({ signal }) => getPayoutsWidgets(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayoutsWidgets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutsWidgetsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutsWidgets>>>
export type GetPayoutsWidgetsQueryError = N404Response | N500Response


export function useGetPayoutsWidgets<TData = Awaited<ReturnType<typeof getPayoutsWidgets>>, TError = N404Response | N500Response>(
 params: undefined |  GetPayoutsWidgetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsWidgets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutsWidgets>>,
          TError,
          Awaited<ReturnType<typeof getPayoutsWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutsWidgets<TData = Awaited<ReturnType<typeof getPayoutsWidgets>>, TError = N404Response | N500Response>(
 params?: GetPayoutsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsWidgets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutsWidgets>>,
          TError,
          Awaited<ReturnType<typeof getPayoutsWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutsWidgets<TData = Awaited<ReturnType<typeof getPayoutsWidgets>>, TError = N404Response | N500Response>(
 params?: GetPayoutsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payouts widgets
 */

export function useGetPayoutsWidgets<TData = Awaited<ReturnType<typeof getPayoutsWidgets>>, TError = N404Response | N500Response>(
 params?: GetPayoutsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutsWidgetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get payouts widgets
 */
export const prefetchGetPayoutsWidgetsQuery = async <TData = Awaited<ReturnType<typeof getPayoutsWidgets>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetPayoutsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPayoutsWidgetsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update payout
 */
export const updatePayout = (
    id: number,
    payoutUpdateRequestBody: PayoutUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PayoutsUpdateResponse>(
      {url: `/admin/api/payouts/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payoutUpdateRequestBody, signal
    },
      options);
    }




export const getUpdatePayoutMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayout>>, TError,{id: number;data: PayoutUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePayout>>, TError,{id: number;data: PayoutUpdateRequestBody}, TContext> => {

const mutationKey = ['updatePayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePayout>>, {id: number;data: PayoutUpdateRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePayout(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof updatePayout>>>
    export type UpdatePayoutMutationBody = PayoutUpdateRequestBody
    export type UpdatePayoutMutationError = N404Response | N500Response

    /**
 * @summary Update payout
 */
export const useUpdatePayout = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePayout>>, TError,{id: number;data: PayoutUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePayout>>,
        TError,
        {id: number;data: PayoutUpdateRequestBody},
        TContext
      > => {
      return useMutation(getUpdatePayoutMutationOptions(options), queryClient);
    }

/**
 * @summary Get payout information needed to edit
 */
export const getPayoutEditInformation = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PayoutEditResponse>(
      {url: `/admin/api/payouts/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetPayoutEditInformationQueryKey = (id: number,) => {
    return [
    'admin','api','payouts',id,'edit'
    ] as const;
    }


export const getGetPayoutEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getPayoutEditInformation>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutEditInformationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayoutEditInformation>>> = ({ signal }) => getPayoutEditInformation(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayoutEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getPayoutEditInformation>>>
export type GetPayoutEditInformationQueryError = N404Response | N500Response


export function useGetPayoutEditInformation<TData = Awaited<ReturnType<typeof getPayoutEditInformation>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getPayoutEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutEditInformation<TData = Awaited<ReturnType<typeof getPayoutEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayoutEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getPayoutEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayoutEditInformation<TData = Awaited<ReturnType<typeof getPayoutEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payout information needed to edit
 */

export function useGetPayoutEditInformation<TData = Awaited<ReturnType<typeof getPayoutEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutEditInformationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get payout information needed to edit
 */
export const prefetchGetPayoutEditInformationQuery = async <TData = Awaited<ReturnType<typeof getPayoutEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayoutEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPayoutEditInformationQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List email templates
 */
export const emailTemplatesIndex = (
    params?: EmailTemplatesIndexParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EmailTemplatesListResponse>(
      {url: `/admin/api/email_templates`, method: 'GET',
        params, signal
    },
      options);
    }




export const getEmailTemplatesIndexQueryKey = (params?: EmailTemplatesIndexParams,) => {
    return [
    'admin','api','email_templates', ...(params ? [params] : [])
    ] as const;
    }


export const getEmailTemplatesIndexQueryOptions = <TData = Awaited<ReturnType<typeof emailTemplatesIndex>>, TError = N404Response | N500Response>(params?: EmailTemplatesIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof emailTemplatesIndex>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEmailTemplatesIndexQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof emailTemplatesIndex>>> = ({ signal }) => emailTemplatesIndex(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof emailTemplatesIndex>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EmailTemplatesIndexQueryResult = NonNullable<Awaited<ReturnType<typeof emailTemplatesIndex>>>
export type EmailTemplatesIndexQueryError = N404Response | N500Response


export function useEmailTemplatesIndex<TData = Awaited<ReturnType<typeof emailTemplatesIndex>>, TError = N404Response | N500Response>(
 params: undefined |  EmailTemplatesIndexParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof emailTemplatesIndex>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplatesIndex>>,
          TError,
          Awaited<ReturnType<typeof emailTemplatesIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmailTemplatesIndex<TData = Awaited<ReturnType<typeof emailTemplatesIndex>>, TError = N404Response | N500Response>(
 params?: EmailTemplatesIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof emailTemplatesIndex>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailTemplatesIndex>>,
          TError,
          Awaited<ReturnType<typeof emailTemplatesIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEmailTemplatesIndex<TData = Awaited<ReturnType<typeof emailTemplatesIndex>>, TError = N404Response | N500Response>(
 params?: EmailTemplatesIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof emailTemplatesIndex>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List email templates
 */

export function useEmailTemplatesIndex<TData = Awaited<ReturnType<typeof emailTemplatesIndex>>, TError = N404Response | N500Response>(
 params?: EmailTemplatesIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof emailTemplatesIndex>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmailTemplatesIndexQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List email templates
 */
export const prefetchEmailTemplatesIndexQuery = async <TData = Awaited<ReturnType<typeof emailTemplatesIndex>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: EmailTemplatesIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof emailTemplatesIndex>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getEmailTemplatesIndexQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new email template
 */
export const createEmailTemplate = (
    emailTemplateCreateUpdateRequestBody: EmailTemplateCreateUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EmailTemplateResponseBody>(
      {url: `/admin/api/email_templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailTemplateCreateUpdateRequestBody, signal
    },
      options);
    }




export const getCreateEmailTemplateMutationOptions = <TError = EmailTemplateResponseBodyError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{data: EmailTemplateCreateUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{data: EmailTemplateCreateUpdateRequestBody}, TContext> => {

const mutationKey = ['createEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmailTemplate>>, {data: EmailTemplateCreateUpdateRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createEmailTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createEmailTemplate>>>
    export type CreateEmailTemplateMutationBody = EmailTemplateCreateUpdateRequestBody
    export type CreateEmailTemplateMutationError = EmailTemplateResponseBodyError | InternalServerError

    /**
 * @summary Create a new email template
 */
export const useCreateEmailTemplate = <TError = EmailTemplateResponseBodyError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmailTemplate>>, TError,{data: EmailTemplateCreateUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmailTemplate>>,
        TError,
        {data: EmailTemplateCreateUpdateRequestBody},
        TContext
      > => {
      return useMutation(getCreateEmailTemplateMutationOptions(options), queryClient);
    }

/**
 * @summary Get email templates count for search filter
 */
export const getEmailTemplateFilterMetadata = (
    params?: GetEmailTemplateFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetEmailTemplateFilterMetadata200>(
      {url: `/admin/api/email_templates/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEmailTemplateFilterMetadataQueryKey = (params?: GetEmailTemplateFilterMetadataParams,) => {
    return [
    'admin','api','email_templates','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetEmailTemplateFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError = N404Response | N500Response>(params?: GetEmailTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailTemplateFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>> = ({ signal }) => getEmailTemplateFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailTemplateFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>>
export type GetEmailTemplateFilterMetadataQueryError = N404Response | N500Response


export function useGetEmailTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetEmailTemplateFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetEmailTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetEmailTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get email templates count for search filter
 */

export function useGetEmailTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetEmailTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailTemplateFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get email templates count for search filter
 */
export const prefetchGetEmailTemplateFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetEmailTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEmailTemplateFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update an existing email template
 */
export const updateEmailTemplate = (
    id: number,
    emailTemplateCreateUpdateRequestBody: EmailTemplateCreateUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EmailTemplateResponseBody>(
      {url: `/admin/api/email_templates/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: emailTemplateCreateUpdateRequestBody, signal
    },
      options);
    }




export const getUpdateEmailTemplateMutationOptions = <TError = ResourceNotFoundError | EmailTemplateResponseBodyError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{id: number;data: EmailTemplateCreateUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{id: number;data: EmailTemplateCreateUpdateRequestBody}, TContext> => {

const mutationKey = ['updateEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmailTemplate>>, {id: number;data: EmailTemplateCreateUpdateRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmailTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmailTemplate>>>
    export type UpdateEmailTemplateMutationBody = EmailTemplateCreateUpdateRequestBody
    export type UpdateEmailTemplateMutationError = ResourceNotFoundError | EmailTemplateResponseBodyError | InternalServerError

    /**
 * @summary Update an existing email template
 */
export const useUpdateEmailTemplate = <TError = ResourceNotFoundError | EmailTemplateResponseBodyError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmailTemplate>>, TError,{id: number;data: EmailTemplateCreateUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmailTemplate>>,
        TError,
        {id: number;data: EmailTemplateCreateUpdateRequestBody},
        TContext
      > => {
      return useMutation(getUpdateEmailTemplateMutationOptions(options), queryClient);
    }

/**
 * @summary Delete email template
 */
export const deleteEmailTemplate = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EmailTemplateResponseBody>(
      {url: `/admin/api/email_templates/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteEmailTemplateMutationOptions = <TError = ResourceNotFoundError | EmailTemplateErrorResponse | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEmailTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmailTemplate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmailTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmailTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmailTemplate>>>

    export type DeleteEmailTemplateMutationError = ResourceNotFoundError | EmailTemplateErrorResponse | InternalServerError

    /**
 * @summary Delete email template
 */
export const useDeleteEmailTemplate = <TError = ResourceNotFoundError | EmailTemplateErrorResponse | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmailTemplate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteEmailTemplateMutationOptions(options), queryClient);
    }

/**
 * Retrieves the modal configuration for a specific bulk action that requires parameters.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary List modal information along with list of params needed for a specific payout bulk action
 */
export const listPayoutBulkActionParams = (
    params: ListPayoutBulkActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BulkFormParamsSchema>(
      {url: `/admin/api/payouts/bulk_actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPayoutBulkActionParamsQueryKey = (params?: ListPayoutBulkActionParamsParams,) => {
    return [
    'admin','api','payouts','bulk_actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListPayoutBulkActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError = N404Response | N500Response>(params: ListPayoutBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayoutBulkActionParamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayoutBulkActionParams>>> = ({ signal }) => listPayoutBulkActionParams(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayoutBulkActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayoutBulkActionParams>>>
export type ListPayoutBulkActionParamsQueryError = N404Response | N500Response


export function useListPayoutBulkActionParams<TData = Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListPayoutBulkActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayoutBulkActionParams>>,
          TError,
          Awaited<ReturnType<typeof listPayoutBulkActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutBulkActionParams<TData = Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListPayoutBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayoutBulkActionParams>>,
          TError,
          Awaited<ReturnType<typeof listPayoutBulkActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutBulkActionParams<TData = Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListPayoutBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List modal information along with list of params needed for a specific payout bulk action
 */

export function useListPayoutBulkActionParams<TData = Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListPayoutBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPayoutBulkActionParamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List modal information along with list of params needed for a specific payout bulk action
 */
export const prefetchListPayoutBulkActionParamsQuery = async <TData = Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params: ListPayoutBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListPayoutBulkActionParamsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Add assignee to payouts
 */
export const addAssigneePayouts = (
    assign: Assign,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutBulkActionResponse>(
      {url: `/admin/api/payouts/bulk_actions/assign`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: assign, signal
    },
      options);
    }




export const getAddAssigneePayoutsMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAssigneePayouts>>, TError,{data: Assign}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addAssigneePayouts>>, TError,{data: Assign}, TContext> => {

const mutationKey = ['addAssigneePayouts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAssigneePayouts>>, {data: Assign}> = (props) => {
          const {data} = props ?? {};

          return  addAssigneePayouts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAssigneePayoutsMutationResult = NonNullable<Awaited<ReturnType<typeof addAssigneePayouts>>>
    export type AddAssigneePayoutsMutationBody = Assign
    export type AddAssigneePayoutsMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Add assignee to payouts
 */
export const useAddAssigneePayouts = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAssigneePayouts>>, TError,{data: Assign}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addAssigneePayouts>>,
        TError,
        {data: Assign},
        TContext
      > => {
      return useMutation(getAddAssigneePayoutsMutationOptions(options), queryClient);
    }

/**
 * @summary Create bulk processing task for payouts
 */
export const createBulkPayoutProcessingTask = (
    createBulkProcessingTask: CreateBulkProcessingTask,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutBulkActionResponse>(
      {url: `/admin/api/payouts/bulk_actions/create_processing_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkProcessingTask, signal
    },
      options);
    }




export const getCreateBulkPayoutProcessingTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkPayoutProcessingTask>>, TError,{data: CreateBulkProcessingTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkPayoutProcessingTask>>, TError,{data: CreateBulkProcessingTask}, TContext> => {

const mutationKey = ['createBulkPayoutProcessingTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkPayoutProcessingTask>>, {data: CreateBulkProcessingTask}> = (props) => {
          const {data} = props ?? {};

          return  createBulkPayoutProcessingTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkPayoutProcessingTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkPayoutProcessingTask>>>
    export type CreateBulkPayoutProcessingTaskMutationBody = CreateBulkProcessingTask
    export type CreateBulkPayoutProcessingTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create bulk processing task for payouts
 */
export const useCreateBulkPayoutProcessingTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkPayoutProcessingTask>>, TError,{data: CreateBulkProcessingTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkPayoutProcessingTask>>,
        TError,
        {data: CreateBulkProcessingTask},
        TContext
      > => {
      return useMutation(getCreateBulkPayoutProcessingTaskMutationOptions(options), queryClient);
    }

/**
 * @summary List users
 */
export const listUsers = (
    params?: ListUsersParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UsersListResponse>(
      {url: `/admin/api/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    'admin','api','users', ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = N404Response | N500Response>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = N404Response | N500Response


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = N404Response | N500Response>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = N404Response | N500Response>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = N404Response | N500Response>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List users
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = N404Response | N500Response>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List users
 */
export const prefetchListUsersQuery = async <TData = Awaited<ReturnType<typeof listUsers>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListUsersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List account managers
 */
export const listAccountManagers = (
    params?: ListAccountManagersParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ListAccountManagers200>(
      {url: `/admin/api/account_managers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAccountManagersQueryKey = (params?: ListAccountManagersParams,) => {
    return [
    'admin','api','account_managers', ...(params ? [params] : [])
    ] as const;
    }


export const getListAccountManagersQueryOptions = <TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = N404Response | N500Response>(params?: ListAccountManagersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountManagersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountManagers>>> = ({ signal }) => listAccountManagers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAccountManagersQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountManagers>>>
export type ListAccountManagersQueryError = N404Response | N500Response


export function useListAccountManagers<TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = N404Response | N500Response>(
 params: undefined |  ListAccountManagersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountManagers>>,
          TError,
          Awaited<ReturnType<typeof listAccountManagers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccountManagers<TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = N404Response | N500Response>(
 params?: ListAccountManagersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountManagers>>,
          TError,
          Awaited<ReturnType<typeof listAccountManagers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccountManagers<TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = N404Response | N500Response>(
 params?: ListAccountManagersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List account managers
 */

export function useListAccountManagers<TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = N404Response | N500Response>(
 params?: ListAccountManagersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAccountManagersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List account managers
 */
export const prefetchListAccountManagersQuery = async <TData = Awaited<ReturnType<typeof listAccountManagers>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListAccountManagersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountManagers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListAccountManagersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List application settings
 */
export const listAppSettings = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ListAppSettings200>(
      {url: `/admin/api/app_settings`, method: 'GET', signal
    },
      options);
    }




export const getListAppSettingsQueryKey = () => {
    return [
    'admin','api','app_settings'
    ] as const;
    }


export const getListAppSettingsQueryOptions = <TData = Awaited<ReturnType<typeof listAppSettings>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppSettings>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAppSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAppSettings>>> = ({ signal }) => listAppSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAppSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAppSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof listAppSettings>>>
export type ListAppSettingsQueryError = N404Response | N500Response


export function useListAppSettings<TData = Awaited<ReturnType<typeof listAppSettings>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAppSettings>>,
          TError,
          Awaited<ReturnType<typeof listAppSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAppSettings<TData = Awaited<ReturnType<typeof listAppSettings>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAppSettings>>,
          TError,
          Awaited<ReturnType<typeof listAppSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAppSettings<TData = Awaited<ReturnType<typeof listAppSettings>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppSettings>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List application settings
 */

export function useListAppSettings<TData = Awaited<ReturnType<typeof listAppSettings>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppSettings>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAppSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List application settings
 */
export const prefetchListAppSettingsQuery = async <TData = Awaited<ReturnType<typeof listAppSettings>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppSettings>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListAppSettingsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update an application setting
 */
export const updateAppSetting = (
    namespace: string,
    key: string,
    appSettingUpdateRequestBody: AppSettingUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AppSettingUpdateResponseBody>(
      {url: `/admin/api/app_settings/${namespace}/keys/${key}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: appSettingUpdateRequestBody, signal
    },
      options);
    }




export const getUpdateAppSettingMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppSetting>>, TError,{namespace: string;key: string;data: AppSettingUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAppSetting>>, TError,{namespace: string;key: string;data: AppSettingUpdateRequestBody}, TContext> => {

const mutationKey = ['updateAppSetting'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAppSetting>>, {namespace: string;key: string;data: AppSettingUpdateRequestBody}> = (props) => {
          const {namespace,key,data} = props ?? {};

          return  updateAppSetting(namespace,key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAppSettingMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppSetting>>>
    export type UpdateAppSettingMutationBody = AppSettingUpdateRequestBody
    export type UpdateAppSettingMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update an application setting
 */
export const useUpdateAppSetting = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppSetting>>, TError,{namespace: string;key: string;data: AppSettingUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAppSetting>>,
        TError,
        {namespace: string;key: string;data: AppSettingUpdateRequestBody},
        TContext
      > => {
      return useMutation(getUpdateAppSettingMutationOptions(options), queryClient);
    }

/**
 * @summary Get user count for search filter and data for dropdowns
 */
export const getUserFilterMetadata = (
    params?: GetUserFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetUserFilterMetadata200>(
      {url: `/admin/api/users/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserFilterMetadataQueryKey = (params?: GetUserFilterMetadataParams,) => {
    return [
    'admin','api','users','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getUserFilterMetadata>>, TError = N404Response | N500Response>(params?: GetUserFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFilterMetadata>>> = ({ signal }) => getUserFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFilterMetadata>>>
export type GetUserFilterMetadataQueryError = N404Response | N500Response


export function useGetUserFilterMetadata<TData = Awaited<ReturnType<typeof getUserFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetUserFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFilterMetadata<TData = Awaited<ReturnType<typeof getUserFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetUserFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserFilterMetadata<TData = Awaited<ReturnType<typeof getUserFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetUserFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user count for search filter and data for dropdowns
 */

export function useGetUserFilterMetadata<TData = Awaited<ReturnType<typeof getUserFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetUserFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user count for search filter and data for dropdowns
 */
export const prefetchGetUserFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getUserFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetUserFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Export data as CSV
 */
export const exportData = (
    params: ExportDataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Blob>(
      {url: `/admin/api/exports`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getExportDataQueryKey = (params?: ExportDataParams,) => {
    return [
    'admin','api','exports', ...(params ? [params] : [])
    ] as const;
    }


export const getExportDataQueryOptions = <TData = Awaited<ReturnType<typeof exportData>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(params: ExportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportDataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportData>>> = ({ signal }) => exportData(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportDataQueryResult = NonNullable<Awaited<ReturnType<typeof exportData>>>
export type ExportDataQueryError = ResourceNotFoundError | InvalidRecordError | InternalServerError


export function useExportData<TData = Awaited<ReturnType<typeof exportData>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: ExportDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportData>>,
          TError,
          Awaited<ReturnType<typeof exportData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportData<TData = Awaited<ReturnType<typeof exportData>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: ExportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportData>>,
          TError,
          Awaited<ReturnType<typeof exportData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportData<TData = Awaited<ReturnType<typeof exportData>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: ExportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export data as CSV
 */

export function useExportData<TData = Awaited<ReturnType<typeof exportData>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: ExportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export data as CSV
 */
export const prefetchExportDataQuery = async <TData = Awaited<ReturnType<typeof exportData>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 queryClient: QueryClient, params: ExportDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getExportDataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get user details
 */
export const getUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserDetailed>(
      {url: `/admin/api/users/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserQueryKey = (id: number,) => {
    return [
    'admin','api','users',id
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = N404Response | N500Response


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user details
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user details
 */
export const prefetchGetUserQuery = async <TData = Awaited<ReturnType<typeof getUser>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update user
 */
export const updateUser = (
    id: number,
    userUpdateRequestBody: UserUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserUpdateResponse>(
      {url: `/admin/api/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateRequestBody, signal
    },
      options);
    }




export const getUpdateUserMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: UserUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: UserUpdateRequestBody}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: number;data: UserUpdateRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UserUpdateRequestBody
    export type UpdateUserMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update user
 */
export const useUpdateUser = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: number;data: UserUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: number;data: UserUpdateRequestBody},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }

/**
 * @summary Delete user
 */
export const deleteUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserUpdateResponse>(
      {url: `/admin/api/users/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteUserMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = N404Response | N500Response

    /**
 * @summary Delete user
 */
export const useDeleteUser = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }

/**
 * @summary Get user statistics
 */
export const getUserStatistics = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserStatisticsResponse>(
      {url: `/admin/api/users/${id}/statistics`, method: 'GET', signal
    },
      options);
    }




export const getGetUserStatisticsQueryKey = (id: number,) => {
    return [
    'admin','api','users',id,'statistics'
    ] as const;
    }


export const getGetUserStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getUserStatistics>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStatisticsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStatistics>>> = ({ signal }) => getUserStatistics(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStatistics>>>
export type GetUserStatisticsQueryError = N404Response | N500Response


export function useGetUserStatistics<TData = Awaited<ReturnType<typeof getUserStatistics>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserStatistics>>,
          TError,
          Awaited<ReturnType<typeof getUserStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserStatistics<TData = Awaited<ReturnType<typeof getUserStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserStatistics>>,
          TError,
          Awaited<ReturnType<typeof getUserStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserStatistics<TData = Awaited<ReturnType<typeof getUserStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user statistics
 */

export function useGetUserStatistics<TData = Awaited<ReturnType<typeof getUserStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserStatisticsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user statistics
 */
export const prefetchGetUserStatisticsQuery = async <TData = Awaited<ReturnType<typeof getUserStatistics>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserStatisticsQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get user detailed statistics
 */
export const getUserTradingRiskStatistics = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserTradingRiskStatisticsResponse>(
      {url: `/admin/api/users/${id}/trading_risk_statistics`, method: 'GET', signal
    },
      options);
    }




export const getGetUserTradingRiskStatisticsQueryKey = (id: number,) => {
    return [
    'admin','api','users',id,'trading_risk_statistics'
    ] as const;
    }


export const getGetUserTradingRiskStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserTradingRiskStatisticsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>> = ({ signal }) => getUserTradingRiskStatistics(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserTradingRiskStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>>
export type GetUserTradingRiskStatisticsQueryError = N404Response | N500Response


export function useGetUserTradingRiskStatistics<TData = Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTradingRiskStatistics>>,
          TError,
          Awaited<ReturnType<typeof getUserTradingRiskStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserTradingRiskStatistics<TData = Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTradingRiskStatistics>>,
          TError,
          Awaited<ReturnType<typeof getUserTradingRiskStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserTradingRiskStatistics<TData = Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user detailed statistics
 */

export function useGetUserTradingRiskStatistics<TData = Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserTradingRiskStatisticsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user detailed statistics
 */
export const prefetchGetUserTradingRiskStatisticsQuery = async <TData = Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTradingRiskStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserTradingRiskStatisticsQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get user Prime monthly reward statistics
 */
export const getUserPrimeStatistics = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserPrimeStatisticsResponse>(
      {url: `/admin/api/users/${id}/prime_statistics`, method: 'GET', signal
    },
      options);
    }




export const getGetUserPrimeStatisticsQueryKey = (id: number,) => {
    return [
    'admin','api','users',id,'prime_statistics'
    ] as const;
    }


export const getGetUserPrimeStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPrimeStatisticsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPrimeStatistics>>> = ({ signal }) => getUserPrimeStatistics(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserPrimeStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPrimeStatistics>>>
export type GetUserPrimeStatisticsQueryError = N404Response | N500Response


export function useGetUserPrimeStatistics<TData = Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPrimeStatistics>>,
          TError,
          Awaited<ReturnType<typeof getUserPrimeStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserPrimeStatistics<TData = Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPrimeStatistics>>,
          TError,
          Awaited<ReturnType<typeof getUserPrimeStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserPrimeStatistics<TData = Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user Prime monthly reward statistics
 */

export function useGetUserPrimeStatistics<TData = Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserPrimeStatisticsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user Prime monthly reward statistics
 */
export const prefetchGetUserPrimeStatisticsQuery = async <TData = Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPrimeStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserPrimeStatisticsQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get user information needed to edit
 */
export const getUserEditInformation = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserEditResponse>(
      {url: `/admin/api/users/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetUserEditInformationQueryKey = (id: number,) => {
    return [
    'admin','api','users',id,'edit'
    ] as const;
    }


export const getGetUserEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getUserEditInformation>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserEditInformationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEditInformation>>> = ({ signal }) => getUserEditInformation(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getUserEditInformation>>>
export type GetUserEditInformationQueryError = N404Response | N500Response


export function useGetUserEditInformation<TData = Awaited<ReturnType<typeof getUserEditInformation>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getUserEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserEditInformation<TData = Awaited<ReturnType<typeof getUserEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getUserEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserEditInformation<TData = Awaited<ReturnType<typeof getUserEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user information needed to edit
 */

export function useGetUserEditInformation<TData = Awaited<ReturnType<typeof getUserEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserEditInformationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user information needed to edit
 */
export const prefetchGetUserEditInformationQuery = async <TData = Awaited<ReturnType<typeof getUserEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserEditInformationQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Retrieves the modal configuration for a specific trading account action that requires parameters.
 *
 * When listing trading accounts, each resource includes an `actions` array describing available operations.
 * - If `require_params = true`, the client must first call this endpoint to fetch the form schema before executing the action.
 * - If `require_params = false`, the action can be invoked directly without this preliminary step.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *       - `button` — a generic control (link, secondary action, etc.)
 *     - **Optional** `action` (object): if present, mirrors a full action descriptor (same shape as in the main `actions` array), indicating that clicking this button should invoke that action (possibly fetching its own form if `require_params = true`).
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary List modal information along with list of params needed for a specific payout action
 */
export const listPayoutActionParams = (
    id: number,
    params: ListPayoutActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<FormParamsSchema>(
      {url: `/admin/api/payouts/${id}/actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPayoutActionParamsQueryKey = (id: number,
    params?: ListPayoutActionParamsParams,) => {
    return [
    'admin','api','payouts',id,'actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListPayoutActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listPayoutActionParams>>, TError = N404Response | N500Response>(id: number,
    params: ListPayoutActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayoutActionParamsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayoutActionParams>>> = ({ signal }) => listPayoutActionParams(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayoutActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayoutActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayoutActionParams>>>
export type ListPayoutActionParamsQueryError = N404Response | N500Response


export function useListPayoutActionParams<TData = Awaited<ReturnType<typeof listPayoutActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayoutActionParams>>,
          TError,
          Awaited<ReturnType<typeof listPayoutActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutActionParams<TData = Awaited<ReturnType<typeof listPayoutActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayoutActionParams>>,
          TError,
          Awaited<ReturnType<typeof listPayoutActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutActionParams<TData = Awaited<ReturnType<typeof listPayoutActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List modal information along with list of params needed for a specific payout action
 */

export function useListPayoutActionParams<TData = Awaited<ReturnType<typeof listPayoutActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPayoutActionParamsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List modal information along with list of params needed for a specific payout action
 */
export const prefetchListPayoutActionParamsQuery = async <TData = Awaited<ReturnType<typeof listPayoutActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params: ListPayoutActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListPayoutActionParamsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Change payment method to crypto
 */
export const changePayoutPaymentMethodToCrypto = (
    id: number,
    convertToCrypto: ConvertToCrypto,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutActionResponse>(
      {url: `/admin/api/payouts/${id}/convert_to_crypto`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: convertToCrypto, signal
    },
      options);
    }




export const getChangePayoutPaymentMethodToCryptoMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePayoutPaymentMethodToCrypto>>, TError,{id: number;data: ConvertToCrypto}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changePayoutPaymentMethodToCrypto>>, TError,{id: number;data: ConvertToCrypto}, TContext> => {

const mutationKey = ['changePayoutPaymentMethodToCrypto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePayoutPaymentMethodToCrypto>>, {id: number;data: ConvertToCrypto}> = (props) => {
          const {id,data} = props ?? {};

          return  changePayoutPaymentMethodToCrypto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePayoutPaymentMethodToCryptoMutationResult = NonNullable<Awaited<ReturnType<typeof changePayoutPaymentMethodToCrypto>>>
    export type ChangePayoutPaymentMethodToCryptoMutationBody = ConvertToCrypto
    export type ChangePayoutPaymentMethodToCryptoMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Change payment method to crypto
 */
export const useChangePayoutPaymentMethodToCrypto = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePayoutPaymentMethodToCrypto>>, TError,{id: number;data: ConvertToCrypto}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePayoutPaymentMethodToCrypto>>,
        TError,
        {id: number;data: ConvertToCrypto},
        TContext
      > => {
      return useMutation(getChangePayoutPaymentMethodToCryptoMutationOptions(options), queryClient);
    }

/**
 * @summary Change payment method to rise
 */
export const changePayoutPaymentMethodToRise = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutActionResponse>(
      {url: `/admin/api/payouts/${id}/convert_to_rise`, method: 'PATCH', signal
    },
      options);
    }




export const getChangePayoutPaymentMethodToRiseMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePayoutPaymentMethodToRise>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changePayoutPaymentMethodToRise>>, TError,{id: number}, TContext> => {

const mutationKey = ['changePayoutPaymentMethodToRise'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePayoutPaymentMethodToRise>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  changePayoutPaymentMethodToRise(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePayoutPaymentMethodToRiseMutationResult = NonNullable<Awaited<ReturnType<typeof changePayoutPaymentMethodToRise>>>

    export type ChangePayoutPaymentMethodToRiseMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Change payment method to rise
 */
export const useChangePayoutPaymentMethodToRise = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePayoutPaymentMethodToRise>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePayoutPaymentMethodToRise>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getChangePayoutPaymentMethodToRiseMutationOptions(options), queryClient);
    }

/**
 * @summary Approve payout
 */
export const approvePayout = (
    id: number,
    payoutEnableTradingRequestBody?: PayoutEnableTradingRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutActionResponse>(
      {url: `/admin/api/payouts/${id}/approve`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payoutEnableTradingRequestBody, signal
    },
      options);
    }




export const getApprovePayoutMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePayout>>, TError,{id: number;data?: PayoutEnableTradingRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePayout>>, TError,{id: number;data?: PayoutEnableTradingRequestBody}, TContext> => {

const mutationKey = ['approvePayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePayout>>, {id: number;data?: PayoutEnableTradingRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  approvePayout(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePayoutMutationResult = NonNullable<Awaited<ReturnType<typeof approvePayout>>>
    export type ApprovePayoutMutationBody = PayoutEnableTradingRequestBody | undefined
    export type ApprovePayoutMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Approve payout
 */
export const useApprovePayout = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePayout>>, TError,{id: number;data?: PayoutEnableTradingRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePayout>>,
        TError,
        {id: number;data?: PayoutEnableTradingRequestBody},
        TContext
      > => {
      return useMutation(getApprovePayoutMutationOptions(options), queryClient);
    }

/**
 * @summary Process payout
 */
export const processPayout = (
    id: number,
    payoutEnableTradingRequestBody?: PayoutEnableTradingRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutActionResponse>(
      {url: `/admin/api/payouts/${id}/processed`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: payoutEnableTradingRequestBody, signal
    },
      options);
    }




export const getProcessPayoutMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processPayout>>, TError,{id: number;data?: PayoutEnableTradingRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof processPayout>>, TError,{id: number;data?: PayoutEnableTradingRequestBody}, TContext> => {

const mutationKey = ['processPayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processPayout>>, {id: number;data?: PayoutEnableTradingRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  processPayout(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessPayoutMutationResult = NonNullable<Awaited<ReturnType<typeof processPayout>>>
    export type ProcessPayoutMutationBody = PayoutEnableTradingRequestBody | undefined
    export type ProcessPayoutMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Process payout
 */
export const useProcessPayout = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processPayout>>, TError,{id: number;data?: PayoutEnableTradingRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processPayout>>,
        TError,
        {id: number;data?: PayoutEnableTradingRequestBody},
        TContext
      > => {
      return useMutation(getProcessPayoutMutationOptions(options), queryClient);
    }

/**
 * @summary Cancel payout
 */
export const cancelPayout = (
    id: number,
    cancelPayoutBody?: CancelPayoutBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutActionResponse>(
      {url: `/admin/api/payouts/${id}/cancel`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: cancelPayoutBody, signal
    },
      options);
    }




export const getCancelPayoutMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPayout>>, TError,{id: number;data?: CancelPayoutBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPayout>>, TError,{id: number;data?: CancelPayoutBody}, TContext> => {

const mutationKey = ['cancelPayout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPayout>>, {id: number;data?: CancelPayoutBody}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelPayout(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPayoutMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPayout>>>
    export type CancelPayoutMutationBody = CancelPayoutBody | undefined
    export type CancelPayoutMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Cancel payout
 */
export const useCancelPayout = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPayout>>, TError,{id: number;data?: CancelPayoutBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelPayout>>,
        TError,
        {id: number;data?: CancelPayoutBody},
        TContext
      > => {
      return useMutation(getCancelPayoutMutationOptions(options), queryClient);
    }

/**
 * @summary Change payout status to risk assessment
 */
export const changePayoutStatusToRiskAssessment = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutActionResponse>(
      {url: `/admin/api/payouts/${id}/risk_assessment`, method: 'PATCH', signal
    },
      options);
    }




export const getChangePayoutStatusToRiskAssessmentMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePayoutStatusToRiskAssessment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changePayoutStatusToRiskAssessment>>, TError,{id: number}, TContext> => {

const mutationKey = ['changePayoutStatusToRiskAssessment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePayoutStatusToRiskAssessment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  changePayoutStatusToRiskAssessment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePayoutStatusToRiskAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof changePayoutStatusToRiskAssessment>>>

    export type ChangePayoutStatusToRiskAssessmentMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Change payout status to risk assessment
 */
export const useChangePayoutStatusToRiskAssessment = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePayoutStatusToRiskAssessment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePayoutStatusToRiskAssessment>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getChangePayoutStatusToRiskAssessmentMutationOptions(options), queryClient);
    }

/**
 * Send a custom email to the user associated with the payout using a specified email template
 * @summary Send email to payout user
 */
export const sendEmailToPayoutUser = (
    id: number,
    payoutSendEmailRequest: PayoutSendEmailRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutActionResponse>(
      {url: `/admin/api/payouts/${id}/send_email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payoutSendEmailRequest, signal
    },
      options);
    }




export const getSendEmailToPayoutUserMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToPayoutUser>>, TError,{id: number;data: PayoutSendEmailRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmailToPayoutUser>>, TError,{id: number;data: PayoutSendEmailRequest}, TContext> => {

const mutationKey = ['sendEmailToPayoutUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmailToPayoutUser>>, {id: number;data: PayoutSendEmailRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  sendEmailToPayoutUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailToPayoutUserMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmailToPayoutUser>>>
    export type SendEmailToPayoutUserMutationBody = PayoutSendEmailRequest
    export type SendEmailToPayoutUserMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Send email to payout user
 */
export const useSendEmailToPayoutUser = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToPayoutUser>>, TError,{id: number;data: PayoutSendEmailRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendEmailToPayoutUser>>,
        TError,
        {id: number;data: PayoutSendEmailRequest},
        TContext
      > => {
      return useMutation(getSendEmailToPayoutUserMutationOptions(options), queryClient);
    }

/**
 * Retrieves the modal configuration for a specific trading account action that requires parameters.
 *
 * When listing trading accounts, each resource includes an `actions` array describing available operations.
 * - If `require_params = true`, the client must first call this endpoint to fetch the form schema before executing the action.
 * - If `require_params = false`, the action can be invoked directly without this preliminary step.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *       - `button` — a generic control (link, secondary action, etc.)
 *     - **Optional** `action` (object): if present, mirrors a full action descriptor (same shape as in the main `actions` array), indicating that clicking this button should invoke that action (possibly fetching its own form if `require_params = true`).
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary List modal information along with list of params needed for a specific payout transaction action
 */
export const listPayoutTransactionActionParams = (
    id: number,
    params: ListPayoutTransactionActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<FormParamsSchema>(
      {url: `/admin/api/payout_transactions/${id}/actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPayoutTransactionActionParamsQueryKey = (id: number,
    params?: ListPayoutTransactionActionParamsParams,) => {
    return [
    'admin','api','payout_transactions',id,'actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListPayoutTransactionActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError = N404Response | N500Response>(id: number,
    params: ListPayoutTransactionActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayoutTransactionActionParamsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>> = ({ signal }) => listPayoutTransactionActionParams(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayoutTransactionActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>>
export type ListPayoutTransactionActionParamsQueryError = N404Response | N500Response


export function useListPayoutTransactionActionParams<TData = Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutTransactionActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayoutTransactionActionParams>>,
          TError,
          Awaited<ReturnType<typeof listPayoutTransactionActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutTransactionActionParams<TData = Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutTransactionActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayoutTransactionActionParams>>,
          TError,
          Awaited<ReturnType<typeof listPayoutTransactionActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayoutTransactionActionParams<TData = Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutTransactionActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List modal information along with list of params needed for a specific payout transaction action
 */

export function useListPayoutTransactionActionParams<TData = Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListPayoutTransactionActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPayoutTransactionActionParamsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List modal information along with list of params needed for a specific payout transaction action
 */
export const prefetchListPayoutTransactionActionParamsQuery = async <TData = Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params: ListPayoutTransactionActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayoutTransactionActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListPayoutTransactionActionParamsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Replace payout transaction payment method
 */
export const replacePayoutTransactionPaymentMethod = (
    id: number,
    replace: Replace,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonPayoutTransactionActionResponse>(
      {url: `/admin/api/payout_transactions/${id}/replace`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: replace, signal
    },
      options);
    }




export const getReplacePayoutTransactionPaymentMethodMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replacePayoutTransactionPaymentMethod>>, TError,{id: number;data: Replace}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replacePayoutTransactionPaymentMethod>>, TError,{id: number;data: Replace}, TContext> => {

const mutationKey = ['replacePayoutTransactionPaymentMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replacePayoutTransactionPaymentMethod>>, {id: number;data: Replace}> = (props) => {
          const {id,data} = props ?? {};

          return  replacePayoutTransactionPaymentMethod(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplacePayoutTransactionPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof replacePayoutTransactionPaymentMethod>>>
    export type ReplacePayoutTransactionPaymentMethodMutationBody = Replace
    export type ReplacePayoutTransactionPaymentMethodMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Replace payout transaction payment method
 */
export const useReplacePayoutTransactionPaymentMethod = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replacePayoutTransactionPaymentMethod>>, TError,{id: number;data: Replace}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replacePayoutTransactionPaymentMethod>>,
        TError,
        {id: number;data: Replace},
        TContext
      > => {
      return useMutation(getReplacePayoutTransactionPaymentMethodMutationOptions(options), queryClient);
    }

/**
 * Retrieves the modal configuration for a specific trading account action that requires parameters.
 *
 * When listing trading accounts, each resource includes an `actions` array describing available operations.
 * - If `require_params = true`, the client must first call this endpoint to fetch the form schema before executing the action.
 * - If `require_params = false`, the action can be invoked directly without this preliminary step.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *       - `button` — a generic control (link, secondary action, etc.)
 *     - **Optional** `action` (object): if present, mirrors a full action descriptor (same shape as in the main `actions` array), indicating that clicking this button should invoke that action (possibly fetching its own form if `require_params = true`).
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary Request action params
 */
export const listUserActionParams = (
    id: number,
    params: ListUserActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<FormParamsSchema>(
      {url: `/admin/api/users/${id}/actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListUserActionParamsQueryKey = (id: number,
    params?: ListUserActionParamsParams,) => {
    return [
    'admin','api','users',id,'actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListUserActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listUserActionParams>>, TError = N404Response | N500Response>(id: number,
    params: ListUserActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserActionParamsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserActionParams>>> = ({ signal }) => listUserActionParams(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listUserActionParams>>>
export type ListUserActionParamsQueryError = N404Response | N500Response


export function useListUserActionParams<TData = Awaited<ReturnType<typeof listUserActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListUserActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserActionParams>>,
          TError,
          Awaited<ReturnType<typeof listUserActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserActionParams<TData = Awaited<ReturnType<typeof listUserActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListUserActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUserActionParams>>,
          TError,
          Awaited<ReturnType<typeof listUserActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserActionParams<TData = Awaited<ReturnType<typeof listUserActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListUserActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request action params
 */

export function useListUserActionParams<TData = Awaited<ReturnType<typeof listUserActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListUserActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserActionParamsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Request action params
 */
export const prefetchListUserActionParamsQuery = async <TData = Awaited<ReturnType<typeof listUserActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params: ListUserActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListUserActionParamsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Block a user
 */
export const blockUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserBlockResponse>(
      {url: `/admin/api/users/${id}/block`, method: 'PATCH', signal
    },
      options);
    }




export const getBlockUserMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['blockUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof blockUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  blockUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BlockUserMutationResult = NonNullable<Awaited<ReturnType<typeof blockUser>>>

    export type BlockUserMutationError = N404Response | N500Response

    /**
 * @summary Block a user
 */
export const useBlockUser = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof blockUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof blockUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getBlockUserMutationOptions(options), queryClient);
    }

/**
 * @summary Unblock a user
 */
export const unblockUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserUnblockResponse>(
      {url: `/admin/api/users/${id}/unblock`, method: 'PATCH', signal
    },
      options);
    }




export const getUnblockUserMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unblockUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unblockUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['unblockUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unblockUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  unblockUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnblockUserMutationResult = NonNullable<Awaited<ReturnType<typeof unblockUser>>>

    export type UnblockUserMutationError = N404Response | N500Response

    /**
 * @summary Unblock a user
 */
export const useUnblockUser = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unblockUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unblockUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUnblockUserMutationOptions(options), queryClient);
    }

/**
 * @summary Reset user password
 */
export const resetUserPassword = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserResetPasswordResponse>(
      {url: `/admin/api/users/${id}/reset_password`, method: 'PATCH', signal
    },
      options);
    }




export const getResetUserPasswordMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{id: number}, TContext> => {

const mutationKey = ['resetUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPassword>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  resetUserPassword(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>

    export type ResetUserPasswordMutationError = N404Response | N500Response

    /**
 * @summary Reset user password
 */
export const useResetUserPassword = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetUserPassword>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getResetUserPasswordMutationOptions(options), queryClient);
    }

/**
 * @summary Reset user 2FA
 */
export const resetUser2FA = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserReset2faResponse>(
      {url: `/admin/api/users/${id}/reset_2fa`, method: 'PATCH', signal
    },
      options);
    }




export const getResetUser2FAMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUser2FA>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUser2FA>>, TError,{id: number}, TContext> => {

const mutationKey = ['resetUser2FA'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUser2FA>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  resetUser2FA(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUser2FAMutationResult = NonNullable<Awaited<ReturnType<typeof resetUser2FA>>>

    export type ResetUser2FAMutationError = N404Response | N500Response

    /**
 * @summary Reset user 2FA
 */
export const useResetUser2FA = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUser2FA>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetUser2FA>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getResetUser2FAMutationOptions(options), queryClient);
    }

/**
 * @summary Start kyc verification
 */
export const startKycVerification = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserStartVerificationResponse>(
      {url: `/admin/api/users/${id}/start_verification`, method: 'POST', signal
    },
      options);
    }




export const getStartKycVerificationMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startKycVerification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startKycVerification>>, TError,{id: number}, TContext> => {

const mutationKey = ['startKycVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startKycVerification>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  startKycVerification(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartKycVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof startKycVerification>>>

    export type StartKycVerificationMutationError = N404Response | N500Response

    /**
 * @summary Start kyc verification
 */
export const useStartKycVerification = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startKycVerification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startKycVerification>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getStartKycVerificationMutationOptions(options), queryClient);
    }

/**
 * @summary Disable verification for a user
 */
export const disableVerification = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DisableVerificationResponse>(
      {url: `/admin/api/users/${id}/disable_verification`, method: 'PATCH', signal
    },
      options);
    }




export const getDisableVerificationMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableVerification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disableVerification>>, TError,{id: number}, TContext> => {

const mutationKey = ['disableVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableVerification>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  disableVerification(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof disableVerification>>>

    export type DisableVerificationMutationError = N404Response | N500Response

    /**
 * @summary Disable verification for a user
 */
export const useDisableVerification = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableVerification>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableVerification>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDisableVerificationMutationOptions(options), queryClient);
    }

/**
 * @summary Generate dispute for a user
 */
export const generateDispute = (
    id: number,
    generateDisputeBody: GenerateDisputeBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Blob>(
      {url: `/admin/api/users/${id}/dispute_generation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateDisputeBody,
        responseType: 'blob', signal
    },
      options);
    }




export const getGenerateDisputeMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDispute>>, TError,{id: number;data: GenerateDisputeBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateDispute>>, TError,{id: number;data: GenerateDisputeBody}, TContext> => {

const mutationKey = ['generateDispute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDispute>>, {id: number;data: GenerateDisputeBody}> = (props) => {
          const {id,data} = props ?? {};

          return  generateDispute(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateDisputeMutationResult = NonNullable<Awaited<ReturnType<typeof generateDispute>>>
    export type GenerateDisputeMutationBody = GenerateDisputeBody
    export type GenerateDisputeMutationError = N404Response | N500Response

    /**
 * @summary Generate dispute for a user
 */
export const useGenerateDispute = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDispute>>, TError,{id: number;data: GenerateDisputeBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateDispute>>,
        TError,
        {id: number;data: GenerateDisputeBody},
        TContext
      > => {
      return useMutation(getGenerateDisputeMutationOptions(options), queryClient);
    }

/**
 * @summary Generate CID match report for a user
 */
export const generateCidReport = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Blob>(
      {url: `/admin/api/users/${id}/generate_cid_report`, method: 'POST',
        responseType: 'blob', signal
    },
      options);
    }




export const getGenerateCidReportMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCidReport>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCidReport>>, TError,{id: number}, TContext> => {

const mutationKey = ['generateCidReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCidReport>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  generateCidReport(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateCidReportMutationResult = NonNullable<Awaited<ReturnType<typeof generateCidReport>>>

    export type GenerateCidReportMutationError = N404Response | N500Response

    /**
 * @summary Generate CID match report for a user
 */
export const useGenerateCidReport = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCidReport>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCidReport>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getGenerateCidReportMutationOptions(options), queryClient);
    }

/**
 * @summary Refresh KYC documents for a user
 */
export const refreshKycDocumentsUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<RefreshKycDocumentsResponse>(
      {url: `/admin/api/users/${id}/refresh_kyc_documents`, method: 'POST', signal
    },
      options);
    }




export const getRefreshKycDocumentsUserMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshKycDocumentsUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshKycDocumentsUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['refreshKycDocumentsUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshKycDocumentsUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  refreshKycDocumentsUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshKycDocumentsUserMutationResult = NonNullable<Awaited<ReturnType<typeof refreshKycDocumentsUser>>>

    export type RefreshKycDocumentsUserMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Refresh KYC documents for a user
 */
export const useRefreshKycDocumentsUser = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshKycDocumentsUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshKycDocumentsUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRefreshKycDocumentsUserMutationOptions(options), queryClient);
    }

/**
 * @summary Start generating a zip of a user's KYC documents, signed agreements, and IP whitelist proof documents, emailed to the requesting admin once ready
 */
export const downloadAsZipUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserDownloadAsZipResponse>(
      {url: `/admin/api/users/${id}/download_as_zip`, method: 'POST', signal
    },
      options);
    }




export const getDownloadAsZipUserMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof downloadAsZipUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof downloadAsZipUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['downloadAsZipUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof downloadAsZipUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  downloadAsZipUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DownloadAsZipUserMutationResult = NonNullable<Awaited<ReturnType<typeof downloadAsZipUser>>>

    export type DownloadAsZipUserMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Start generating a zip of a user's KYC documents, signed agreements, and IP whitelist proof documents, emailed to the requesting admin once ready
 */
export const useDownloadAsZipUser = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof downloadAsZipUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof downloadAsZipUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDownloadAsZipUserMutationOptions(options), queryClient);
    }

/**
 * @summary Toggle high risk for user
 */
export const toggleHighRiskUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ToggleHighRiskResponse>(
      {url: `/admin/api/users/${id}/high_risk`, method: 'PATCH', signal
    },
      options);
    }




export const getToggleHighRiskUserMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleHighRiskUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleHighRiskUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['toggleHighRiskUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleHighRiskUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  toggleHighRiskUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleHighRiskUserMutationResult = NonNullable<Awaited<ReturnType<typeof toggleHighRiskUser>>>

    export type ToggleHighRiskUserMutationError = N404Response | N500Response

    /**
 * @summary Toggle high risk for user
 */
export const useToggleHighRiskUser = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleHighRiskUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleHighRiskUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getToggleHighRiskUserMutationOptions(options), queryClient);
    }

/**
 * @summary Change a user's brand
 */
export const changeUserBrand = (
    id: number,
    changeUserBrandBody: ChangeUserBrandBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserChangeBrandResponse>(
      {url: `/admin/api/users/${id}/change_brand`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeUserBrandBody, signal
    },
      options);
    }




export const getChangeUserBrandMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserBrand>>, TError,{id: number;data: ChangeUserBrandBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeUserBrand>>, TError,{id: number;data: ChangeUserBrandBody}, TContext> => {

const mutationKey = ['changeUserBrand'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeUserBrand>>, {id: number;data: ChangeUserBrandBody}> = (props) => {
          const {id,data} = props ?? {};

          return  changeUserBrand(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeUserBrandMutationResult = NonNullable<Awaited<ReturnType<typeof changeUserBrand>>>
    export type ChangeUserBrandMutationBody = ChangeUserBrandBody
    export type ChangeUserBrandMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Change a user's brand
 */
export const useChangeUserBrand = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserBrand>>, TError,{id: number;data: ChangeUserBrandBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeUserBrand>>,
        TError,
        {id: number;data: ChangeUserBrandBody},
        TContext
      > => {
      return useMutation(getChangeUserBrandMutationOptions(options), queryClient);
    }

/**
 * Manually registers a withdrawal that was settled outside our backend: refunds selected deposit payment sessions and/or records an external payout, without calling any PSP.
 * @summary Manually create and settle a withdrawal for a user
 */
export const createUserWithdrawal = (
    id: number,
    createUserWithdrawalBody: CreateUserWithdrawalBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserCreateWithdrawalResponse>(
      {url: `/admin/api/users/${id}/create_withdrawal`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserWithdrawalBody, signal
    },
      options);
    }




export const getCreateUserWithdrawalMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserWithdrawal>>, TError,{id: number;data: CreateUserWithdrawalBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserWithdrawal>>, TError,{id: number;data: CreateUserWithdrawalBody}, TContext> => {

const mutationKey = ['createUserWithdrawal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserWithdrawal>>, {id: number;data: CreateUserWithdrawalBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createUserWithdrawal(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserWithdrawalMutationResult = NonNullable<Awaited<ReturnType<typeof createUserWithdrawal>>>
    export type CreateUserWithdrawalMutationBody = CreateUserWithdrawalBody
    export type CreateUserWithdrawalMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Manually create and settle a withdrawal for a user
 */
export const useCreateUserWithdrawal = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserWithdrawal>>, TError,{id: number;data: CreateUserWithdrawalBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserWithdrawal>>,
        TError,
        {id: number;data: CreateUserWithdrawalBody},
        TContext
      > => {
      return useMutation(getCreateUserWithdrawalMutationOptions(options), queryClient);
    }

/**
 * Manually registers a deposit that completed outside our backend
 * @summary Manually create and settle a deposit for a user
 */
export const createUserDeposit = (
    id: number,
    createUserDepositBody: CreateUserDepositBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserCreateDepositResponse>(
      {url: `/admin/api/users/${id}/create_deposit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserDepositBody, signal
    },
      options);
    }




export const getCreateUserDepositMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserDeposit>>, TError,{id: number;data: CreateUserDepositBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserDeposit>>, TError,{id: number;data: CreateUserDepositBody}, TContext> => {

const mutationKey = ['createUserDeposit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserDeposit>>, {id: number;data: CreateUserDepositBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createUserDeposit(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserDepositMutationResult = NonNullable<Awaited<ReturnType<typeof createUserDeposit>>>
    export type CreateUserDepositMutationBody = CreateUserDepositBody
    export type CreateUserDepositMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Manually create and settle a deposit for a user
 */
export const useCreateUserDeposit = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserDeposit>>, TError,{id: number;data: CreateUserDepositBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserDeposit>>,
        TError,
        {id: number;data: CreateUserDepositBody},
        TContext
      > => {
      return useMutation(getCreateUserDepositMutationOptions(options), queryClient);
    }

/**
 * @summary Get 1000 IP activities for a user
 */
export const getIpActivities = (
    userId: number,
    params?: GetIpActivitiesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserIpActivitiesResponse>(
      {url: `/admin/api/users/${userId}/ip_activities`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetIpActivitiesQueryKey = (userId: number,
    params?: GetIpActivitiesParams,) => {
    return [
    'admin','api','users',userId,'ip_activities', ...(params ? [params] : [])
    ] as const;
    }


export const getGetIpActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getIpActivities>>, TError = N404Response | N500Response>(userId: number,
    params?: GetIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIpActivitiesQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIpActivities>>> = ({ signal }) => getIpActivities(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIpActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIpActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getIpActivities>>>
export type GetIpActivitiesQueryError = N404Response | N500Response


export function useGetIpActivities<TData = Awaited<ReturnType<typeof getIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  GetIpActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIpActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIpActivities<TData = Awaited<ReturnType<typeof getIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIpActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIpActivities<TData = Awaited<ReturnType<typeof getIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get 1000 IP activities for a user
 */

export function useGetIpActivities<TData = Awaited<ReturnType<typeof getIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIpActivitiesQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get 1000 IP activities for a user
 */
export const prefetchGetIpActivitiesQuery = async <TData = Awaited<ReturnType<typeof getIpActivities>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: GetIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIpActivitiesQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get filter metadata for closed positions for trading account
 */
export const getFilterMetadataIpActivities = (
    userId: number,
    params?: GetFilterMetadataIpActivitiesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserIpActivitiesFilterMetadataResponse>(
      {url: `/admin/api/users/${userId}/ip_activities/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFilterMetadataIpActivitiesQueryKey = (userId: number,
    params?: GetFilterMetadataIpActivitiesParams,) => {
    return [
    'admin','api','users',userId,'ip_activities','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetFilterMetadataIpActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError = N404Response | N500Response>(userId: number,
    params?: GetFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilterMetadataIpActivitiesQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>> = ({ signal }) => getFilterMetadataIpActivities(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFilterMetadataIpActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>>
export type GetFilterMetadataIpActivitiesQueryError = N404Response | N500Response


export function useGetFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  GetFilterMetadataIpActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterMetadataIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getFilterMetadataIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterMetadataIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getFilterMetadataIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata for closed positions for trading account
 */

export function useGetFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFilterMetadataIpActivitiesQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata for closed positions for trading account
 */
export const prefetchGetFilterMetadataIpActivitiesQuery = async <TData = Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: GetFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFilterMetadataIpActivitiesQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Returns users whose current name or KYC name is similar to the given user's name
 * @summary Get users with a similar name
 */
export const getSimilarUsers = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetSimilarUsers200>(
      {url: `/admin/api/users/${userId}/similar_users`, method: 'GET', signal
    },
      options);
    }




export const getGetSimilarUsersQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'similar_users'
    ] as const;
    }


export const getGetSimilarUsersQueryOptions = <TData = Awaited<ReturnType<typeof getSimilarUsers>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimilarUsersQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimilarUsers>>> = ({ signal }) => getSimilarUsers(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimilarUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimilarUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getSimilarUsers>>>
export type GetSimilarUsersQueryError = N404Response | N500Response


export function useGetSimilarUsers<TData = Awaited<ReturnType<typeof getSimilarUsers>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimilarUsers>>,
          TError,
          Awaited<ReturnType<typeof getSimilarUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimilarUsers<TData = Awaited<ReturnType<typeof getSimilarUsers>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimilarUsers>>,
          TError,
          Awaited<ReturnType<typeof getSimilarUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimilarUsers<TData = Awaited<ReturnType<typeof getSimilarUsers>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get users with a similar name
 */

export function useGetSimilarUsers<TData = Awaited<ReturnType<typeof getSimilarUsers>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimilarUsersQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get users with a similar name
 */
export const prefetchGetSimilarUsersQuery = async <TData = Awaited<ReturnType<typeof getSimilarUsers>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetSimilarUsersQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get email logs for a user
 */
export const getEmailLogs = (
    userId: number,
    params?: GetEmailLogsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EmailLogsListResponse>(
      {url: `/admin/api/users/${userId}/email_logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEmailLogsQueryKey = (userId: number,
    params?: GetEmailLogsParams,) => {
    return [
    'admin','api','users',userId,'email_logs', ...(params ? [params] : [])
    ] as const;
    }


export const getGetEmailLogsQueryOptions = <TData = Awaited<ReturnType<typeof getEmailLogs>>, TError = N404Response | N500Response>(userId: number,
    params?: GetEmailLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailLogsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailLogs>>> = ({ signal }) => getEmailLogs(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailLogs>>>
export type GetEmailLogsQueryError = N404Response | N500Response


export function useGetEmailLogs<TData = Awaited<ReturnType<typeof getEmailLogs>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  GetEmailLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailLogs>>,
          TError,
          Awaited<ReturnType<typeof getEmailLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailLogs<TData = Awaited<ReturnType<typeof getEmailLogs>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetEmailLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailLogs>>,
          TError,
          Awaited<ReturnType<typeof getEmailLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailLogs<TData = Awaited<ReturnType<typeof getEmailLogs>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetEmailLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get email logs for a user
 */

export function useGetEmailLogs<TData = Awaited<ReturnType<typeof getEmailLogs>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetEmailLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailLogsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get email logs for a user
 */
export const prefetchGetEmailLogsQuery = async <TData = Awaited<ReturnType<typeof getEmailLogs>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: GetEmailLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEmailLogsQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get email log
 */
export const getEmailLog = (
    userId: number,
    id: string,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EmailLogResponse>(
      {url: `/admin/api/users/${userId}/email_logs/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetEmailLogQueryKey = (userId: number,
    id: string,) => {
    return [
    'admin','api','users',userId,'email_logs',id
    ] as const;
    }


export const getGetEmailLogQueryOptions = <TData = Awaited<ReturnType<typeof getEmailLog>>, TError = N404Response | N500Response>(userId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailLogQueryKey(userId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailLog>>> = ({ signal }) => getEmailLog(userId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailLogQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailLog>>>
export type GetEmailLogQueryError = N404Response | N500Response


export function useGetEmailLog<TData = Awaited<ReturnType<typeof getEmailLog>>, TError = N404Response | N500Response>(
 userId: number,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailLog>>,
          TError,
          Awaited<ReturnType<typeof getEmailLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailLog<TData = Awaited<ReturnType<typeof getEmailLog>>, TError = N404Response | N500Response>(
 userId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailLog>>,
          TError,
          Awaited<ReturnType<typeof getEmailLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailLog<TData = Awaited<ReturnType<typeof getEmailLog>>, TError = N404Response | N500Response>(
 userId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get email log
 */

export function useGetEmailLog<TData = Awaited<ReturnType<typeof getEmailLog>>, TError = N404Response | N500Response>(
 userId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailLogQueryOptions(userId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get email log
 */
export const prefetchGetEmailLogQuery = async <TData = Awaited<ReturnType<typeof getEmailLog>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEmailLogQueryOptions(userId,id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List filtermetadata for challenges for a given user
 */
export const filterMetadataChallengesForUser = (
    userId: number,
    params?: FilterMetadataChallengesForUserParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ChallengesFilterMetadataResponse>(
      {url: `/admin/api/users/${userId}/challenges/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getFilterMetadataChallengesForUserQueryKey = (userId: number,
    params?: FilterMetadataChallengesForUserParams,) => {
    return [
    'admin','api','users',userId,'challenges','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getFilterMetadataChallengesForUserQueryOptions = <TData = Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError = N404Response | N500Response>(userId: number,
    params?: FilterMetadataChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFilterMetadataChallengesForUserQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>> = ({ signal }) => filterMetadataChallengesForUser(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FilterMetadataChallengesForUserQueryResult = NonNullable<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>>
export type FilterMetadataChallengesForUserQueryError = N404Response | N500Response


export function useFilterMetadataChallengesForUser<TData = Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  FilterMetadataChallengesForUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterMetadataChallengesForUser>>,
          TError,
          Awaited<ReturnType<typeof filterMetadataChallengesForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterMetadataChallengesForUser<TData = Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: FilterMetadataChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof filterMetadataChallengesForUser>>,
          TError,
          Awaited<ReturnType<typeof filterMetadataChallengesForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFilterMetadataChallengesForUser<TData = Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: FilterMetadataChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List filtermetadata for challenges for a given user
 */

export function useFilterMetadataChallengesForUser<TData = Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: FilterMetadataChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFilterMetadataChallengesForUserQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List filtermetadata for challenges for a given user
 */
export const prefetchFilterMetadataChallengesForUserQuery = async <TData = Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: FilterMetadataChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof filterMetadataChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFilterMetadataChallengesForUserQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List challenges for a given user
 */
export const listChallengesForUser = (
    userId: number,
    params?: ListChallengesForUserParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ChallengesListResponse>(
      {url: `/admin/api/users/${userId}/challenges`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListChallengesForUserQueryKey = (userId: number,
    params?: ListChallengesForUserParams,) => {
    return [
    'admin','api','users',userId,'challenges', ...(params ? [params] : [])
    ] as const;
    }


export const getListChallengesForUserQueryOptions = <TData = Awaited<ReturnType<typeof listChallengesForUser>>, TError = N404Response | N500Response>(userId: number,
    params?: ListChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListChallengesForUserQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listChallengesForUser>>> = ({ signal }) => listChallengesForUser(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listChallengesForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListChallengesForUserQueryResult = NonNullable<Awaited<ReturnType<typeof listChallengesForUser>>>
export type ListChallengesForUserQueryError = N404Response | N500Response


export function useListChallengesForUser<TData = Awaited<ReturnType<typeof listChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  ListChallengesForUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listChallengesForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChallengesForUser>>,
          TError,
          Awaited<ReturnType<typeof listChallengesForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListChallengesForUser<TData = Awaited<ReturnType<typeof listChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: ListChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listChallengesForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChallengesForUser>>,
          TError,
          Awaited<ReturnType<typeof listChallengesForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListChallengesForUser<TData = Awaited<ReturnType<typeof listChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: ListChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List challenges for a given user
 */

export function useListChallengesForUser<TData = Awaited<ReturnType<typeof listChallengesForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: ListChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListChallengesForUserQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List challenges for a given user
 */
export const prefetchListChallengesForUserQuery = async <TData = Awaited<ReturnType<typeof listChallengesForUser>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: ListChallengesForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listChallengesForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListChallengesForUserQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new challenge for a given user
 */
export const createChallengeForUser = (
    userId: number,
    createChallengeForUserBody: CreateChallengeForUserBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ChallengeCreated>(
      {url: `/admin/api/users/${userId}/challenges`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createChallengeForUserBody, signal
    },
      options);
    }




export const getCreateChallengeForUserMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChallengeForUser>>, TError,{userId: number;data: CreateChallengeForUserBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createChallengeForUser>>, TError,{userId: number;data: CreateChallengeForUserBody}, TContext> => {

const mutationKey = ['createChallengeForUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChallengeForUser>>, {userId: number;data: CreateChallengeForUserBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  createChallengeForUser(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateChallengeForUserMutationResult = NonNullable<Awaited<ReturnType<typeof createChallengeForUser>>>
    export type CreateChallengeForUserMutationBody = CreateChallengeForUserBody
    export type CreateChallengeForUserMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create a new challenge for a given user
 */
export const useCreateChallengeForUser = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChallengeForUser>>, TError,{userId: number;data: CreateChallengeForUserBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createChallengeForUser>>,
        TError,
        {userId: number;data: CreateChallengeForUserBody},
        TContext
      > => {
      return useMutation(getCreateChallengeForUserMutationOptions(options), queryClient);
    }

/**
 * @summary Get bank accounts
 */
export const getBankAccounts = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BankAccountsResponse>(
      {url: `/admin/api/users/${userId}/bank_accounts`, method: 'GET', signal
    },
      options);
    }




export const getGetBankAccountsQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'bank_accounts'
    ] as const;
    }


export const getGetBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccounts>>> = ({ signal }) => getBankAccounts(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccounts>>>
export type GetBankAccountsQueryError = N404Response | N500Response


export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get bank accounts
 */

export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankAccountsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get bank accounts
 */
export const prefetchGetBankAccountsQuery = async <TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBankAccountsQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get crypto wallets
 */
export const getCryptoWallets = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CryptoWalletsResponse>(
      {url: `/admin/api/users/${userId}/crypto_wallets`, method: 'GET', signal
    },
      options);
    }




export const getGetCryptoWalletsQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'crypto_wallets'
    ] as const;
    }


export const getGetCryptoWalletsQueryOptions = <TData = Awaited<ReturnType<typeof getCryptoWallets>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCryptoWallets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCryptoWalletsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCryptoWallets>>> = ({ signal }) => getCryptoWallets(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCryptoWallets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCryptoWalletsQueryResult = NonNullable<Awaited<ReturnType<typeof getCryptoWallets>>>
export type GetCryptoWalletsQueryError = N404Response | N500Response


export function useGetCryptoWallets<TData = Awaited<ReturnType<typeof getCryptoWallets>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCryptoWallets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoWallets>>,
          TError,
          Awaited<ReturnType<typeof getCryptoWallets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCryptoWallets<TData = Awaited<ReturnType<typeof getCryptoWallets>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCryptoWallets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCryptoWallets>>,
          TError,
          Awaited<ReturnType<typeof getCryptoWallets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCryptoWallets<TData = Awaited<ReturnType<typeof getCryptoWallets>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCryptoWallets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get crypto wallets
 */

export function useGetCryptoWallets<TData = Awaited<ReturnType<typeof getCryptoWallets>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCryptoWallets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCryptoWalletsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get crypto wallets
 */
export const prefetchGetCryptoWalletsQuery = async <TData = Awaited<ReturnType<typeof getCryptoWallets>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCryptoWallets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCryptoWalletsQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get payment cards
 */
export const getPaymentCards = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PaymentCardsResponse>(
      {url: `/admin/api/users/${userId}/payment_cards`, method: 'GET', signal
    },
      options);
    }




export const getGetPaymentCardsQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'payment_cards'
    ] as const;
    }


export const getGetPaymentCardsQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentCardsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentCards>>> = ({ signal }) => getPaymentCards(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentCards>>>
export type GetPaymentCardsQueryError = N404Response | N500Response


export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentCards>>,
          TError,
          Awaited<ReturnType<typeof getPaymentCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentCards>>,
          TError,
          Awaited<ReturnType<typeof getPaymentCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment cards
 */

export function useGetPaymentCards<TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentCardsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get payment cards
 */
export const prefetchGetPaymentCardsQuery = async <TData = Awaited<ReturnType<typeof getPaymentCards>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCards>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPaymentCardsQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get policy acceptances for a user
 */
export const getUserPolicyAcceptances = (
    userId: number,
    params?: GetUserPolicyAcceptancesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PolicyAcceptancesResponse>(
      {url: `/admin/api/users/${userId}/documents/policy_acceptances`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserPolicyAcceptancesQueryKey = (userId: number,
    params?: GetUserPolicyAcceptancesParams,) => {
    return [
    'admin','api','users',userId,'documents','policy_acceptances', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserPolicyAcceptancesQueryOptions = <TData = Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError = N404Response | N500Response>(userId: number,
    params?: GetUserPolicyAcceptancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPolicyAcceptancesQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPolicyAcceptances>>> = ({ signal }) => getUserPolicyAcceptances(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserPolicyAcceptancesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPolicyAcceptances>>>
export type GetUserPolicyAcceptancesQueryError = N404Response | N500Response


export function useGetUserPolicyAcceptances<TData = Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  GetUserPolicyAcceptancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPolicyAcceptances>>,
          TError,
          Awaited<ReturnType<typeof getUserPolicyAcceptances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserPolicyAcceptances<TData = Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetUserPolicyAcceptancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPolicyAcceptances>>,
          TError,
          Awaited<ReturnType<typeof getUserPolicyAcceptances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserPolicyAcceptances<TData = Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetUserPolicyAcceptancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get policy acceptances for a user
 */

export function useGetUserPolicyAcceptances<TData = Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetUserPolicyAcceptancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserPolicyAcceptancesQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get policy acceptances for a user
 */
export const prefetchGetUserPolicyAcceptancesQuery = async <TData = Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: GetUserPolicyAcceptancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptances>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserPolicyAcceptancesQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get filter metadata for user policy acceptances
 */
export const getUserPolicyAcceptancesFilterMetadata = (
    userId: number,
    params?: GetUserPolicyAcceptancesFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PolicyAcceptancesFilterMetadataResponse>(
      {url: `/admin/api/users/${userId}/documents/policy_acceptances/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserPolicyAcceptancesFilterMetadataQueryKey = (userId: number,
    params?: GetUserPolicyAcceptancesFilterMetadataParams,) => {
    return [
    'admin','api','users',userId,'documents','policy_acceptances','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserPolicyAcceptancesFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError = N404Response | N500Response>(userId: number,
    params?: GetUserPolicyAcceptancesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPolicyAcceptancesFilterMetadataQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>> = ({ signal }) => getUserPolicyAcceptancesFilterMetadata(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserPolicyAcceptancesFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>>
export type GetUserPolicyAcceptancesFilterMetadataQueryError = N404Response | N500Response


export function useGetUserPolicyAcceptancesFilterMetadata<TData = Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  GetUserPolicyAcceptancesFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserPolicyAcceptancesFilterMetadata<TData = Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetUserPolicyAcceptancesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserPolicyAcceptancesFilterMetadata<TData = Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetUserPolicyAcceptancesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata for user policy acceptances
 */

export function useGetUserPolicyAcceptancesFilterMetadata<TData = Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetUserPolicyAcceptancesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserPolicyAcceptancesFilterMetadataQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata for user policy acceptances
 */
export const prefetchGetUserPolicyAcceptancesFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: GetUserPolicyAcceptancesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPolicyAcceptancesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserPolicyAcceptancesFilterMetadataQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get KYC documents
 */
export const getKycDocuments = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<KycDocumentsResponse>(
      {url: `/admin/api/users/${userId}/documents/kyc`, method: 'GET', signal
    },
      options);
    }




export const getGetKycDocumentsQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'documents','kyc'
    ] as const;
    }


export const getGetKycDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getKycDocuments>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKycDocuments>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetKycDocumentsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getKycDocuments>>> = ({ signal }) => getKycDocuments(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getKycDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetKycDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getKycDocuments>>>
export type GetKycDocumentsQueryError = N404Response | N500Response


export function useGetKycDocuments<TData = Awaited<ReturnType<typeof getKycDocuments>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKycDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKycDocuments>>,
          TError,
          Awaited<ReturnType<typeof getKycDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKycDocuments<TData = Awaited<ReturnType<typeof getKycDocuments>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKycDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKycDocuments>>,
          TError,
          Awaited<ReturnType<typeof getKycDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKycDocuments<TData = Awaited<ReturnType<typeof getKycDocuments>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKycDocuments>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get KYC documents
 */

export function useGetKycDocuments<TData = Awaited<ReturnType<typeof getKycDocuments>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKycDocuments>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetKycDocumentsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get KYC documents
 */
export const prefetchGetKycDocumentsQuery = async <TData = Awaited<ReturnType<typeof getKycDocuments>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKycDocuments>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetKycDocumentsQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Returns one summary entry per questionnaire type each with its own completion status and a url to its detail endpoint, if available.
 * @summary List a user's questionnaires
 */
export const getUserQuestionnaires = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<QuestionnairesResponse>(
      {url: `/admin/api/users/${userId}/questionnaires`, method: 'GET', signal
    },
      options);
    }




export const getGetUserQuestionnairesQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'questionnaires'
    ] as const;
    }


export const getGetUserQuestionnairesQueryOptions = <TData = Awaited<ReturnType<typeof getUserQuestionnaires>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQuestionnairesQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserQuestionnaires>>> = ({ signal }) => getUserQuestionnaires(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserQuestionnaires>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQuestionnairesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserQuestionnaires>>>
export type GetUserQuestionnairesQueryError = N404Response | N500Response


export function useGetUserQuestionnaires<TData = Awaited<ReturnType<typeof getUserQuestionnaires>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserQuestionnaires>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getUserQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserQuestionnaires<TData = Awaited<ReturnType<typeof getUserQuestionnaires>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserQuestionnaires>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserQuestionnaires>>,
          TError,
          Awaited<ReturnType<typeof getUserQuestionnaires>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserQuestionnaires<TData = Awaited<ReturnType<typeof getUserQuestionnaires>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a user's questionnaires
 */

export function useGetUserQuestionnaires<TData = Awaited<ReturnType<typeof getUserQuestionnaires>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQuestionnairesQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List a user's questionnaires
 */
export const prefetchGetUserQuestionnairesQuery = async <TData = Awaited<ReturnType<typeof getUserQuestionnaires>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserQuestionnaires>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserQuestionnairesQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Returns the onboarding questionnaire's steps, sections, and the user's saved answers.
 * @summary Get a user's onboarding questionnaire
 */
export const getUserOnboardingQuestionnaire = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<OnboardingQuestionnaireResponse>(
      {url: `/admin/api/users/${userId}/questionnaires/onboarding`, method: 'GET', signal
    },
      options);
    }




export const getGetUserOnboardingQuestionnaireQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'questionnaires','onboarding'
    ] as const;
    }


export const getGetUserOnboardingQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserOnboardingQuestionnaireQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>> = ({ signal }) => getUserOnboardingQuestionnaire(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserOnboardingQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>>
export type GetUserOnboardingQuestionnaireQueryError = N404Response | N500Response


export function useGetUserOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user's onboarding questionnaire
 */

export function useGetUserOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserOnboardingQuestionnaireQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a user's onboarding questionnaire
 */
export const prefetchGetUserOnboardingQuestionnaireQuery = async <TData = Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserOnboardingQuestionnaireQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Returns the IB onboarding questionnaire's steps, sections, saved answers, and available review actions. Approve and reject actions are available while the IB profile is awaiting approval.
 * @summary Get a user's IB onboarding questionnaire
 */
export const getUserIbOnboardingQuestionnaire = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IbOnboardingQuestionnaireResponse>(
      {url: `/admin/api/users/${userId}/questionnaires/ib_onboarding`, method: 'GET', signal
    },
      options);
    }




export const getGetUserIbOnboardingQuestionnaireQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'questionnaires','ib_onboarding'
    ] as const;
    }


export const getGetUserIbOnboardingQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIbOnboardingQuestionnaireQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>> = ({ signal }) => getUserIbOnboardingQuestionnaire(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIbOnboardingQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>>
export type GetUserIbOnboardingQuestionnaireQueryError = N404Response | N500Response


export function useGetUserIbOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIbOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIbOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user's IB onboarding questionnaire
 */

export function useGetUserIbOnboardingQuestionnaire<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIbOnboardingQuestionnaireQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a user's IB onboarding questionnaire
 */
export const prefetchGetUserIbOnboardingQuestionnaireQuery = async <TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserIbOnboardingQuestionnaireQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Saves the submitted step's inputs, same as the member-facing IB onboarding endpoint. The IB profile is created on the first saved step (status questionnaire_pending) and its status is recomputed on each save.
 * @summary Save an IB onboarding step on behalf of a user
 */
export const createUserIbOnboardingQuestionnaire = (
    userId: number,
    saveIbOnboardingStepRequestBody: SaveIbOnboardingStepRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<QuestionnaireDetail>(
      {url: `/admin/api/users/${userId}/questionnaires/ib_onboarding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveIbOnboardingStepRequestBody, signal
    },
      options);
    }




export const getCreateUserIbOnboardingQuestionnaireMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserIbOnboardingQuestionnaire>>, TError,{userId: number;data: SaveIbOnboardingStepRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserIbOnboardingQuestionnaire>>, TError,{userId: number;data: SaveIbOnboardingStepRequestBody}, TContext> => {

const mutationKey = ['createUserIbOnboardingQuestionnaire'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserIbOnboardingQuestionnaire>>, {userId: number;data: SaveIbOnboardingStepRequestBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  createUserIbOnboardingQuestionnaire(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserIbOnboardingQuestionnaireMutationResult = NonNullable<Awaited<ReturnType<typeof createUserIbOnboardingQuestionnaire>>>
    export type CreateUserIbOnboardingQuestionnaireMutationBody = SaveIbOnboardingStepRequestBody
    export type CreateUserIbOnboardingQuestionnaireMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Save an IB onboarding step on behalf of a user
 */
export const useCreateUserIbOnboardingQuestionnaire = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserIbOnboardingQuestionnaire>>, TError,{userId: number;data: SaveIbOnboardingStepRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserIbOnboardingQuestionnaire>>,
        TError,
        {userId: number;data: SaveIbOnboardingStepRequestBody},
        TContext
      > => {
      return useMutation(getCreateUserIbOnboardingQuestionnaireMutationOptions(options), queryClient);
    }

/**
 * Saves the submitted step's inputs, same as the member-facing IB onboarding endpoint. The IB profile is created on the first saved step (status questionnaire_pending) and its status is recomputed on each save.
 * @summary Save an IB onboarding step on behalf of a user
 */
export const updateUserIbOnboardingQuestionnaire = (
    userId: number,
    saveIbOnboardingStepRequestBody: SaveIbOnboardingStepRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<QuestionnaireDetail>(
      {url: `/admin/api/users/${userId}/questionnaires/ib_onboarding`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: saveIbOnboardingStepRequestBody, signal
    },
      options);
    }




export const getUpdateUserIbOnboardingQuestionnaireMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserIbOnboardingQuestionnaire>>, TError,{userId: number;data: SaveIbOnboardingStepRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserIbOnboardingQuestionnaire>>, TError,{userId: number;data: SaveIbOnboardingStepRequestBody}, TContext> => {

const mutationKey = ['updateUserIbOnboardingQuestionnaire'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserIbOnboardingQuestionnaire>>, {userId: number;data: SaveIbOnboardingStepRequestBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUserIbOnboardingQuestionnaire(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserIbOnboardingQuestionnaireMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserIbOnboardingQuestionnaire>>>
    export type UpdateUserIbOnboardingQuestionnaireMutationBody = SaveIbOnboardingStepRequestBody
    export type UpdateUserIbOnboardingQuestionnaireMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Save an IB onboarding step on behalf of a user
 */
export const useUpdateUserIbOnboardingQuestionnaire = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserIbOnboardingQuestionnaire>>, TError,{userId: number;data: SaveIbOnboardingStepRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserIbOnboardingQuestionnaire>>,
        TError,
        {userId: number;data: SaveIbOnboardingStepRequestBody},
        TContext
      > => {
      return useMutation(getUpdateUserIbOnboardingQuestionnaireMutationOptions(options), queryClient);
    }

/**
 * Returns the raw IB onboarding stepper state (steps, the same shape as the member-facing endpoint), but only when the user has not started IB onboarding yet. Errors if an IbProfile already exists for the user. The first successful member or Admin step submission creates it; this endpoint is not for viewing an in-progress or completed application.
 * @summary Get a user's blank IB onboarding stepper config, only if not yet started
 */
export const getUserIbOnboardingQuestionnaireNew = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IbOnboardingDetailsSerializer>(
      {url: `/admin/api/users/${userId}/questionnaires/ib_onboarding/new`, method: 'GET', signal
    },
      options);
    }




export const getGetUserIbOnboardingQuestionnaireNewQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'questionnaires','ib_onboarding','new'
    ] as const;
    }


export const getGetUserIbOnboardingQuestionnaireNewQueryOptions = <TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError = N404Response | N422Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIbOnboardingQuestionnaireNewQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>> = ({ signal }) => getUserIbOnboardingQuestionnaireNew(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIbOnboardingQuestionnaireNewQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>>
export type GetUserIbOnboardingQuestionnaireNewQueryError = N404Response | N422Response | N500Response


export function useGetUserIbOnboardingQuestionnaireNew<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>,
          TError,
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIbOnboardingQuestionnaireNew<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>,
          TError,
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIbOnboardingQuestionnaireNew<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user's blank IB onboarding stepper config, only if not yet started
 */

export function useGetUserIbOnboardingQuestionnaireNew<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIbOnboardingQuestionnaireNewQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a user's blank IB onboarding stepper config, only if not yet started
 */
export const prefetchGetUserIbOnboardingQuestionnaireNewQuery = async <TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserIbOnboardingQuestionnaireNewQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Returns the raw IB onboarding stepper state (steps + saved answers, same shape as the member-facing endpoint and as GET .../ib_onboarding/new), but only when the user has already started IB onboarding. Errors if the user has no IbProfile yet.
 * @summary Get a user's IB onboarding stepper config and progress, only if already started
 */
export const getUserIbOnboardingQuestionnaireEdit = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IbOnboardingDetailsSerializer>(
      {url: `/admin/api/users/${userId}/questionnaires/ib_onboarding/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetUserIbOnboardingQuestionnaireEditQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'questionnaires','ib_onboarding','edit'
    ] as const;
    }


export const getGetUserIbOnboardingQuestionnaireEditQueryOptions = <TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError = N404Response | N422Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIbOnboardingQuestionnaireEditQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>> = ({ signal }) => getUserIbOnboardingQuestionnaireEdit(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIbOnboardingQuestionnaireEditQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>>
export type GetUserIbOnboardingQuestionnaireEditQueryError = N404Response | N422Response | N500Response


export function useGetUserIbOnboardingQuestionnaireEdit<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>,
          TError,
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIbOnboardingQuestionnaireEdit<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>,
          TError,
          Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIbOnboardingQuestionnaireEdit<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user's IB onboarding stepper config and progress, only if already started
 */

export function useGetUserIbOnboardingQuestionnaireEdit<TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError = N404Response | N422Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIbOnboardingQuestionnaireEditQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a user's IB onboarding stepper config and progress, only if already started
 */
export const prefetchGetUserIbOnboardingQuestionnaireEditQuery = async <TData = Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIbOnboardingQuestionnaireEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserIbOnboardingQuestionnaireEditQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Generate invoice for a payment session
 */
export const generatePaymentSessionInvoice = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Blob>(
      {url: `/admin/api/payment_sessions/${id}/generate_invoice`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGeneratePaymentSessionInvoiceQueryKey = (id: number,) => {
    return [
    'admin','api','payment_sessions',id,'generate_invoice'
    ] as const;
    }


export const getGeneratePaymentSessionInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGeneratePaymentSessionInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>> = ({ signal }) => generatePaymentSessionInvoice(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GeneratePaymentSessionInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>>
export type GeneratePaymentSessionInvoiceQueryError = N404Response | N500Response


export function useGeneratePaymentSessionInvoice<TData = Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePaymentSessionInvoice>>,
          TError,
          Awaited<ReturnType<typeof generatePaymentSessionInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGeneratePaymentSessionInvoice<TData = Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generatePaymentSessionInvoice>>,
          TError,
          Awaited<ReturnType<typeof generatePaymentSessionInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGeneratePaymentSessionInvoice<TData = Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate invoice for a payment session
 */

export function useGeneratePaymentSessionInvoice<TData = Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGeneratePaymentSessionInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Generate invoice for a payment session
 */
export const prefetchGeneratePaymentSessionInvoiceQuery = async <TData = Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generatePaymentSessionInvoice>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGeneratePaymentSessionInvoiceQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get options for the new challenge
 */
export const getNewChallengeOptions = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ChallengesNewResponse>(
      {url: `/admin/api/challenges/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewChallengeOptionsQueryKey = () => {
    return [
    'admin','api','challenges','new'
    ] as const;
    }


export const getGetNewChallengeOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getNewChallengeOptions>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewChallengeOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewChallengeOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewChallengeOptions>>> = ({ signal }) => getNewChallengeOptions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewChallengeOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewChallengeOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getNewChallengeOptions>>>
export type GetNewChallengeOptionsQueryError = N404Response | N500Response


export function useGetNewChallengeOptions<TData = Awaited<ReturnType<typeof getNewChallengeOptions>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewChallengeOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewChallengeOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewChallengeOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewChallengeOptions<TData = Awaited<ReturnType<typeof getNewChallengeOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewChallengeOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewChallengeOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewChallengeOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewChallengeOptions<TData = Awaited<ReturnType<typeof getNewChallengeOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewChallengeOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for the new challenge
 */

export function useGetNewChallengeOptions<TData = Awaited<ReturnType<typeof getNewChallengeOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewChallengeOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewChallengeOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for the new challenge
 */
export const prefetchGetNewChallengeOptionsQuery = async <TData = Awaited<ReturnType<typeof getNewChallengeOptions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewChallengeOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewChallengeOptionsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List trading accounts
 */
export const listTradingAccounts = (
    params?: ListTradingAccountsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountsListResponse>(
      {url: `/admin/api/trading_accounts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTradingAccountsQueryKey = (params?: ListTradingAccountsParams,) => {
    return [
    'admin','api','trading_accounts', ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listTradingAccounts>>, TError = N404Response | N500Response>(params?: ListTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingAccounts>>> = ({ signal }) => listTradingAccounts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingAccounts>>>
export type ListTradingAccountsQueryError = N404Response | N500Response


export function useListTradingAccounts<TData = Awaited<ReturnType<typeof listTradingAccounts>>, TError = N404Response | N500Response>(
 params: undefined |  ListTradingAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingAccounts>>,
          TError,
          Awaited<ReturnType<typeof listTradingAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingAccounts<TData = Awaited<ReturnType<typeof listTradingAccounts>>, TError = N404Response | N500Response>(
 params?: ListTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingAccounts>>,
          TError,
          Awaited<ReturnType<typeof listTradingAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingAccounts<TData = Awaited<ReturnType<typeof listTradingAccounts>>, TError = N404Response | N500Response>(
 params?: ListTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List trading accounts
 */

export function useListTradingAccounts<TData = Awaited<ReturnType<typeof listTradingAccounts>>, TError = N404Response | N500Response>(
 params?: ListTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List trading accounts
 */
export const prefetchListTradingAccountsQuery = async <TData = Awaited<ReturnType<typeof listTradingAccounts>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTradingAccountsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get trading account count for search filter and data for dropdowns
 */
export const getTradingAccountFilterMetadata = (
    params?: GetTradingAccountFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountsFilterMetadataResponse>(
      {url: `/admin/api/trading_accounts/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountFilterMetadataQueryKey = (params?: GetTradingAccountFilterMetadataParams,) => {
    return [
    'admin','api','trading_accounts','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError = N404Response | N500Response>(params?: GetTradingAccountFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>> = ({ signal }) => getTradingAccountFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>>
export type GetTradingAccountFilterMetadataQueryError = N404Response | N500Response


export function useGetTradingAccountFilterMetadata<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetTradingAccountFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountFilterMetadata<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountFilterMetadata<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get trading account count for search filter and data for dropdowns
 */

export function useGetTradingAccountFilterMetadata<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get trading account count for search filter and data for dropdowns
 */
export const prefetchGetTradingAccountFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetTradingAccountFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get trading account statistics
 */
export const getTradingAccountStatistics = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountStatisticsResponse>(
      {url: `/admin/api/trading_accounts/${id}/statistics`, method: 'GET', signal
    },
      options);
    }




export const getGetTradingAccountStatisticsQueryKey = (id: number,) => {
    return [
    'admin','api','trading_accounts',id,'statistics'
    ] as const;
    }


export const getGetTradingAccountStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountStatisticsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountStatistics>>> = ({ signal }) => getTradingAccountStatistics(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountStatistics>>>
export type GetTradingAccountStatisticsQueryError = N404Response | N500Response


export function useGetTradingAccountStatistics<TData = Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountStatistics>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountStatistics<TData = Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountStatistics>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountStatistics<TData = Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get trading account statistics
 */

export function useGetTradingAccountStatistics<TData = Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountStatisticsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get trading account statistics
 */
export const prefetchGetTradingAccountStatisticsQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountStatistics>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountStatisticsQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get trading account widgets
 */
export const getTradingAccountWidgets = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountWidgetsResponse>(
      {url: `/admin/api/trading_accounts/${id}/widgets`, method: 'GET', signal
    },
      options);
    }




export const getGetTradingAccountWidgetsQueryKey = (id: number,) => {
    return [
    'admin','api','trading_accounts',id,'widgets'
    ] as const;
    }


export const getGetTradingAccountWidgetsQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountWidgetsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountWidgets>>> = ({ signal }) => getTradingAccountWidgets(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountWidgetsQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountWidgets>>>
export type GetTradingAccountWidgetsQueryError = N404Response | N500Response


export function useGetTradingAccountWidgets<TData = Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountWidgets>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountWidgets<TData = Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountWidgets>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountWidgets<TData = Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get trading account widgets
 */

export function useGetTradingAccountWidgets<TData = Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountWidgetsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get trading account widgets
 */
export const prefetchGetTradingAccountWidgetsQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountWidgetsQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get related trading accounts
 */
export const getRelatedTradingAccounts = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetRelatedTradingAccounts200>(
      {url: `/admin/api/trading_accounts/${id}/related`, method: 'GET', signal
    },
      options);
    }




export const getGetRelatedTradingAccountsQueryKey = (id: number,) => {
    return [
    'admin','api','trading_accounts',id,'related'
    ] as const;
    }


export const getGetRelatedTradingAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRelatedTradingAccountsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRelatedTradingAccounts>>> = ({ signal }) => getRelatedTradingAccounts(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRelatedTradingAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getRelatedTradingAccounts>>>
export type GetRelatedTradingAccountsQueryError = N404Response | N500Response


export function useGetRelatedTradingAccounts<TData = Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRelatedTradingAccounts>>,
          TError,
          Awaited<ReturnType<typeof getRelatedTradingAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRelatedTradingAccounts<TData = Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRelatedTradingAccounts>>,
          TError,
          Awaited<ReturnType<typeof getRelatedTradingAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRelatedTradingAccounts<TData = Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get related trading accounts
 */

export function useGetRelatedTradingAccounts<TData = Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRelatedTradingAccountsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get related trading accounts
 */
export const prefetchGetRelatedTradingAccountsQuery = async <TData = Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRelatedTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetRelatedTradingAccountsQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get trading account details
 */
export const getTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DetailedTradingAccount>(
      {url: `/admin/api/trading_accounts/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetTradingAccountQueryKey = (id: number,) => {
    return [
    'admin','api','trading_accounts',id
    ] as const;
    }


export const getGetTradingAccountQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccount>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccount>>> = ({ signal }) => getTradingAccount(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccount>>>
export type GetTradingAccountQueryError = N404Response | N500Response


export function useGetTradingAccount<TData = Awaited<ReturnType<typeof getTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccount<TData = Awaited<ReturnType<typeof getTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccount<TData = Awaited<ReturnType<typeof getTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get trading account details
 */

export function useGetTradingAccount<TData = Awaited<ReturnType<typeof getTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get trading account details
 */
export const prefetchGetTradingAccountQuery = async <TData = Awaited<ReturnType<typeof getTradingAccount>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update trading account
 */
export const updateTradingAccount = (
    id: number,
    tradingAccountUpdateRequest: TradingAccountUpdateRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountUpdateResponse>(
      {url: `/admin/api/trading_accounts/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountUpdateRequest, signal
    },
      options);
    }




export const getUpdateTradingAccountMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTradingAccount>>, TError,{id: number;data: TradingAccountUpdateRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTradingAccount>>, TError,{id: number;data: TradingAccountUpdateRequest}, TContext> => {

const mutationKey = ['updateTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTradingAccount>>, {id: number;data: TradingAccountUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateTradingAccount>>>
    export type UpdateTradingAccountMutationBody = TradingAccountUpdateRequest
    export type UpdateTradingAccountMutationError = N404Response | N500Response

    /**
 * @summary Update trading account
 */
export const useUpdateTradingAccount = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTradingAccount>>, TError,{id: number;data: TradingAccountUpdateRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTradingAccount>>,
        TError,
        {id: number;data: TradingAccountUpdateRequest},
        TContext
      > => {
      return useMutation(getUpdateTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Get editable attributes for trading account
 */
export const editTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountEditResponse>(
      {url: `/admin/api/trading_accounts/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getEditTradingAccountQueryKey = (id: number,) => {
    return [
    'admin','api','trading_accounts',id,'edit'
    ] as const;
    }


export const getEditTradingAccountQueryOptions = <TData = Awaited<ReturnType<typeof editTradingAccount>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEditTradingAccountQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof editTradingAccount>>> = ({ signal }) => editTradingAccount(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof editTradingAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EditTradingAccountQueryResult = NonNullable<Awaited<ReturnType<typeof editTradingAccount>>>
export type EditTradingAccountQueryError = N404Response | N500Response


export function useEditTradingAccount<TData = Awaited<ReturnType<typeof editTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof editTradingAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof editTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof editTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEditTradingAccount<TData = Awaited<ReturnType<typeof editTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editTradingAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof editTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof editTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEditTradingAccount<TData = Awaited<ReturnType<typeof editTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get editable attributes for trading account
 */

export function useEditTradingAccount<TData = Awaited<ReturnType<typeof editTradingAccount>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEditTradingAccountQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get editable attributes for trading account
 */
export const prefetchEditTradingAccountQuery = async <TData = Awaited<ReturnType<typeof editTradingAccount>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getEditTradingAccountQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Retrieves the modal configuration for a specific trading account action that requires parameters.
 *
 * When listing trading accounts, each resource includes an `actions` array describing available operations.
 * - If `require_params = true`, the client must first call this endpoint to fetch the form schema before executing the action.
 * - If `require_params = false`, the action can be invoked directly without this preliminary step.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *       - `button` — a generic control (link, secondary action, etc.)
 *     - **Optional** `action` (object): if present, mirrors a full action descriptor (same shape as in the main `actions` array), indicating that clicking this button should invoke that action (possibly fetching its own form if `require_params = true`).
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary List modal information along with list of params needed for a specific trading account action
 */
export const listTradingAccountActionParams = (
    id: number,
    params: ListTradingAccountActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<FormParamsSchema>(
      {url: `/admin/api/trading_accounts/${id}/actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTradingAccountActionParamsQueryKey = (id: number,
    params?: ListTradingAccountActionParamsParams,) => {
    return [
    'admin','api','trading_accounts',id,'actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingAccountActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError = N404Response | N500Response>(id: number,
    params: ListTradingAccountActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingAccountActionParamsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingAccountActionParams>>> = ({ signal }) => listTradingAccountActionParams(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingAccountActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingAccountActionParams>>>
export type ListTradingAccountActionParamsQueryError = N404Response | N500Response


export function useListTradingAccountActionParams<TData = Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTradingAccountActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingAccountActionParams>>,
          TError,
          Awaited<ReturnType<typeof listTradingAccountActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingAccountActionParams<TData = Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTradingAccountActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingAccountActionParams>>,
          TError,
          Awaited<ReturnType<typeof listTradingAccountActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingAccountActionParams<TData = Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTradingAccountActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List modal information along with list of params needed for a specific trading account action
 */

export function useListTradingAccountActionParams<TData = Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTradingAccountActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingAccountActionParamsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List modal information along with list of params needed for a specific trading account action
 */
export const prefetchListTradingAccountActionParamsQuery = async <TData = Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params: ListTradingAccountActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTradingAccountActionParamsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Close trading account
 */
export const closeTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/close`, method: 'POST', signal
    },
      options);
    }




export const getCloseTradingAccountMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof closeTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['closeTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  closeTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof closeTradingAccount>>>

    export type CloseTradingAccountMutationError = N404Response | N500Response

    /**
 * @summary Close trading account
 */
export const useCloseTradingAccount = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCloseTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Refund trading account
 */
export const refundTradingAccount = (
    id: number,
    tradingAccountRefundRequest: TradingAccountRefundRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountRefundRequest, signal
    },
      options);
    }




export const getRefundTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundTradingAccount>>, TError,{id: number;data: TradingAccountRefundRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refundTradingAccount>>, TError,{id: number;data: TradingAccountRefundRequest}, TContext> => {

const mutationKey = ['refundTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refundTradingAccount>>, {id: number;data: TradingAccountRefundRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  refundTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefundTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof refundTradingAccount>>>
    export type RefundTradingAccountMutationBody = TradingAccountRefundRequest
    export type RefundTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Refund trading account
 */
export const useRefundTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundTradingAccount>>, TError,{id: number;data: TradingAccountRefundRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refundTradingAccount>>,
        TError,
        {id: number;data: TradingAccountRefundRequest},
        TContext
      > => {
      return useMutation(getRefundTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Reset password of trading account
 */
export const resetPasswordTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/reset_password`, method: 'POST', signal
    },
      options);
    }




export const getResetPasswordTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPasswordTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPasswordTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['resetPasswordTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPasswordTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  resetPasswordTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof resetPasswordTradingAccount>>>

    export type ResetPasswordTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Reset password of trading account
 */
export const useResetPasswordTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPasswordTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPasswordTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getResetPasswordTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Send email to trading account
 */
export const sendEmailToTradingAccount = (
    id: number,
    tradingAccountSendEmailRequest: TradingAccountSendEmailRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/send_email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountSendEmailRequest, signal
    },
      options);
    }




export const getSendEmailToTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToTradingAccount>>, TError,{id: number;data: TradingAccountSendEmailRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmailToTradingAccount>>, TError,{id: number;data: TradingAccountSendEmailRequest}, TContext> => {

const mutationKey = ['sendEmailToTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmailToTradingAccount>>, {id: number;data: TradingAccountSendEmailRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  sendEmailToTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailToTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmailToTradingAccount>>>
    export type SendEmailToTradingAccountMutationBody = TradingAccountSendEmailRequest
    export type SendEmailToTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Send email to trading account
 */
export const useSendEmailToTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailToTradingAccount>>, TError,{id: number;data: TradingAccountSendEmailRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendEmailToTradingAccount>>,
        TError,
        {id: number;data: TradingAccountSendEmailRequest},
        TContext
      > => {
      return useMutation(getSendEmailToTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Violate a trading account
 */
export const violateTradingAccount = (
    id: number,
    tradingAccountViolateRequest: TradingAccountViolateRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/violate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountViolateRequest, signal
    },
      options);
    }




export const getViolateTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof violateTradingAccount>>, TError,{id: number;data: TradingAccountViolateRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof violateTradingAccount>>, TError,{id: number;data: TradingAccountViolateRequest}, TContext> => {

const mutationKey = ['violateTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof violateTradingAccount>>, {id: number;data: TradingAccountViolateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  violateTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ViolateTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof violateTradingAccount>>>
    export type ViolateTradingAccountMutationBody = TradingAccountViolateRequest
    export type ViolateTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Violate a trading account
 */
export const useViolateTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof violateTradingAccount>>, TError,{id: number;data: TradingAccountViolateRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof violateTradingAccount>>,
        TError,
        {id: number;data: TradingAccountViolateRequest},
        TContext
      > => {
      return useMutation(getViolateTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Reactivate a trading account
 */
export const reactivateTradingAccount = (
    id: number,
    tradingAccountReactivateRequest: TradingAccountReactivateRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/reactivate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountReactivateRequest, signal
    },
      options);
    }




export const getReactivateTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateTradingAccount>>, TError,{id: number;data: TradingAccountReactivateRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivateTradingAccount>>, TError,{id: number;data: TradingAccountReactivateRequest}, TContext> => {

const mutationKey = ['reactivateTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateTradingAccount>>, {id: number;data: TradingAccountReactivateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  reactivateTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateTradingAccount>>>
    export type ReactivateTradingAccountMutationBody = TradingAccountReactivateRequest
    export type ReactivateTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Reactivate a trading account
 */
export const useReactivateTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateTradingAccount>>, TError,{id: number;data: TradingAccountReactivateRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivateTradingAccount>>,
        TError,
        {id: number;data: TradingAccountReactivateRequest},
        TContext
      > => {
      return useMutation(getReactivateTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Change leverage of a trading account
 */
export const changeLeverageTradingAccount = (
    id: number,
    tradingAccountChangeLeverageRequest: TradingAccountChangeLeverageRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/change_leverage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountChangeLeverageRequest, signal
    },
      options);
    }




export const getChangeLeverageTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeLeverageTradingAccount>>, TError,{id: number;data: TradingAccountChangeLeverageRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeLeverageTradingAccount>>, TError,{id: number;data: TradingAccountChangeLeverageRequest}, TContext> => {

const mutationKey = ['changeLeverageTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeLeverageTradingAccount>>, {id: number;data: TradingAccountChangeLeverageRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  changeLeverageTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeLeverageTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof changeLeverageTradingAccount>>>
    export type ChangeLeverageTradingAccountMutationBody = TradingAccountChangeLeverageRequest
    export type ChangeLeverageTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Change leverage of a trading account
 */
export const useChangeLeverageTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeLeverageTradingAccount>>, TError,{id: number;data: TradingAccountChangeLeverageRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeLeverageTradingAccount>>,
        TError,
        {id: number;data: TradingAccountChangeLeverageRequest},
        TContext
      > => {
      return useMutation(getChangeLeverageTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Change group of a trading account
 */
export const changeGroupTradingAccount = (
    id: number,
    tradingAccountChangeGroupRequest: TradingAccountChangeGroupRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/change_group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountChangeGroupRequest, signal
    },
      options);
    }




export const getChangeGroupTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeGroupTradingAccount>>, TError,{id: number;data: TradingAccountChangeGroupRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeGroupTradingAccount>>, TError,{id: number;data: TradingAccountChangeGroupRequest}, TContext> => {

const mutationKey = ['changeGroupTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeGroupTradingAccount>>, {id: number;data: TradingAccountChangeGroupRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  changeGroupTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeGroupTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof changeGroupTradingAccount>>>
    export type ChangeGroupTradingAccountMutationBody = TradingAccountChangeGroupRequest
    export type ChangeGroupTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Change group of a trading account
 */
export const useChangeGroupTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeGroupTradingAccount>>, TError,{id: number;data: TradingAccountChangeGroupRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeGroupTradingAccount>>,
        TError,
        {id: number;data: TradingAccountChangeGroupRequest},
        TContext
      > => {
      return useMutation(getChangeGroupTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Enable trading for a given trading account
 */
export const enableTradingForTradingAccount = (
    id: number,
    tradingAccountEnableTradingRequest?: TradingAccountEnableTradingRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/enable_trading`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountEnableTradingRequest, signal
    },
      options);
    }




export const getEnableTradingForTradingAccountMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTradingForTradingAccount>>, TError,{id: number;data?: TradingAccountEnableTradingRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enableTradingForTradingAccount>>, TError,{id: number;data?: TradingAccountEnableTradingRequest}, TContext> => {

const mutationKey = ['enableTradingForTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableTradingForTradingAccount>>, {id: number;data?: TradingAccountEnableTradingRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  enableTradingForTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableTradingForTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof enableTradingForTradingAccount>>>
    export type EnableTradingForTradingAccountMutationBody = TradingAccountEnableTradingRequest | undefined
    export type EnableTradingForTradingAccountMutationError = N404Response | N500Response

    /**
 * @summary Enable trading for a given trading account
 */
export const useEnableTradingForTradingAccount = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableTradingForTradingAccount>>, TError,{id: number;data?: TradingAccountEnableTradingRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableTradingForTradingAccount>>,
        TError,
        {id: number;data?: TradingAccountEnableTradingRequest},
        TContext
      > => {
      return useMutation(getEnableTradingForTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Disable trading for a given trading account
 */
export const disableTradingForTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/disable_trading`, method: 'PATCH', signal
    },
      options);
    }




export const getDisableTradingForTradingAccountMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTradingForTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disableTradingForTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['disableTradingForTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableTradingForTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  disableTradingForTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableTradingForTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof disableTradingForTradingAccount>>>

    export type DisableTradingForTradingAccountMutationError = N404Response | N500Response

    /**
 * @summary Disable trading for a given trading account
 */
export const useDisableTradingForTradingAccount = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableTradingForTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableTradingForTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDisableTradingForTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Add new trading rule to a trading account
 */
export const addNewRule = (
    id: number,
    tradingAccountAddNewRuleRequest: TradingAccountAddNewRuleRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/add_new_rule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountAddNewRuleRequest, signal
    },
      options);
    }




export const getAddNewRuleMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewRule>>, TError,{id: number;data: TradingAccountAddNewRuleRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addNewRule>>, TError,{id: number;data: TradingAccountAddNewRuleRequest}, TContext> => {

const mutationKey = ['addNewRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addNewRule>>, {id: number;data: TradingAccountAddNewRuleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addNewRule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddNewRuleMutationResult = NonNullable<Awaited<ReturnType<typeof addNewRule>>>
    export type AddNewRuleMutationBody = TradingAccountAddNewRuleRequest
    export type AddNewRuleMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Add new trading rule to a trading account
 */
export const useAddNewRule = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNewRule>>, TError,{id: number;data: TradingAccountAddNewRuleRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addNewRule>>,
        TError,
        {id: number;data: TradingAccountAddNewRuleRequest},
        TContext
      > => {
      return useMutation(getAddNewRuleMutationOptions(options), queryClient);
    }

/**
 * @summary Onboard a given trading account
 */
export const onboardTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/onboard`, method: 'POST', signal
    },
      options);
    }




export const getOnboardTradingAccountMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof onboardTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['onboardTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof onboardTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  onboardTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OnboardTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof onboardTradingAccount>>>

    export type OnboardTradingAccountMutationError = N404Response | N500Response

    /**
 * @summary Onboard a given trading account
 */
export const useOnboardTradingAccount = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof onboardTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof onboardTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getOnboardTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Perform full sync for a given trading account
 */
export const performFullSyncForTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/perform_full_sync`, method: 'POST', signal
    },
      options);
    }




export const getPerformFullSyncForTradingAccountMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof performFullSyncForTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof performFullSyncForTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['performFullSyncForTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof performFullSyncForTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  performFullSyncForTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PerformFullSyncForTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof performFullSyncForTradingAccount>>>

    export type PerformFullSyncForTradingAccountMutationError = N404Response | N500Response

    /**
 * @summary Perform full sync for a given trading account
 */
export const usePerformFullSyncForTradingAccount = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof performFullSyncForTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof performFullSyncForTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPerformFullSyncForTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Perform migration on a trading account
 */
export const performMigrationTradingAccount = (
    id: number,
    tradingAccountPerformMigrationRequest: TradingAccountPerformMigrationRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/perform_migration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountPerformMigrationRequest, signal
    },
      options);
    }




export const getPerformMigrationTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof performMigrationTradingAccount>>, TError,{id: number;data: TradingAccountPerformMigrationRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof performMigrationTradingAccount>>, TError,{id: number;data: TradingAccountPerformMigrationRequest}, TContext> => {

const mutationKey = ['performMigrationTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof performMigrationTradingAccount>>, {id: number;data: TradingAccountPerformMigrationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  performMigrationTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PerformMigrationTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof performMigrationTradingAccount>>>
    export type PerformMigrationTradingAccountMutationBody = TradingAccountPerformMigrationRequest
    export type PerformMigrationTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Perform migration on a trading account
 */
export const usePerformMigrationTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof performMigrationTradingAccount>>, TError,{id: number;data: TradingAccountPerformMigrationRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof performMigrationTradingAccount>>,
        TError,
        {id: number;data: TradingAccountPerformMigrationRequest},
        TContext
      > => {
      return useMutation(getPerformMigrationTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Set payout cycle for trading account
 */
export const setPayoutCycleTradingAccount = (
    id: number,
    tradingAccountSetPayoutCycleRequest: TradingAccountSetPayoutCycleRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/set_payout_cycle`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountSetPayoutCycleRequest, signal
    },
      options);
    }




export const getSetPayoutCycleTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPayoutCycleTradingAccount>>, TError,{id: number;data: TradingAccountSetPayoutCycleRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPayoutCycleTradingAccount>>, TError,{id: number;data: TradingAccountSetPayoutCycleRequest}, TContext> => {

const mutationKey = ['setPayoutCycleTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPayoutCycleTradingAccount>>, {id: number;data: TradingAccountSetPayoutCycleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  setPayoutCycleTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPayoutCycleTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof setPayoutCycleTradingAccount>>>
    export type SetPayoutCycleTradingAccountMutationBody = TradingAccountSetPayoutCycleRequest
    export type SetPayoutCycleTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Set payout cycle for trading account
 */
export const useSetPayoutCycleTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPayoutCycleTradingAccount>>, TError,{id: number;data: TradingAccountSetPayoutCycleRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPayoutCycleTradingAccount>>,
        TError,
        {id: number;data: TradingAccountSetPayoutCycleRequest},
        TContext
      > => {
      return useMutation(getSetPayoutCycleTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Approve a trading account
 */
export const approveTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/approve`, method: 'POST', signal
    },
      options);
    }




export const getApproveTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['approveTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approveTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof approveTradingAccount>>>

    export type ApproveTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Approve a trading account
 */
export const useApproveTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApproveTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Reject a trading account for TC violation
 */
export const rejectTcViolationTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/reject_tc_violation`, method: 'POST', signal
    },
      options);
    }




export const getRejectTcViolationTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTcViolationTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectTcViolationTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['rejectTcViolationTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectTcViolationTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  rejectTcViolationTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectTcViolationTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof rejectTcViolationTradingAccount>>>

    export type RejectTcViolationTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Reject a trading account for TC violation
 */
export const useRejectTcViolationTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectTcViolationTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectTcViolationTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRejectTcViolationTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Cancel a raised RTP violation on a trading account
 */
export const cancelRtpViolationTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/cancel_rtp_violation`, method: 'POST', signal
    },
      options);
    }




export const getCancelRtpViolationTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRtpViolationTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRtpViolationTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelRtpViolationTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRtpViolationTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelRtpViolationTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRtpViolationTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRtpViolationTradingAccount>>>

    export type CancelRtpViolationTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Cancel a raised RTP violation on a trading account
 */
export const useCancelRtpViolationTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRtpViolationTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelRtpViolationTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelRtpViolationTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Scale up trading account
 */
export const scaleUpTradingAccount = (
    id: number,
    tradingAccountScaleUpRequest: TradingAccountScaleUpRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/scale_up`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradingAccountScaleUpRequest, signal
    },
      options);
    }




export const getScaleUpTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scaleUpTradingAccount>>, TError,{id: number;data: TradingAccountScaleUpRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scaleUpTradingAccount>>, TError,{id: number;data: TradingAccountScaleUpRequest}, TContext> => {

const mutationKey = ['scaleUpTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scaleUpTradingAccount>>, {id: number;data: TradingAccountScaleUpRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  scaleUpTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScaleUpTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof scaleUpTradingAccount>>>
    export type ScaleUpTradingAccountMutationBody = TradingAccountScaleUpRequest
    export type ScaleUpTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Scale up trading account
 */
export const useScaleUpTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scaleUpTradingAccount>>, TError,{id: number;data: TradingAccountScaleUpRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scaleUpTradingAccount>>,
        TError,
        {id: number;data: TradingAccountScaleUpRequest},
        TContext
      > => {
      return useMutation(getScaleUpTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Initiate a prime upgrade for a master trading account
 */
export const initiatePrimeUpgradeTradingAccount = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountActionResponse>(
      {url: `/admin/api/trading_accounts/${id}/initiate_prime_upgrade`, method: 'POST', signal
    },
      options);
    }




export const getInitiatePrimeUpgradeTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePrimeUpgradeTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof initiatePrimeUpgradeTradingAccount>>, TError,{id: number}, TContext> => {

const mutationKey = ['initiatePrimeUpgradeTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiatePrimeUpgradeTradingAccount>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  initiatePrimeUpgradeTradingAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiatePrimeUpgradeTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof initiatePrimeUpgradeTradingAccount>>>

    export type InitiatePrimeUpgradeTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Initiate a prime upgrade for a master trading account
 */
export const useInitiatePrimeUpgradeTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePrimeUpgradeTradingAccount>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiatePrimeUpgradeTradingAccount>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getInitiatePrimeUpgradeTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Generate evidence report for trading accounts
 */
export const generateEvidenceReportTradingAccount = (
    id: number,
    generateEvidenceReportRequest: GenerateEvidenceReportRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Blob>(
      {url: `/admin/api/trading_accounts/${id}/generate_evidence_report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateEvidenceReportRequest,
        responseType: 'blob', signal
    },
      options);
    }




export const getGenerateEvidenceReportTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEvidenceReportTradingAccount>>, TError,{id: number;data: GenerateEvidenceReportRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateEvidenceReportTradingAccount>>, TError,{id: number;data: GenerateEvidenceReportRequest}, TContext> => {

const mutationKey = ['generateEvidenceReportTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateEvidenceReportTradingAccount>>, {id: number;data: GenerateEvidenceReportRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  generateEvidenceReportTradingAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateEvidenceReportTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof generateEvidenceReportTradingAccount>>>
    export type GenerateEvidenceReportTradingAccountMutationBody = GenerateEvidenceReportRequest
    export type GenerateEvidenceReportTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Generate evidence report for trading accounts
 */
export const useGenerateEvidenceReportTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEvidenceReportTradingAccount>>, TError,{id: number;data: GenerateEvidenceReportRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateEvidenceReportTradingAccount>>,
        TError,
        {id: number;data: GenerateEvidenceReportRequest},
        TContext
      > => {
      return useMutation(getGenerateEvidenceReportTradingAccountMutationOptions(options), queryClient);
    }

/**
 * Retrieves the modal configuration for a specific bulk action that requires parameters.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary List modal information along with list of params needed for trading accounts bulk action
 */
export const listTradingAccountBulkActionParams = (
    params: ListTradingAccountBulkActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BulkFormParamsSchema>(
      {url: `/admin/api/trading_accounts/bulk_actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTradingAccountBulkActionParamsQueryKey = (params?: ListTradingAccountBulkActionParamsParams,) => {
    return [
    'admin','api','trading_accounts','bulk_actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListTradingAccountBulkActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError = N404Response | N500Response>(params: ListTradingAccountBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTradingAccountBulkActionParamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>> = ({ signal }) => listTradingAccountBulkActionParams(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTradingAccountBulkActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>>
export type ListTradingAccountBulkActionParamsQueryError = N404Response | N500Response


export function useListTradingAccountBulkActionParams<TData = Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListTradingAccountBulkActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>,
          TError,
          Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingAccountBulkActionParams<TData = Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListTradingAccountBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>,
          TError,
          Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTradingAccountBulkActionParams<TData = Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListTradingAccountBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List modal information along with list of params needed for trading accounts bulk action
 */

export function useListTradingAccountBulkActionParams<TData = Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError = N404Response | N500Response>(
 params: ListTradingAccountBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTradingAccountBulkActionParamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List modal information along with list of params needed for trading accounts bulk action
 */
export const prefetchListTradingAccountBulkActionParamsQuery = async <TData = Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params: ListTradingAccountBulkActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTradingAccountBulkActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTradingAccountBulkActionParamsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create bulk reactivate task for trading accounts
 */
export const createBulkTradingAccountReactivateTask = (
    createBulkReactivateTask: CreateBulkReactivateTask,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountBulkActionResponse>(
      {url: `/admin/api/trading_accounts/bulk_actions/create_reactivate_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkReactivateTask, signal
    },
      options);
    }




export const getCreateBulkTradingAccountReactivateTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountReactivateTask>>, TError,{data: CreateBulkReactivateTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountReactivateTask>>, TError,{data: CreateBulkReactivateTask}, TContext> => {

const mutationKey = ['createBulkTradingAccountReactivateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkTradingAccountReactivateTask>>, {data: CreateBulkReactivateTask}> = (props) => {
          const {data} = props ?? {};

          return  createBulkTradingAccountReactivateTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkTradingAccountReactivateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkTradingAccountReactivateTask>>>
    export type CreateBulkTradingAccountReactivateTaskMutationBody = CreateBulkReactivateTask
    export type CreateBulkTradingAccountReactivateTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create bulk reactivate task for trading accounts
 */
export const useCreateBulkTradingAccountReactivateTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountReactivateTask>>, TError,{data: CreateBulkReactivateTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkTradingAccountReactivateTask>>,
        TError,
        {data: CreateBulkReactivateTask},
        TContext
      > => {
      return useMutation(getCreateBulkTradingAccountReactivateTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Create bulk violate task for trading accounts
 */
export const createBulkTradingAccountViolateTask = (
    createBulkViolateTask: CreateBulkViolateTask,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountBulkActionResponse>(
      {url: `/admin/api/trading_accounts/bulk_actions/create_violate_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkViolateTask, signal
    },
      options);
    }




export const getCreateBulkTradingAccountViolateTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountViolateTask>>, TError,{data: CreateBulkViolateTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountViolateTask>>, TError,{data: CreateBulkViolateTask}, TContext> => {

const mutationKey = ['createBulkTradingAccountViolateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkTradingAccountViolateTask>>, {data: CreateBulkViolateTask}> = (props) => {
          const {data} = props ?? {};

          return  createBulkTradingAccountViolateTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkTradingAccountViolateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkTradingAccountViolateTask>>>
    export type CreateBulkTradingAccountViolateTaskMutationBody = CreateBulkViolateTask
    export type CreateBulkTradingAccountViolateTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create bulk violate task for trading accounts
 */
export const useCreateBulkTradingAccountViolateTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountViolateTask>>, TError,{data: CreateBulkViolateTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkTradingAccountViolateTask>>,
        TError,
        {data: CreateBulkViolateTask},
        TContext
      > => {
      return useMutation(getCreateBulkTradingAccountViolateTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Create bulk approve task for trading accounts
 */
export const createBulkTradingAccountApproveTask = (
    createBulkApproveTask: CreateBulkApproveTask,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountBulkActionResponse>(
      {url: `/admin/api/trading_accounts/bulk_actions/create_approve_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkApproveTask, signal
    },
      options);
    }




export const getCreateBulkTradingAccountApproveTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountApproveTask>>, TError,{data: CreateBulkApproveTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountApproveTask>>, TError,{data: CreateBulkApproveTask}, TContext> => {

const mutationKey = ['createBulkTradingAccountApproveTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkTradingAccountApproveTask>>, {data: CreateBulkApproveTask}> = (props) => {
          const {data} = props ?? {};

          return  createBulkTradingAccountApproveTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkTradingAccountApproveTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkTradingAccountApproveTask>>>
    export type CreateBulkTradingAccountApproveTaskMutationBody = CreateBulkApproveTask
    export type CreateBulkTradingAccountApproveTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create bulk approve task for trading accounts
 */
export const useCreateBulkTradingAccountApproveTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountApproveTask>>, TError,{data: CreateBulkApproveTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkTradingAccountApproveTask>>,
        TError,
        {data: CreateBulkApproveTask},
        TContext
      > => {
      return useMutation(getCreateBulkTradingAccountApproveTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Create bulk disable trading task for trading accounts
 */
export const createBulkTradingAccountDisableTradingTask = (
    createBulkDisableTradingTask: CreateBulkDisableTradingTask,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountBulkActionResponse>(
      {url: `/admin/api/trading_accounts/bulk_actions/create_disable_trading_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkDisableTradingTask, signal
    },
      options);
    }




export const getCreateBulkTradingAccountDisableTradingTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountDisableTradingTask>>, TError,{data: CreateBulkDisableTradingTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountDisableTradingTask>>, TError,{data: CreateBulkDisableTradingTask}, TContext> => {

const mutationKey = ['createBulkTradingAccountDisableTradingTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkTradingAccountDisableTradingTask>>, {data: CreateBulkDisableTradingTask}> = (props) => {
          const {data} = props ?? {};

          return  createBulkTradingAccountDisableTradingTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkTradingAccountDisableTradingTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkTradingAccountDisableTradingTask>>>
    export type CreateBulkTradingAccountDisableTradingTaskMutationBody = CreateBulkDisableTradingTask
    export type CreateBulkTradingAccountDisableTradingTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create bulk disable trading task for trading accounts
 */
export const useCreateBulkTradingAccountDisableTradingTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountDisableTradingTask>>, TError,{data: CreateBulkDisableTradingTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkTradingAccountDisableTradingTask>>,
        TError,
        {data: CreateBulkDisableTradingTask},
        TContext
      > => {
      return useMutation(getCreateBulkTradingAccountDisableTradingTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Create bulk onboarding task for trading accounts
 */
export const createBulkTradingAccountEnableTradingTask = (
    createBulkOnboardingTask: CreateBulkOnboardingTask,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountBulkActionResponse>(
      {url: `/admin/api/trading_accounts/bulk_actions/create_onboarding_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkOnboardingTask, signal
    },
      options);
    }




export const getCreateBulkTradingAccountEnableTradingTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountEnableTradingTask>>, TError,{data: CreateBulkOnboardingTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountEnableTradingTask>>, TError,{data: CreateBulkOnboardingTask}, TContext> => {

const mutationKey = ['createBulkTradingAccountEnableTradingTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkTradingAccountEnableTradingTask>>, {data: CreateBulkOnboardingTask}> = (props) => {
          const {data} = props ?? {};

          return  createBulkTradingAccountEnableTradingTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkTradingAccountEnableTradingTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkTradingAccountEnableTradingTask>>>
    export type CreateBulkTradingAccountEnableTradingTaskMutationBody = CreateBulkOnboardingTask
    export type CreateBulkTradingAccountEnableTradingTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create bulk onboarding task for trading accounts
 */
export const useCreateBulkTradingAccountEnableTradingTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountEnableTradingTask>>, TError,{data: CreateBulkOnboardingTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkTradingAccountEnableTradingTask>>,
        TError,
        {data: CreateBulkOnboardingTask},
        TContext
      > => {
      return useMutation(getCreateBulkTradingAccountEnableTradingTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Create bulk send email by login task for trading accounts
 */
export const createBulkTradingAccountSendEmailByLoginTask = (
    createBulkSendEmailByLoginTask: CreateBulkSendEmailByLoginTask,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTradingAccountBulkActionResponse>(
      {url: `/admin/api/trading_accounts/bulk_actions/create_send_email_by_login_task`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkSendEmailByLoginTask, signal
    },
      options);
    }




export const getCreateBulkTradingAccountSendEmailByLoginTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountSendEmailByLoginTask>>, TError,{data: CreateBulkSendEmailByLoginTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountSendEmailByLoginTask>>, TError,{data: CreateBulkSendEmailByLoginTask}, TContext> => {

const mutationKey = ['createBulkTradingAccountSendEmailByLoginTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkTradingAccountSendEmailByLoginTask>>, {data: CreateBulkSendEmailByLoginTask}> = (props) => {
          const {data} = props ?? {};

          return  createBulkTradingAccountSendEmailByLoginTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkTradingAccountSendEmailByLoginTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkTradingAccountSendEmailByLoginTask>>>
    export type CreateBulkTradingAccountSendEmailByLoginTaskMutationBody = CreateBulkSendEmailByLoginTask
    export type CreateBulkTradingAccountSendEmailByLoginTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create bulk send email by login task for trading accounts
 */
export const useCreateBulkTradingAccountSendEmailByLoginTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkTradingAccountSendEmailByLoginTask>>, TError,{data: CreateBulkSendEmailByLoginTask}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkTradingAccountSendEmailByLoginTask>>,
        TError,
        {data: CreateBulkSendEmailByLoginTask},
        TContext
      > => {
      return useMutation(getCreateBulkTradingAccountSendEmailByLoginTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Get 1000 IP activities for a trading account
 */
export const getTradingAccountIpActivities = (
    tradingAccountId: number,
    params?: GetTradingAccountIpActivitiesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountIpActivitiesResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/ip_activities`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountIpActivitiesQueryKey = (tradingAccountId: number,
    params?: GetTradingAccountIpActivitiesParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'ip_activities', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountIpActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetTradingAccountIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountIpActivitiesQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountIpActivities>>> = ({ signal }) => getTradingAccountIpActivities(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountIpActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountIpActivities>>>
export type GetTradingAccountIpActivitiesQueryError = N404Response | N500Response


export function useGetTradingAccountIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetTradingAccountIpActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get 1000 IP activities for a trading account
 */

export function useGetTradingAccountIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountIpActivitiesQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get 1000 IP activities for a trading account
 */
export const prefetchGetTradingAccountIpActivitiesQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetTradingAccountIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountIpActivitiesQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get filter metadata for ip activities of a trading account
 */
export const getTradingAccountFilterMetadataIpActivities = (
    tradingAccountId: number,
    params?: GetTradingAccountFilterMetadataIpActivitiesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountIpActivitiesFilterMetadataResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/ip_activities/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountFilterMetadataIpActivitiesQueryKey = (tradingAccountId: number,
    params?: GetTradingAccountFilterMetadataIpActivitiesParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'ip_activities','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountFilterMetadataIpActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetTradingAccountFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountFilterMetadataIpActivitiesQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>> = ({ signal }) => getTradingAccountFilterMetadataIpActivities(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountFilterMetadataIpActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>>
export type GetTradingAccountFilterMetadataIpActivitiesQueryError = N404Response | N500Response


export function useGetTradingAccountFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetTradingAccountFilterMetadataIpActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata for ip activities of a trading account
 */

export function useGetTradingAccountFilterMetadataIpActivities<TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountFilterMetadataIpActivitiesQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata for ip activities of a trading account
 */
export const prefetchGetTradingAccountFilterMetadataIpActivitiesQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetTradingAccountFilterMetadataIpActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountFilterMetadataIpActivities>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountFilterMetadataIpActivitiesQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Request trades from risk engine
 */
export const requestTradesFromRiskEngine = (
    tradingAccountId: number,
    params: RequestTradesFromRiskEngineParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewTradingEvidenceReportResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/trading_evidence_reports/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRequestTradesFromRiskEngineQueryKey = (tradingAccountId: number,
    params?: RequestTradesFromRiskEngineParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'trading_evidence_reports','new', ...(params ? [params] : [])
    ] as const;
    }


export const getRequestTradesFromRiskEngineQueryOptions = <TData = Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError = N404Response | N422Response | N500Response>(tradingAccountId: number,
    params: RequestTradesFromRiskEngineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequestTradesFromRiskEngineQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>> = ({ signal }) => requestTradesFromRiskEngine(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequestTradesFromRiskEngineQueryResult = NonNullable<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>>
export type RequestTradesFromRiskEngineQueryError = N404Response | N422Response | N500Response


export function useRequestTradesFromRiskEngine<TData = Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    params: RequestTradesFromRiskEngineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestTradesFromRiskEngine>>,
          TError,
          Awaited<ReturnType<typeof requestTradesFromRiskEngine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestTradesFromRiskEngine<TData = Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    params: RequestTradesFromRiskEngineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestTradesFromRiskEngine>>,
          TError,
          Awaited<ReturnType<typeof requestTradesFromRiskEngine>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestTradesFromRiskEngine<TData = Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    params: RequestTradesFromRiskEngineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request trades from risk engine
 */

export function useRequestTradesFromRiskEngine<TData = Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    params: RequestTradesFromRiskEngineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequestTradesFromRiskEngineQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Request trades from risk engine
 */
export const prefetchRequestTradesFromRiskEngineQuery = async <TData = Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params: RequestTradesFromRiskEngineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestTradesFromRiskEngine>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getRequestTradesFromRiskEngineQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Generate evidence report for trading accounts
 */
export const generateEvidenceReportForTradingAccount = (
    tradingAccountId: number,
    generateSelectedTradesEvidenceReportRequest: GenerateSelectedTradesEvidenceReportRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Blob>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/trading_evidence_reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateSelectedTradesEvidenceReportRequest,
        responseType: 'blob', signal
    },
      options);
    }




export const getGenerateEvidenceReportForTradingAccountMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEvidenceReportForTradingAccount>>, TError,{tradingAccountId: number;data: GenerateSelectedTradesEvidenceReportRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateEvidenceReportForTradingAccount>>, TError,{tradingAccountId: number;data: GenerateSelectedTradesEvidenceReportRequest}, TContext> => {

const mutationKey = ['generateEvidenceReportForTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateEvidenceReportForTradingAccount>>, {tradingAccountId: number;data: GenerateSelectedTradesEvidenceReportRequest}> = (props) => {
          const {tradingAccountId,data} = props ?? {};

          return  generateEvidenceReportForTradingAccount(tradingAccountId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateEvidenceReportForTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof generateEvidenceReportForTradingAccount>>>
    export type GenerateEvidenceReportForTradingAccountMutationBody = GenerateSelectedTradesEvidenceReportRequest
    export type GenerateEvidenceReportForTradingAccountMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Generate evidence report for trading accounts
 */
export const useGenerateEvidenceReportForTradingAccount = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEvidenceReportForTradingAccount>>, TError,{tradingAccountId: number;data: GenerateSelectedTradesEvidenceReportRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateEvidenceReportForTradingAccount>>,
        TError,
        {tradingAccountId: number;data: GenerateSelectedTradesEvidenceReportRequest},
        TContext
      > => {
      return useMutation(getGenerateEvidenceReportForTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Request parameters for a risk parameter creation
 */
export const riskParametersNew = (
    tradingAccountId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewRiskParameterResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/risk_parameters/new`, method: 'GET', signal
    },
      options);
    }




export const getRiskParametersNewQueryKey = (tradingAccountId: number,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'risk_parameters','new'
    ] as const;
    }


export const getRiskParametersNewQueryOptions = <TData = Awaited<ReturnType<typeof riskParametersNew>>, TError = N404Response | N422Response | N500Response>(tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRiskParametersNewQueryKey(tradingAccountId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof riskParametersNew>>> = ({ signal }) => riskParametersNew(tradingAccountId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof riskParametersNew>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RiskParametersNewQueryResult = NonNullable<Awaited<ReturnType<typeof riskParametersNew>>>
export type RiskParametersNewQueryError = N404Response | N422Response | N500Response


export function useRiskParametersNew<TData = Awaited<ReturnType<typeof riskParametersNew>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersNew>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskParametersNew>>,
          TError,
          Awaited<ReturnType<typeof riskParametersNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskParametersNew<TData = Awaited<ReturnType<typeof riskParametersNew>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersNew>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskParametersNew>>,
          TError,
          Awaited<ReturnType<typeof riskParametersNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskParametersNew<TData = Awaited<ReturnType<typeof riskParametersNew>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request parameters for a risk parameter creation
 */

export function useRiskParametersNew<TData = Awaited<ReturnType<typeof riskParametersNew>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRiskParametersNewQueryOptions(tradingAccountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Request parameters for a risk parameter creation
 */
export const prefetchRiskParametersNewQuery = async <TData = Awaited<ReturnType<typeof riskParametersNew>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getRiskParametersNewQueryOptions(tradingAccountId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Request parameters for a risk parameter update
 */
export const riskParametersEdit = (
    tradingAccountId: number,
    riskParameterId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EditRiskParameterResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/risk_parameters/${riskParameterId}/edit`, method: 'GET', signal
    },
      options);
    }




export const getRiskParametersEditQueryKey = (tradingAccountId: number,
    riskParameterId: number,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'risk_parameters',riskParameterId,'edit'
    ] as const;
    }


export const getRiskParametersEditQueryOptions = <TData = Awaited<ReturnType<typeof riskParametersEdit>>, TError = N404Response | N422Response | N500Response>(tradingAccountId: number,
    riskParameterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRiskParametersEditQueryKey(tradingAccountId,riskParameterId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof riskParametersEdit>>> = ({ signal }) => riskParametersEdit(tradingAccountId,riskParameterId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined && riskParameterId !== null && riskParameterId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof riskParametersEdit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RiskParametersEditQueryResult = NonNullable<Awaited<ReturnType<typeof riskParametersEdit>>>
export type RiskParametersEditQueryError = N404Response | N422Response | N500Response


export function useRiskParametersEdit<TData = Awaited<ReturnType<typeof riskParametersEdit>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    riskParameterId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersEdit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskParametersEdit>>,
          TError,
          Awaited<ReturnType<typeof riskParametersEdit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskParametersEdit<TData = Awaited<ReturnType<typeof riskParametersEdit>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    riskParameterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersEdit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof riskParametersEdit>>,
          TError,
          Awaited<ReturnType<typeof riskParametersEdit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRiskParametersEdit<TData = Awaited<ReturnType<typeof riskParametersEdit>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    riskParameterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request parameters for a risk parameter update
 */

export function useRiskParametersEdit<TData = Awaited<ReturnType<typeof riskParametersEdit>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number,
    riskParameterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRiskParametersEditQueryOptions(tradingAccountId,riskParameterId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Request parameters for a risk parameter update
 */
export const prefetchRiskParametersEditQuery = async <TData = Awaited<ReturnType<typeof riskParametersEdit>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    riskParameterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof riskParametersEdit>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getRiskParametersEditQueryOptions(tradingAccountId,riskParameterId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a risk parameter
 */
export const createRiskParameter = (
    tradingAccountId: number,
    createRiskParameterRequest: CreateRiskParameterRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<RiskParameterActionResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/risk_parameters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRiskParameterRequest, signal
    },
      options);
    }




export const getCreateRiskParameterMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRiskParameter>>, TError,{tradingAccountId: number;data: CreateRiskParameterRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRiskParameter>>, TError,{tradingAccountId: number;data: CreateRiskParameterRequest}, TContext> => {

const mutationKey = ['createRiskParameter'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRiskParameter>>, {tradingAccountId: number;data: CreateRiskParameterRequest}> = (props) => {
          const {tradingAccountId,data} = props ?? {};

          return  createRiskParameter(tradingAccountId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRiskParameterMutationResult = NonNullable<Awaited<ReturnType<typeof createRiskParameter>>>
    export type CreateRiskParameterMutationBody = CreateRiskParameterRequest
    export type CreateRiskParameterMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create a risk parameter
 */
export const useCreateRiskParameter = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRiskParameter>>, TError,{tradingAccountId: number;data: CreateRiskParameterRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRiskParameter>>,
        TError,
        {tradingAccountId: number;data: CreateRiskParameterRequest},
        TContext
      > => {
      return useMutation(getCreateRiskParameterMutationOptions(options), queryClient);
    }

/**
 * @summary Request risk parameters
 */
export const getRiskParameters = (
    tradingAccountId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<RiskParametersListResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/risk_parameters`, method: 'GET', signal
    },
      options);
    }




export const getGetRiskParametersQueryKey = (tradingAccountId: number,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'risk_parameters'
    ] as const;
    }


export const getGetRiskParametersQueryOptions = <TData = Awaited<ReturnType<typeof getRiskParameters>>, TError = N404Response | N422Response | N500Response>(tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskParameters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRiskParametersQueryKey(tradingAccountId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRiskParameters>>> = ({ signal }) => getRiskParameters(tradingAccountId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRiskParameters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRiskParametersQueryResult = NonNullable<Awaited<ReturnType<typeof getRiskParameters>>>
export type GetRiskParametersQueryError = N404Response | N422Response | N500Response


export function useGetRiskParameters<TData = Awaited<ReturnType<typeof getRiskParameters>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskParameters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskParameters>>,
          TError,
          Awaited<ReturnType<typeof getRiskParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRiskParameters<TData = Awaited<ReturnType<typeof getRiskParameters>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskParameters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskParameters>>,
          TError,
          Awaited<ReturnType<typeof getRiskParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRiskParameters<TData = Awaited<ReturnType<typeof getRiskParameters>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskParameters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request risk parameters
 */

export function useGetRiskParameters<TData = Awaited<ReturnType<typeof getRiskParameters>>, TError = N404Response | N422Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskParameters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRiskParametersQueryOptions(tradingAccountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Request risk parameters
 */
export const prefetchGetRiskParametersQuery = async <TData = Awaited<ReturnType<typeof getRiskParameters>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskParameters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetRiskParametersQueryOptions(tradingAccountId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update a risk parameter
 */
export const updateRiskParameter = (
    tradingAccountId: number,
    riskParameterId: number,
    updateRiskParameterRequest: UpdateRiskParameterRequest,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<RiskParameterActionResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/risk_parameters/${riskParameterId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateRiskParameterRequest, signal
    },
      options);
    }




export const getUpdateRiskParameterMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRiskParameter>>, TError,{tradingAccountId: number;riskParameterId: number;data: UpdateRiskParameterRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRiskParameter>>, TError,{tradingAccountId: number;riskParameterId: number;data: UpdateRiskParameterRequest}, TContext> => {

const mutationKey = ['updateRiskParameter'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRiskParameter>>, {tradingAccountId: number;riskParameterId: number;data: UpdateRiskParameterRequest}> = (props) => {
          const {tradingAccountId,riskParameterId,data} = props ?? {};

          return  updateRiskParameter(tradingAccountId,riskParameterId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRiskParameterMutationResult = NonNullable<Awaited<ReturnType<typeof updateRiskParameter>>>
    export type UpdateRiskParameterMutationBody = UpdateRiskParameterRequest
    export type UpdateRiskParameterMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update a risk parameter
 */
export const useUpdateRiskParameter = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRiskParameter>>, TError,{tradingAccountId: number;riskParameterId: number;data: UpdateRiskParameterRequest}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRiskParameter>>,
        TError,
        {tradingAccountId: number;riskParameterId: number;data: UpdateRiskParameterRequest},
        TContext
      > => {
      return useMutation(getUpdateRiskParameterMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a risk parameter
 */
export const deleteRiskParameter = (
    tradingAccountId: number,
    riskParameterId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<RiskParameterActionResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/risk_parameters/${riskParameterId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteRiskParameterMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRiskParameter>>, TError,{tradingAccountId: number;riskParameterId: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRiskParameter>>, TError,{tradingAccountId: number;riskParameterId: number}, TContext> => {

const mutationKey = ['deleteRiskParameter'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRiskParameter>>, {tradingAccountId: number;riskParameterId: number}> = (props) => {
          const {tradingAccountId,riskParameterId} = props ?? {};

          return  deleteRiskParameter(tradingAccountId,riskParameterId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRiskParameterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRiskParameter>>>

    export type DeleteRiskParameterMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Delete a risk parameter
 */
export const useDeleteRiskParameter = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRiskParameter>>, TError,{tradingAccountId: number;riskParameterId: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRiskParameter>>,
        TError,
        {tradingAccountId: number;riskParameterId: number},
        TContext
      > => {
      return useMutation(getDeleteRiskParameterMutationOptions(options), queryClient);
    }

/**
 * @summary Get options for new template
 */
export const getNewTemplate = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewTemplateResponse>(
      {url: `/admin/api/templates/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewTemplateQueryKey = () => {
    return [
    'admin','api','templates','new'
    ] as const;
    }


export const getGetNewTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getNewTemplate>>, TError = N422Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewTemplateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewTemplate>>> = ({ signal }) => getNewTemplate(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getNewTemplate>>>
export type GetNewTemplateQueryError = N422Response | N500Response


export function useGetNewTemplate<TData = Awaited<ReturnType<typeof getNewTemplate>>, TError = N422Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewTemplate>>,
          TError,
          Awaited<ReturnType<typeof getNewTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewTemplate<TData = Awaited<ReturnType<typeof getNewTemplate>>, TError = N422Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewTemplate>>,
          TError,
          Awaited<ReturnType<typeof getNewTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewTemplate<TData = Awaited<ReturnType<typeof getNewTemplate>>, TError = N422Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for new template
 */

export function useGetNewTemplate<TData = Awaited<ReturnType<typeof getNewTemplate>>, TError = N422Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewTemplateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for new template
 */
export const prefetchGetNewTemplateQuery = async <TData = Awaited<ReturnType<typeof getNewTemplate>>, TError = N422Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewTemplateQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List templates
 */
export const listTemplates = (
    params?: ListTemplatesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ListTemplateResponse>(
      {url: `/admin/api/templates`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTemplatesQueryKey = (params?: ListTemplatesParams,) => {
    return [
    'admin','api','templates', ...(params ? [params] : [])
    ] as const;
    }


export const getListTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplates>>, TError = N404Response | N500Response>(params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) => listTemplates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>
export type ListTemplatesQueryError = N404Response | N500Response


export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = N404Response | N500Response>(
 params: undefined |  ListTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = N404Response | N500Response>(
 params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = N404Response | N500Response>(
 params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List templates
 */

export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = N404Response | N500Response>(
 params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List templates
 */
export const prefetchListTemplatesQuery = async <TData = Awaited<ReturnType<typeof listTemplates>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTemplatesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new template
 */
export const createTemplate = (
    createUpdateTemplateRequestBody: CreateUpdateTemplateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TemplateCommonResponse>(
      {url: `/admin/api/templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUpdateTemplateRequestBody, signal
    },
      options);
    }




export const getCreateTemplateMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: CreateUpdateTemplateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: CreateUpdateTemplateRequestBody}, TContext> => {

const mutationKey = ['createTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplate>>, {data: CreateUpdateTemplateRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplate>>>
    export type CreateTemplateMutationBody = CreateUpdateTemplateRequestBody
    export type CreateTemplateMutationError = N422Response | N500Response

    /**
 * @summary Create a new template
 */
export const useCreateTemplate = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: CreateUpdateTemplateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTemplate>>,
        TError,
        {data: CreateUpdateTemplateRequestBody},
        TContext
      > => {
      return useMutation(getCreateTemplateMutationOptions(options), queryClient);
    }

/**
 * @summary Get fields for the template
 */
export const getEditTemplate = (
    templateId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EditTemplateResponse>(
      {url: `/admin/api/templates/${templateId}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetEditTemplateQueryKey = (templateId: number,) => {
    return [
    'admin','api','templates',templateId,'edit'
    ] as const;
    }


export const getGetEditTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getEditTemplate>>, TError = N422Response | N500Response>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEditTemplateQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditTemplate>>> = ({ signal }) => getEditTemplate(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEditTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getEditTemplate>>>
export type GetEditTemplateQueryError = N422Response | N500Response


export function useGetEditTemplate<TData = Awaited<ReturnType<typeof getEditTemplate>>, TError = N422Response | N500Response>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEditTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditTemplate<TData = Awaited<ReturnType<typeof getEditTemplate>>, TError = N422Response | N500Response>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditTemplate>>,
          TError,
          Awaited<ReturnType<typeof getEditTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditTemplate<TData = Awaited<ReturnType<typeof getEditTemplate>>, TError = N422Response | N500Response>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fields for the template
 */

export function useGetEditTemplate<TData = Awaited<ReturnType<typeof getEditTemplate>>, TError = N422Response | N500Response>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEditTemplateQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get fields for the template
 */
export const prefetchGetEditTemplateQuery = async <TData = Awaited<ReturnType<typeof getEditTemplate>>, TError = N422Response | N500Response>(
 queryClient: QueryClient, templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditTemplate>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEditTemplateQueryOptions(templateId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update the template
 */
export const updateTemplate = (
    templateId: number,
    createUpdateTemplateRequestBody: CreateUpdateTemplateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TemplateCommonResponse>(
      {url: `/admin/api/templates/${templateId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: createUpdateTemplateRequestBody, signal
    },
      options);
    }




export const getUpdateTemplateMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{templateId: number;data: CreateUpdateTemplateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{templateId: number;data: CreateUpdateTemplateRequestBody}, TContext> => {

const mutationKey = ['updateTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTemplate>>, {templateId: number;data: CreateUpdateTemplateRequestBody}> = (props) => {
          const {templateId,data} = props ?? {};

          return  updateTemplate(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplate>>>
    export type UpdateTemplateMutationBody = CreateUpdateTemplateRequestBody
    export type UpdateTemplateMutationError = N422Response | N500Response

    /**
 * @summary Update the template
 */
export const useUpdateTemplate = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{templateId: number;data: CreateUpdateTemplateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTemplate>>,
        TError,
        {templateId: number;data: CreateUpdateTemplateRequestBody},
        TContext
      > => {
      return useMutation(getUpdateTemplateMutationOptions(options), queryClient);
    }

/**
 * @summary Delete the template
 */
export const deleteTemplate = (
    templateId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TemplateCommonResponse>(
      {url: `/admin/api/templates/${templateId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTemplateMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{templateId: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{templateId: number}, TContext> => {

const mutationKey = ['deleteTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplate>>, {templateId: number}> = (props) => {
          const {templateId} = props ?? {};

          return  deleteTemplate(templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplate>>>

    export type DeleteTemplateMutationError = N422Response | N500Response

    /**
 * @summary Delete the template
 */
export const useDeleteTemplate = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{templateId: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplate>>,
        TError,
        {templateId: number},
        TContext
      > => {
      return useMutation(getDeleteTemplateMutationOptions(options), queryClient);
    }

/**
 * @summary Get templates count for search filter and data for dropdowns for the index
 */
export const getTemplateFilterMetadata = (
    params?: GetTemplateFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TemplatesFilterMetadataResponse>(
      {url: `/admin/api/templates/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTemplateFilterMetadataQueryKey = (params?: GetTemplateFilterMetadataParams,) => {
    return [
    'admin','api','templates','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTemplateFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError = N404Response | N500Response>(params?: GetTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateFilterMetadata>>> = ({ signal }) => getTemplateFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTemplateFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplateFilterMetadata>>>
export type GetTemplateFilterMetadataQueryError = N404Response | N500Response


export function useGetTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetTemplateFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getTemplateFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getTemplateFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get templates count for search filter and data for dropdowns for the index
 */

export function useGetTemplateFilterMetadata<TData = Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTemplateFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get templates count for search filter and data for dropdowns for the index
 */
export const prefetchGetTemplateFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetTemplateFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTemplateFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get options for new policy
 */
export const getNewPolicy = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewPolicyResponse>(
      {url: `/admin/api/policies/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewPolicyQueryKey = () => {
    return [
    'admin','api','policies','new'
    ] as const;
    }


export const getGetNewPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getNewPolicy>>, TError = N422Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewPolicy>>> = ({ signal }) => getNewPolicy(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getNewPolicy>>>
export type GetNewPolicyQueryError = N422Response | N500Response


export function useGetNewPolicy<TData = Awaited<ReturnType<typeof getNewPolicy>>, TError = N422Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPolicy>>,
          TError,
          Awaited<ReturnType<typeof getNewPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPolicy<TData = Awaited<ReturnType<typeof getNewPolicy>>, TError = N422Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPolicy>>,
          TError,
          Awaited<ReturnType<typeof getNewPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPolicy<TData = Awaited<ReturnType<typeof getNewPolicy>>, TError = N422Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for new policy
 */

export function useGetNewPolicy<TData = Awaited<ReturnType<typeof getNewPolicy>>, TError = N422Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for new policy
 */
export const prefetchGetNewPolicyQuery = async <TData = Awaited<ReturnType<typeof getNewPolicy>>, TError = N422Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewPolicyQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List policies
 */
export const listPolicies = (
    params?: ListPoliciesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ListPolicyResponse>(
      {url: `/admin/api/policies`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPoliciesQueryKey = (params?: ListPoliciesParams,) => {
    return [
    'admin','api','policies', ...(params ? [params] : [])
    ] as const;
    }


export const getListPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof listPolicies>>, TError = N404Response | N500Response>(params?: ListPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPoliciesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPolicies>>> = ({ signal }) => listPolicies(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPolicies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof listPolicies>>>
export type ListPoliciesQueryError = N404Response | N500Response


export function useListPolicies<TData = Awaited<ReturnType<typeof listPolicies>>, TError = N404Response | N500Response>(
 params: undefined |  ListPoliciesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPolicies>>,
          TError,
          Awaited<ReturnType<typeof listPolicies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPolicies<TData = Awaited<ReturnType<typeof listPolicies>>, TError = N404Response | N500Response>(
 params?: ListPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPolicies>>,
          TError,
          Awaited<ReturnType<typeof listPolicies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPolicies<TData = Awaited<ReturnType<typeof listPolicies>>, TError = N404Response | N500Response>(
 params?: ListPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List policies
 */

export function useListPolicies<TData = Awaited<ReturnType<typeof listPolicies>>, TError = N404Response | N500Response>(
 params?: ListPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPoliciesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List policies
 */
export const prefetchListPoliciesQuery = async <TData = Awaited<ReturnType<typeof listPolicies>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListPoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListPoliciesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new policy
 */
export const createPolicy = (
    createPolicyRequestBody: CreatePolicyRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PolicyCommonResponse>(
      {url: `/admin/api/policies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPolicyRequestBody, signal
    },
      options);
    }




export const getCreatePolicyMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPolicy>>, TError,{data: CreatePolicyRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPolicy>>, TError,{data: CreatePolicyRequestBody}, TContext> => {

const mutationKey = ['createPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPolicy>>, {data: CreatePolicyRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createPolicy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof createPolicy>>>
    export type CreatePolicyMutationBody = CreatePolicyRequestBody
    export type CreatePolicyMutationError = N422Response | N500Response

    /**
 * @summary Create a new policy
 */
export const useCreatePolicy = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPolicy>>, TError,{data: CreatePolicyRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPolicy>>,
        TError,
        {data: CreatePolicyRequestBody},
        TContext
      > => {
      return useMutation(getCreatePolicyMutationOptions(options), queryClient);
    }

/**
 * @summary Get fields for editing the policy
 */
export const getEditPolicy = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EditPolicyResponse>(
      {url: `/admin/api/policies/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetEditPolicyQueryKey = (id: number,) => {
    return [
    'admin','api','policies',id,'edit'
    ] as const;
    }


export const getGetEditPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getEditPolicy>>, TError = N404Response | N422Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEditPolicyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditPolicy>>> = ({ signal }) => getEditPolicy(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEditPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getEditPolicy>>>
export type GetEditPolicyQueryError = N404Response | N422Response | N500Response


export function useGetEditPolicy<TData = Awaited<ReturnType<typeof getEditPolicy>>, TError = N404Response | N422Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditPolicy>>,
          TError,
          Awaited<ReturnType<typeof getEditPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditPolicy<TData = Awaited<ReturnType<typeof getEditPolicy>>, TError = N404Response | N422Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditPolicy>>,
          TError,
          Awaited<ReturnType<typeof getEditPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditPolicy<TData = Awaited<ReturnType<typeof getEditPolicy>>, TError = N404Response | N422Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fields for editing the policy
 */

export function useGetEditPolicy<TData = Awaited<ReturnType<typeof getEditPolicy>>, TError = N404Response | N422Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEditPolicyQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get fields for editing the policy
 */
export const prefetchGetEditPolicyQuery = async <TData = Awaited<ReturnType<typeof getEditPolicy>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEditPolicyQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update the policy
 */
export const updatePolicy = (
    id: number,
    updatePolicyRequestBody: UpdatePolicyRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PolicyCommonResponse>(
      {url: `/admin/api/policies/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePolicyRequestBody, signal
    },
      options);
    }




export const getUpdatePolicyMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePolicy>>, TError,{id: number;data: UpdatePolicyRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePolicy>>, TError,{id: number;data: UpdatePolicyRequestBody}, TContext> => {

const mutationKey = ['updatePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePolicy>>, {id: number;data: UpdatePolicyRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePolicy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof updatePolicy>>>
    export type UpdatePolicyMutationBody = UpdatePolicyRequestBody
    export type UpdatePolicyMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update the policy
 */
export const useUpdatePolicy = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePolicy>>, TError,{id: number;data: UpdatePolicyRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePolicy>>,
        TError,
        {id: number;data: UpdatePolicyRequestBody},
        TContext
      > => {
      return useMutation(getUpdatePolicyMutationOptions(options), queryClient);
    }

/**
 * @summary Delete the policy
 */
export const deletePolicy = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PolicyCommonResponse>(
      {url: `/admin/api/policies/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePolicyMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePolicy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePolicy>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePolicy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePolicy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePolicyMutationResult = NonNullable<Awaited<ReturnType<typeof deletePolicy>>>

    export type DeletePolicyMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Delete the policy
 */
export const useDeletePolicy = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePolicy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePolicy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePolicyMutationOptions(options), queryClient);
    }

/**
 * @summary Get policy count for search filter and data for dropdowns
 */
export const getPolicyFilterMetadata = (
    params?: GetPolicyFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PoliciesFilterMetadataResponse>(
      {url: `/admin/api/policies/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPolicyFilterMetadataQueryKey = (params?: GetPolicyFilterMetadataParams,) => {
    return [
    'admin','api','policies','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetPolicyFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError = N404Response | N500Response>(params?: GetPolicyFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPolicyFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPolicyFilterMetadata>>> = ({ signal }) => getPolicyFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPolicyFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getPolicyFilterMetadata>>>
export type GetPolicyFilterMetadataQueryError = N404Response | N500Response


export function useGetPolicyFilterMetadata<TData = Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetPolicyFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPolicyFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPolicyFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPolicyFilterMetadata<TData = Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetPolicyFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPolicyFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPolicyFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPolicyFilterMetadata<TData = Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetPolicyFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get policy count for search filter and data for dropdowns
 */

export function useGetPolicyFilterMetadata<TData = Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetPolicyFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPolicyFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get policy count for search filter and data for dropdowns
 */
export const prefetchGetPolicyFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetPolicyFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicyFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPolicyFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get options for new group
 */
export const getNewGroup = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewGroupResponse>(
      {url: `/admin/api/groups/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewGroupQueryKey = () => {
    return [
    'admin','api','groups','new'
    ] as const;
    }


export const getGetNewGroupQueryOptions = <TData = Awaited<ReturnType<typeof getNewGroup>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewGroupQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewGroup>>> = ({ signal }) => getNewGroup(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getNewGroup>>>
export type GetNewGroupQueryError = N404Response | N500Response


export function useGetNewGroup<TData = Awaited<ReturnType<typeof getNewGroup>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewGroup>>,
          TError,
          Awaited<ReturnType<typeof getNewGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewGroup<TData = Awaited<ReturnType<typeof getNewGroup>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewGroup>>,
          TError,
          Awaited<ReturnType<typeof getNewGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewGroup<TData = Awaited<ReturnType<typeof getNewGroup>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for new group
 */

export function useGetNewGroup<TData = Awaited<ReturnType<typeof getNewGroup>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewGroupQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for new group
 */
export const prefetchGetNewGroupQuery = async <TData = Awaited<ReturnType<typeof getNewGroup>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewGroupQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List groups
 */
export const listGroups = (
    params?: ListGroupsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ListGroupResponse>(
      {url: `/admin/api/groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListGroupsQueryKey = (params?: ListGroupsParams,) => {
    return [
    'admin','api','groups', ...(params ? [params] : [])
    ] as const;
    }


export const getListGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listGroups>>, TError = N404Response | N500Response>(params?: ListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroups>>> = ({ signal }) => listGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listGroups>>>
export type ListGroupsQueryError = N404Response | N500Response


export function useListGroups<TData = Awaited<ReturnType<typeof listGroups>>, TError = N404Response | N500Response>(
 params: undefined |  ListGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroups>>,
          TError,
          Awaited<ReturnType<typeof listGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroups<TData = Awaited<ReturnType<typeof listGroups>>, TError = N404Response | N500Response>(
 params?: ListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroups>>,
          TError,
          Awaited<ReturnType<typeof listGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListGroups<TData = Awaited<ReturnType<typeof listGroups>>, TError = N404Response | N500Response>(
 params?: ListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List groups
 */

export function useListGroups<TData = Awaited<ReturnType<typeof listGroups>>, TError = N404Response | N500Response>(
 params?: ListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List groups
 */
export const prefetchListGroupsQuery = async <TData = Awaited<ReturnType<typeof listGroups>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListGroupsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new group
 */
export const createGroup = (
    createGroupRequestBody: CreateGroupRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GroupCommonResponse>(
      {url: `/admin/api/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupRequestBody, signal
    },
      options);
    }




export const getCreateGroupMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroupRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroupRequestBody}, TContext> => {

const mutationKey = ['createGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroup>>, {data: CreateGroupRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>
    export type CreateGroupMutationBody = CreateGroupRequestBody
    export type CreateGroupMutationError = N422Response | N500Response

    /**
 * @summary Create a new group
 */
export const useCreateGroup = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroupRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroup>>,
        TError,
        {data: CreateGroupRequestBody},
        TContext
      > => {
      return useMutation(getCreateGroupMutationOptions(options), queryClient);
    }

/**
 * @summary Get fields for the group
 */
export const getEditGroup = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<EditGroupResponse>(
      {url: `/admin/api/groups/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetEditGroupQueryKey = (id: number,) => {
    return [
    'admin','api','groups',id,'edit'
    ] as const;
    }


export const getGetEditGroupQueryOptions = <TData = Awaited<ReturnType<typeof getEditGroup>>, TError = N404Response | N422Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEditGroupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditGroup>>> = ({ signal }) => getEditGroup(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEditGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getEditGroup>>>
export type GetEditGroupQueryError = N404Response | N422Response | N500Response


export function useGetEditGroup<TData = Awaited<ReturnType<typeof getEditGroup>>, TError = N404Response | N422Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditGroup>>,
          TError,
          Awaited<ReturnType<typeof getEditGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditGroup<TData = Awaited<ReturnType<typeof getEditGroup>>, TError = N404Response | N422Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditGroup>>,
          TError,
          Awaited<ReturnType<typeof getEditGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditGroup<TData = Awaited<ReturnType<typeof getEditGroup>>, TError = N404Response | N422Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fields for the group
 */

export function useGetEditGroup<TData = Awaited<ReturnType<typeof getEditGroup>>, TError = N404Response | N422Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEditGroupQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get fields for the group
 */
export const prefetchGetEditGroupQuery = async <TData = Awaited<ReturnType<typeof getEditGroup>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetEditGroupQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update the group
 */
export const updateGroup = (
    id: number,
    updateGroupRequestBody: UpdateGroupRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GroupCommonResponse>(
      {url: `/admin/api/groups/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroupRequestBody, signal
    },
      options);
    }




export const getUpdateGroupMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{id: number;data: UpdateGroupRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{id: number;data: UpdateGroupRequestBody}, TContext> => {

const mutationKey = ['updateGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGroup>>, {id: number;data: UpdateGroupRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroup>>>
    export type UpdateGroupMutationBody = UpdateGroupRequestBody
    export type UpdateGroupMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update the group
 */
export const useUpdateGroup = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{id: number;data: UpdateGroupRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGroup>>,
        TError,
        {id: number;data: UpdateGroupRequestBody},
        TContext
      > => {
      return useMutation(getUpdateGroupMutationOptions(options), queryClient);
    }

/**
 * @summary Get groups count for search filter and data for dropdowns for the index
 */
export const getGroupFilterMetadata = (
    params?: GetGroupFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GroupsFilterMetadataResponse>(
      {url: `/admin/api/groups/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupFilterMetadataQueryKey = (params?: GetGroupFilterMetadataParams,) => {
    return [
    'admin','api','groups','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError = N404Response | N422Response | N500Response>(params?: GetGroupFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupFilterMetadata>>> = ({ signal }) => getGroupFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupFilterMetadata>>>
export type GetGroupFilterMetadataQueryError = N404Response | N422Response | N500Response


export function useGetGroupFilterMetadata<TData = Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError = N404Response | N422Response | N500Response>(
 params: undefined |  GetGroupFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getGroupFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupFilterMetadata<TData = Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError = N404Response | N422Response | N500Response>(
 params?: GetGroupFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getGroupFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupFilterMetadata<TData = Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError = N404Response | N422Response | N500Response>(
 params?: GetGroupFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get groups count for search filter and data for dropdowns for the index
 */

export function useGetGroupFilterMetadata<TData = Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError = N404Response | N422Response | N500Response>(
 params?: GetGroupFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get groups count for search filter and data for dropdowns for the index
 */
export const prefetchGetGroupFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, params?: GetGroupFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetGroupFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get risk scores from risk engine for the trading accounts with the sent ids
 */
export const getTradingAccountsRiskScores = (
    params?: GetTradingAccountsRiskScoresParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountRiskScoresResponse>(
      {url: `/admin/api/risk_scores/trading_accounts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountsRiskScoresQueryKey = (params?: GetTradingAccountsRiskScoresParams,) => {
    return [
    'admin','api','risk_scores','trading_accounts', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountsRiskScoresQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError = N404Response | N500Response>(params?: GetTradingAccountsRiskScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountsRiskScoresQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>> = ({ signal }) => getTradingAccountsRiskScores(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountsRiskScoresQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>>
export type GetTradingAccountsRiskScoresQueryError = N404Response | N500Response


export function useGetTradingAccountsRiskScores<TData = Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError = N404Response | N500Response>(
 params: undefined |  GetTradingAccountsRiskScoresParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountsRiskScores>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountsRiskScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountsRiskScores<TData = Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountsRiskScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountsRiskScores>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountsRiskScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountsRiskScores<TData = Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountsRiskScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get risk scores from risk engine for the trading accounts with the sent ids
 */

export function useGetTradingAccountsRiskScores<TData = Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountsRiskScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountsRiskScoresQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get risk scores from risk engine for the trading accounts with the sent ids
 */
export const prefetchGetTradingAccountsRiskScoresQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetTradingAccountsRiskScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsRiskScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountsRiskScoresQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get current session
 */
export const getCurrentSession = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<SessionGetCreateResponse>(
      {url: `/admin/api/session`, method: 'GET', signal
    },
      options);
    }




export const getGetCurrentSessionQueryKey = () => {
    return [
    'admin','api','session'
    ] as const;
    }


export const getGetCurrentSessionQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentSession>>, TError = ResourceNotFoundError | InternalServerError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentSession>>> = ({ signal }) => getCurrentSession(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentSession>>>
export type GetCurrentSessionQueryError = ResourceNotFoundError | InternalServerError


export function useGetCurrentSession<TData = Awaited<ReturnType<typeof getCurrentSession>>, TError = ResourceNotFoundError | InternalServerError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentSession>>,
          TError,
          Awaited<ReturnType<typeof getCurrentSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentSession<TData = Awaited<ReturnType<typeof getCurrentSession>>, TError = ResourceNotFoundError | InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentSession>>,
          TError,
          Awaited<ReturnType<typeof getCurrentSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentSession<TData = Awaited<ReturnType<typeof getCurrentSession>>, TError = ResourceNotFoundError | InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current session
 */

export function useGetCurrentSession<TData = Awaited<ReturnType<typeof getCurrentSession>>, TError = ResourceNotFoundError | InternalServerError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get current session
 */
export const prefetchGetCurrentSessionQuery = async <TData = Awaited<ReturnType<typeof getCurrentSession>>, TError = ResourceNotFoundError | InternalServerError>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentSession>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCurrentSessionQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Logout
 */
export const logout = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<void>(
      {url: `/admin/api/session`, method: 'DELETE', signal
    },
      options);
    }




export const getLogoutMutationOptions = <TError = ResourceNotFoundError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ResourceNotFoundError | InternalServerError

    /**
 * @summary Logout
 */
export const useLogout = <TError = ResourceNotFoundError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }

/**
 * @summary Login
 */
export const createSession = (
    createSessionBody: CreateSessionBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<SessionGetCreateResponse>(
      {url: `/admin/api/session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSessionBody, signal
    },
      options);
    }




export const getCreateSessionMutationOptions = <TError = CreateSession401 | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: CreateSessionBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: CreateSessionBody}, TContext> => {

const mutationKey = ['createSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, {data: CreateSessionBody}> = (props) => {
          const {data} = props ?? {};

          return  createSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    export type CreateSessionMutationBody = CreateSessionBody
    export type CreateSessionMutationError = CreateSession401 | InvalidRecordError | InternalServerError

    /**
 * @summary Login
 */
export const useCreateSession = <TError = CreateSession401 | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,{data: CreateSessionBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        {data: CreateSessionBody},
        TContext
      > => {
      return useMutation(getCreateSessionMutationOptions(options), queryClient);
    }

/**
 * Verify OTP for authentication
 * @summary Login with OTP
 */
export const otpAttempt = (
    otpAttemptBody: OtpAttemptBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<SessionGetCreateResponse>(
      {url: `/admin/api/sessions/otp_attempt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otpAttemptBody, signal
    },
      options);
    }




export const getOtpAttemptMutationOptions = <TError = OtpAttempt422 | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof otpAttempt>>, TError,{data: OtpAttemptBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof otpAttempt>>, TError,{data: OtpAttemptBody}, TContext> => {

const mutationKey = ['otpAttempt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof otpAttempt>>, {data: OtpAttemptBody}> = (props) => {
          const {data} = props ?? {};

          return  otpAttempt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OtpAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof otpAttempt>>>
    export type OtpAttemptMutationBody = OtpAttemptBody
    export type OtpAttemptMutationError = OtpAttempt422 | InternalServerError

    /**
 * @summary Login with OTP
 */
export const useOtpAttempt = <TError = OtpAttempt422 | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof otpAttempt>>, TError,{data: OtpAttemptBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof otpAttempt>>,
        TError,
        {data: OtpAttemptBody},
        TContext
      > => {
      return useMutation(getOtpAttemptMutationOptions(options), queryClient);
    }

/**
 * @summary Create trading account
 */
export const createTradingAccount = (
    challengeId: number,
    createTradingAccountBody: CreateTradingAccountBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CreateTradingAccountResponse>(
      {url: `/admin/api/challenges/${challengeId}/trading_accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTradingAccountBody, signal
    },
      options);
    }




export const getCreateTradingAccountMutationOptions = <TError = N404Response | CreateTradingAccount422 | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTradingAccount>>, TError,{challengeId: number;data: CreateTradingAccountBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTradingAccount>>, TError,{challengeId: number;data: CreateTradingAccountBody}, TContext> => {

const mutationKey = ['createTradingAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTradingAccount>>, {challengeId: number;data: CreateTradingAccountBody}> = (props) => {
          const {challengeId,data} = props ?? {};

          return  createTradingAccount(challengeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTradingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createTradingAccount>>>
    export type CreateTradingAccountMutationBody = CreateTradingAccountBody
    export type CreateTradingAccountMutationError = N404Response | CreateTradingAccount422 | N500Response

    /**
 * @summary Create trading account
 */
export const useCreateTradingAccount = <TError = N404Response | CreateTradingAccount422 | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTradingAccount>>, TError,{challengeId: number;data: CreateTradingAccountBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTradingAccount>>,
        TError,
        {challengeId: number;data: CreateTradingAccountBody},
        TContext
      > => {
      return useMutation(getCreateTradingAccountMutationOptions(options), queryClient);
    }

/**
 * @summary Data for new trading account modal
 */
export const tradingAccountsNew = (
    challengeId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewTradingAccountResponse>(
      {url: `/admin/api/challenges/${challengeId}/trading_accounts/new`, method: 'GET', signal
    },
      options);
    }




export const getTradingAccountsNewQueryKey = (challengeId: number,) => {
    return [
    'admin','api','challenges',challengeId,'trading_accounts','new'
    ] as const;
    }


export const getTradingAccountsNewQueryOptions = <TData = Awaited<ReturnType<typeof tradingAccountsNew>>, TError = N404Response | N500Response>(challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTradingAccountsNewQueryKey(challengeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradingAccountsNew>>> = ({ signal }) => tradingAccountsNew(challengeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: challengeId !== null && challengeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradingAccountsNew>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TradingAccountsNewQueryResult = NonNullable<Awaited<ReturnType<typeof tradingAccountsNew>>>
export type TradingAccountsNewQueryError = N404Response | N500Response


export function useTradingAccountsNew<TData = Awaited<ReturnType<typeof tradingAccountsNew>>, TError = N404Response | N500Response>(
 challengeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradingAccountsNew>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tradingAccountsNew>>,
          TError,
          Awaited<ReturnType<typeof tradingAccountsNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTradingAccountsNew<TData = Awaited<ReturnType<typeof tradingAccountsNew>>, TError = N404Response | N500Response>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradingAccountsNew>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tradingAccountsNew>>,
          TError,
          Awaited<ReturnType<typeof tradingAccountsNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTradingAccountsNew<TData = Awaited<ReturnType<typeof tradingAccountsNew>>, TError = N404Response | N500Response>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Data for new trading account modal
 */

export function useTradingAccountsNew<TData = Awaited<ReturnType<typeof tradingAccountsNew>>, TError = N404Response | N500Response>(
 challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTradingAccountsNewQueryOptions(challengeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Data for new trading account modal
 */
export const prefetchTradingAccountsNewQuery = async <TData = Awaited<ReturnType<typeof tradingAccountsNew>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, challengeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getTradingAccountsNewQueryOptions(challengeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Returns flags of a trading account
 */
export const flagsForTradingAccount = (
    tradingAccountId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountFlagsResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/flags`, method: 'GET', signal
    },
      options);
    }




export const getFlagsForTradingAccountQueryKey = (tradingAccountId: number,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'flags'
    ] as const;
    }


export const getFlagsForTradingAccountQueryOptions = <TData = Awaited<ReturnType<typeof flagsForTradingAccount>>, TError = N404Response | N500Response>(tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof flagsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFlagsForTradingAccountQueryKey(tradingAccountId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof flagsForTradingAccount>>> = ({ signal }) => flagsForTradingAccount(tradingAccountId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof flagsForTradingAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FlagsForTradingAccountQueryResult = NonNullable<Awaited<ReturnType<typeof flagsForTradingAccount>>>
export type FlagsForTradingAccountQueryError = N404Response | N500Response


export function useFlagsForTradingAccount<TData = Awaited<ReturnType<typeof flagsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof flagsForTradingAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof flagsForTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof flagsForTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFlagsForTradingAccount<TData = Awaited<ReturnType<typeof flagsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof flagsForTradingAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof flagsForTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof flagsForTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFlagsForTradingAccount<TData = Awaited<ReturnType<typeof flagsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof flagsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns flags of a trading account
 */

export function useFlagsForTradingAccount<TData = Awaited<ReturnType<typeof flagsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof flagsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFlagsForTradingAccountQueryOptions(tradingAccountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Returns flags of a trading account
 */
export const prefetchFlagsForTradingAccountQuery = async <TData = Awaited<ReturnType<typeof flagsForTradingAccount>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof flagsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFlagsForTradingAccountQueryOptions(tradingAccountId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Returns violations of a trading account
 */
export const violationsForTradingAccount = (
    tradingAccountId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountViolationsResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/violations`, method: 'GET', signal
    },
      options);
    }




export const getViolationsForTradingAccountQueryKey = (tradingAccountId: number,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'violations'
    ] as const;
    }


export const getViolationsForTradingAccountQueryOptions = <TData = Awaited<ReturnType<typeof violationsForTradingAccount>>, TError = N404Response | N500Response>(tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof violationsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViolationsForTradingAccountQueryKey(tradingAccountId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof violationsForTradingAccount>>> = ({ signal }) => violationsForTradingAccount(tradingAccountId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof violationsForTradingAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViolationsForTradingAccountQueryResult = NonNullable<Awaited<ReturnType<typeof violationsForTradingAccount>>>
export type ViolationsForTradingAccountQueryError = N404Response | N500Response


export function useViolationsForTradingAccount<TData = Awaited<ReturnType<typeof violationsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof violationsForTradingAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof violationsForTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof violationsForTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViolationsForTradingAccount<TData = Awaited<ReturnType<typeof violationsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof violationsForTradingAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof violationsForTradingAccount>>,
          TError,
          Awaited<ReturnType<typeof violationsForTradingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViolationsForTradingAccount<TData = Awaited<ReturnType<typeof violationsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof violationsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns violations of a trading account
 */

export function useViolationsForTradingAccount<TData = Awaited<ReturnType<typeof violationsForTradingAccount>>, TError = N404Response | N500Response>(
 tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof violationsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViolationsForTradingAccountQueryOptions(tradingAccountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Returns violations of a trading account
 */
export const prefetchViolationsForTradingAccountQuery = async <TData = Awaited<ReturnType<typeof violationsForTradingAccount>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof violationsForTradingAccount>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getViolationsForTradingAccountQueryOptions(tradingAccountId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get closed positions for trading account
 */
export const getTradingAccountClosedPositions = (
    tradingAccountId: number,
    params?: GetTradingAccountClosedPositionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetTradingAccountClosedPositionsResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/closed_positions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountClosedPositionsQueryKey = (tradingAccountId: number,
    params?: GetTradingAccountClosedPositionsParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'closed_positions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountClosedPositionsQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountClosedPositionsQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>> = ({ signal }) => getTradingAccountClosedPositions(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountClosedPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>>
export type GetTradingAccountClosedPositionsQueryError = N404Response | N500Response


export function useGetTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetTradingAccountClosedPositionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountClosedPositions>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountClosedPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountClosedPositions>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountClosedPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get closed positions for trading account
 */

export function useGetTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountClosedPositionsQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get closed positions for trading account
 */
export const prefetchGetTradingAccountClosedPositionsQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountClosedPositionsQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get filter metadata for closed positions for trading account
 */
export const getFilterMetadataTradingAccountClosedPositions = (
    tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountClosedPositionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ClosedPositionsFilterMetadataResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/closed_positions/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFilterMetadataTradingAccountClosedPositionsQueryKey = (tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountClosedPositionsParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'closed_positions','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetFilterMetadataTradingAccountClosedPositionsQueryOptions = <TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilterMetadataTradingAccountClosedPositionsQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>> = ({ signal }) => getFilterMetadataTradingAccountClosedPositions(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFilterMetadataTradingAccountClosedPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>>
export type GetFilterMetadataTradingAccountClosedPositionsQueryError = N404Response | N500Response


export function useGetFilterMetadataTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetFilterMetadataTradingAccountClosedPositionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>,
          TError,
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterMetadataTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>,
          TError,
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterMetadataTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata for closed positions for trading account
 */

export function useGetFilterMetadataTradingAccountClosedPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFilterMetadataTradingAccountClosedPositionsQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata for closed positions for trading account
 */
export const prefetchGetFilterMetadataTradingAccountClosedPositionsQuery = async <TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountClosedPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountClosedPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFilterMetadataTradingAccountClosedPositionsQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get open positions for trading account
 */
export const getTradingAccountOpenPositions = (
    tradingAccountId: number,
    params?: GetTradingAccountOpenPositionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetTradingAccountOpenPositionsResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/open_positions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountOpenPositionsQueryKey = (tradingAccountId: number,
    params?: GetTradingAccountOpenPositionsParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'open_positions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountOpenPositionsQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountOpenPositionsQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>> = ({ signal }) => getTradingAccountOpenPositions(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountOpenPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>>
export type GetTradingAccountOpenPositionsQueryError = N404Response | N500Response


export function useGetTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetTradingAccountOpenPositionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountOpenPositions>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountOpenPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountOpenPositions>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountOpenPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get open positions for trading account
 */

export function useGetTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountOpenPositionsQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get open positions for trading account
 */
export const prefetchGetTradingAccountOpenPositionsQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountOpenPositionsQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get filter metadata open positions for trading account
 */
export const getFilterMetadataTradingAccountOpenPositions = (
    tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountOpenPositionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<OpenPositionsFilterMetadataResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/open_positions/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFilterMetadataTradingAccountOpenPositionsQueryKey = (tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountOpenPositionsParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'open_positions','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetFilterMetadataTradingAccountOpenPositionsQueryOptions = <TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilterMetadataTradingAccountOpenPositionsQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>> = ({ signal }) => getFilterMetadataTradingAccountOpenPositions(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFilterMetadataTradingAccountOpenPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>>
export type GetFilterMetadataTradingAccountOpenPositionsQueryError = N404Response | N500Response


export function useGetFilterMetadataTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetFilterMetadataTradingAccountOpenPositionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>,
          TError,
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterMetadataTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>,
          TError,
          Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilterMetadataTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata open positions for trading account
 */

export function useGetFilterMetadataTradingAccountOpenPositions<TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFilterMetadataTradingAccountOpenPositionsQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata open positions for trading account
 */
export const prefetchGetFilterMetadataTradingAccountOpenPositionsQuery = async <TData = Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetFilterMetadataTradingAccountOpenPositionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilterMetadataTradingAccountOpenPositions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFilterMetadataTradingAccountOpenPositionsQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get balance actions for trading account
 */
export const getTradingAccountBalanceActions = (
    tradingAccountId: number,
    params?: GetTradingAccountBalanceActionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetTradingAccountBalanceActionsResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/balance_actions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountBalanceActionsQueryKey = (tradingAccountId: number,
    params?: GetTradingAccountBalanceActionsParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'balance_actions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountBalanceActionsQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetTradingAccountBalanceActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountBalanceActionsQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>> = ({ signal }) => getTradingAccountBalanceActions(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountBalanceActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>>
export type GetTradingAccountBalanceActionsQueryError = N404Response | N500Response


export function useGetTradingAccountBalanceActions<TData = Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetTradingAccountBalanceActionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountBalanceActions>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountBalanceActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountBalanceActions<TData = Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountBalanceActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountBalanceActions>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountBalanceActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountBalanceActions<TData = Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountBalanceActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get balance actions for trading account
 */

export function useGetTradingAccountBalanceActions<TData = Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradingAccountBalanceActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountBalanceActionsQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get balance actions for trading account
 */
export const prefetchGetTradingAccountBalanceActionsQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetTradingAccountBalanceActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountBalanceActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountBalanceActionsQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get trades for each IP
 */
export const getTradesPerIp = (
    tradingAccountId: number,
    params?: GetTradesPerIpParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetTradesPerIpResponse>(
      {url: `/admin/api/trading_accounts/${tradingAccountId}/trades_per_ip`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradesPerIpQueryKey = (tradingAccountId: number,
    params?: GetTradesPerIpParams,) => {
    return [
    'admin','api','trading_accounts',tradingAccountId,'trades_per_ip', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradesPerIpQueryOptions = <TData = Awaited<ReturnType<typeof getTradesPerIp>>, TError = N404Response | N500Response>(tradingAccountId: number,
    params?: GetTradesPerIpParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradesPerIp>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradesPerIpQueryKey(tradingAccountId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradesPerIp>>> = ({ signal }) => getTradesPerIp(tradingAccountId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradingAccountId !== null && tradingAccountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradesPerIp>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradesPerIpQueryResult = NonNullable<Awaited<ReturnType<typeof getTradesPerIp>>>
export type GetTradesPerIpQueryError = N404Response | N500Response


export function useGetTradesPerIp<TData = Awaited<ReturnType<typeof getTradesPerIp>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params: undefined |  GetTradesPerIpParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradesPerIp>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradesPerIp>>,
          TError,
          Awaited<ReturnType<typeof getTradesPerIp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradesPerIp<TData = Awaited<ReturnType<typeof getTradesPerIp>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradesPerIpParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradesPerIp>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradesPerIp>>,
          TError,
          Awaited<ReturnType<typeof getTradesPerIp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradesPerIp<TData = Awaited<ReturnType<typeof getTradesPerIp>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradesPerIpParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradesPerIp>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get trades for each IP
 */

export function useGetTradesPerIp<TData = Awaited<ReturnType<typeof getTradesPerIp>>, TError = N404Response | N500Response>(
 tradingAccountId: number,
    params?: GetTradesPerIpParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradesPerIp>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradesPerIpQueryOptions(tradingAccountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get trades for each IP
 */
export const prefetchGetTradesPerIpQuery = async <TData = Awaited<ReturnType<typeof getTradesPerIp>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, tradingAccountId: number,
    params?: GetTradesPerIpParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradesPerIp>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradesPerIpQueryOptions(tradingAccountId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Returns a list of user mergeable trading accounts
 */
export const mergeTradingAccountsNew = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountsMergeNewResponse>(
      {url: `/admin/api/users/${userId}/merge_trading_accounts/new`, method: 'GET', signal
    },
      options);
    }




export const getMergeTradingAccountsNewQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'merge_trading_accounts','new'
    ] as const;
    }


export const getMergeTradingAccountsNewQueryOptions = <TData = Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMergeTradingAccountsNewQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mergeTradingAccountsNew>>> = ({ signal }) => mergeTradingAccountsNew(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MergeTradingAccountsNewQueryResult = NonNullable<Awaited<ReturnType<typeof mergeTradingAccountsNew>>>
export type MergeTradingAccountsNewQueryError = N404Response | N500Response


export function useMergeTradingAccountsNew<TData = Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mergeTradingAccountsNew>>,
          TError,
          Awaited<ReturnType<typeof mergeTradingAccountsNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMergeTradingAccountsNew<TData = Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mergeTradingAccountsNew>>,
          TError,
          Awaited<ReturnType<typeof mergeTradingAccountsNew>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMergeTradingAccountsNew<TData = Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a list of user mergeable trading accounts
 */

export function useMergeTradingAccountsNew<TData = Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMergeTradingAccountsNewQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Returns a list of user mergeable trading accounts
 */
export const prefetchMergeTradingAccountsNewQuery = async <TData = Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeTradingAccountsNew>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getMergeTradingAccountsNewQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Merge trading accounts
 */
export const mergeTradingAccountsPost = (
    userId: number,
    mergeTradingAccountsPostBody: MergeTradingAccountsPostBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountsMergeResponse>(
      {url: `/admin/api/users/${userId}/merge_trading_accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mergeTradingAccountsPostBody, signal
    },
      options);
    }




export const getMergeTradingAccountsPostMutationOptions = <TError = N404Response | MergeTradingAccountsPost422 | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeTradingAccountsPost>>, TError,{userId: number;data: MergeTradingAccountsPostBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeTradingAccountsPost>>, TError,{userId: number;data: MergeTradingAccountsPostBody}, TContext> => {

const mutationKey = ['mergeTradingAccountsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeTradingAccountsPost>>, {userId: number;data: MergeTradingAccountsPostBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  mergeTradingAccountsPost(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergeTradingAccountsPostMutationResult = NonNullable<Awaited<ReturnType<typeof mergeTradingAccountsPost>>>
    export type MergeTradingAccountsPostMutationBody = MergeTradingAccountsPostBody
    export type MergeTradingAccountsPostMutationError = N404Response | MergeTradingAccountsPost422 | N500Response

    /**
 * @summary Merge trading accounts
 */
export const useMergeTradingAccountsPost = <TError = N404Response | MergeTradingAccountsPost422 | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeTradingAccountsPost>>, TError,{userId: number;data: MergeTradingAccountsPostBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mergeTradingAccountsPost>>,
        TError,
        {userId: number;data: MergeTradingAccountsPostBody},
        TContext
      > => {
      return useMutation(getMergeTradingAccountsPostMutationOptions(options), queryClient);
    }

/**
 * @summary Get a user's affiliate profile
 */
export const getUserAffiliateProfile = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AffiliateProfile>(
      {url: `/admin/api/users/${userId}/affiliate_profile`, method: 'GET', signal
    },
      options);
    }




export const getGetUserAffiliateProfileQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'affiliate_profile'
    ] as const;
    }


export const getGetUserAffiliateProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAffiliateProfileQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAffiliateProfile>>> = ({ signal }) => getUserAffiliateProfile(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserAffiliateProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAffiliateProfile>>>
export type GetUserAffiliateProfileQueryError = N404Response | N500Response


export function useGetUserAffiliateProfile<TData = Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAffiliateProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserAffiliateProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAffiliateProfile<TData = Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAffiliateProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserAffiliateProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAffiliateProfile<TData = Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a user's affiliate profile
 */

export function useGetUserAffiliateProfile<TData = Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserAffiliateProfileQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a user's affiliate profile
 */
export const prefetchGetUserAffiliateProfileQuery = async <TData = Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAffiliateProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserAffiliateProfileQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Reassign an existing affiliate discount tier and/or toggle on-demand affiliate payouts.
 * @summary Update a user's affiliate profile
 */
export const updateUserAffiliateProfile = (
    userId: number,
    affiliateProfileUpdateRequestBody: AffiliateProfileUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AffiliateProfile>(
      {url: `/admin/api/users/${userId}/affiliate_profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: affiliateProfileUpdateRequestBody, signal
    },
      options);
    }




export const getUpdateUserAffiliateProfileMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserAffiliateProfile>>, TError,{userId: number;data: AffiliateProfileUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserAffiliateProfile>>, TError,{userId: number;data: AffiliateProfileUpdateRequestBody}, TContext> => {

const mutationKey = ['updateUserAffiliateProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserAffiliateProfile>>, {userId: number;data: AffiliateProfileUpdateRequestBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUserAffiliateProfile(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserAffiliateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserAffiliateProfile>>>
    export type UpdateUserAffiliateProfileMutationBody = AffiliateProfileUpdateRequestBody
    export type UpdateUserAffiliateProfileMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update a user's affiliate profile
 */
export const useUpdateUserAffiliateProfile = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserAffiliateProfile>>, TError,{userId: number;data: AffiliateProfileUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserAffiliateProfile>>,
        TError,
        {userId: number;data: AffiliateProfileUpdateRequestBody},
        TContext
      > => {
      return useMutation(getUpdateUserAffiliateProfileMutationOptions(options), queryClient);
    }

/**
 * @summary Get total referrals for a given user
 */
export const getTotalReferralsForUser = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TotalReferralsResponse>(
      {url: `/admin/api/users/${userId}/referrals`, method: 'GET', signal
    },
      options);
    }




export const getGetTotalReferralsForUserQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'referrals'
    ] as const;
    }


export const getGetTotalReferralsForUserQueryOptions = <TData = Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTotalReferralsForUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTotalReferralsForUser>>> = ({ signal }) => getTotalReferralsForUser(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTotalReferralsForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getTotalReferralsForUser>>>
export type GetTotalReferralsForUserQueryError = N404Response | N500Response


export function useGetTotalReferralsForUser<TData = Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalReferralsForUser>>,
          TError,
          Awaited<ReturnType<typeof getTotalReferralsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTotalReferralsForUser<TData = Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalReferralsForUser>>,
          TError,
          Awaited<ReturnType<typeof getTotalReferralsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTotalReferralsForUser<TData = Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get total referrals for a given user
 */

export function useGetTotalReferralsForUser<TData = Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTotalReferralsForUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get total referrals for a given user
 */
export const prefetchGetTotalReferralsForUserQuery = async <TData = Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferralsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTotalReferralsForUserQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get referrals widgets per user
 */
export const getUsersReferralsWidgets = (
    userId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserReferralsWidgetsResponse>(
      {url: `/admin/api/users/${userId}/referrals/widgets`, method: 'GET', signal
    },
      options);
    }




export const getGetUsersReferralsWidgetsQueryKey = (userId: number,) => {
    return [
    'admin','api','users',userId,'referrals','widgets'
    ] as const;
    }


export const getGetUsersReferralsWidgetsQueryOptions = <TData = Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError = N404Response | N500Response>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersReferralsWidgetsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersReferralsWidgets>>> = ({ signal }) => getUsersReferralsWidgets(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersReferralsWidgetsQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersReferralsWidgets>>>
export type GetUsersReferralsWidgetsQueryError = N404Response | N500Response


export function useGetUsersReferralsWidgets<TData = Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError = N404Response | N500Response>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersReferralsWidgets>>,
          TError,
          Awaited<ReturnType<typeof getUsersReferralsWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersReferralsWidgets<TData = Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersReferralsWidgets>>,
          TError,
          Awaited<ReturnType<typeof getUsersReferralsWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersReferralsWidgets<TData = Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get referrals widgets per user
 */

export function useGetUsersReferralsWidgets<TData = Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError = N404Response | N500Response>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersReferralsWidgetsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get referrals widgets per user
 */
export const prefetchGetUsersReferralsWidgetsQuery = async <TData = Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUsersReferralsWidgetsQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get referrals
 */
export const getTotalReferrals = (
    params?: GetTotalReferralsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetTotalReferrals200>(
      {url: `/admin/api/referrals`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTotalReferralsQueryKey = (params?: GetTotalReferralsParams,) => {
    return [
    'admin','api','referrals', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTotalReferralsQueryOptions = <TData = Awaited<ReturnType<typeof getTotalReferrals>>, TError = N404Response | N500Response>(params?: GetTotalReferralsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferrals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTotalReferralsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTotalReferrals>>> = ({ signal }) => getTotalReferrals(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTotalReferrals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTotalReferralsQueryResult = NonNullable<Awaited<ReturnType<typeof getTotalReferrals>>>
export type GetTotalReferralsQueryError = N404Response | N500Response


export function useGetTotalReferrals<TData = Awaited<ReturnType<typeof getTotalReferrals>>, TError = N404Response | N500Response>(
 params: undefined |  GetTotalReferralsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferrals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalReferrals>>,
          TError,
          Awaited<ReturnType<typeof getTotalReferrals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTotalReferrals<TData = Awaited<ReturnType<typeof getTotalReferrals>>, TError = N404Response | N500Response>(
 params?: GetTotalReferralsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferrals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalReferrals>>,
          TError,
          Awaited<ReturnType<typeof getTotalReferrals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTotalReferrals<TData = Awaited<ReturnType<typeof getTotalReferrals>>, TError = N404Response | N500Response>(
 params?: GetTotalReferralsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferrals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get referrals
 */

export function useGetTotalReferrals<TData = Awaited<ReturnType<typeof getTotalReferrals>>, TError = N404Response | N500Response>(
 params?: GetTotalReferralsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferrals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTotalReferralsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get referrals
 */
export const prefetchGetTotalReferralsQuery = async <TData = Awaited<ReturnType<typeof getTotalReferrals>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetTotalReferralsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTotalReferrals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTotalReferralsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get referrals widgets
 */
export const getReferralsWidgets = (
    params?: GetReferralsWidgetsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ReferralsWidgetsResponse>(
      {url: `/admin/api/referrals/widgets`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetReferralsWidgetsQueryKey = (params?: GetReferralsWidgetsParams,) => {
    return [
    'admin','api','referrals','widgets', ...(params ? [params] : [])
    ] as const;
    }


export const getGetReferralsWidgetsQueryOptions = <TData = Awaited<ReturnType<typeof getReferralsWidgets>>, TError = N404Response | N500Response>(params?: GetReferralsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralsWidgetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferralsWidgets>>> = ({ signal }) => getReferralsWidgets(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferralsWidgets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferralsWidgetsQueryResult = NonNullable<Awaited<ReturnType<typeof getReferralsWidgets>>>
export type GetReferralsWidgetsQueryError = N404Response | N500Response


export function useGetReferralsWidgets<TData = Awaited<ReturnType<typeof getReferralsWidgets>>, TError = N404Response | N500Response>(
 params: undefined |  GetReferralsWidgetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralsWidgets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferralsWidgets>>,
          TError,
          Awaited<ReturnType<typeof getReferralsWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralsWidgets<TData = Awaited<ReturnType<typeof getReferralsWidgets>>, TError = N404Response | N500Response>(
 params?: GetReferralsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralsWidgets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferralsWidgets>>,
          TError,
          Awaited<ReturnType<typeof getReferralsWidgets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralsWidgets<TData = Awaited<ReturnType<typeof getReferralsWidgets>>, TError = N404Response | N500Response>(
 params?: GetReferralsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get referrals widgets
 */

export function useGetReferralsWidgets<TData = Awaited<ReturnType<typeof getReferralsWidgets>>, TError = N404Response | N500Response>(
 params?: GetReferralsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferralsWidgetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get referrals widgets
 */
export const prefetchGetReferralsWidgetsQuery = async <TData = Awaited<ReturnType<typeof getReferralsWidgets>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetReferralsWidgetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralsWidgets>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetReferralsWidgetsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List notes for a given resource
 */
export const listNotesForResource = (
    resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params?: ListNotesForResourceParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NotesListResponse>(
      {url: `/admin/api/${resourceType}/${resourceId}/notes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListNotesForResourceQueryKey = (resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params?: ListNotesForResourceParams,) => {
    return [
    'admin','api',resourceType,resourceId,'notes', ...(params ? [params] : [])
    ] as const;
    }


export const getListNotesForResourceQueryOptions = <TData = Awaited<ReturnType<typeof listNotesForResource>>, TError = N404Response | N500Response>(resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params?: ListNotesForResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotesForResource>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotesForResourceQueryKey(resourceType,resourceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotesForResource>>> = ({ signal }) => listNotesForResource(resourceType,resourceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: resourceType !== null && resourceType !== undefined && resourceId !== null && resourceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotesForResource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotesForResourceQueryResult = NonNullable<Awaited<ReturnType<typeof listNotesForResource>>>
export type ListNotesForResourceQueryError = N404Response | N500Response


export function useListNotesForResource<TData = Awaited<ReturnType<typeof listNotesForResource>>, TError = N404Response | N500Response>(
 resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params: undefined |  ListNotesForResourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotesForResource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotesForResource>>,
          TError,
          Awaited<ReturnType<typeof listNotesForResource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotesForResource<TData = Awaited<ReturnType<typeof listNotesForResource>>, TError = N404Response | N500Response>(
 resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params?: ListNotesForResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotesForResource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotesForResource>>,
          TError,
          Awaited<ReturnType<typeof listNotesForResource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotesForResource<TData = Awaited<ReturnType<typeof listNotesForResource>>, TError = N404Response | N500Response>(
 resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params?: ListNotesForResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotesForResource>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List notes for a given resource
 */

export function useListNotesForResource<TData = Awaited<ReturnType<typeof listNotesForResource>>, TError = N404Response | N500Response>(
 resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params?: ListNotesForResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotesForResource>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotesForResourceQueryOptions(resourceType,resourceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List notes for a given resource
 */
export const prefetchListNotesForResourceQuery = async <TData = Awaited<ReturnType<typeof listNotesForResource>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    params?: ListNotesForResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotesForResource>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListNotesForResourceQueryOptions(resourceType,resourceId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Adds a note to a resource. Valid `id` along with the `body` for the note must be provided. The note will be created by the current authenticated user. If `type` is omitted, the note is created as `user`. System notes are created internally only and cannot be created through this endpoint. Risk notes can be created only by super users or users with risk, senior risk, admin, and super admin roles.
 * @summary Create a new note for a given resource
 */
export const createResourceNote = (
    resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    noteRequestBody: NoteRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NoteApiResponse>(
      {url: `/admin/api/${resourceType}/${resourceId}/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: noteRequestBody, signal
    },
      options);
    }




export const getCreateResourceNoteMutationOptions = <TError = ResourceNotFoundError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: NoteRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: NoteRequestBody}, TContext> => {

const mutationKey = ['createResourceNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResourceNote>>, {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: NoteRequestBody}> = (props) => {
          const {resourceType,resourceId,data} = props ?? {};

          return  createResourceNote(resourceType,resourceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createResourceNote>>>
    export type CreateResourceNoteMutationBody = NoteRequestBody
    export type CreateResourceNoteMutationError = ResourceNotFoundError | InvalidRecordError | InternalServerError

    /**
 * @summary Create a new note for a given resource
 */
export const useCreateResourceNote = <TError = ResourceNotFoundError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: NoteRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResourceNote>>,
        TError,
        {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: NoteRequestBody},
        TContext
      > => {
      return useMutation(getCreateResourceNoteMutationOptions(options), queryClient);
    }

/**
 * @summary Update a specific note for a given resource
 */
export const updateAResourceNote = (
    resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    id: number,
    noteUpdateRequestBody: NoteUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NoteApiResponse>(
      {url: `/admin/api/${resourceType}/${resourceId}/notes/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: noteUpdateRequestBody, signal
    },
      options);
    }




export const getUpdateAResourceNoteMutationOptions = <TError = ApiError | ResourceNotFoundError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number;data: NoteUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number;data: NoteUpdateRequestBody}, TContext> => {

const mutationKey = ['updateAResourceNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAResourceNote>>, {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number;data: NoteUpdateRequestBody}> = (props) => {
          const {resourceType,resourceId,id,data} = props ?? {};

          return  updateAResourceNote(resourceType,resourceId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAResourceNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateAResourceNote>>>
    export type UpdateAResourceNoteMutationBody = NoteUpdateRequestBody
    export type UpdateAResourceNoteMutationError = ApiError | ResourceNotFoundError | InvalidRecordError | InternalServerError

    /**
 * @summary Update a specific note for a given resource
 */
export const useUpdateAResourceNote = <TError = ApiError | ResourceNotFoundError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number;data: NoteUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAResourceNote>>,
        TError,
        {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number;data: NoteUpdateRequestBody},
        TContext
      > => {
      return useMutation(getUpdateAResourceNoteMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a specific note for a given resource
 */
export const deleteAResourceNote = (
    resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DeleteAResourceNote200>(
      {url: `/admin/api/${resourceType}/${resourceId}/notes/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAResourceNoteMutationOptions = <TError = ApiError | ResourceNotFoundError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number}, TContext> => {

const mutationKey = ['deleteAResourceNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAResourceNote>>, {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number}> = (props) => {
          const {resourceType,resourceId,id} = props ?? {};

          return  deleteAResourceNote(resourceType,resourceId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAResourceNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAResourceNote>>>

    export type DeleteAResourceNoteMutationError = ApiError | ResourceNotFoundError | InvalidRecordError | InternalServerError

    /**
 * @summary Delete a specific note for a given resource
 */
export const useDeleteAResourceNote = <TError = ApiError | ResourceNotFoundError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAResourceNote>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAResourceNote>>,
        TError,
        {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteAResourceNoteMutationOptions(options), queryClient);
    }

/**
 * @summary List search filters for a current user for specific resource_type
 */
export const listSearchFilters = (
    params: ListSearchFiltersParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<SearchFiltersListResponse>(
      {url: `/admin/api/search_filters`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListSearchFiltersQueryKey = (params?: ListSearchFiltersParams,) => {
    return [
    'admin','api','search_filters', ...(params ? [params] : [])
    ] as const;
    }


export const getListSearchFiltersQueryOptions = <TData = Awaited<ReturnType<typeof listSearchFilters>>, TError = ResourceTypeNotSupportedError | InternalServerError>(params: ListSearchFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSearchFilters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSearchFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSearchFilters>>> = ({ signal }) => listSearchFilters(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSearchFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSearchFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof listSearchFilters>>>
export type ListSearchFiltersQueryError = ResourceTypeNotSupportedError | InternalServerError


export function useListSearchFilters<TData = Awaited<ReturnType<typeof listSearchFilters>>, TError = ResourceTypeNotSupportedError | InternalServerError>(
 params: ListSearchFiltersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSearchFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSearchFilters>>,
          TError,
          Awaited<ReturnType<typeof listSearchFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSearchFilters<TData = Awaited<ReturnType<typeof listSearchFilters>>, TError = ResourceTypeNotSupportedError | InternalServerError>(
 params: ListSearchFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSearchFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSearchFilters>>,
          TError,
          Awaited<ReturnType<typeof listSearchFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSearchFilters<TData = Awaited<ReturnType<typeof listSearchFilters>>, TError = ResourceTypeNotSupportedError | InternalServerError>(
 params: ListSearchFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSearchFilters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List search filters for a current user for specific resource_type
 */

export function useListSearchFilters<TData = Awaited<ReturnType<typeof listSearchFilters>>, TError = ResourceTypeNotSupportedError | InternalServerError>(
 params: ListSearchFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSearchFilters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSearchFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List search filters for a current user for specific resource_type
 */
export const prefetchListSearchFiltersQuery = async <TData = Awaited<ReturnType<typeof listSearchFilters>>, TError = ResourceTypeNotSupportedError | InternalServerError>(
 queryClient: QueryClient, params: ListSearchFiltersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSearchFilters>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListSearchFiltersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new search filter for a current user for specific resource_type
 */
export const createSearchFilterForUser = (
    createSearchFilterForUserBody: CreateSearchFilterForUserBody,
    params: CreateSearchFilterForUserParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CreateSearchFilterResponse>(
      {url: `/admin/api/search_filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSearchFilterForUserBody,
        params, signal
    },
      options);
    }




export const getCreateSearchFilterForUserMutationOptions = <TError = ResourceTypeNotSupportedError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSearchFilterForUser>>, TError,{data: CreateSearchFilterForUserBody;params: CreateSearchFilterForUserParams}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSearchFilterForUser>>, TError,{data: CreateSearchFilterForUserBody;params: CreateSearchFilterForUserParams}, TContext> => {

const mutationKey = ['createSearchFilterForUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSearchFilterForUser>>, {data: CreateSearchFilterForUserBody;params: CreateSearchFilterForUserParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createSearchFilterForUser(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSearchFilterForUserMutationResult = NonNullable<Awaited<ReturnType<typeof createSearchFilterForUser>>>
    export type CreateSearchFilterForUserMutationBody = CreateSearchFilterForUserBody
    export type CreateSearchFilterForUserMutationError = ResourceTypeNotSupportedError | InvalidRecordError | InternalServerError

    /**
 * @summary Create a new search filter for a current user for specific resource_type
 */
export const useCreateSearchFilterForUser = <TError = ResourceTypeNotSupportedError | InvalidRecordError | InternalServerError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSearchFilterForUser>>, TError,{data: CreateSearchFilterForUserBody;params: CreateSearchFilterForUserParams}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSearchFilterForUser>>,
        TError,
        {data: CreateSearchFilterForUserBody;params: CreateSearchFilterForUserParams},
        TContext
      > => {
      return useMutation(getCreateSearchFilterForUserMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a search filter for a current user for specific resource_type
 */
export const deleteSearchFilterForUser = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DeleteSearchFilterForUser200>(
      {url: `/admin/api/search_filters/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSearchFilterForUserMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSearchFilterForUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSearchFilterForUser>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSearchFilterForUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSearchFilterForUser>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSearchFilterForUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSearchFilterForUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSearchFilterForUser>>>

    export type DeleteSearchFilterForUserMutationError = N404Response | N500Response

    /**
 * @summary Delete a search filter for a current user for specific resource_type
 */
export const useDeleteSearchFilterForUser = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSearchFilterForUser>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSearchFilterForUser>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSearchFilterForUserMutationOptions(options), queryClient);
    }

/**
 * @summary List balance transactions for a given user
 */
export const listBalanceTransactionsForUser = (
    userId: number,
    params?: ListBalanceTransactionsForUserParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BalanceTransactionsListResponse>(
      {url: `/admin/api/users/${userId}/balance_transactions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListBalanceTransactionsForUserQueryKey = (userId: number,
    params?: ListBalanceTransactionsForUserParams,) => {
    return [
    'admin','api','users',userId,'balance_transactions', ...(params ? [params] : [])
    ] as const;
    }


export const getListBalanceTransactionsForUserQueryOptions = <TData = Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError = N404Response | N500Response>(userId: number,
    params?: ListBalanceTransactionsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBalanceTransactionsForUserQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>> = ({ signal }) => listBalanceTransactionsForUser(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBalanceTransactionsForUserQueryResult = NonNullable<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>>
export type ListBalanceTransactionsForUserQueryError = N404Response | N500Response


export function useListBalanceTransactionsForUser<TData = Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  ListBalanceTransactionsForUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBalanceTransactionsForUser>>,
          TError,
          Awaited<ReturnType<typeof listBalanceTransactionsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBalanceTransactionsForUser<TData = Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: ListBalanceTransactionsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBalanceTransactionsForUser>>,
          TError,
          Awaited<ReturnType<typeof listBalanceTransactionsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBalanceTransactionsForUser<TData = Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: ListBalanceTransactionsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List balance transactions for a given user
 */

export function useListBalanceTransactionsForUser<TData = Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError = N404Response | N500Response>(
 userId: number,
    params?: ListBalanceTransactionsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBalanceTransactionsForUserQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List balance transactions for a given user
 */
export const prefetchListBalanceTransactionsForUserQuery = async <TData = Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: ListBalanceTransactionsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactionsForUser>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListBalanceTransactionsForUserQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get balance transactions count for search filter and data for dropdowns
 */
export const getBalanceTransactionFilterMetadata = (
    userId: number,
    params?: GetBalanceTransactionFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BalanceTransactionsFilterMetadataResponse>(
      {url: `/admin/api/users/${userId}/balance_transactions/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetBalanceTransactionFilterMetadataQueryKey = (userId: number,
    params?: GetBalanceTransactionFilterMetadataParams,) => {
    return [
    'admin','api','users',userId,'balance_transactions','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetBalanceTransactionFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError = N404Response | N500Response>(userId: number,
    params?: GetBalanceTransactionFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBalanceTransactionFilterMetadataQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>> = ({ signal }) => getBalanceTransactionFilterMetadata(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBalanceTransactionFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>>
export type GetBalanceTransactionFilterMetadataQueryError = N404Response | N500Response


export function useGetBalanceTransactionFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params: undefined |  GetBalanceTransactionFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalanceTransactionFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetBalanceTransactionFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalanceTransactionFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetBalanceTransactionFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get balance transactions count for search filter and data for dropdowns
 */

export function useGetBalanceTransactionFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError = N404Response | N500Response>(
 userId: number,
    params?: GetBalanceTransactionFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBalanceTransactionFilterMetadataQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get balance transactions count for search filter and data for dropdowns
 */
export const prefetchGetBalanceTransactionFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, userId: number,
    params?: GetBalanceTransactionFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBalanceTransactionFilterMetadataQueryOptions(userId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List balance transactions
 */
export const listBalanceTransactions = (
    params?: ListBalanceTransactionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BalanceTransactionsListResponse>(
      {url: `/admin/api/balance_transactions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListBalanceTransactionsQueryKey = (params?: ListBalanceTransactionsParams,) => {
    return [
    'admin','api','balance_transactions', ...(params ? [params] : [])
    ] as const;
    }


export const getListBalanceTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof listBalanceTransactions>>, TError = N404Response | N500Response>(params?: ListBalanceTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBalanceTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBalanceTransactions>>> = ({ signal }) => listBalanceTransactions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBalanceTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof listBalanceTransactions>>>
export type ListBalanceTransactionsQueryError = N404Response | N500Response


export function useListBalanceTransactions<TData = Awaited<ReturnType<typeof listBalanceTransactions>>, TError = N404Response | N500Response>(
 params: undefined |  ListBalanceTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBalanceTransactions>>,
          TError,
          Awaited<ReturnType<typeof listBalanceTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBalanceTransactions<TData = Awaited<ReturnType<typeof listBalanceTransactions>>, TError = N404Response | N500Response>(
 params?: ListBalanceTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBalanceTransactions>>,
          TError,
          Awaited<ReturnType<typeof listBalanceTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBalanceTransactions<TData = Awaited<ReturnType<typeof listBalanceTransactions>>, TError = N404Response | N500Response>(
 params?: ListBalanceTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List balance transactions
 */

export function useListBalanceTransactions<TData = Awaited<ReturnType<typeof listBalanceTransactions>>, TError = N404Response | N500Response>(
 params?: ListBalanceTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBalanceTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List balance transactions
 */
export const prefetchListBalanceTransactionsQuery = async <TData = Awaited<ReturnType<typeof listBalanceTransactions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListBalanceTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBalanceTransactions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListBalanceTransactionsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get a balance transaction
 */
export const getBalanceTransaction = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BalanceTransactionDetails>(
      {url: `/admin/api/balance_transactions/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetBalanceTransactionQueryKey = (id: number,) => {
    return [
    'admin','api','balance_transactions',id
    ] as const;
    }


export const getGetBalanceTransactionQueryOptions = <TData = Awaited<ReturnType<typeof getBalanceTransaction>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransaction>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBalanceTransactionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalanceTransaction>>> = ({ signal }) => getBalanceTransaction(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransaction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBalanceTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof getBalanceTransaction>>>
export type GetBalanceTransactionQueryError = N404Response | N500Response


export function useGetBalanceTransaction<TData = Awaited<ReturnType<typeof getBalanceTransaction>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransaction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceTransaction>>,
          TError,
          Awaited<ReturnType<typeof getBalanceTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalanceTransaction<TData = Awaited<ReturnType<typeof getBalanceTransaction>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransaction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceTransaction>>,
          TError,
          Awaited<ReturnType<typeof getBalanceTransaction>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalanceTransaction<TData = Awaited<ReturnType<typeof getBalanceTransaction>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransaction>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a balance transaction
 */

export function useGetBalanceTransaction<TData = Awaited<ReturnType<typeof getBalanceTransaction>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransaction>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBalanceTransactionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a balance transaction
 */
export const prefetchGetBalanceTransactionQuery = async <TData = Awaited<ReturnType<typeof getBalanceTransaction>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransaction>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBalanceTransactionQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get balance transactions count for search filter and data for dropdowns for the index
 */
export const getBalanceTransactionIndexFilterMetadata = (
    params?: GetBalanceTransactionIndexFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BalanceTransactionsFilterMetadataResponse>(
      {url: `/admin/api/balance_transactions/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetBalanceTransactionIndexFilterMetadataQueryKey = (params?: GetBalanceTransactionIndexFilterMetadataParams,) => {
    return [
    'admin','api','balance_transactions','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetBalanceTransactionIndexFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError = N404Response | N500Response>(params?: GetBalanceTransactionIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBalanceTransactionIndexFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>> = ({ signal }) => getBalanceTransactionIndexFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBalanceTransactionIndexFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>>
export type GetBalanceTransactionIndexFilterMetadataQueryError = N404Response | N500Response


export function useGetBalanceTransactionIndexFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetBalanceTransactionIndexFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalanceTransactionIndexFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetBalanceTransactionIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalanceTransactionIndexFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetBalanceTransactionIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get balance transactions count for search filter and data for dropdowns for the index
 */

export function useGetBalanceTransactionIndexFilterMetadata<TData = Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetBalanceTransactionIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBalanceTransactionIndexFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get balance transactions count for search filter and data for dropdowns for the index
 */
export const prefetchGetBalanceTransactionIndexFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetBalanceTransactionIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalanceTransactionIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBalanceTransactionIndexFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List permission groups
 */
export const listPermissionGroups = (
    params?: ListPermissionGroupsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PermissionGroupsListResponse>(
      {url: `/admin/api/permission_groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPermissionGroupsQueryKey = (params?: ListPermissionGroupsParams,) => {
    return [
    'admin','api','permission_groups', ...(params ? [params] : [])
    ] as const;
    }


export const getListPermissionGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = N404Response | N500Response>(params?: ListPermissionGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPermissionGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPermissionGroups>>> = ({ signal }) => listPermissionGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPermissionGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listPermissionGroups>>>
export type ListPermissionGroupsQueryError = N404Response | N500Response


export function useListPermissionGroups<TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = N404Response | N500Response>(
 params: undefined |  ListPermissionGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPermissionGroups>>,
          TError,
          Awaited<ReturnType<typeof listPermissionGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPermissionGroups<TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = N404Response | N500Response>(
 params?: ListPermissionGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPermissionGroups>>,
          TError,
          Awaited<ReturnType<typeof listPermissionGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPermissionGroups<TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = N404Response | N500Response>(
 params?: ListPermissionGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List permission groups
 */

export function useListPermissionGroups<TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = N404Response | N500Response>(
 params?: ListPermissionGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPermissionGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List permission groups
 */
export const prefetchListPermissionGroupsQuery = async <TData = Awaited<ReturnType<typeof listPermissionGroups>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListPermissionGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPermissionGroups>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListPermissionGroupsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a permission group
 */
export const createPermissionGroup = (
    createPermissionGroupBody: CreatePermissionGroupBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PermissionGroupResponseBody>(
      {url: `/admin/api/permission_groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPermissionGroupBody, signal
    },
      options);
    }




export const getCreatePermissionGroupMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermissionGroup>>, TError,{data: CreatePermissionGroupBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPermissionGroup>>, TError,{data: CreatePermissionGroupBody}, TContext> => {

const mutationKey = ['createPermissionGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPermissionGroup>>, {data: CreatePermissionGroupBody}> = (props) => {
          const {data} = props ?? {};

          return  createPermissionGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePermissionGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createPermissionGroup>>>
    export type CreatePermissionGroupMutationBody = CreatePermissionGroupBody
    export type CreatePermissionGroupMutationError = N422Response | N500Response

    /**
 * @summary Create a permission group
 */
export const useCreatePermissionGroup = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermissionGroup>>, TError,{data: CreatePermissionGroupBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPermissionGroup>>,
        TError,
        {data: CreatePermissionGroupBody},
        TContext
      > => {
      return useMutation(getCreatePermissionGroupMutationOptions(options), queryClient);
    }

/**
 * @summary Get options for a new permission group
 */
export const getNewPermissionGroupOptions = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PermissionGroupNewResponse>(
      {url: `/admin/api/permission_groups/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewPermissionGroupOptionsQueryKey = () => {
    return [
    'admin','api','permission_groups','new'
    ] as const;
    }


export const getGetNewPermissionGroupOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewPermissionGroupOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>> = ({ signal }) => getNewPermissionGroupOptions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewPermissionGroupOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>>
export type GetNewPermissionGroupOptionsQueryError = N404Response | N500Response


export function useGetNewPermissionGroupOptions<TData = Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPermissionGroupOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewPermissionGroupOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPermissionGroupOptions<TData = Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPermissionGroupOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewPermissionGroupOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPermissionGroupOptions<TData = Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for a new permission group
 */

export function useGetNewPermissionGroupOptions<TData = Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewPermissionGroupOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for a new permission group
 */
export const prefetchGetNewPermissionGroupOptionsQuery = async <TData = Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPermissionGroupOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewPermissionGroupOptionsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get a permission group
 */
export const getPermissionGroup = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PermissionGroupDetailed>(
      {url: `/admin/api/permission_groups/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetPermissionGroupQueryKey = (id: number,) => {
    return [
    'admin','api','permission_groups',id
    ] as const;
    }


export const getGetPermissionGroupQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionGroup>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionGroupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionGroup>>> = ({ signal }) => getPermissionGroup(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPermissionGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionGroup>>>
export type GetPermissionGroupQueryError = N404Response | N500Response


export function useGetPermissionGroup<TData = Awaited<ReturnType<typeof getPermissionGroup>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionGroup>>,
          TError,
          Awaited<ReturnType<typeof getPermissionGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionGroup<TData = Awaited<ReturnType<typeof getPermissionGroup>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionGroup>>,
          TError,
          Awaited<ReturnType<typeof getPermissionGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionGroup<TData = Awaited<ReturnType<typeof getPermissionGroup>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a permission group
 */

export function useGetPermissionGroup<TData = Awaited<ReturnType<typeof getPermissionGroup>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPermissionGroupQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a permission group
 */
export const prefetchGetPermissionGroupQuery = async <TData = Awaited<ReturnType<typeof getPermissionGroup>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroup>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPermissionGroupQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update a permission group
 */
export const updatePermissionGroup = (
    id: number,
    updatePermissionGroupBody: UpdatePermissionGroupBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PermissionGroupResponseBody>(
      {url: `/admin/api/permission_groups/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePermissionGroupBody, signal
    },
      options);
    }




export const getUpdatePermissionGroupMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePermissionGroup>>, TError,{id: number;data: UpdatePermissionGroupBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePermissionGroup>>, TError,{id: number;data: UpdatePermissionGroupBody}, TContext> => {

const mutationKey = ['updatePermissionGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePermissionGroup>>, {id: number;data: UpdatePermissionGroupBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePermissionGroup(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePermissionGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updatePermissionGroup>>>
    export type UpdatePermissionGroupMutationBody = UpdatePermissionGroupBody
    export type UpdatePermissionGroupMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update a permission group
 */
export const useUpdatePermissionGroup = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePermissionGroup>>, TError,{id: number;data: UpdatePermissionGroupBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePermissionGroup>>,
        TError,
        {id: number;data: UpdatePermissionGroupBody},
        TContext
      > => {
      return useMutation(getUpdatePermissionGroupMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a permission group
 */
export const deletePermissionGroup = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PermissionGroupResponseBody>(
      {url: `/admin/api/permission_groups/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePermissionGroupMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePermissionGroup>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePermissionGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePermissionGroup>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePermissionGroup(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePermissionGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deletePermissionGroup>>>

    export type DeletePermissionGroupMutationError = N404Response | N500Response

    /**
 * @summary Delete a permission group
 */
export const useDeletePermissionGroup = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionGroup>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePermissionGroup>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePermissionGroupMutationOptions(options), queryClient);
    }

/**
 * @summary Get permission group data for editing
 */
export const getPermissionGroupEditData = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PermissionGroupEditResponse>(
      {url: `/admin/api/permission_groups/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetPermissionGroupEditDataQueryKey = (id: number,) => {
    return [
    'admin','api','permission_groups',id,'edit'
    ] as const;
    }


export const getGetPermissionGroupEditDataQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionGroupEditDataQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionGroupEditData>>> = ({ signal }) => getPermissionGroupEditData(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPermissionGroupEditDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionGroupEditData>>>
export type GetPermissionGroupEditDataQueryError = N404Response | N500Response


export function useGetPermissionGroupEditData<TData = Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionGroupEditData>>,
          TError,
          Awaited<ReturnType<typeof getPermissionGroupEditData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionGroupEditData<TData = Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionGroupEditData>>,
          TError,
          Awaited<ReturnType<typeof getPermissionGroupEditData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionGroupEditData<TData = Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get permission group data for editing
 */

export function useGetPermissionGroupEditData<TData = Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPermissionGroupEditDataQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get permission group data for editing
 */
export const prefetchGetPermissionGroupEditDataQuery = async <TData = Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionGroupEditData>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPermissionGroupEditDataQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List coupons
 */
export const listCoupons = (
    params?: ListCouponsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CouponsListResponse>(
      {url: `/admin/api/coupons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListCouponsQueryKey = (params?: ListCouponsParams,) => {
    return [
    'admin','api','coupons', ...(params ? [params] : [])
    ] as const;
    }


export const getListCouponsQueryOptions = <TData = Awaited<ReturnType<typeof listCoupons>>, TError = N404Response | N500Response>(params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCouponsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCoupons>>> = ({ signal }) => listCoupons(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCouponsQueryResult = NonNullable<Awaited<ReturnType<typeof listCoupons>>>
export type ListCouponsQueryError = N404Response | N500Response


export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = N404Response | N500Response>(
 params: undefined |  ListCouponsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoupons>>,
          TError,
          Awaited<ReturnType<typeof listCoupons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = N404Response | N500Response>(
 params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCoupons>>,
          TError,
          Awaited<ReturnType<typeof listCoupons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = N404Response | N500Response>(
 params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List coupons
 */

export function useListCoupons<TData = Awaited<ReturnType<typeof listCoupons>>, TError = N404Response | N500Response>(
 params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCouponsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List coupons
 */
export const prefetchListCouponsQuery = async <TData = Awaited<ReturnType<typeof listCoupons>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListCouponsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCoupons>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListCouponsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new coupon
 */
export const createCoupon = (
    createCouponRequestBody: CreateCouponRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonResponseBody>(
      {url: `/admin/api/coupons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCouponRequestBody, signal
    },
      options);
    }




export const getCreateCouponMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoupon>>, TError,{data: CreateCouponRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCoupon>>, TError,{data: CreateCouponRequestBody}, TContext> => {

const mutationKey = ['createCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCoupon>>, {data: CreateCouponRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createCoupon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof createCoupon>>>
    export type CreateCouponMutationBody = CreateCouponRequestBody
    export type CreateCouponMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create a new coupon
 */
export const useCreateCoupon = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoupon>>, TError,{data: CreateCouponRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCoupon>>,
        TError,
        {data: CreateCouponRequestBody},
        TContext
      > => {
      return useMutation(getCreateCouponMutationOptions(options), queryClient);
    }

/**
 * @summary Get coupons count for search filter and data for dropdowns
 */
export const getCouponsFilterMetadata = (
    params?: GetCouponsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CouponsFilterMetadataResponse>(
      {url: `/admin/api/coupons/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCouponsFilterMetadataQueryKey = (params?: GetCouponsFilterMetadataParams,) => {
    return [
    'admin','api','coupons','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetCouponsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError = N404Response | N500Response>(params?: GetCouponsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponsFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCouponsFilterMetadata>>> = ({ signal }) => getCouponsFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getCouponsFilterMetadata>>>
export type GetCouponsFilterMetadataQueryError = N404Response | N500Response


export function useGetCouponsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetCouponsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCouponsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCouponsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCouponsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCouponsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get coupons count for search filter and data for dropdowns
 */

export function useGetCouponsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCouponsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponsFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get coupons count for search filter and data for dropdowns
 */
export const prefetchGetCouponsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetCouponsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCouponsFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List audit logs
 */
export const listAuditLogs = (
    params?: ListAuditLogsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AuditLogsListResponse>(
      {url: `/admin/api/audit_logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAuditLogsQueryKey = (params?: ListAuditLogsParams,) => {
    return [
    'admin','api','audit_logs', ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = N404Response | N500Response>(params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = N404Response | N500Response


export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = N404Response | N500Response>(
 params: undefined |  ListAuditLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = N404Response | N500Response>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = N404Response | N500Response>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List audit logs
 */

export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = N404Response | N500Response>(
 params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List audit logs
 */
export const prefetchListAuditLogsQuery = async <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListAuditLogsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get audit logs filter metadata
 */
export const getAuditLogsFilterMetadata = (
    params?: GetAuditLogsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AuditLogsFilterMetadataResponse>(
      {url: `/admin/api/audit_logs/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAuditLogsFilterMetadataQueryKey = (params?: GetAuditLogsFilterMetadataParams,) => {
    return [
    'admin','api','audit_logs','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetAuditLogsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError = N404Response | N500Response>(params?: GetAuditLogsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditLogsFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>> = ({ signal }) => getAuditLogsFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditLogsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>>
export type GetAuditLogsFilterMetadataQueryError = N404Response | N500Response


export function useGetAuditLogsFilterMetadata<TData = Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetAuditLogsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditLogsFilterMetadata<TData = Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetAuditLogsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditLogsFilterMetadata<TData = Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetAuditLogsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get audit logs filter metadata
 */

export function useGetAuditLogsFilterMetadata<TData = Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetAuditLogsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditLogsFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get audit logs filter metadata
 */
export const prefetchGetAuditLogsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetAuditLogsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditLogsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAuditLogsFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List withdrawals
 */
export const listWithdrawals = (
    params?: ListWithdrawalsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<WithdrawalsListResponse>(
      {url: `/admin/api/withdrawals`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListWithdrawalsQueryKey = (params?: ListWithdrawalsParams,) => {
    return [
    'admin','api','withdrawals', ...(params ? [params] : [])
    ] as const;
    }


export const getListWithdrawalsQueryOptions = <TData = Awaited<ReturnType<typeof listWithdrawals>>, TError = N404Response | N500Response>(params?: ListWithdrawalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWithdrawals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWithdrawalsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWithdrawals>>> = ({ signal }) => listWithdrawals(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWithdrawals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWithdrawalsQueryResult = NonNullable<Awaited<ReturnType<typeof listWithdrawals>>>
export type ListWithdrawalsQueryError = N404Response | N500Response


export function useListWithdrawals<TData = Awaited<ReturnType<typeof listWithdrawals>>, TError = N404Response | N500Response>(
 params: undefined |  ListWithdrawalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWithdrawals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWithdrawals>>,
          TError,
          Awaited<ReturnType<typeof listWithdrawals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWithdrawals<TData = Awaited<ReturnType<typeof listWithdrawals>>, TError = N404Response | N500Response>(
 params?: ListWithdrawalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWithdrawals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWithdrawals>>,
          TError,
          Awaited<ReturnType<typeof listWithdrawals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWithdrawals<TData = Awaited<ReturnType<typeof listWithdrawals>>, TError = N404Response | N500Response>(
 params?: ListWithdrawalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWithdrawals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List withdrawals
 */

export function useListWithdrawals<TData = Awaited<ReturnType<typeof listWithdrawals>>, TError = N404Response | N500Response>(
 params?: ListWithdrawalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWithdrawals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWithdrawalsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List withdrawals
 */
export const prefetchListWithdrawalsQuery = async <TData = Awaited<ReturnType<typeof listWithdrawals>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListWithdrawalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWithdrawals>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListWithdrawalsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get withdrawal count for search filter and data for dropdowns
 */
export const getWithdrawalsFilterMetadata = (
    params?: GetWithdrawalsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<WithdrawalsFilterMetadataResponse>(
      {url: `/admin/api/withdrawals/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWithdrawalsFilterMetadataQueryKey = (params?: GetWithdrawalsFilterMetadataParams,) => {
    return [
    'admin','api','withdrawals','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetWithdrawalsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError = N404Response | N500Response>(params?: GetWithdrawalsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWithdrawalsFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>> = ({ signal }) => getWithdrawalsFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWithdrawalsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>>
export type GetWithdrawalsFilterMetadataQueryError = N404Response | N500Response


export function useGetWithdrawalsFilterMetadata<TData = Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetWithdrawalsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWithdrawalsFilterMetadata<TData = Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetWithdrawalsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWithdrawalsFilterMetadata<TData = Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetWithdrawalsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get withdrawal count for search filter and data for dropdowns
 */

export function useGetWithdrawalsFilterMetadata<TData = Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetWithdrawalsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWithdrawalsFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get withdrawal count for search filter and data for dropdowns
 */
export const prefetchGetWithdrawalsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetWithdrawalsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawalsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetWithdrawalsFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get withdrawal details
 */
export const getWithdrawal = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<WithdrawalDetailedResponse>(
      {url: `/admin/api/withdrawals/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetWithdrawalQueryKey = (id: number,) => {
    return [
    'admin','api','withdrawals',id
    ] as const;
    }


export const getGetWithdrawalQueryOptions = <TData = Awaited<ReturnType<typeof getWithdrawal>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawal>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWithdrawalQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWithdrawal>>> = ({ signal }) => getWithdrawal(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWithdrawal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWithdrawalQueryResult = NonNullable<Awaited<ReturnType<typeof getWithdrawal>>>
export type GetWithdrawalQueryError = N404Response | N500Response


export function useGetWithdrawal<TData = Awaited<ReturnType<typeof getWithdrawal>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWithdrawal>>,
          TError,
          Awaited<ReturnType<typeof getWithdrawal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWithdrawal<TData = Awaited<ReturnType<typeof getWithdrawal>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWithdrawal>>,
          TError,
          Awaited<ReturnType<typeof getWithdrawal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWithdrawal<TData = Awaited<ReturnType<typeof getWithdrawal>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawal>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get withdrawal details
 */

export function useGetWithdrawal<TData = Awaited<ReturnType<typeof getWithdrawal>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawal>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWithdrawalQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get withdrawal details
 */
export const prefetchGetWithdrawalQuery = async <TData = Awaited<ReturnType<typeof getWithdrawal>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWithdrawal>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetWithdrawalQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Approve a withdrawal
 */
export const approveWithdrawal = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<WithdrawalActionResponse>(
      {url: `/admin/api/withdrawals/${id}/approve`, method: 'PATCH', signal
    },
      options);
    }




export const getApproveWithdrawalMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveWithdrawal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveWithdrawal>>, TError,{id: number}, TContext> => {

const mutationKey = ['approveWithdrawal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveWithdrawal>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  approveWithdrawal(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveWithdrawalMutationResult = NonNullable<Awaited<ReturnType<typeof approveWithdrawal>>>

    export type ApproveWithdrawalMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Approve a withdrawal
 */
export const useApproveWithdrawal = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveWithdrawal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveWithdrawal>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApproveWithdrawalMutationOptions(options), queryClient);
    }

/**
 * @summary Reject a withdrawal
 */
export const rejectWithdrawal = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<WithdrawalActionResponse>(
      {url: `/admin/api/withdrawals/${id}/reject`, method: 'PATCH', signal
    },
      options);
    }




export const getRejectWithdrawalMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectWithdrawal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectWithdrawal>>, TError,{id: number}, TContext> => {

const mutationKey = ['rejectWithdrawal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectWithdrawal>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  rejectWithdrawal(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectWithdrawalMutationResult = NonNullable<Awaited<ReturnType<typeof rejectWithdrawal>>>

    export type RejectWithdrawalMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Reject a withdrawal
 */
export const useRejectWithdrawal = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectWithdrawal>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectWithdrawal>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRejectWithdrawalMutationOptions(options), queryClient);
    }

/**
 * @summary List IB profiles
 */
export const listIbProfiles = (
    params?: ListIbProfilesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IbProfilesListResponse>(
      {url: `/admin/api/ib_profiles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListIbProfilesQueryKey = (params?: ListIbProfilesParams,) => {
    return [
    'admin','api','ib_profiles', ...(params ? [params] : [])
    ] as const;
    }


export const getListIbProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listIbProfiles>>, TError = N404Response | N500Response>(params?: ListIbProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIbProfiles>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIbProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIbProfiles>>> = ({ signal }) => listIbProfiles(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIbProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIbProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listIbProfiles>>>
export type ListIbProfilesQueryError = N404Response | N500Response


export function useListIbProfiles<TData = Awaited<ReturnType<typeof listIbProfiles>>, TError = N404Response | N500Response>(
 params: undefined |  ListIbProfilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIbProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIbProfiles>>,
          TError,
          Awaited<ReturnType<typeof listIbProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIbProfiles<TData = Awaited<ReturnType<typeof listIbProfiles>>, TError = N404Response | N500Response>(
 params?: ListIbProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIbProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIbProfiles>>,
          TError,
          Awaited<ReturnType<typeof listIbProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIbProfiles<TData = Awaited<ReturnType<typeof listIbProfiles>>, TError = N404Response | N500Response>(
 params?: ListIbProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIbProfiles>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List IB profiles
 */

export function useListIbProfiles<TData = Awaited<ReturnType<typeof listIbProfiles>>, TError = N404Response | N500Response>(
 params?: ListIbProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIbProfiles>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIbProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List IB profiles
 */
export const prefetchListIbProfilesQuery = async <TData = Awaited<ReturnType<typeof listIbProfiles>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListIbProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIbProfiles>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListIbProfilesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get IB profile count for search filter and data for dropdowns
 */
export const getIbProfilesFilterMetadata = (
    params?: GetIbProfilesFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IbProfilesFilterMetadataResponse>(
      {url: `/admin/api/ib_profiles/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetIbProfilesFilterMetadataQueryKey = (params?: GetIbProfilesFilterMetadataParams,) => {
    return [
    'admin','api','ib_profiles','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetIbProfilesFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError = N404Response | N500Response>(params?: GetIbProfilesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIbProfilesFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>> = ({ signal }) => getIbProfilesFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIbProfilesFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>>
export type GetIbProfilesFilterMetadataQueryError = N404Response | N500Response


export function useGetIbProfilesFilterMetadata<TData = Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetIbProfilesFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbProfilesFilterMetadata<TData = Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetIbProfilesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbProfilesFilterMetadata<TData = Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetIbProfilesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get IB profile count for search filter and data for dropdowns
 */

export function useGetIbProfilesFilterMetadata<TData = Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetIbProfilesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIbProfilesFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get IB profile count for search filter and data for dropdowns
 */
export const prefetchGetIbProfilesFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetIbProfilesFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfilesFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIbProfilesFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Returns the IB profile's identity (id, owning user, status, created_at) together with its IB onboarding questionnaire (the same questionnaire payload as `GET /admin/api/users/{userId}/questionnaires/ib_onboarding`) and applicable actions.
 * @summary Get IB profile details
 */
export const getIbProfile = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IbProfileDetail>(
      {url: `/admin/api/ib_profiles/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetIbProfileQueryKey = (id: number,) => {
    return [
    'admin','api','ib_profiles',id
    ] as const;
    }


export const getGetIbProfileQueryOptions = <TData = Awaited<ReturnType<typeof getIbProfile>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIbProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIbProfile>>> = ({ signal }) => getIbProfile(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIbProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIbProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getIbProfile>>>
export type GetIbProfileQueryError = N404Response | N500Response


export function useGetIbProfile<TData = Awaited<ReturnType<typeof getIbProfile>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIbProfile>>,
          TError,
          Awaited<ReturnType<typeof getIbProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbProfile<TData = Awaited<ReturnType<typeof getIbProfile>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIbProfile>>,
          TError,
          Awaited<ReturnType<typeof getIbProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIbProfile<TData = Awaited<ReturnType<typeof getIbProfile>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get IB profile details
 */

export function useGetIbProfile<TData = Awaited<ReturnType<typeof getIbProfile>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIbProfileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get IB profile details
 */
export const prefetchGetIbProfileQuery = async <TData = Awaited<ReturnType<typeof getIbProfile>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIbProfile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetIbProfileQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get coupon details
 */
export const getCoupon = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DetailedCoupon>(
      {url: `/admin/api/coupons/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetCouponQueryKey = (id: number,) => {
    return [
    'admin','api','coupons',id
    ] as const;
    }


export const getGetCouponQueryOptions = <TData = Awaited<ReturnType<typeof getCoupon>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupon>>> = ({ signal }) => getCoupon(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupon>>>
export type GetCouponQueryError = N404Response | N500Response


export function useGetCoupon<TData = Awaited<ReturnType<typeof getCoupon>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoupon>>,
          TError,
          Awaited<ReturnType<typeof getCoupon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoupon<TData = Awaited<ReturnType<typeof getCoupon>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoupon>>,
          TError,
          Awaited<ReturnType<typeof getCoupon>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCoupon<TData = Awaited<ReturnType<typeof getCoupon>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get coupon details
 */

export function useGetCoupon<TData = Awaited<ReturnType<typeof getCoupon>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get coupon details
 */
export const prefetchGetCouponQuery = async <TData = Awaited<ReturnType<typeof getCoupon>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCouponQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update coupon details
 */
export const updateCoupon = (
    id: number,
    updateCouponRequestBody: UpdateCouponRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonResponseBody>(
      {url: `/admin/api/coupons/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCouponRequestBody, signal
    },
      options);
    }




export const getUpdateCouponMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoupon>>, TError,{id: number;data: UpdateCouponRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCoupon>>, TError,{id: number;data: UpdateCouponRequestBody}, TContext> => {

const mutationKey = ['updateCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCoupon>>, {id: number;data: UpdateCouponRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCoupon(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCouponMutationResult = NonNullable<Awaited<ReturnType<typeof updateCoupon>>>
    export type UpdateCouponMutationBody = UpdateCouponRequestBody
    export type UpdateCouponMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update coupon details
 */
export const useUpdateCoupon = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoupon>>, TError,{id: number;data: UpdateCouponRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCoupon>>,
        TError,
        {id: number;data: UpdateCouponRequestBody},
        TContext
      > => {
      return useMutation(getUpdateCouponMutationOptions(options), queryClient);
    }

/**
 * @summary Delete coupon
 */
export const deleteCoupon = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonResponseBody>(
      {url: `/admin/api/coupons/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteCouponMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCoupon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCoupon>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCoupon(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCouponMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoupon>>>

    export type DeleteCouponMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Delete coupon
 */
export const useDeleteCoupon = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoupon>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCoupon>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCouponMutationOptions(options), queryClient);
    }

/**
 * @summary Get options for the new coupon
 */
export const getNewCouponOptions = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CouponsNewResponse>(
      {url: `/admin/api/coupons/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewCouponOptionsQueryKey = () => {
    return [
    'admin','api','coupons','new'
    ] as const;
    }


export const getGetNewCouponOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getNewCouponOptions>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCouponOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewCouponOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewCouponOptions>>> = ({ signal }) => getNewCouponOptions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewCouponOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewCouponOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getNewCouponOptions>>>
export type GetNewCouponOptionsQueryError = N404Response | N500Response


export function useGetNewCouponOptions<TData = Awaited<ReturnType<typeof getNewCouponOptions>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCouponOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewCouponOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewCouponOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewCouponOptions<TData = Awaited<ReturnType<typeof getNewCouponOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCouponOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewCouponOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewCouponOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewCouponOptions<TData = Awaited<ReturnType<typeof getNewCouponOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCouponOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for the new coupon
 */

export function useGetNewCouponOptions<TData = Awaited<ReturnType<typeof getNewCouponOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCouponOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewCouponOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for the new coupon
 */
export const prefetchGetNewCouponOptionsQuery = async <TData = Awaited<ReturnType<typeof getNewCouponOptions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCouponOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewCouponOptionsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get coupon information needed to edit
 */
export const getCouponEditInformation = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CouponEditResponse>(
      {url: `/admin/api/coupons/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetCouponEditInformationQueryKey = (id: number,) => {
    return [
    'admin','api','coupons',id,'edit'
    ] as const;
    }


export const getGetCouponEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getCouponEditInformation>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponEditInformationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCouponEditInformation>>> = ({ signal }) => getCouponEditInformation(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCouponEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getCouponEditInformation>>>
export type GetCouponEditInformationQueryError = N404Response | N500Response


export function useGetCouponEditInformation<TData = Awaited<ReturnType<typeof getCouponEditInformation>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getCouponEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponEditInformation<TData = Awaited<ReturnType<typeof getCouponEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getCouponEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponEditInformation<TData = Awaited<ReturnType<typeof getCouponEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get coupon information needed to edit
 */

export function useGetCouponEditInformation<TData = Awaited<ReturnType<typeof getCouponEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponEditInformationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get coupon information needed to edit
 */
export const prefetchGetCouponEditInformationQuery = async <TData = Awaited<ReturnType<typeof getCouponEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCouponEditInformationQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get all redemptions for a specific coupon
 */
export const getCouponRedemptions = (
    couponId: number,
    params?: GetCouponRedemptionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetCouponRedemptions200>(
      {url: `/admin/api/coupons/${couponId}/redemptions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCouponRedemptionsQueryKey = (couponId: number,
    params?: GetCouponRedemptionsParams,) => {
    return [
    'admin','api','coupons',couponId,'redemptions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetCouponRedemptionsQueryOptions = <TData = Awaited<ReturnType<typeof getCouponRedemptions>>, TError = N404Response | N500Response>(couponId: number,
    params?: GetCouponRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponRedemptionsQueryKey(couponId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCouponRedemptions>>> = ({ signal }) => getCouponRedemptions(couponId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: couponId !== null && couponId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponRedemptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCouponRedemptions>>>
export type GetCouponRedemptionsQueryError = N404Response | N500Response


export function useGetCouponRedemptions<TData = Awaited<ReturnType<typeof getCouponRedemptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params: undefined |  GetCouponRedemptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponRedemptions>>,
          TError,
          Awaited<ReturnType<typeof getCouponRedemptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponRedemptions<TData = Awaited<ReturnType<typeof getCouponRedemptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetCouponRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponRedemptions>>,
          TError,
          Awaited<ReturnType<typeof getCouponRedemptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponRedemptions<TData = Awaited<ReturnType<typeof getCouponRedemptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetCouponRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all redemptions for a specific coupon
 */

export function useGetCouponRedemptions<TData = Awaited<ReturnType<typeof getCouponRedemptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetCouponRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponRedemptionsQueryOptions(couponId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get all redemptions for a specific coupon
 */
export const prefetchGetCouponRedemptionsQuery = async <TData = Awaited<ReturnType<typeof getCouponRedemptions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, couponId: number,
    params?: GetCouponRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCouponRedemptionsQueryOptions(couponId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get coupon redemptions filter metadata
 */
export const getCouponRedemptionsFilterMetadata = (
    couponId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<RedemptionsFilterMetadataResponse>(
      {url: `/admin/api/coupons/${couponId}/redemptions/filter_metadata`, method: 'GET', signal
    },
      options);
    }




export const getGetCouponRedemptionsFilterMetadataQueryKey = (couponId: number,) => {
    return [
    'admin','api','coupons',couponId,'redemptions','filter_metadata'
    ] as const;
    }


export const getGetCouponRedemptionsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError = N404Response | N500Response>(couponId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCouponRedemptionsFilterMetadataQueryKey(couponId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>> = ({ signal }) => getCouponRedemptionsFilterMetadata(couponId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: couponId !== null && couponId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCouponRedemptionsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>>
export type GetCouponRedemptionsFilterMetadataQueryError = N404Response | N500Response


export function useGetCouponRedemptionsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponRedemptionsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCouponRedemptionsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get coupon redemptions filter metadata
 */

export function useGetCouponRedemptionsFilterMetadata<TData = Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponRedemptionsFilterMetadataQueryOptions(couponId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get coupon redemptions filter metadata
 */
export const prefetchGetCouponRedemptionsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, couponId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCouponRedemptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCouponRedemptionsFilterMetadataQueryOptions(couponId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get all user exceptions for a specific coupon
 */
export const getUserExceptions = (
    couponId: number,
    params?: GetUserExceptionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserExceptionsListResponseBody>(
      {url: `/admin/api/coupons/${couponId}/user_exceptions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserExceptionsQueryKey = (couponId: number,
    params?: GetUserExceptionsParams,) => {
    return [
    'admin','api','coupons',couponId,'user_exceptions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserExceptionsQueryOptions = <TData = Awaited<ReturnType<typeof getUserExceptions>>, TError = N404Response | N500Response>(couponId: number,
    params?: GetUserExceptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserExceptionsQueryKey(couponId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserExceptions>>> = ({ signal }) => getUserExceptions(couponId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: couponId !== null && couponId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserExceptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserExceptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserExceptions>>>
export type GetUserExceptionsQueryError = N404Response | N500Response


export function useGetUserExceptions<TData = Awaited<ReturnType<typeof getUserExceptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params: undefined |  GetUserExceptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExceptions>>,
          TError,
          Awaited<ReturnType<typeof getUserExceptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExceptions<TData = Awaited<ReturnType<typeof getUserExceptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetUserExceptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExceptions>>,
          TError,
          Awaited<ReturnType<typeof getUserExceptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExceptions<TData = Awaited<ReturnType<typeof getUserExceptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetUserExceptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user exceptions for a specific coupon
 */

export function useGetUserExceptions<TData = Awaited<ReturnType<typeof getUserExceptions>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetUserExceptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserExceptionsQueryOptions(couponId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get all user exceptions for a specific coupon
 */
export const prefetchGetUserExceptionsQuery = async <TData = Awaited<ReturnType<typeof getUserExceptions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, couponId: number,
    params?: GetUserExceptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserExceptionsQueryOptions(couponId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new user exception
 */
export const createUserException = (
    couponId: number,
    userExceptionRequestBody: UserExceptionRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserExceptionCommonResponseBody>(
      {url: `/admin/api/coupons/${couponId}/user_exceptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userExceptionRequestBody, signal
    },
      options);
    }




export const getCreateUserExceptionMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserException>>, TError,{couponId: number;data: UserExceptionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserException>>, TError,{couponId: number;data: UserExceptionRequestBody}, TContext> => {

const mutationKey = ['createUserException'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserException>>, {couponId: number;data: UserExceptionRequestBody}> = (props) => {
          const {couponId,data} = props ?? {};

          return  createUserException(couponId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserExceptionMutationResult = NonNullable<Awaited<ReturnType<typeof createUserException>>>
    export type CreateUserExceptionMutationBody = UserExceptionRequestBody
    export type CreateUserExceptionMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create a new user exception
 */
export const useCreateUserException = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserException>>, TError,{couponId: number;data: UserExceptionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserException>>,
        TError,
        {couponId: number;data: UserExceptionRequestBody},
        TContext
      > => {
      return useMutation(getCreateUserExceptionMutationOptions(options), queryClient);
    }

/**
 * @summary Get filter metadata for all user exceptions for a specific coupon
 */
export const getUserExceptionsFilterMetadata = (
    couponId: number,
    params?: GetUserExceptionsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetUserExceptionsFilterMetadata200>(
      {url: `/admin/api/coupons/${couponId}/user_exceptions/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserExceptionsFilterMetadataQueryKey = (couponId: number,
    params?: GetUserExceptionsFilterMetadataParams,) => {
    return [
    'admin','api','coupons',couponId,'user_exceptions','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserExceptionsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError = N404Response | N500Response>(couponId: number,
    params?: GetUserExceptionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserExceptionsFilterMetadataQueryKey(couponId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>> = ({ signal }) => getUserExceptionsFilterMetadata(couponId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: couponId !== null && couponId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserExceptionsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>>
export type GetUserExceptionsFilterMetadataQueryError = N404Response | N500Response


export function useGetUserExceptionsFilterMetadata<TData = Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number,
    params: undefined |  GetUserExceptionsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExceptionsFilterMetadata<TData = Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetUserExceptionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExceptionsFilterMetadata<TData = Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetUserExceptionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata for all user exceptions for a specific coupon
 */

export function useGetUserExceptionsFilterMetadata<TData = Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError = N404Response | N500Response>(
 couponId: number,
    params?: GetUserExceptionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserExceptionsFilterMetadataQueryOptions(couponId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata for all user exceptions for a specific coupon
 */
export const prefetchGetUserExceptionsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, couponId: number,
    params?: GetUserExceptionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserExceptionsFilterMetadataQueryOptions(couponId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get user exception details
 */
export const getUserException = (
    couponId: number,
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserException>(
      {url: `/admin/api/coupons/${couponId}/user_exceptions/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserExceptionQueryKey = (couponId: number,
    id: number,) => {
    return [
    'admin','api','coupons',couponId,'user_exceptions',id
    ] as const;
    }


export const getGetUserExceptionQueryOptions = <TData = Awaited<ReturnType<typeof getUserException>>, TError = N404Response | N500Response>(couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserException>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserExceptionQueryKey(couponId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserException>>> = ({ signal }) => getUserException(couponId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: couponId !== null && couponId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserException>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserExceptionQueryResult = NonNullable<Awaited<ReturnType<typeof getUserException>>>
export type GetUserExceptionQueryError = N404Response | N500Response


export function useGetUserException<TData = Awaited<ReturnType<typeof getUserException>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserException>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserException>>,
          TError,
          Awaited<ReturnType<typeof getUserException>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserException<TData = Awaited<ReturnType<typeof getUserException>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserException>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserException>>,
          TError,
          Awaited<ReturnType<typeof getUserException>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserException<TData = Awaited<ReturnType<typeof getUserException>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserException>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user exception details
 */

export function useGetUserException<TData = Awaited<ReturnType<typeof getUserException>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserException>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserExceptionQueryOptions(couponId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user exception details
 */
export const prefetchGetUserExceptionQuery = async <TData = Awaited<ReturnType<typeof getUserException>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserException>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserExceptionQueryOptions(couponId,id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update user exception details
 */
export const updateUserException = (
    couponId: number,
    id: number,
    userExceptionRequestBody: UserExceptionRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserExceptionCommonResponseBody>(
      {url: `/admin/api/coupons/${couponId}/user_exceptions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userExceptionRequestBody, signal
    },
      options);
    }




export const getUpdateUserExceptionMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserException>>, TError,{couponId: number;id: number;data: UserExceptionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserException>>, TError,{couponId: number;id: number;data: UserExceptionRequestBody}, TContext> => {

const mutationKey = ['updateUserException'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserException>>, {couponId: number;id: number;data: UserExceptionRequestBody}> = (props) => {
          const {couponId,id,data} = props ?? {};

          return  updateUserException(couponId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserExceptionMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserException>>>
    export type UpdateUserExceptionMutationBody = UserExceptionRequestBody
    export type UpdateUserExceptionMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update user exception details
 */
export const useUpdateUserException = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserException>>, TError,{couponId: number;id: number;data: UserExceptionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserException>>,
        TError,
        {couponId: number;id: number;data: UserExceptionRequestBody},
        TContext
      > => {
      return useMutation(getUpdateUserExceptionMutationOptions(options), queryClient);
    }

/**
 * @summary Delete user exception
 */
export const deleteUserException = (
    couponId: number,
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserExceptionCommonResponseBody>(
      {url: `/admin/api/coupons/${couponId}/user_exceptions/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteUserExceptionMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserException>>, TError,{couponId: number;id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserException>>, TError,{couponId: number;id: number}, TContext> => {

const mutationKey = ['deleteUserException'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserException>>, {couponId: number;id: number}> = (props) => {
          const {couponId,id} = props ?? {};

          return  deleteUserException(couponId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserExceptionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserException>>>

    export type DeleteUserExceptionMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Delete user exception
 */
export const useDeleteUserException = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserException>>, TError,{couponId: number;id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserException>>,
        TError,
        {couponId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteUserExceptionMutationOptions(options), queryClient);
    }

/**
 * @summary Get user exception information needed to edit
 */
export const getUserExceptionEditInformation = (
    couponId: number,
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserExceptionEditResponse>(
      {url: `/admin/api/coupons/${couponId}/user_exceptions/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetUserExceptionEditInformationQueryKey = (couponId: number,
    id: number,) => {
    return [
    'admin','api','coupons',couponId,'user_exceptions',id,'edit'
    ] as const;
    }


export const getGetUserExceptionEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError = N404Response | N500Response>(couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserExceptionEditInformationQueryKey(couponId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserExceptionEditInformation>>> = ({ signal }) => getUserExceptionEditInformation(couponId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: couponId !== null && couponId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserExceptionEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getUserExceptionEditInformation>>>
export type GetUserExceptionEditInformationQueryError = N404Response | N500Response


export function useGetUserExceptionEditInformation<TData = Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExceptionEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getUserExceptionEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExceptionEditInformation<TData = Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExceptionEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getUserExceptionEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExceptionEditInformation<TData = Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user exception information needed to edit
 */

export function useGetUserExceptionEditInformation<TData = Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError = N404Response | N500Response>(
 couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserExceptionEditInformationQueryOptions(couponId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user exception information needed to edit
 */
export const prefetchGetUserExceptionEditInformationQuery = async <TData = Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, couponId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExceptionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserExceptionEditInformationQueryOptions(couponId,id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List tasks
 */
export const listTasks = (
    params?: ListTasksParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TasksListResponse>(
      {url: `/admin/api/tasks`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTasksQueryKey = (params?: ListTasksParams,) => {
    return [
    'admin','api','tasks', ...(params ? [params] : [])
    ] as const;
    }


export const getListTasksQueryOptions = <TData = Awaited<ReturnType<typeof listTasks>>, TError = N404Response | N500Response>(params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) => listTasks(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>
export type ListTasksQueryError = N404Response | N500Response


export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = N404Response | N500Response>(
 params: undefined |  ListTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = N404Response | N500Response>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = N404Response | N500Response>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tasks
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = N404Response | N500Response>(
 params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List tasks
 */
export const prefetchListTasksQuery = async <TData = Awaited<ReturnType<typeof listTasks>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTasksQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new task
 */
export const createTask = (
    createTaskRequestBody: CreateTaskRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`task[type]`, createTaskRequestBody['task[type]']);
formData.append(`task[csv]`, createTaskRequestBody['task[csv]']);

      return orvalFetch<TaskResponseBody>(
      {url: `/admin/api/tasks`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getCreateTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: CreateTaskRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: CreateTaskRequestBody}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: CreateTaskRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = CreateTaskRequestBody
    export type CreateTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create a new task
 */
export const useCreateTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: CreateTaskRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: CreateTaskRequestBody},
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Get tasks count for search filter and data for dropdowns for the index
 */
export const getTaskIndexFilterMetadata = (
    params?: GetTaskIndexFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TasksFilterMetadataResponse>(
      {url: `/admin/api/tasks/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTaskIndexFilterMetadataQueryKey = (params?: GetTaskIndexFilterMetadataParams,) => {
    return [
    'admin','api','tasks','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskIndexFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError = N404Response | N500Response>(params?: GetTaskIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskIndexFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>> = ({ signal }) => getTaskIndexFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskIndexFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>>
export type GetTaskIndexFilterMetadataQueryError = N404Response | N500Response


export function useGetTaskIndexFilterMetadata<TData = Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetTaskIndexFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskIndexFilterMetadata<TData = Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTaskIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskIndexFilterMetadata<TData = Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTaskIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tasks count for search filter and data for dropdowns for the index
 */

export function useGetTaskIndexFilterMetadata<TData = Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetTaskIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskIndexFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get tasks count for search filter and data for dropdowns for the index
 */
export const prefetchGetTaskIndexFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetTaskIndexFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskIndexFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTaskIndexFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get options for the new task
 */
export const getNewTaskOptions = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TasksNewResponse>(
      {url: `/admin/api/tasks/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewTaskOptionsQueryKey = () => {
    return [
    'admin','api','tasks','new'
    ] as const;
    }


export const getGetNewTaskOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getNewTaskOptions>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTaskOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewTaskOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewTaskOptions>>> = ({ signal }) => getNewTaskOptions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewTaskOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewTaskOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getNewTaskOptions>>>
export type GetNewTaskOptionsQueryError = N404Response | N500Response


export function useGetNewTaskOptions<TData = Awaited<ReturnType<typeof getNewTaskOptions>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTaskOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewTaskOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewTaskOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewTaskOptions<TData = Awaited<ReturnType<typeof getNewTaskOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTaskOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewTaskOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewTaskOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewTaskOptions<TData = Awaited<ReturnType<typeof getNewTaskOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTaskOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for the new task
 */

export function useGetNewTaskOptions<TData = Awaited<ReturnType<typeof getNewTaskOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTaskOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewTaskOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for the new task
 */
export const prefetchGetNewTaskOptionsQuery = async <TData = Awaited<ReturnType<typeof getNewTaskOptions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewTaskOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewTaskOptionsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Download sample file as CSV
 */
export const downloadTasksSampleFile = (
    params: DownloadTasksSampleFileParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Blob>(
      {url: `/admin/api/tasks/download_sample`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getDownloadTasksSampleFileQueryKey = (params?: DownloadTasksSampleFileParams,) => {
    return [
    'admin','api','tasks','download_sample', ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadTasksSampleFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(params: DownloadTasksSampleFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadTasksSampleFileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadTasksSampleFile>>> = ({ signal }) => downloadTasksSampleFile(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadTasksSampleFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadTasksSampleFile>>>
export type DownloadTasksSampleFileQueryError = ResourceNotFoundError | InvalidRecordError | InternalServerError


export function useDownloadTasksSampleFile<TData = Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: DownloadTasksSampleFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTasksSampleFile>>,
          TError,
          Awaited<ReturnType<typeof downloadTasksSampleFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTasksSampleFile<TData = Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: DownloadTasksSampleFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadTasksSampleFile>>,
          TError,
          Awaited<ReturnType<typeof downloadTasksSampleFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadTasksSampleFile<TData = Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: DownloadTasksSampleFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download sample file as CSV
 */

export function useDownloadTasksSampleFile<TData = Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 params: DownloadTasksSampleFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadTasksSampleFileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download sample file as CSV
 */
export const prefetchDownloadTasksSampleFileQuery = async <TData = Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError = ResourceNotFoundError | InvalidRecordError | InternalServerError>(
 queryClient: QueryClient, params: DownloadTasksSampleFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadTasksSampleFile>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getDownloadTasksSampleFileQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get task details
 */
export const getTask = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TaskDetailed>(
      {url: `/admin/api/tasks/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetTaskQueryKey = (id: number,) => {
    return [
    'admin','api','tasks',id
    ] as const;
    }


export const getGetTaskQueryOptions = <TData = Awaited<ReturnType<typeof getTask>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({ signal }) => getTask(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getTask>>>
export type GetTaskQueryError = N404Response | N500Response


export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get task details
 */

export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get task details
 */
export const prefetchGetTaskQuery = async <TData = Awaited<ReturnType<typeof getTask>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTaskQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Start processing a task
 */
export const updateTask = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UpdateTaskResponse>(
      {url: `/admin/api/tasks/${id}`, method: 'PATCH', signal
    },
      options);
    }




export const getUpdateTaskMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  updateTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>

    export type UpdateTaskMutationError = N404Response | N500Response

    /**
 * @summary Start processing a task
 */
export const useUpdateTask = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUpdateTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Cancel the task
 */
export const deleteTask = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DeleteTaskResponse>(
      {url: `/admin/api/tasks/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTaskMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>

    export type DeleteTaskMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Cancel the task
 */
export const useDeleteTask = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskMutationOptions(options), queryClient);
    }

/**
 * @summary Get failed rows of the task
 */
export const getTaskFailedRows = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TaskFailedRowsResponse | Blob>(
      {url: `/admin/api/tasks/${id}/failed_rows`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetTaskFailedRowsQueryKey = (id: number,) => {
    return [
    'admin','api','tasks',id,'failed_rows'
    ] as const;
    }


export const getGetTaskFailedRowsQueryOptions = <TData = Awaited<ReturnType<typeof getTaskFailedRows>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFailedRows>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskFailedRowsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskFailedRows>>> = ({ signal }) => getTaskFailedRows(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskFailedRows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskFailedRowsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskFailedRows>>>
export type GetTaskFailedRowsQueryError = N404Response | N500Response


export function useGetTaskFailedRows<TData = Awaited<ReturnType<typeof getTaskFailedRows>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFailedRows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskFailedRows>>,
          TError,
          Awaited<ReturnType<typeof getTaskFailedRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskFailedRows<TData = Awaited<ReturnType<typeof getTaskFailedRows>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFailedRows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskFailedRows>>,
          TError,
          Awaited<ReturnType<typeof getTaskFailedRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskFailedRows<TData = Awaited<ReturnType<typeof getTaskFailedRows>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFailedRows>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get failed rows of the task
 */

export function useGetTaskFailedRows<TData = Awaited<ReturnType<typeof getTaskFailedRows>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFailedRows>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskFailedRowsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get failed rows of the task
 */
export const prefetchGetTaskFailedRowsQuery = async <TData = Awaited<ReturnType<typeof getTaskFailedRows>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskFailedRows>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTaskFailedRowsQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Retrieves the modal configuration for a specific trading account action that requires parameters.
 *
 * When listing trading accounts, each resource includes an `actions` array describing available operations.
 * - If `require_params = true`, the client must first call this endpoint to fetch the form schema before executing the action.
 * - If `require_params = false`, the action can be invoked directly without this preliminary step.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *       - `button` — a generic control (link, secondary action, etc.)
 *     - **Optional** `action` (object): if present, mirrors a full action descriptor (same shape as in the main `actions` array), indicating that clicking this button should invoke that action (possibly fetching its own form if `require_params = true`).
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary List modal information along with list of params needed for a specific task action
 */
export const listTaskActionParams = (
    id: number,
    params: ListTaskActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<FormParamsSchema>(
      {url: `/admin/api/tasks/${id}/actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListTaskActionParamsQueryKey = (id: number,
    params?: ListTaskActionParamsParams,) => {
    return [
    'admin','api','tasks',id,'actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListTaskActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listTaskActionParams>>, TError = N404Response | N500Response>(id: number,
    params: ListTaskActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTaskActionParamsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaskActionParams>>> = ({ signal }) => listTaskActionParams(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTaskActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTaskActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listTaskActionParams>>>
export type ListTaskActionParamsQueryError = N404Response | N500Response


export function useListTaskActionParams<TData = Awaited<ReturnType<typeof listTaskActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTaskActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTaskActionParams>>,
          TError,
          Awaited<ReturnType<typeof listTaskActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTaskActionParams<TData = Awaited<ReturnType<typeof listTaskActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTaskActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTaskActionParams>>,
          TError,
          Awaited<ReturnType<typeof listTaskActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTaskActionParams<TData = Awaited<ReturnType<typeof listTaskActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTaskActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List modal information along with list of params needed for a specific task action
 */

export function useListTaskActionParams<TData = Awaited<ReturnType<typeof listTaskActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListTaskActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTaskActionParamsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List modal information along with list of params needed for a specific task action
 */
export const prefetchListTaskActionParamsQuery = async <TData = Awaited<ReturnType<typeof listTaskActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params: ListTaskActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTaskActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTaskActionParamsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Schedule task execution
 */
export const scheduleTaskSchedule = (
    id: number,
    scheduledActionRequestBody: ScheduledActionRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonTaskActionResponse>(
      {url: `/admin/api/tasks/${id}/schedule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduledActionRequestBody, signal
    },
      options);
    }




export const getScheduleTaskScheduleMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleTaskSchedule>>, TError,{id: number;data: ScheduledActionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scheduleTaskSchedule>>, TError,{id: number;data: ScheduledActionRequestBody}, TContext> => {

const mutationKey = ['scheduleTaskSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleTaskSchedule>>, {id: number;data: ScheduledActionRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  scheduleTaskSchedule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleTaskScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleTaskSchedule>>>
    export type ScheduleTaskScheduleMutationBody = ScheduledActionRequestBody
    export type ScheduleTaskScheduleMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Schedule task execution
 */
export const useScheduleTaskSchedule = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleTaskSchedule>>, TError,{id: number;data: ScheduledActionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleTaskSchedule>>,
        TError,
        {id: number;data: ScheduledActionRequestBody},
        TContext
      > => {
      return useMutation(getScheduleTaskScheduleMutationOptions(options), queryClient);
    }

/**
 * @summary Get fields for a new referral tier
 */
export const getNewReferralTiers = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewReferralTierResponse>(
      {url: `/admin/api/referral_tiers/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewReferralTiersQueryKey = () => {
    return [
    'admin','api','referral_tiers','new'
    ] as const;
    }


export const getGetNewReferralTiersQueryOptions = <TData = Awaited<ReturnType<typeof getNewReferralTiers>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewReferralTiersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewReferralTiers>>> = ({ signal }) => getNewReferralTiers(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewReferralTiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewReferralTiersQueryResult = NonNullable<Awaited<ReturnType<typeof getNewReferralTiers>>>
export type GetNewReferralTiersQueryError = N404Response | N500Response


export function useGetNewReferralTiers<TData = Awaited<ReturnType<typeof getNewReferralTiers>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewReferralTiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewReferralTiers>>,
          TError,
          Awaited<ReturnType<typeof getNewReferralTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewReferralTiers<TData = Awaited<ReturnType<typeof getNewReferralTiers>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewReferralTiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewReferralTiers>>,
          TError,
          Awaited<ReturnType<typeof getNewReferralTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewReferralTiers<TData = Awaited<ReturnType<typeof getNewReferralTiers>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fields for a new referral tier
 */

export function useGetNewReferralTiers<TData = Awaited<ReturnType<typeof getNewReferralTiers>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewReferralTiersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get fields for a new referral tier
 */
export const prefetchGetNewReferralTiersQuery = async <TData = Awaited<ReturnType<typeof getNewReferralTiers>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewReferralTiersQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get referral tiers
 */
export const getReferralTiers = (
    params?: GetReferralTiersParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ReferralTiersResponse>(
      {url: `/admin/api/referral_tiers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetReferralTiersQueryKey = (params?: GetReferralTiersParams,) => {
    return [
    'admin','api','referral_tiers', ...(params ? [params] : [])
    ] as const;
    }


export const getGetReferralTiersQueryOptions = <TData = Awaited<ReturnType<typeof getReferralTiers>>, TError = N404Response | N500Response>(params?: GetReferralTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralTiersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferralTiers>>> = ({ signal }) => getReferralTiers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferralTiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferralTiersQueryResult = NonNullable<Awaited<ReturnType<typeof getReferralTiers>>>
export type GetReferralTiersQueryError = N404Response | N500Response


export function useGetReferralTiers<TData = Awaited<ReturnType<typeof getReferralTiers>>, TError = N404Response | N500Response>(
 params: undefined |  GetReferralTiersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferralTiers>>,
          TError,
          Awaited<ReturnType<typeof getReferralTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralTiers<TData = Awaited<ReturnType<typeof getReferralTiers>>, TError = N404Response | N500Response>(
 params?: GetReferralTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferralTiers>>,
          TError,
          Awaited<ReturnType<typeof getReferralTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralTiers<TData = Awaited<ReturnType<typeof getReferralTiers>>, TError = N404Response | N500Response>(
 params?: GetReferralTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get referral tiers
 */

export function useGetReferralTiers<TData = Awaited<ReturnType<typeof getReferralTiers>>, TError = N404Response | N500Response>(
 params?: GetReferralTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferralTiersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get referral tiers
 */
export const prefetchGetReferralTiersQuery = async <TData = Awaited<ReturnType<typeof getReferralTiers>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetReferralTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetReferralTiersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a referral tier
 */
export const createReferralTier = (
    referralTierRequestBody: ReferralTierRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CreateReferralTierResponse>(
      {url: `/admin/api/referral_tiers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: referralTierRequestBody, signal
    },
      options);
    }




export const getCreateReferralTierMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReferralTier>>, TError,{data: ReferralTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReferralTier>>, TError,{data: ReferralTierRequestBody}, TContext> => {

const mutationKey = ['createReferralTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReferralTier>>, {data: ReferralTierRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createReferralTier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReferralTierMutationResult = NonNullable<Awaited<ReturnType<typeof createReferralTier>>>
    export type CreateReferralTierMutationBody = ReferralTierRequestBody
    export type CreateReferralTierMutationError = N422Response | N500Response

    /**
 * @summary Create a referral tier
 */
export const useCreateReferralTier = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReferralTier>>, TError,{data: ReferralTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createReferralTier>>,
        TError,
        {data: ReferralTierRequestBody},
        TContext
      > => {
      return useMutation(getCreateReferralTierMutationOptions(options), queryClient);
    }

/**
 * @summary Update a referral tier
 */
export const updateReferralTier = (
    id: number,
    referralTierRequestBody: ReferralTierRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UpdateReferralTierResponse>(
      {url: `/admin/api/referral_tiers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: referralTierRequestBody, signal
    },
      options);
    }




export const getUpdateReferralTierMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReferralTier>>, TError,{id: number;data: ReferralTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReferralTier>>, TError,{id: number;data: ReferralTierRequestBody}, TContext> => {

const mutationKey = ['updateReferralTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReferralTier>>, {id: number;data: ReferralTierRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateReferralTier(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReferralTierMutationResult = NonNullable<Awaited<ReturnType<typeof updateReferralTier>>>
    export type UpdateReferralTierMutationBody = ReferralTierRequestBody
    export type UpdateReferralTierMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update a referral tier
 */
export const useUpdateReferralTier = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReferralTier>>, TError,{id: number;data: ReferralTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateReferralTier>>,
        TError,
        {id: number;data: ReferralTierRequestBody},
        TContext
      > => {
      return useMutation(getUpdateReferralTierMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a referral tier
 */
export const deleteReferralTier = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DeleteReferralTierResponse>(
      {url: `/admin/api/referral_tiers/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteReferralTierMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReferralTier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReferralTier>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteReferralTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReferralTier>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteReferralTier(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReferralTierMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReferralTier>>>

    export type DeleteReferralTierMutationError = N404Response | N500Response

    /**
 * @summary Delete a referral tier
 */
export const useDeleteReferralTier = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReferralTier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteReferralTier>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteReferralTierMutationOptions(options), queryClient);
    }

/**
 * @summary Get referral tier information needed to edit
 */
export const getReferralTierEditInformation = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ReferralTierEditResponse>(
      {url: `/admin/api/referral_tiers/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetReferralTierEditInformationQueryKey = (id: number,) => {
    return [
    'admin','api','referral_tiers',id,'edit'
    ] as const;
    }


export const getGetReferralTierEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferralTierEditInformationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferralTierEditInformation>>> = ({ signal }) => getReferralTierEditInformation(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferralTierEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getReferralTierEditInformation>>>
export type GetReferralTierEditInformationQueryError = N404Response | N500Response


export function useGetReferralTierEditInformation<TData = Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferralTierEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getReferralTierEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralTierEditInformation<TData = Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferralTierEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getReferralTierEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferralTierEditInformation<TData = Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get referral tier information needed to edit
 */

export function useGetReferralTierEditInformation<TData = Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferralTierEditInformationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get referral tier information needed to edit
 */
export const prefetchGetReferralTierEditInformationQuery = async <TData = Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferralTierEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetReferralTierEditInformationQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get default fields for a new discount tier
 */
export const getNewDiscountTier = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewDiscountTier>(
      {url: `/admin/api/discount_tiers/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewDiscountTierQueryKey = () => {
    return [
    'admin','api','discount_tiers','new'
    ] as const;
    }


export const getGetNewDiscountTierQueryOptions = <TData = Awaited<ReturnType<typeof getNewDiscountTier>>, TError = N404Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewDiscountTierQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewDiscountTier>>> = ({ signal }) => getNewDiscountTier(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewDiscountTier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewDiscountTierQueryResult = NonNullable<Awaited<ReturnType<typeof getNewDiscountTier>>>
export type GetNewDiscountTierQueryError = N404Response


export function useGetNewDiscountTier<TData = Awaited<ReturnType<typeof getNewDiscountTier>>, TError = N404Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewDiscountTier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewDiscountTier>>,
          TError,
          Awaited<ReturnType<typeof getNewDiscountTier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewDiscountTier<TData = Awaited<ReturnType<typeof getNewDiscountTier>>, TError = N404Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewDiscountTier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewDiscountTier>>,
          TError,
          Awaited<ReturnType<typeof getNewDiscountTier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewDiscountTier<TData = Awaited<ReturnType<typeof getNewDiscountTier>>, TError = N404Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get default fields for a new discount tier
 */

export function useGetNewDiscountTier<TData = Awaited<ReturnType<typeof getNewDiscountTier>>, TError = N404Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewDiscountTierQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get default fields for a new discount tier
 */
export const prefetchGetNewDiscountTierQuery = async <TData = Awaited<ReturnType<typeof getNewDiscountTier>>, TError = N404Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewDiscountTierQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List discount tiers
 */
export const getDiscountTiers = (
    params?: GetDiscountTiersParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<GetDiscountTiers200>(
      {url: `/admin/api/discount_tiers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDiscountTiersQueryKey = (params?: GetDiscountTiersParams,) => {
    return [
    'admin','api','discount_tiers', ...(params ? [params] : [])
    ] as const;
    }


export const getGetDiscountTiersQueryOptions = <TData = Awaited<ReturnType<typeof getDiscountTiers>>, TError = N404Response>(params?: GetDiscountTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDiscountTiersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscountTiers>>> = ({ signal }) => getDiscountTiers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDiscountTiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDiscountTiersQueryResult = NonNullable<Awaited<ReturnType<typeof getDiscountTiers>>>
export type GetDiscountTiersQueryError = N404Response


export function useGetDiscountTiers<TData = Awaited<ReturnType<typeof getDiscountTiers>>, TError = N404Response>(
 params: undefined |  GetDiscountTiersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountTiers>>,
          TError,
          Awaited<ReturnType<typeof getDiscountTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountTiers<TData = Awaited<ReturnType<typeof getDiscountTiers>>, TError = N404Response>(
 params?: GetDiscountTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountTiers>>,
          TError,
          Awaited<ReturnType<typeof getDiscountTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountTiers<TData = Awaited<ReturnType<typeof getDiscountTiers>>, TError = N404Response>(
 params?: GetDiscountTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List discount tiers
 */

export function useGetDiscountTiers<TData = Awaited<ReturnType<typeof getDiscountTiers>>, TError = N404Response>(
 params?: GetDiscountTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDiscountTiersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List discount tiers
 */
export const prefetchGetDiscountTiersQuery = async <TData = Awaited<ReturnType<typeof getDiscountTiers>>, TError = N404Response>(
 queryClient: QueryClient, params?: GetDiscountTiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTiers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetDiscountTiersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a discount tier
 */
export const createDiscountTier = (
    discountTierRequestBody: DiscountTierRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DiscountTierMutationResponseResponse>(
      {url: `/admin/api/discount_tiers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: discountTierRequestBody, signal
    },
      options);
    }




export const getCreateDiscountTierMutationOptions = <TError = void | N422Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDiscountTier>>, TError,{data: DiscountTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDiscountTier>>, TError,{data: DiscountTierRequestBody}, TContext> => {

const mutationKey = ['createDiscountTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDiscountTier>>, {data: DiscountTierRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createDiscountTier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDiscountTierMutationResult = NonNullable<Awaited<ReturnType<typeof createDiscountTier>>>
    export type CreateDiscountTierMutationBody = DiscountTierRequestBody
    export type CreateDiscountTierMutationError = void | N422Response

    /**
 * @summary Create a discount tier
 */
export const useCreateDiscountTier = <TError = void | N422Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDiscountTier>>, TError,{data: DiscountTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDiscountTier>>,
        TError,
        {data: DiscountTierRequestBody},
        TContext
      > => {
      return useMutation(getCreateDiscountTierMutationOptions(options), queryClient);
    }

/**
 * @summary Get a discount tier
 */
export const getDiscountTier = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DetailedDiscountTier>(
      {url: `/admin/api/discount_tiers/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetDiscountTierQueryKey = (id: number,) => {
    return [
    'admin','api','discount_tiers',id
    ] as const;
    }


export const getGetDiscountTierQueryOptions = <TData = Awaited<ReturnType<typeof getDiscountTier>>, TError = N404Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDiscountTierQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscountTier>>> = ({ signal }) => getDiscountTier(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDiscountTier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDiscountTierQueryResult = NonNullable<Awaited<ReturnType<typeof getDiscountTier>>>
export type GetDiscountTierQueryError = N404Response


export function useGetDiscountTier<TData = Awaited<ReturnType<typeof getDiscountTier>>, TError = N404Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountTier>>,
          TError,
          Awaited<ReturnType<typeof getDiscountTier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountTier<TData = Awaited<ReturnType<typeof getDiscountTier>>, TError = N404Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscountTier>>,
          TError,
          Awaited<ReturnType<typeof getDiscountTier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscountTier<TData = Awaited<ReturnType<typeof getDiscountTier>>, TError = N404Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a discount tier
 */

export function useGetDiscountTier<TData = Awaited<ReturnType<typeof getDiscountTier>>, TError = N404Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDiscountTierQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a discount tier
 */
export const prefetchGetDiscountTierQuery = async <TData = Awaited<ReturnType<typeof getDiscountTier>>, TError = N404Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscountTier>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetDiscountTierQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Replace a discount tier rule matrix
 */
export const updateDiscountTier = (
    id: number,
    discountTierRequestBody: DiscountTierRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DiscountTierMutationResponseResponse>(
      {url: `/admin/api/discount_tiers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: discountTierRequestBody, signal
    },
      options);
    }




export const getUpdateDiscountTierMutationOptions = <TError = void | N404Response | N422Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDiscountTier>>, TError,{id: number;data: DiscountTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDiscountTier>>, TError,{id: number;data: DiscountTierRequestBody}, TContext> => {

const mutationKey = ['updateDiscountTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDiscountTier>>, {id: number;data: DiscountTierRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDiscountTier(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDiscountTierMutationResult = NonNullable<Awaited<ReturnType<typeof updateDiscountTier>>>
    export type UpdateDiscountTierMutationBody = DiscountTierRequestBody
    export type UpdateDiscountTierMutationError = void | N404Response | N422Response

    /**
 * @summary Replace a discount tier rule matrix
 */
export const useUpdateDiscountTier = <TError = void | N404Response | N422Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDiscountTier>>, TError,{id: number;data: DiscountTierRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDiscountTier>>,
        TError,
        {id: number;data: DiscountTierRequestBody},
        TContext
      > => {
      return useMutation(getUpdateDiscountTierMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a discount tier
 */
export const deleteDiscountTier = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DiscountTierMutationResponseResponse>(
      {url: `/admin/api/discount_tiers/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteDiscountTierMutationOptions = <TError = N404Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDiscountTier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDiscountTier>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDiscountTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDiscountTier>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDiscountTier(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDiscountTierMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDiscountTier>>>

    export type DeleteDiscountTierMutationError = N404Response

    /**
 * @summary Delete a discount tier
 */
export const useDeleteDiscountTier = <TError = N404Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDiscountTier>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDiscountTier>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteDiscountTierMutationOptions(options), queryClient);
    }

/**
 * @summary List competitions
 */
export const listCompetitions = (
    params?: ListCompetitionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CompetitionsListResponse>(
      {url: `/admin/api/competitions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListCompetitionsQueryKey = (params?: ListCompetitionsParams,) => {
    return [
    'admin','api','competitions', ...(params ? [params] : [])
    ] as const;
    }


export const getListCompetitionsQueryOptions = <TData = Awaited<ReturnType<typeof listCompetitions>>, TError = N404Response | N500Response>(params?: ListCompetitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompetitions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompetitionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompetitions>>> = ({ signal }) => listCompetitions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompetitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCompetitionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCompetitions>>>
export type ListCompetitionsQueryError = N404Response | N500Response


export function useListCompetitions<TData = Awaited<ReturnType<typeof listCompetitions>>, TError = N404Response | N500Response>(
 params: undefined |  ListCompetitionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompetitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCompetitions>>,
          TError,
          Awaited<ReturnType<typeof listCompetitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCompetitions<TData = Awaited<ReturnType<typeof listCompetitions>>, TError = N404Response | N500Response>(
 params?: ListCompetitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompetitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCompetitions>>,
          TError,
          Awaited<ReturnType<typeof listCompetitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCompetitions<TData = Awaited<ReturnType<typeof listCompetitions>>, TError = N404Response | N500Response>(
 params?: ListCompetitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompetitions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List competitions
 */

export function useListCompetitions<TData = Awaited<ReturnType<typeof listCompetitions>>, TError = N404Response | N500Response>(
 params?: ListCompetitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompetitions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCompetitionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List competitions
 */
export const prefetchListCompetitionsQuery = async <TData = Awaited<ReturnType<typeof listCompetitions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListCompetitionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCompetitions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListCompetitionsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a new competition
 */
export const createCompetition = (
    createCompetitionRequestBody: CreateCompetitionRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CompetitionResponse>(
      {url: `/admin/api/competitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompetitionRequestBody, signal
    },
      options);
    }




export const getCreateCompetitionMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompetition>>, TError,{data: CreateCompetitionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompetition>>, TError,{data: CreateCompetitionRequestBody}, TContext> => {

const mutationKey = ['createCompetition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompetition>>, {data: CreateCompetitionRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createCompetition(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompetitionMutationResult = NonNullable<Awaited<ReturnType<typeof createCompetition>>>
    export type CreateCompetitionMutationBody = CreateCompetitionRequestBody
    export type CreateCompetitionMutationError = N422Response | N500Response

    /**
 * @summary Create a new competition
 */
export const useCreateCompetition = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompetition>>, TError,{data: CreateCompetitionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCompetition>>,
        TError,
        {data: CreateCompetitionRequestBody},
        TContext
      > => {
      return useMutation(getCreateCompetitionMutationOptions(options), queryClient);
    }

/**
 * @summary Get filter metadata for competitions
 */
export const getCompetitionsFilterMetadata = (
    params?: GetCompetitionsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CompetitionsFilterMetadataResponse>(
      {url: `/admin/api/competitions/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCompetitionsFilterMetadataQueryKey = (params?: GetCompetitionsFilterMetadataParams,) => {
    return [
    'admin','api','competitions','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetCompetitionsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError = N404Response | N500Response>(params?: GetCompetitionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompetitionsFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>> = ({ signal }) => getCompetitionsFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompetitionsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>>
export type GetCompetitionsFilterMetadataQueryError = N404Response | N500Response


export function useGetCompetitionsFilterMetadata<TData = Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetCompetitionsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompetitionsFilterMetadata<TData = Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCompetitionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompetitionsFilterMetadata<TData = Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCompetitionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata for competitions
 */

export function useGetCompetitionsFilterMetadata<TData = Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCompetitionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompetitionsFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata for competitions
 */
export const prefetchGetCompetitionsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetCompetitionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCompetitionsFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get options for a new competition
 */
export const getNewCompetitionOptions = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CompetitionFormOptions>(
      {url: `/admin/api/competitions/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewCompetitionOptionsQueryKey = () => {
    return [
    'admin','api','competitions','new'
    ] as const;
    }


export const getGetNewCompetitionOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewCompetitionOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewCompetitionOptions>>> = ({ signal }) => getNewCompetitionOptions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewCompetitionOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getNewCompetitionOptions>>>
export type GetNewCompetitionOptionsQueryError = N404Response | N500Response


export function useGetNewCompetitionOptions<TData = Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewCompetitionOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewCompetitionOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewCompetitionOptions<TData = Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewCompetitionOptions>>,
          TError,
          Awaited<ReturnType<typeof getNewCompetitionOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewCompetitionOptions<TData = Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get options for a new competition
 */

export function useGetNewCompetitionOptions<TData = Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewCompetitionOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get options for a new competition
 */
export const prefetchGetNewCompetitionOptionsQuery = async <TData = Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewCompetitionOptions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewCompetitionOptionsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Delete a competition
 */
export const deleteCompetition = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CompetitionResponse>(
      {url: `/admin/api/competitions/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteCompetitionMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompetition>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompetition>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCompetition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompetition>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompetition(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompetitionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompetition>>>

    export type DeleteCompetitionMutationError = N404Response | N500Response

    /**
 * @summary Delete a competition
 */
export const useDeleteCompetition = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompetition>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompetition>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCompetitionMutationOptions(options), queryClient);
    }

/**
 * @summary Update competition details
 */
export const updateCompetition = (
    id: number,
    updateCompetitionRequestBody: UpdateCompetitionRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CompetitionResponse>(
      {url: `/admin/api/competitions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompetitionRequestBody, signal
    },
      options);
    }




export const getUpdateCompetitionMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompetition>>, TError,{id: number;data: UpdateCompetitionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompetition>>, TError,{id: number;data: UpdateCompetitionRequestBody}, TContext> => {

const mutationKey = ['updateCompetition'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompetition>>, {id: number;data: UpdateCompetitionRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompetition(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompetitionMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompetition>>>
    export type UpdateCompetitionMutationBody = UpdateCompetitionRequestBody
    export type UpdateCompetitionMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update competition details
 */
export const useUpdateCompetition = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompetition>>, TError,{id: number;data: UpdateCompetitionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCompetition>>,
        TError,
        {id: number;data: UpdateCompetitionRequestBody},
        TContext
      > => {
      return useMutation(getUpdateCompetitionMutationOptions(options), queryClient);
    }

/**
 * @summary Get competition information needed to edit
 */
export const getCompetitionEditInformation = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CompetitionEditResponse>(
      {url: `/admin/api/competitions/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetCompetitionEditInformationQueryKey = (id: number,) => {
    return [
    'admin','api','competitions',id,'edit'
    ] as const;
    }


export const getGetCompetitionEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompetitionEditInformationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompetitionEditInformation>>> = ({ signal }) => getCompetitionEditInformation(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompetitionEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getCompetitionEditInformation>>>
export type GetCompetitionEditInformationQueryError = N404Response | N500Response


export function useGetCompetitionEditInformation<TData = Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompetitionEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getCompetitionEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompetitionEditInformation<TData = Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompetitionEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getCompetitionEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompetitionEditInformation<TData = Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get competition information needed to edit
 */

export function useGetCompetitionEditInformation<TData = Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompetitionEditInformationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get competition information needed to edit
 */
export const prefetchGetCompetitionEditInformationQuery = async <TData = Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompetitionEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCompetitionEditInformationQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get brands
 */
export const getBrands = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BrandsListResponse>(
      {url: `/admin/api/brands`, method: 'GET', signal
    },
      options);
    }




export const getGetBrandsQueryKey = () => {
    return [
    'admin','api','brands'
    ] as const;
    }


export const getGetBrandsQueryOptions = <TData = Awaited<ReturnType<typeof getBrands>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrands>>> = ({ signal }) => getBrands(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrands>>>
export type GetBrandsQueryError = N404Response | N500Response


export function useGetBrands<TData = Awaited<ReturnType<typeof getBrands>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrands>>,
          TError,
          Awaited<ReturnType<typeof getBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrands<TData = Awaited<ReturnType<typeof getBrands>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrands>>,
          TError,
          Awaited<ReturnType<typeof getBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrands<TData = Awaited<ReturnType<typeof getBrands>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get brands
 */

export function useGetBrands<TData = Awaited<ReturnType<typeof getBrands>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get brands
 */
export const prefetchGetBrandsQuery = async <TData = Awaited<ReturnType<typeof getBrands>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBrandsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a brand
 */
export const createBrand = (
    brandRequestBody: BrandRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CreateBrandResponse>(
      {url: `/admin/api/brands`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: brandRequestBody, signal
    },
      options);
    }




export const getCreateBrandMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBrand>>, TError,{data: BrandRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBrand>>, TError,{data: BrandRequestBody}, TContext> => {

const mutationKey = ['createBrand'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBrand>>, {data: BrandRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  createBrand(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBrandMutationResult = NonNullable<Awaited<ReturnType<typeof createBrand>>>
    export type CreateBrandMutationBody = BrandRequestBody
    export type CreateBrandMutationError = N422Response | N500Response

    /**
 * @summary Create a brand
 */
export const useCreateBrand = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBrand>>, TError,{data: BrandRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBrand>>,
        TError,
        {data: BrandRequestBody},
        TContext
      > => {
      return useMutation(getCreateBrandMutationOptions(options), queryClient);
    }

/**
 * @summary Get fields for a new brand
 */
export const getNewBrand = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewBrandResponse>(
      {url: `/admin/api/brands/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewBrandQueryKey = () => {
    return [
    'admin','api','brands','new'
    ] as const;
    }


export const getGetNewBrandQueryOptions = <TData = Awaited<ReturnType<typeof getNewBrand>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewBrand>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewBrandQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewBrand>>> = ({ signal }) => getNewBrand(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewBrand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewBrandQueryResult = NonNullable<Awaited<ReturnType<typeof getNewBrand>>>
export type GetNewBrandQueryError = N404Response | N500Response


export function useGetNewBrand<TData = Awaited<ReturnType<typeof getNewBrand>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewBrand>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewBrand>>,
          TError,
          Awaited<ReturnType<typeof getNewBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewBrand<TData = Awaited<ReturnType<typeof getNewBrand>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewBrand>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewBrand>>,
          TError,
          Awaited<ReturnType<typeof getNewBrand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewBrand<TData = Awaited<ReturnType<typeof getNewBrand>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewBrand>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fields for a new brand
 */

export function useGetNewBrand<TData = Awaited<ReturnType<typeof getNewBrand>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewBrand>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewBrandQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get fields for a new brand
 */
export const prefetchGetNewBrandQuery = async <TData = Awaited<ReturnType<typeof getNewBrand>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewBrand>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewBrandQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update a brand
 */
export const updateBrand = (
    id: number,
    brandUpdateRequestBody: BrandUpdateRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UpdateBrandResponse>(
      {url: `/admin/api/brands/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: brandUpdateRequestBody, signal
    },
      options);
    }




export const getUpdateBrandMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBrand>>, TError,{id: number;data: BrandUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBrand>>, TError,{id: number;data: BrandUpdateRequestBody}, TContext> => {

const mutationKey = ['updateBrand'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBrand>>, {id: number;data: BrandUpdateRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBrand(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBrandMutationResult = NonNullable<Awaited<ReturnType<typeof updateBrand>>>
    export type UpdateBrandMutationBody = BrandUpdateRequestBody
    export type UpdateBrandMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update a brand
 */
export const useUpdateBrand = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBrand>>, TError,{id: number;data: BrandUpdateRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBrand>>,
        TError,
        {id: number;data: BrandUpdateRequestBody},
        TContext
      > => {
      return useMutation(getUpdateBrandMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a brand
 */
export const deleteBrand = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DeleteBrandResponse>(
      {url: `/admin/api/brands/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteBrandMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrand>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBrand>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteBrand'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBrand>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBrand(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBrandMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBrand>>>

    export type DeleteBrandMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Delete a brand
 */
export const useDeleteBrand = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrand>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBrand>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteBrandMutationOptions(options), queryClient);
    }

/**
 * @summary Get brand information needed to edit
 */
export const getBrandEditInformation = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<BrandEditResponse>(
      {url: `/admin/api/brands/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetBrandEditInformationQueryKey = (id: number,) => {
    return [
    'admin','api','brands',id,'edit'
    ] as const;
    }


export const getGetBrandEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getBrandEditInformation>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandEditInformationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandEditInformation>>> = ({ signal }) => getBrandEditInformation(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandEditInformation>>>
export type GetBrandEditInformationQueryError = N404Response | N500Response


export function useGetBrandEditInformation<TData = Awaited<ReturnType<typeof getBrandEditInformation>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getBrandEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandEditInformation<TData = Awaited<ReturnType<typeof getBrandEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getBrandEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandEditInformation<TData = Awaited<ReturnType<typeof getBrandEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get brand information needed to edit
 */

export function useGetBrandEditInformation<TData = Awaited<ReturnType<typeof getBrandEditInformation>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandEditInformationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get brand information needed to edit
 */
export const prefetchGetBrandEditInformationQuery = async <TData = Awaited<ReturnType<typeof getBrandEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBrandEditInformationQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get payment provider gateways for a brand
 */
export const getPaymentProviderGateways = (
    brandId: number,
    params?: GetPaymentProviderGatewaysParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PaymentProviderGatewaysListResponse>(
      {url: `/admin/api/brands/${brandId}/payment_provider_gateways`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPaymentProviderGatewaysQueryKey = (brandId: number,
    params?: GetPaymentProviderGatewaysParams,) => {
    return [
    'admin','api','brands',brandId,'payment_provider_gateways', ...(params ? [params] : [])
    ] as const;
    }


export const getGetPaymentProviderGatewaysQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError = N404Response | N500Response>(brandId: number,
    params?: GetPaymentProviderGatewaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentProviderGatewaysQueryKey(brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentProviderGateways>>> = ({ signal }) => getPaymentProviderGateways(brandId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentProviderGatewaysQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentProviderGateways>>>
export type GetPaymentProviderGatewaysQueryError = N404Response | N500Response


export function useGetPaymentProviderGateways<TData = Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError = N404Response | N500Response>(
 brandId: number,
    params: undefined |  GetPaymentProviderGatewaysParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentProviderGateways>>,
          TError,
          Awaited<ReturnType<typeof getPaymentProviderGateways>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentProviderGateways<TData = Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError = N404Response | N500Response>(
 brandId: number,
    params?: GetPaymentProviderGatewaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentProviderGateways>>,
          TError,
          Awaited<ReturnType<typeof getPaymentProviderGateways>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentProviderGateways<TData = Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError = N404Response | N500Response>(
 brandId: number,
    params?: GetPaymentProviderGatewaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment provider gateways for a brand
 */

export function useGetPaymentProviderGateways<TData = Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError = N404Response | N500Response>(
 brandId: number,
    params?: GetPaymentProviderGatewaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentProviderGatewaysQueryOptions(brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get payment provider gateways for a brand
 */
export const prefetchGetPaymentProviderGatewaysQuery = async <TData = Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, brandId: number,
    params?: GetPaymentProviderGatewaysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGateways>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPaymentProviderGatewaysQueryOptions(brandId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Create a payment provider gateway for a brand
 */
export const createPaymentProviderGateway = (
    brandId: number,
    paymentProviderGatewayRequestBody: PaymentProviderGatewayRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CreatePaymentProviderGatewayResponse>(
      {url: `/admin/api/brands/${brandId}/payment_provider_gateways`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentProviderGatewayRequestBody, signal
    },
      options);
    }




export const getCreatePaymentProviderGatewayMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentProviderGateway>>, TError,{brandId: number;data: PaymentProviderGatewayRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPaymentProviderGateway>>, TError,{brandId: number;data: PaymentProviderGatewayRequestBody}, TContext> => {

const mutationKey = ['createPaymentProviderGateway'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPaymentProviderGateway>>, {brandId: number;data: PaymentProviderGatewayRequestBody}> = (props) => {
          const {brandId,data} = props ?? {};

          return  createPaymentProviderGateway(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentProviderGatewayMutationResult = NonNullable<Awaited<ReturnType<typeof createPaymentProviderGateway>>>
    export type CreatePaymentProviderGatewayMutationBody = PaymentProviderGatewayRequestBody
    export type CreatePaymentProviderGatewayMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Create a payment provider gateway for a brand
 */
export const useCreatePaymentProviderGateway = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPaymentProviderGateway>>, TError,{brandId: number;data: PaymentProviderGatewayRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPaymentProviderGateway>>,
        TError,
        {brandId: number;data: PaymentProviderGatewayRequestBody},
        TContext
      > => {
      return useMutation(getCreatePaymentProviderGatewayMutationOptions(options), queryClient);
    }

/**
 * @summary Get payment provider gateway count for search filter
 */
export const getPaymentProviderGatewayFilterMetadata = (
    brandId: number,
    params?: GetPaymentProviderGatewayFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PaymentProviderGatewaysFilterMetadataResponse>(
      {url: `/admin/api/brands/${brandId}/payment_provider_gateways/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPaymentProviderGatewayFilterMetadataQueryKey = (brandId: number,
    params?: GetPaymentProviderGatewayFilterMetadataParams,) => {
    return [
    'admin','api','brands',brandId,'payment_provider_gateways','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetPaymentProviderGatewayFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError = N404Response | N500Response>(brandId: number,
    params?: GetPaymentProviderGatewayFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentProviderGatewayFilterMetadataQueryKey(brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>> = ({ signal }) => getPaymentProviderGatewayFilterMetadata(brandId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentProviderGatewayFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>>
export type GetPaymentProviderGatewayFilterMetadataQueryError = N404Response | N500Response


export function useGetPaymentProviderGatewayFilterMetadata<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError = N404Response | N500Response>(
 brandId: number,
    params: undefined |  GetPaymentProviderGatewayFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentProviderGatewayFilterMetadata<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError = N404Response | N500Response>(
 brandId: number,
    params?: GetPaymentProviderGatewayFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentProviderGatewayFilterMetadata<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError = N404Response | N500Response>(
 brandId: number,
    params?: GetPaymentProviderGatewayFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment provider gateway count for search filter
 */

export function useGetPaymentProviderGatewayFilterMetadata<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError = N404Response | N500Response>(
 brandId: number,
    params?: GetPaymentProviderGatewayFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentProviderGatewayFilterMetadataQueryOptions(brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get payment provider gateway count for search filter
 */
export const prefetchGetPaymentProviderGatewayFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, brandId: number,
    params?: GetPaymentProviderGatewayFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPaymentProviderGatewayFilterMetadataQueryOptions(brandId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get fields for a new payment provider gateway
 */
export const getNewPaymentProviderGateway = (
    brandId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<NewPaymentProviderGatewayResponse>(
      {url: `/admin/api/brands/${brandId}/payment_provider_gateways/new`, method: 'GET', signal
    },
      options);
    }




export const getGetNewPaymentProviderGatewayQueryKey = (brandId: number,) => {
    return [
    'admin','api','brands',brandId,'payment_provider_gateways','new'
    ] as const;
    }


export const getGetNewPaymentProviderGatewayQueryOptions = <TData = Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError = N404Response | N500Response>(brandId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewPaymentProviderGatewayQueryKey(brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>> = ({ signal }) => getNewPaymentProviderGateway(brandId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNewPaymentProviderGatewayQueryResult = NonNullable<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>>
export type GetNewPaymentProviderGatewayQueryError = N404Response | N500Response


export function useGetNewPaymentProviderGateway<TData = Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError = N404Response | N500Response>(
 brandId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPaymentProviderGateway>>,
          TError,
          Awaited<ReturnType<typeof getNewPaymentProviderGateway>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPaymentProviderGateway<TData = Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError = N404Response | N500Response>(
 brandId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNewPaymentProviderGateway>>,
          TError,
          Awaited<ReturnType<typeof getNewPaymentProviderGateway>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNewPaymentProviderGateway<TData = Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError = N404Response | N500Response>(
 brandId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fields for a new payment provider gateway
 */

export function useGetNewPaymentProviderGateway<TData = Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError = N404Response | N500Response>(
 brandId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNewPaymentProviderGatewayQueryOptions(brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get fields for a new payment provider gateway
 */
export const prefetchGetNewPaymentProviderGatewayQuery = async <TData = Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, brandId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNewPaymentProviderGateway>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetNewPaymentProviderGatewayQueryOptions(brandId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update a payment provider gateway
 */
export const updatePaymentProviderGateway = (
    brandId: number,
    id: number,
    paymentProviderGatewayRequestBody: PaymentProviderGatewayRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UpdatePaymentProviderGatewayResponse>(
      {url: `/admin/api/brands/${brandId}/payment_provider_gateways/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: paymentProviderGatewayRequestBody, signal
    },
      options);
    }




export const getUpdatePaymentProviderGatewayMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentProviderGateway>>, TError,{brandId: number;id: number;data: PaymentProviderGatewayRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePaymentProviderGateway>>, TError,{brandId: number;id: number;data: PaymentProviderGatewayRequestBody}, TContext> => {

const mutationKey = ['updatePaymentProviderGateway'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePaymentProviderGateway>>, {brandId: number;id: number;data: PaymentProviderGatewayRequestBody}> = (props) => {
          const {brandId,id,data} = props ?? {};

          return  updatePaymentProviderGateway(brandId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePaymentProviderGatewayMutationResult = NonNullable<Awaited<ReturnType<typeof updatePaymentProviderGateway>>>
    export type UpdatePaymentProviderGatewayMutationBody = PaymentProviderGatewayRequestBody
    export type UpdatePaymentProviderGatewayMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update a payment provider gateway
 */
export const useUpdatePaymentProviderGateway = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePaymentProviderGateway>>, TError,{brandId: number;id: number;data: PaymentProviderGatewayRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePaymentProviderGateway>>,
        TError,
        {brandId: number;id: number;data: PaymentProviderGatewayRequestBody},
        TContext
      > => {
      return useMutation(getUpdatePaymentProviderGatewayMutationOptions(options), queryClient);
    }

/**
 * @summary Delete a payment provider gateway
 */
export const deletePaymentProviderGateway = (
    brandId: number,
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<DeletePaymentProviderGatewayResponse>(
      {url: `/admin/api/brands/${brandId}/payment_provider_gateways/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePaymentProviderGatewayMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentProviderGateway>>, TError,{brandId: number;id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePaymentProviderGateway>>, TError,{brandId: number;id: number}, TContext> => {

const mutationKey = ['deletePaymentProviderGateway'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePaymentProviderGateway>>, {brandId: number;id: number}> = (props) => {
          const {brandId,id} = props ?? {};

          return  deletePaymentProviderGateway(brandId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentProviderGatewayMutationResult = NonNullable<Awaited<ReturnType<typeof deletePaymentProviderGateway>>>

    export type DeletePaymentProviderGatewayMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Delete a payment provider gateway
 */
export const useDeletePaymentProviderGateway = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentProviderGateway>>, TError,{brandId: number;id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePaymentProviderGateway>>,
        TError,
        {brandId: number;id: number},
        TContext
      > => {
      return useMutation(getDeletePaymentProviderGatewayMutationOptions(options), queryClient);
    }

/**
 * @summary Get payment provider gateway information needed to edit
 */
export const getPaymentProviderGatewayEditInformation = (
    brandId: number,
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<PaymentProviderGatewayEditResponse>(
      {url: `/admin/api/brands/${brandId}/payment_provider_gateways/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getGetPaymentProviderGatewayEditInformationQueryKey = (brandId: number,
    id: number,) => {
    return [
    'admin','api','brands',brandId,'payment_provider_gateways',id,'edit'
    ] as const;
    }


export const getGetPaymentProviderGatewayEditInformationQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError = N404Response | N500Response>(brandId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentProviderGatewayEditInformationQueryKey(brandId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>> = ({ signal }) => getPaymentProviderGatewayEditInformation(brandId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentProviderGatewayEditInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>>
export type GetPaymentProviderGatewayEditInformationQueryError = N404Response | N500Response


export function useGetPaymentProviderGatewayEditInformation<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError = N404Response | N500Response>(
 brandId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentProviderGatewayEditInformation<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError = N404Response | N500Response>(
 brandId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>,
          TError,
          Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentProviderGatewayEditInformation<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError = N404Response | N500Response>(
 brandId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment provider gateway information needed to edit
 */

export function useGetPaymentProviderGatewayEditInformation<TData = Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError = N404Response | N500Response>(
 brandId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentProviderGatewayEditInformationQueryOptions(brandId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get payment provider gateway information needed to edit
 */
export const prefetchGetPaymentProviderGatewayEditInformationQuery = async <TData = Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, brandId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentProviderGatewayEditInformation>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPaymentProviderGatewayEditInformationQueryOptions(brandId,id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update tags for a given resource
 */
export const updateAResourceTags = (
    resourceType: 'users' | 'trading_accounts' | 'payouts',
    resourceId: number,
    tagRequestBody: TagRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TagUpdateResponseBody>(
      {url: `/admin/api/${resourceType}/${resourceId}/tags`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tagRequestBody, signal
    },
      options);
    }




export const getUpdateAResourceTagsMutationOptions = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAResourceTags>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: TagRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAResourceTags>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: TagRequestBody}, TContext> => {

const mutationKey = ['updateAResourceTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAResourceTags>>, {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: TagRequestBody}> = (props) => {
          const {resourceType,resourceId,data} = props ?? {};

          return  updateAResourceTags(resourceType,resourceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAResourceTagsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAResourceTags>>>
    export type UpdateAResourceTagsMutationBody = TagRequestBody
    export type UpdateAResourceTagsMutationError = N404Response | N500Response

    /**
 * @summary Update tags for a given resource
 */
export const useUpdateAResourceTags = <TError = N404Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAResourceTags>>, TError,{resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: TagRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAResourceTags>>,
        TError,
        {resourceType: 'users' | 'trading_accounts' | 'payouts';resourceId: number;data: TagRequestBody},
        TContext
      > => {
      return useMutation(getUpdateAResourceTagsMutationOptions(options), queryClient);
    }

/**
 * @summary List of users matching search criteria
 */
export const searchUsers = (
    params?: SearchUsersParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<SearchUsers200>(
      {url: `/admin/api/search_users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSearchUsersQueryKey = (params?: SearchUsersParams,) => {
    return [
    'admin','api','search_users', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchUsersQueryOptions = <TData = Awaited<ReturnType<typeof searchUsers>>, TError = N404Response | N500Response>(params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsers>>> = ({ signal }) => searchUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
export type SearchUsersQueryError = N404Response | N500Response


export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = N404Response | N500Response>(
 params: undefined |  SearchUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = N404Response | N500Response>(
 params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = N404Response | N500Response>(
 params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List of users matching search criteria
 */

export function useSearchUsers<TData = Awaited<ReturnType<typeof searchUsers>>, TError = N404Response | N500Response>(
 params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List of users matching search criteria
 */
export const prefetchSearchUsersQuery = async <TData = Awaited<ReturnType<typeof searchUsers>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: SearchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getSearchUsersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List versions for an object
 */
export const listVersions = (
    params: ListVersionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<VersionsListResponse>(
      {url: `/admin/api/versions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListVersionsQueryKey = (params?: ListVersionsParams,) => {
    return [
    'admin','api','versions', ...(params ? [params] : [])
    ] as const;
    }


export const getListVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listVersions>>, TError = N404Response | N422Response | N500Response>(params: ListVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVersions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVersionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVersions>>> = ({ signal }) => listVersions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listVersions>>>
export type ListVersionsQueryError = N404Response | N422Response | N500Response


export function useListVersions<TData = Awaited<ReturnType<typeof listVersions>>, TError = N404Response | N422Response | N500Response>(
 params: ListVersionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVersions>>,
          TError,
          Awaited<ReturnType<typeof listVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVersions<TData = Awaited<ReturnType<typeof listVersions>>, TError = N404Response | N422Response | N500Response>(
 params: ListVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVersions>>,
          TError,
          Awaited<ReturnType<typeof listVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVersions<TData = Awaited<ReturnType<typeof listVersions>>, TError = N404Response | N422Response | N500Response>(
 params: ListVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVersions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List versions for an object
 */

export function useListVersions<TData = Awaited<ReturnType<typeof listVersions>>, TError = N404Response | N422Response | N500Response>(
 params: ListVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVersions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVersionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List versions for an object
 */
export const prefetchListVersionsQuery = async <TData = Awaited<ReturnType<typeof listVersions>>, TError = N404Response | N422Response | N500Response>(
 queryClient: QueryClient, params: ListVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVersions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListVersionsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get scheduled actions
 */
export const getScheduledActions = (
    params?: GetScheduledActionsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ScheduledActionsResponse>(
      {url: `/admin/api/scheduled_actions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetScheduledActionsQueryKey = (params?: GetScheduledActionsParams,) => {
    return [
    'admin','api','scheduled_actions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetScheduledActionsQueryOptions = <TData = Awaited<ReturnType<typeof getScheduledActions>>, TError = N404Response | N500Response>(params?: GetScheduledActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduledActionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduledActions>>> = ({ signal }) => getScheduledActions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduledActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduledActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduledActions>>>
export type GetScheduledActionsQueryError = N404Response | N500Response


export function useGetScheduledActions<TData = Awaited<ReturnType<typeof getScheduledActions>>, TError = N404Response | N500Response>(
 params: undefined |  GetScheduledActionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledActions>>,
          TError,
          Awaited<ReturnType<typeof getScheduledActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduledActions<TData = Awaited<ReturnType<typeof getScheduledActions>>, TError = N404Response | N500Response>(
 params?: GetScheduledActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledActions>>,
          TError,
          Awaited<ReturnType<typeof getScheduledActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduledActions<TData = Awaited<ReturnType<typeof getScheduledActions>>, TError = N404Response | N500Response>(
 params?: GetScheduledActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get scheduled actions
 */

export function useGetScheduledActions<TData = Awaited<ReturnType<typeof getScheduledActions>>, TError = N404Response | N500Response>(
 params?: GetScheduledActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduledActionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get scheduled actions
 */
export const prefetchGetScheduledActionsQuery = async <TData = Awaited<ReturnType<typeof getScheduledActions>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetScheduledActionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActions>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetScheduledActionsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Returns scheduled actions count for search filter and dropdown data.
 * @summary Get scheduled actions count for search filter and data for dropdowns
 */
export const getScheduledActionsFilterMetadata = (
    params?: GetScheduledActionsFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ScheduledActionsFilterMetadataResponse>(
      {url: `/admin/api/scheduled_actions/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetScheduledActionsFilterMetadataQueryKey = (params?: GetScheduledActionsFilterMetadataParams,) => {
    return [
    'admin','api','scheduled_actions','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetScheduledActionsFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError = N404Response | N500Response>(params?: GetScheduledActionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduledActionsFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>> = ({ signal }) => getScheduledActionsFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduledActionsFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>>
export type GetScheduledActionsFilterMetadataQueryError = N404Response | N500Response


export function useGetScheduledActionsFilterMetadata<TData = Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetScheduledActionsFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduledActionsFilterMetadata<TData = Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetScheduledActionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduledActionsFilterMetadata<TData = Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetScheduledActionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get scheduled actions count for search filter and data for dropdowns
 */

export function useGetScheduledActionsFilterMetadata<TData = Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetScheduledActionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduledActionsFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get scheduled actions count for search filter and data for dropdowns
 */
export const prefetchGetScheduledActionsFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetScheduledActionsFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduledActionsFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetScheduledActionsFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * Retrieves the modal configuration for a specific trading account action that requires parameters.
 *
 * When listing trading accounts, each resource includes an `actions` array describing available operations.
 * - If `require_params = true`, the client must first call this endpoint to fetch the form schema before executing the action.
 * - If `require_params = false`, the action can be invoked directly without this preliminary step.
 *
 * This endpoint returns:
 * - **Modal metadata** (title, description, submit button text)
 * - **Form fields** with types, defaults and validation rules
 * - **Action details** (name, method, path) for submission
 * - **Buttons**: an array of one or more button definitions (always present; at least one `submit`)
 *   - Each button object includes:
 *     - `name` (string): the label shown on the button
 *     - `type` (string):
 *       - `submit` — submits the current form against the primary action
 *       - `button` — a generic control (link, secondary action, etc.)
 *     - **Optional** `action` (object): if present, mirrors a full action descriptor (same shape as in the main `actions` array), indicating that clicking this button should invoke that action (possibly fetching its own form if `require_params = true`).
 *   - Buttons are rendered in the order they appear, enabling multi-step or conditional flows within the same modal.
 * @summary List modal information along with list of params needed for a specific scheduled action
 */
export const listScheduledActionParams = (
    id: number,
    params: ListScheduledActionParamsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<FormParamsSchema>(
      {url: `/admin/api/scheduled_actions/${id}/actions/new`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListScheduledActionParamsQueryKey = (id: number,
    params?: ListScheduledActionParamsParams,) => {
    return [
    'admin','api','scheduled_actions',id,'actions','new', ...(params ? [params] : [])
    ] as const;
    }


export const getListScheduledActionParamsQueryOptions = <TData = Awaited<ReturnType<typeof listScheduledActionParams>>, TError = N404Response | N500Response>(id: number,
    params: ListScheduledActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScheduledActionParamsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScheduledActionParams>>> = ({ signal }) => listScheduledActionParams(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScheduledActionParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListScheduledActionParamsQueryResult = NonNullable<Awaited<ReturnType<typeof listScheduledActionParams>>>
export type ListScheduledActionParamsQueryError = N404Response | N500Response


export function useListScheduledActionParams<TData = Awaited<ReturnType<typeof listScheduledActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListScheduledActionParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledActionParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScheduledActionParams>>,
          TError,
          Awaited<ReturnType<typeof listScheduledActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScheduledActionParams<TData = Awaited<ReturnType<typeof listScheduledActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListScheduledActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledActionParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listScheduledActionParams>>,
          TError,
          Awaited<ReturnType<typeof listScheduledActionParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListScheduledActionParams<TData = Awaited<ReturnType<typeof listScheduledActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListScheduledActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List modal information along with list of params needed for a specific scheduled action
 */

export function useListScheduledActionParams<TData = Awaited<ReturnType<typeof listScheduledActionParams>>, TError = N404Response | N500Response>(
 id: number,
    params: ListScheduledActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListScheduledActionParamsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List modal information along with list of params needed for a specific scheduled action
 */
export const prefetchListScheduledActionParamsQuery = async <TData = Awaited<ReturnType<typeof listScheduledActionParams>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params: ListScheduledActionParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScheduledActionParams>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListScheduledActionParamsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Cancel scheduled action execution
 */
export const cancelScheduledAction = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonScheduledActionResponse>(
      {url: `/admin/api/scheduled_actions/${id}/cancel`, method: 'PATCH', signal
    },
      options);
    }




export const getCancelScheduledActionMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledAction>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledAction>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelScheduledAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelScheduledAction>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelScheduledAction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelScheduledActionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelScheduledAction>>>

    export type CancelScheduledActionMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Cancel scheduled action execution
 */
export const useCancelScheduledAction = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelScheduledAction>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelScheduledAction>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelScheduledActionMutationOptions(options), queryClient);
    }

/**
 * @summary Reschedules a scheduled action
 */
export const rescheduleScheduledAction = (
    id: number,
    scheduledActionRequestBody: ScheduledActionRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CommonScheduledActionResponse>(
      {url: `/admin/api/scheduled_actions/${id}/reschedule`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: scheduledActionRequestBody, signal
    },
      options);
    }




export const getRescheduleScheduledActionMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescheduleScheduledAction>>, TError,{id: number;data: ScheduledActionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rescheduleScheduledAction>>, TError,{id: number;data: ScheduledActionRequestBody}, TContext> => {

const mutationKey = ['rescheduleScheduledAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rescheduleScheduledAction>>, {id: number;data: ScheduledActionRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  rescheduleScheduledAction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RescheduleScheduledActionMutationResult = NonNullable<Awaited<ReturnType<typeof rescheduleScheduledAction>>>
    export type RescheduleScheduledActionMutationBody = ScheduledActionRequestBody
    export type RescheduleScheduledActionMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Reschedules a scheduled action
 */
export const useRescheduleScheduledAction = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescheduleScheduledAction>>, TError,{id: number;data: ScheduledActionRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rescheduleScheduledAction>>,
        TError,
        {id: number;data: ScheduledActionRequestBody},
        TContext
      > => {
      return useMutation(getRescheduleScheduledActionMutationOptions(options), queryClient);
    }

/**
 * @summary Get filter metadata for risk engine matching endpoints
 */
export const getRiskEngineMatchingFilterMetadata = (

 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<MatchingFilterMetadataResponse>(
      {url: `/admin/api/risk_engine/matching/filter_metadata`, method: 'GET', signal
    },
      options);
    }




export const getGetRiskEngineMatchingFilterMetadataQueryKey = () => {
    return [
    'admin','api','risk_engine','matching','filter_metadata'
    ] as const;
    }


export const getGetRiskEngineMatchingFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError = N404Response | N500Response>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRiskEngineMatchingFilterMetadataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>> = ({ signal }) => getRiskEngineMatchingFilterMetadata(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRiskEngineMatchingFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>>
export type GetRiskEngineMatchingFilterMetadataQueryError = N404Response | N500Response


export function useGetRiskEngineMatchingFilterMetadata<TData = Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError = N404Response | N500Response>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRiskEngineMatchingFilterMetadata<TData = Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRiskEngineMatchingFilterMetadata<TData = Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get filter metadata for risk engine matching endpoints
 */

export function useGetRiskEngineMatchingFilterMetadata<TData = Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError = N404Response | N500Response>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRiskEngineMatchingFilterMetadataQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get filter metadata for risk engine matching endpoints
 */
export const prefetchGetRiskEngineMatchingFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRiskEngineMatchingFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetRiskEngineMatchingFilterMetadataQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get matching incidents between two trading accounts from risk engine
 */
export const getTradingAccountIncidents = (
    params: GetTradingAccountIncidentsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IncidentsResponse>(
      {url: `/admin/api/risk_engine/matching/trading_accounts/incidents`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountIncidentsQueryKey = (params?: GetTradingAccountIncidentsParams,) => {
    return [
    'admin','api','risk_engine','matching','trading_accounts','incidents', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountIncidentsQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError = N404Response | N500Response>(params: GetTradingAccountIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountIncidentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountIncidents>>> = ({ signal }) => getTradingAccountIncidents(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountIncidentsQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountIncidents>>>
export type GetTradingAccountIncidentsQueryError = N404Response | N500Response


export function useGetTradingAccountIncidents<TData = Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError = N404Response | N500Response>(
 params: GetTradingAccountIncidentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountIncidents>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountIncidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountIncidents<TData = Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError = N404Response | N500Response>(
 params: GetTradingAccountIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountIncidents>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountIncidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountIncidents<TData = Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError = N404Response | N500Response>(
 params: GetTradingAccountIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get matching incidents between two trading accounts from risk engine
 */

export function useGetTradingAccountIncidents<TData = Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError = N404Response | N500Response>(
 params: GetTradingAccountIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountIncidentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get matching incidents between two trading accounts from risk engine
 */
export const prefetchGetTradingAccountIncidentsQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params: GetTradingAccountIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountIncidentsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get similar trading accounts from risk engine
 */
export const getSimilarTradingAccounts = (
    id: number,
    params?: GetSimilarTradingAccountsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<SimilarAccountsResponse>(
      {url: `/admin/api/risk_engine/matching/trading_accounts/${id}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSimilarTradingAccountsQueryKey = (id: number,
    params?: GetSimilarTradingAccountsParams,) => {
    return [
    'admin','api','risk_engine','matching','trading_accounts',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimilarTradingAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError = N404Response | N500Response>(id: number,
    params?: GetSimilarTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimilarTradingAccountsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimilarTradingAccounts>>> = ({ signal }) => getSimilarTradingAccounts(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimilarTradingAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimilarTradingAccounts>>>
export type GetSimilarTradingAccountsQueryError = N404Response | N500Response


export function useGetSimilarTradingAccounts<TData = Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params: undefined |  GetSimilarTradingAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimilarTradingAccounts>>,
          TError,
          Awaited<ReturnType<typeof getSimilarTradingAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimilarTradingAccounts<TData = Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params?: GetSimilarTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimilarTradingAccounts>>,
          TError,
          Awaited<ReturnType<typeof getSimilarTradingAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimilarTradingAccounts<TData = Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params?: GetSimilarTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get similar trading accounts from risk engine
 */

export function useGetSimilarTradingAccounts<TData = Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params?: GetSimilarTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimilarTradingAccountsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get similar trading accounts from risk engine
 */
export const prefetchGetSimilarTradingAccountsQuery = async <TData = Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params?: GetSimilarTradingAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarTradingAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetSimilarTradingAccountsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get matching incidents between two users from risk engine
 */
export const getUserIncidents = (
    params: GetUserIncidentsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IncidentsResponse>(
      {url: `/admin/api/risk_engine/matching/users/incidents`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUserIncidentsQueryKey = (params?: GetUserIncidentsParams,) => {
    return [
    'admin','api','risk_engine','matching','users','incidents', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserIncidentsQueryOptions = <TData = Awaited<ReturnType<typeof getUserIncidents>>, TError = N404Response | N500Response>(params: GetUserIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIncidentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIncidents>>> = ({ signal }) => getUserIncidents(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIncidents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIncidentsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIncidents>>>
export type GetUserIncidentsQueryError = N404Response | N500Response


export function useGetUserIncidents<TData = Awaited<ReturnType<typeof getUserIncidents>>, TError = N404Response | N500Response>(
 params: GetUserIncidentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIncidents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIncidents>>,
          TError,
          Awaited<ReturnType<typeof getUserIncidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIncidents<TData = Awaited<ReturnType<typeof getUserIncidents>>, TError = N404Response | N500Response>(
 params: GetUserIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIncidents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIncidents>>,
          TError,
          Awaited<ReturnType<typeof getUserIncidents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIncidents<TData = Awaited<ReturnType<typeof getUserIncidents>>, TError = N404Response | N500Response>(
 params: GetUserIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get matching incidents between two users from risk engine
 */

export function useGetUserIncidents<TData = Awaited<ReturnType<typeof getUserIncidents>>, TError = N404Response | N500Response>(
 params: GetUserIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIncidentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get matching incidents between two users from risk engine
 */
export const prefetchGetUserIncidentsQuery = async <TData = Awaited<ReturnType<typeof getUserIncidents>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params: GetUserIncidentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIncidents>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserIncidentsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get similar accounts for a user from risk engine
 */
export const getSimilarUserAccounts = (
    id: number,
    params?: GetSimilarUserAccountsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<SimilarAccountsResponse>(
      {url: `/admin/api/risk_engine/matching/users/${id}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSimilarUserAccountsQueryKey = (id: number,
    params?: GetSimilarUserAccountsParams,) => {
    return [
    'admin','api','risk_engine','matching','users',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimilarUserAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError = N404Response | N500Response>(id: number,
    params?: GetSimilarUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimilarUserAccountsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimilarUserAccounts>>> = ({ signal }) => getSimilarUserAccounts(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimilarUserAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimilarUserAccounts>>>
export type GetSimilarUserAccountsQueryError = N404Response | N500Response


export function useGetSimilarUserAccounts<TData = Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params: undefined |  GetSimilarUserAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimilarUserAccounts>>,
          TError,
          Awaited<ReturnType<typeof getSimilarUserAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimilarUserAccounts<TData = Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params?: GetSimilarUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimilarUserAccounts>>,
          TError,
          Awaited<ReturnType<typeof getSimilarUserAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimilarUserAccounts<TData = Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params?: GetSimilarUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get similar accounts for a user from risk engine
 */

export function useGetSimilarUserAccounts<TData = Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError = N404Response | N500Response>(
 id: number,
    params?: GetSimilarUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimilarUserAccountsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get similar accounts for a user from risk engine
 */
export const prefetchGetSimilarUserAccountsQuery = async <TData = Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number,
    params?: GetSimilarUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimilarUserAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetSimilarUserAccountsQueryOptions(id,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get paginated flagged trading account pairs from risk engine
 */
export const getFlaggedAccounts = (
    params?: GetFlaggedAccountsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<FlaggedAccountsResponse>(
      {url: `/admin/api/risk_engine/matching/flagged`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFlaggedAccountsQueryKey = (params?: GetFlaggedAccountsParams,) => {
    return [
    'admin','api','risk_engine','matching','flagged', ...(params ? [params] : [])
    ] as const;
    }


export const getGetFlaggedAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getFlaggedAccounts>>, TError = N404Response | N500Response>(params?: GetFlaggedAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlaggedAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFlaggedAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFlaggedAccounts>>> = ({ signal }) => getFlaggedAccounts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFlaggedAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFlaggedAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getFlaggedAccounts>>>
export type GetFlaggedAccountsQueryError = N404Response | N500Response


export function useGetFlaggedAccounts<TData = Awaited<ReturnType<typeof getFlaggedAccounts>>, TError = N404Response | N500Response>(
 params: undefined |  GetFlaggedAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlaggedAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlaggedAccounts>>,
          TError,
          Awaited<ReturnType<typeof getFlaggedAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlaggedAccounts<TData = Awaited<ReturnType<typeof getFlaggedAccounts>>, TError = N404Response | N500Response>(
 params?: GetFlaggedAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlaggedAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlaggedAccounts>>,
          TError,
          Awaited<ReturnType<typeof getFlaggedAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlaggedAccounts<TData = Awaited<ReturnType<typeof getFlaggedAccounts>>, TError = N404Response | N500Response>(
 params?: GetFlaggedAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlaggedAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get paginated flagged trading account pairs from risk engine
 */

export function useGetFlaggedAccounts<TData = Awaited<ReturnType<typeof getFlaggedAccounts>>, TError = N404Response | N500Response>(
 params?: GetFlaggedAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlaggedAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFlaggedAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get paginated flagged trading account pairs from risk engine
 */
export const prefetchGetFlaggedAccountsQuery = async <TData = Awaited<ReturnType<typeof getFlaggedAccounts>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetFlaggedAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlaggedAccounts>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetFlaggedAccountsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get IP anomalies for a user from risk engine
 */
export const getUserIpAnomalies = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IpAnomaliesResponse>(
      {url: `/admin/api/risk_engine/ip/users/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserIpAnomaliesQueryKey = (id: number,) => {
    return [
    'admin','api','risk_engine','ip','users',id
    ] as const;
    }


export const getGetUserIpAnomaliesQueryOptions = <TData = Awaited<ReturnType<typeof getUserIpAnomalies>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIpAnomaliesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIpAnomalies>>> = ({ signal }) => getUserIpAnomalies(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIpAnomalies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIpAnomaliesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIpAnomalies>>>
export type GetUserIpAnomaliesQueryError = N404Response | N500Response


export function useGetUserIpAnomalies<TData = Awaited<ReturnType<typeof getUserIpAnomalies>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIpAnomalies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIpAnomalies>>,
          TError,
          Awaited<ReturnType<typeof getUserIpAnomalies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIpAnomalies<TData = Awaited<ReturnType<typeof getUserIpAnomalies>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIpAnomalies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIpAnomalies>>,
          TError,
          Awaited<ReturnType<typeof getUserIpAnomalies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIpAnomalies<TData = Awaited<ReturnType<typeof getUserIpAnomalies>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get IP anomalies for a user from risk engine
 */

export function useGetUserIpAnomalies<TData = Awaited<ReturnType<typeof getUserIpAnomalies>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIpAnomaliesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get IP anomalies for a user from risk engine
 */
export const prefetchGetUserIpAnomaliesQuery = async <TData = Awaited<ReturnType<typeof getUserIpAnomalies>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserIpAnomaliesQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Mark user as checked after reviewing IP anomalies
 */
export const markUserChecked = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<MarkUserChecked200>(
      {url: `/admin/api/risk_engine/ip/users/${id}`, method: 'POST', signal
    },
      options);
    }




export const getMarkUserCheckedMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markUserChecked>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markUserChecked>>, TError,{id: number}, TContext> => {

const mutationKey = ['markUserChecked'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markUserChecked>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markUserChecked(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkUserCheckedMutationResult = NonNullable<Awaited<ReturnType<typeof markUserChecked>>>

    export type MarkUserCheckedMutationError = N422Response | N500Response

    /**
 * @summary Mark user as checked after reviewing IP anomalies
 */
export const useMarkUserChecked = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markUserChecked>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markUserChecked>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkUserCheckedMutationOptions(options), queryClient);
    }

/**
 * @summary Get IP anomalies for multiple users from risk engine
 */
export const getUsersIpAnomalies = (
    params: GetUsersIpAnomaliesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<IpAnomaliesResponse>(
      {url: `/admin/api/risk_engine/ip/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUsersIpAnomaliesQueryKey = (params?: GetUsersIpAnomaliesParams,) => {
    return [
    'admin','api','risk_engine','ip','users', ...(params ? [params] : [])
    ] as const;
    }


export const getGetUsersIpAnomaliesQueryOptions = <TData = Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError = N404Response | N500Response>(params: GetUsersIpAnomaliesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersIpAnomaliesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersIpAnomalies>>> = ({ signal }) => getUsersIpAnomalies(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersIpAnomaliesQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersIpAnomalies>>>
export type GetUsersIpAnomaliesQueryError = N404Response | N500Response


export function useGetUsersIpAnomalies<TData = Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError = N404Response | N500Response>(
 params: GetUsersIpAnomaliesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersIpAnomalies>>,
          TError,
          Awaited<ReturnType<typeof getUsersIpAnomalies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersIpAnomalies<TData = Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError = N404Response | N500Response>(
 params: GetUsersIpAnomaliesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersIpAnomalies>>,
          TError,
          Awaited<ReturnType<typeof getUsersIpAnomalies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersIpAnomalies<TData = Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError = N404Response | N500Response>(
 params: GetUsersIpAnomaliesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get IP anomalies for multiple users from risk engine
 */

export function useGetUsersIpAnomalies<TData = Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError = N404Response | N500Response>(
 params: GetUsersIpAnomaliesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersIpAnomaliesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get IP anomalies for multiple users from risk engine
 */
export const prefetchGetUsersIpAnomaliesQuery = async <TData = Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params: GetUsersIpAnomaliesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersIpAnomalies>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUsersIpAnomaliesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Mark multiple users as checked
 */
export const markUsersChecked = (
    markUsersCheckedBody: MarkUsersCheckedBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {

      const formUrlEncoded = new URLSearchParams();
markUsersCheckedBody.user_ids.forEach(value => formUrlEncoded.append(`user_ids`, value.toString()));

      return orvalFetch<MarkUsersChecked200>(
      {url: `/admin/api/risk_engine/ip/users`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded, signal
    },
      options);
    }




export const getMarkUsersCheckedMutationOptions = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markUsersChecked>>, TError,{data: MarkUsersCheckedBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markUsersChecked>>, TError,{data: MarkUsersCheckedBody}, TContext> => {

const mutationKey = ['markUsersChecked'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markUsersChecked>>, {data: MarkUsersCheckedBody}> = (props) => {
          const {data} = props ?? {};

          return  markUsersChecked(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkUsersCheckedMutationResult = NonNullable<Awaited<ReturnType<typeof markUsersChecked>>>
    export type MarkUsersCheckedMutationBody = MarkUsersCheckedBody
    export type MarkUsersCheckedMutationError = N422Response | N500Response

    /**
 * @summary Mark multiple users as checked
 */
export const useMarkUsersChecked = <TError = N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markUsersChecked>>, TError,{data: MarkUsersCheckedBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markUsersChecked>>,
        TError,
        {data: MarkUsersCheckedBody},
        TContext
      > => {
      return useMutation(getMarkUsersCheckedMutationOptions(options), queryClient);
    }

/**
 * @summary List countries
 */
export const listCountries = (
    params?: ListCountriesParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CountriesListResponse>(
      {url: `/admin/api/countries`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListCountriesQueryKey = (params?: ListCountriesParams,) => {
    return [
    'admin','api','countries', ...(params ? [params] : [])
    ] as const;
    }


export const getListCountriesQueryOptions = <TData = Awaited<ReturnType<typeof listCountries>>, TError = N404Response | N500Response>(params?: ListCountriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCountriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCountries>>> = ({ signal }) => listCountries(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCountriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCountries>>>
export type ListCountriesQueryError = N404Response | N500Response


export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = N404Response | N500Response>(
 params: undefined |  ListCountriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCountries>>,
          TError,
          Awaited<ReturnType<typeof listCountries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = N404Response | N500Response>(
 params?: ListCountriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCountries>>,
          TError,
          Awaited<ReturnType<typeof listCountries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = N404Response | N500Response>(
 params?: ListCountriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List countries
 */

export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = N404Response | N500Response>(
 params?: ListCountriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCountriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List countries
 */
export const prefetchListCountriesQuery = async <TData = Awaited<ReturnType<typeof listCountries>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: ListCountriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListCountriesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get country count for search filter and brand options
 */
export const getCountryFilterMetadata = (
    params?: GetCountryFilterMetadataParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CountriesFilterMetadataResponse>(
      {url: `/admin/api/countries/filter_metadata`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCountryFilterMetadataQueryKey = (params?: GetCountryFilterMetadataParams,) => {
    return [
    'admin','api','countries','filter_metadata', ...(params ? [params] : [])
    ] as const;
    }


export const getGetCountryFilterMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError = N404Response | N500Response>(params?: GetCountryFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountryFilterMetadataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountryFilterMetadata>>> = ({ signal }) => getCountryFilterMetadata(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCountryFilterMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getCountryFilterMetadata>>>
export type GetCountryFilterMetadataQueryError = N404Response | N500Response


export function useGetCountryFilterMetadata<TData = Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError = N404Response | N500Response>(
 params: undefined |  GetCountryFilterMetadataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCountryFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryFilterMetadata<TData = Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCountryFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryFilterMetadata>>,
          TError,
          Awaited<ReturnType<typeof getCountryFilterMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryFilterMetadata<TData = Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCountryFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get country count for search filter and brand options
 */

export function useGetCountryFilterMetadata<TData = Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError = N404Response | N500Response>(
 params?: GetCountryFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCountryFilterMetadataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get country count for search filter and brand options
 */
export const prefetchGetCountryFilterMetadataQuery = async <TData = Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetCountryFilterMetadataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryFilterMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCountryFilterMetadataQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get country details
 */
export const getCountry = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<Country>(
      {url: `/admin/api/countries/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetCountryQueryKey = (id: number,) => {
    return [
    'admin','api','countries',id
    ] as const;
    }


export const getGetCountryQueryOptions = <TData = Awaited<ReturnType<typeof getCountry>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountry>>> = ({ signal }) => getCountry(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCountryQueryResult = NonNullable<Awaited<ReturnType<typeof getCountry>>>
export type GetCountryQueryError = N404Response | N500Response


export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountry>>,
          TError,
          Awaited<ReturnType<typeof getCountry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountry>>,
          TError,
          Awaited<ReturnType<typeof getCountry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get country details
 */

export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCountryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get country details
 */
export const prefetchGetCountryQuery = async <TData = Awaited<ReturnType<typeof getCountry>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCountryQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Update country details
 */
export const updateCountry = (
    id: number,
    updateCountryRequestBody: UpdateCountryRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CountryResponse>(
      {url: `/admin/api/countries/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCountryRequestBody, signal
    },
      options);
    }




export const getUpdateCountryMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCountry>>, TError,{id: number;data: UpdateCountryRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCountry>>, TError,{id: number;data: UpdateCountryRequestBody}, TContext> => {

const mutationKey = ['updateCountry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCountry>>, {id: number;data: UpdateCountryRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCountry(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCountryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCountry>>>
    export type UpdateCountryMutationBody = UpdateCountryRequestBody
    export type UpdateCountryMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Update country details
 */
export const useUpdateCountry = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCountry>>, TError,{id: number;data: UpdateCountryRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCountry>>,
        TError,
        {id: number;data: UpdateCountryRequestBody},
        TContext
      > => {
      return useMutation(getUpdateCountryMutationOptions(options), queryClient);
    }

/**
 * @summary Get country details with form options for editing
 */
export const editCountry = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<CountryEditResponse>(
      {url: `/admin/api/countries/${id}/edit`, method: 'GET', signal
    },
      options);
    }




export const getEditCountryQueryKey = (id: number,) => {
    return [
    'admin','api','countries',id,'edit'
    ] as const;
    }


export const getEditCountryQueryOptions = <TData = Awaited<ReturnType<typeof editCountry>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEditCountryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof editCountry>>> = ({ signal }) => editCountry(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof editCountry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EditCountryQueryResult = NonNullable<Awaited<ReturnType<typeof editCountry>>>
export type EditCountryQueryError = N404Response | N500Response


export function useEditCountry<TData = Awaited<ReturnType<typeof editCountry>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof editCountry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof editCountry>>,
          TError,
          Awaited<ReturnType<typeof editCountry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEditCountry<TData = Awaited<ReturnType<typeof editCountry>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editCountry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof editCountry>>,
          TError,
          Awaited<ReturnType<typeof editCountry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEditCountry<TData = Awaited<ReturnType<typeof editCountry>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get country details with form options for editing
 */

export function useEditCountry<TData = Awaited<ReturnType<typeof editCountry>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEditCountryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get country details with form options for editing
 */
export const prefetchEditCountryQuery = async <TData = Awaited<ReturnType<typeof editCountry>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof editCountry>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getEditCountryQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary List all IP whitelist requests
 */
export const adminListIpWhitelistRequests = (
    params?: AdminListIpWhitelistRequestsParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AdminListIpWhitelistRequests200>(
      {url: `/admin/api/ip_whitelist_requests`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAdminListIpWhitelistRequestsQueryKey = (params?: AdminListIpWhitelistRequestsParams,) => {
    return [
    'admin','api','ip_whitelist_requests', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListIpWhitelistRequestsQueryOptions = <TData = Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError = void>(params?: AdminListIpWhitelistRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListIpWhitelistRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>> = ({ signal }) => adminListIpWhitelistRequests(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListIpWhitelistRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>>
export type AdminListIpWhitelistRequestsQueryError = void


export function useAdminListIpWhitelistRequests<TData = Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError = void>(
 params: undefined |  AdminListIpWhitelistRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListIpWhitelistRequests>>,
          TError,
          Awaited<ReturnType<typeof adminListIpWhitelistRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListIpWhitelistRequests<TData = Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError = void>(
 params?: AdminListIpWhitelistRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListIpWhitelistRequests>>,
          TError,
          Awaited<ReturnType<typeof adminListIpWhitelistRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListIpWhitelistRequests<TData = Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError = void>(
 params?: AdminListIpWhitelistRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all IP whitelist requests
 */

export function useAdminListIpWhitelistRequests<TData = Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError = void>(
 params?: AdminListIpWhitelistRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListIpWhitelistRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List all IP whitelist requests
 */
export const prefetchAdminListIpWhitelistRequestsQuery = async <TData = Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError = void>(
 queryClient: QueryClient, params?: AdminListIpWhitelistRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIpWhitelistRequests>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAdminListIpWhitelistRequestsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get a single IP whitelist request
 */
export const adminGetIpWhitelistRequest = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AdminIpWhitelistRequestSerializer>(
      {url: `/admin/api/ip_whitelist_requests/${id}`, method: 'GET', signal
    },
      options);
    }




export const getAdminGetIpWhitelistRequestQueryKey = (id: number,) => {
    return [
    'admin','api','ip_whitelist_requests',id
    ] as const;
    }


export const getAdminGetIpWhitelistRequestQueryOptions = <TData = Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetIpWhitelistRequestQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>> = ({ signal }) => adminGetIpWhitelistRequest(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetIpWhitelistRequestQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>>
export type AdminGetIpWhitelistRequestQueryError = void


export function useAdminGetIpWhitelistRequest<TData = Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>,
          TError,
          Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetIpWhitelistRequest<TData = Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>,
          TError,
          Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetIpWhitelistRequest<TData = Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single IP whitelist request
 */

export function useAdminGetIpWhitelistRequest<TData = Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetIpWhitelistRequestQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a single IP whitelist request
 */
export const prefetchAdminGetIpWhitelistRequestQuery = async <TData = Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError = void>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetIpWhitelistRequest>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getAdminGetIpWhitelistRequestQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Approve a pending IP whitelist request
 */
export const adminApproveIpWhitelistRequest = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AdminIpWhitelistRequestSerializer>(
      {url: `/admin/api/ip_whitelist_requests/${id}/approve`, method: 'POST', signal
    },
      options);
    }




export const getAdminApproveIpWhitelistRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminApproveIpWhitelistRequest>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminApproveIpWhitelistRequest>>, TError,{id: number}, TContext> => {

const mutationKey = ['adminApproveIpWhitelistRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminApproveIpWhitelistRequest>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  adminApproveIpWhitelistRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminApproveIpWhitelistRequestMutationResult = NonNullable<Awaited<ReturnType<typeof adminApproveIpWhitelistRequest>>>

    export type AdminApproveIpWhitelistRequestMutationError = void

    /**
 * @summary Approve a pending IP whitelist request
 */
export const useAdminApproveIpWhitelistRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminApproveIpWhitelistRequest>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminApproveIpWhitelistRequest>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAdminApproveIpWhitelistRequestMutationOptions(options), queryClient);
    }

/**
 * @summary Reject a pending IP whitelist request
 */
export const adminRejectIpWhitelistRequest = (
    id: number,
    adminRejectIpWhitelistRequestBody?: AdminRejectIpWhitelistRequestBody,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<AdminIpWhitelistRequestSerializer>(
      {url: `/admin/api/ip_whitelist_requests/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminRejectIpWhitelistRequestBody, signal
    },
      options);
    }




export const getAdminRejectIpWhitelistRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectIpWhitelistRequest>>, TError,{id: number;data?: AdminRejectIpWhitelistRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRejectIpWhitelistRequest>>, TError,{id: number;data?: AdminRejectIpWhitelistRequestBody}, TContext> => {

const mutationKey = ['adminRejectIpWhitelistRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRejectIpWhitelistRequest>>, {id: number;data?: AdminRejectIpWhitelistRequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminRejectIpWhitelistRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRejectIpWhitelistRequestMutationResult = NonNullable<Awaited<ReturnType<typeof adminRejectIpWhitelistRequest>>>
    export type AdminRejectIpWhitelistRequestMutationBody = AdminRejectIpWhitelistRequestBody | undefined
    export type AdminRejectIpWhitelistRequestMutationError = void

    /**
 * @summary Reject a pending IP whitelist request
 */
export const useAdminRejectIpWhitelistRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectIpWhitelistRequest>>, TError,{id: number;data?: AdminRejectIpWhitelistRequestBody}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRejectIpWhitelistRequest>>,
        TError,
        {id: number;data?: AdminRejectIpWhitelistRequestBody},
        TContext
      > => {
      return useMutation(getAdminRejectIpWhitelistRequestMutationOptions(options), queryClient);
    }

/**
 * @summary Get scores for a trading account from risk engine
 */
export const getTradingAccountScore = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountRiskScore>(
      {url: `/admin/api/risk_engine/scores/trading_accounts/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetTradingAccountScoreQueryKey = (id: number,) => {
    return [
    'admin','api','risk_engine','scores','trading_accounts',id
    ] as const;
    }


export const getGetTradingAccountScoreQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountScore>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountScoreQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountScore>>> = ({ signal }) => getTradingAccountScore(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountScore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountScoreQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountScore>>>
export type GetTradingAccountScoreQueryError = N404Response | N500Response


export function useGetTradingAccountScore<TData = Awaited<ReturnType<typeof getTradingAccountScore>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountScore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountScore>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountScore<TData = Awaited<ReturnType<typeof getTradingAccountScore>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountScore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountScore>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountScore<TData = Awaited<ReturnType<typeof getTradingAccountScore>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get scores for a trading account from risk engine
 */

export function useGetTradingAccountScore<TData = Awaited<ReturnType<typeof getTradingAccountScore>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountScoreQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get scores for a trading account from risk engine
 */
export const prefetchGetTradingAccountScoreQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountScore>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountScoreQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get scores for multiple trading accounts from risk engine
 */
export const getTradingAccountsScores = (
    params?: GetTradingAccountsScoresParams,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<TradingAccountRiskScoresResponse>(
      {url: `/admin/api/risk_engine/scores/trading_accounts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTradingAccountsScoresQueryKey = (params?: GetTradingAccountsScoresParams,) => {
    return [
    'admin','api','risk_engine','scores','trading_accounts', ...(params ? [params] : [])
    ] as const;
    }


export const getGetTradingAccountsScoresQueryOptions = <TData = Awaited<ReturnType<typeof getTradingAccountsScores>>, TError = N404Response | N500Response>(params?: GetTradingAccountsScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingAccountsScoresQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingAccountsScores>>> = ({ signal }) => getTradingAccountsScores(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsScores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTradingAccountsScoresQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingAccountsScores>>>
export type GetTradingAccountsScoresQueryError = N404Response | N500Response


export function useGetTradingAccountsScores<TData = Awaited<ReturnType<typeof getTradingAccountsScores>>, TError = N404Response | N500Response>(
 params: undefined |  GetTradingAccountsScoresParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsScores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountsScores>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountsScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountsScores<TData = Awaited<ReturnType<typeof getTradingAccountsScores>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountsScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsScores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradingAccountsScores>>,
          TError,
          Awaited<ReturnType<typeof getTradingAccountsScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTradingAccountsScores<TData = Awaited<ReturnType<typeof getTradingAccountsScores>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountsScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get scores for multiple trading accounts from risk engine
 */

export function useGetTradingAccountsScores<TData = Awaited<ReturnType<typeof getTradingAccountsScores>>, TError = N404Response | N500Response>(
 params?: GetTradingAccountsScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTradingAccountsScoresQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get scores for multiple trading accounts from risk engine
 */
export const prefetchGetTradingAccountsScoresQuery = async <TData = Awaited<ReturnType<typeof getTradingAccountsScores>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, params?: GetTradingAccountsScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradingAccountsScores>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetTradingAccountsScoresQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Get aggregated scores for a user from risk engine
 */
export const getUserScore = (
    id: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<UserRiskScore>(
      {url: `/admin/api/risk_engine/scores/users/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserScoreQueryKey = (id: number,) => {
    return [
    'admin','api','risk_engine','scores','users',id
    ] as const;
    }


export const getGetUserScoreQueryOptions = <TData = Awaited<ReturnType<typeof getUserScore>>, TError = N404Response | N500Response>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserScoreQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserScore>>> = ({ signal }) => getUserScore(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserScore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserScoreQueryResult = NonNullable<Awaited<ReturnType<typeof getUserScore>>>
export type GetUserScoreQueryError = N404Response | N500Response


export function useGetUserScore<TData = Awaited<ReturnType<typeof getUserScore>>, TError = N404Response | N500Response>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserScore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserScore>>,
          TError,
          Awaited<ReturnType<typeof getUserScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserScore<TData = Awaited<ReturnType<typeof getUserScore>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserScore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserScore>>,
          TError,
          Awaited<ReturnType<typeof getUserScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserScore<TData = Awaited<ReturnType<typeof getUserScore>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get aggregated scores for a user from risk engine
 */

export function useGetUserScore<TData = Awaited<ReturnType<typeof getUserScore>>, TError = N404Response | N500Response>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserScoreQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get aggregated scores for a user from risk engine
 */
export const prefetchGetUserScoreQuery = async <TData = Awaited<ReturnType<typeof getUserScore>>, TError = N404Response | N500Response>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserScore>>, TError, TData>>, request?: SecondParameter<typeof orvalFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetUserScoreQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}






/**
 * @summary Resend a contract to its signer
 */
export const resendAgreementContract = (
    agreementId: number,
 options?: SecondParameter<typeof orvalFetch>,signal?: AbortSignal
) => {


      return orvalFetch<ResendAgreementContract200>(
      {url: `/admin/api/agreements/${agreementId}/contracts/resend`, method: 'POST', signal
    },
      options);
    }




export const getResendAgreementContractMutationOptions = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAgreementContract>>, TError,{agreementId: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendAgreementContract>>, TError,{agreementId: number}, TContext> => {

const mutationKey = ['resendAgreementContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendAgreementContract>>, {agreementId: number}> = (props) => {
          const {agreementId} = props ?? {};

          return  resendAgreementContract(agreementId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendAgreementContractMutationResult = NonNullable<Awaited<ReturnType<typeof resendAgreementContract>>>

    export type ResendAgreementContractMutationError = N404Response | N422Response | N500Response

    /**
 * @summary Resend a contract to its signer
 */
export const useResendAgreementContract = <TError = N404Response | N422Response | N500Response,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAgreementContract>>, TError,{agreementId: number}, TContext>, request?: SecondParameter<typeof orvalFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendAgreementContract>>,
        TError,
        {agreementId: number},
        TContext
      > => {
      return useMutation(getResendAgreementContractMutationOptions(options), queryClient);
    }
